theme.StoreLocator = function(t) {
    var e = {
            filterCountryEl: $("#filterCountry"),
            filterBoutiqueEl: $("#filterBoutique"),
            filterStockistEl: $("#filterStockist"),
            filterShowroomEl: $("#filterShowroom"),
            filterTextEl: $("#filterInput"),
            filterWrapEl: $(".stores__filter-wrap"),
            filterAddressEl: $("#addressInput"),
            filterRadiusEl: $("#filterRadius"),
            filterLocationEl: $("#filterLocation"),
            filterNoResultsEl: $("#filterNoResults"),
            filterInvalidAddressEl: $("#filterInvalidAddress"),
            resultEmptyEl: $(".stores__result-empty"),
            storeEls: $(".store-item"),
            resultCountEl: $(".stores__result-count"),
            resultCountWrapEl: $(".stores__result-count-wrap"),
            resultEmptyEl: $(".stores__result-empty"),
            resultCountSingle: $(".stores__result-count").data("single"),
            resultCountPlural: $(".stores__result-count").data("plural"),
            storeGridClass: ".store-grid",
            storeCountryClass: ".stores__country",
            brandStoresClass: ".stores__brand-stores",
            brandStoreClass: ".brand-store",
            sectionByCountry: t.sectionByCountry,
            mapId: "storesMap",
            mapWrapClass: ".stores__map",
            apiUrl: t.ipAccessKey ? "https://api.ipstack.com/check?access_key=" + t.ipAccessKey : void 0
        },
        o = [],
        r = [];
    const l = "country" === t.filterType ? function(t) {
        console.log("country filter run"), $(e.storeGridClass).empty(), $(e.storeCountryClass).hide(), $(e.resultCountEl).toggle("string" == typeof $(e.filterCountryEl).val());
        var r = e.filterCountryEl.val(),
            l = e.filterTextEl.val(),
            i = e.filterBoutiqueEl.is(":checked"),
            s = e.filterStockistEl.is(":checked"),
            n = e.filterShowroomEl.is(":checked"),
            a = t || o,
            d = function(t, e, o, r, l, i) {
                var s = function(t, e) {
                        return t.filter((function(t) {
                            return t.addressCountry == e
                        }))
                    }(t, e),
                    n = function(t, e) {
                        return e = (e = e || "").toLowerCase().split(" "), t.filter((function(t) {
                            return e.every((function(e) {
                                return t._search.indexOf(e) > -1
                            }))
                        }))
                    }(s, o);
                return function(t, e, o, r) {
                    return 1 == [e, o, r].filter(((t, e, o) => o.indexOf(t) == e)).length ? t : t.filter((function(t) {
                        return t.boutique && e || t.stockist && o || t.showroom && r
                    }))
                }(n, r, l, i)
            }(a, r, l, i, s, n);
        $(e.storeGridClass).toggleClass("filtered", d.length != a.length), f(d)
    } : i;

     function i(r) {
        $(e.storeGridClass).empty(), $(e.storeCountryClass).hide();
        var l = e.filterTextEl.val(),
            i = (e.filterBoutiqueEl.is(":checked"), e.filterStockistEl.is(":checked"), e.filterShowroomEl.is(":checked"), r || o),
            s = function(t, e, o, r) {
                var l = function(t, e) {
                    return e = (e = e || "").toLowerCase().split(" "), t.filter((function(t) {
                        return e.every((function(e) {
                            return t._search.indexOf(e) > -1
                        }))
                    }))
                }(t, e);
                return function(t, e, o) {
                    if (e == o) return t;
                    return t.filter((function(t) {
                        return t.webshop && e || t.physical && o
                    }))
                }(l, o, r)
            }(i, l, filterOnline, filterPhysical);
        $(e.storeGridClass).toggleClass("filtered", s.length != i.length), f(s), t.enableMap && u(s.length ? s : i)
    }

    function s(t) {
        $(e.filterCountryEl).val(t).change()
    }

    function n(e) {
        var o = [];
        return _.isUndefined(e) ? "" : (e[t.csvFieldAddress] && o.push(e[t.csvFieldAddress]), e[t.csvFieldPostalCode] && o.push(e[t.csvFieldPostalCode]), e[t.csvFieldCity] && o.push(e[t.csvFieldCity]), e[t.csvFieldRegion] && o.push(e[t.csvFieldRegion]), o.join(" "))
    }

    function a(t) {
        return _.isUndefined(t) ? "" : t.replace(/http:\/\//g, "").replace(/https:\/\//g, "")
    }

    function d(e) {
        var o = t.storeTemplate;
        return Mustache.parse(o), Mustache.to_html(o, e)
    }

    function u(r = o) {
        var l, i = new google.maps.LatLngBounds,
            s = {
                mapTypeId: "roadmap"
            },
            n = [],
            a = [];
        t.mapStylesJSON && (s.styles = t.mapStylesJSON), t.enableUI || (s.disableDefaultUI = !0), (l = new google.maps.Map(document.getElementById(e.mapId), s)).setTilt(45), r.forEach((function(t) {
            "" != t.lat && "" != t.lat && (n.push([t.title, t.lat, t.lng]), a.push(['<div class="infoWindow"><h3>' + t.title + "</h3><p>" + t.addressString + "</p></div>"]))
        }));
        var d, u, c = new google.maps.InfoWindow;
        for (u = 0; u < n.length; u++) {
            var f = new google.maps.LatLng(n[u][1], n[u][2]);
            if (i.extend(f), d = new google.maps.Marker({
                    position: f,
                    map: l,
                    title: n[u][0],
                    icon: t.mapMarkerImage
                }), google.maps.event.addListener(d, "click", function(t, e) {
                    return function() {
                        c.setContent(a[e][0]), c.open(l, t)
                    }
                }(d, u)), r.length > 1) l.fitBounds(i);
            else {
                var p = new google.maps.LatLng(r[0].lat, r[0].lng);
                l.setCenter(p), l.setZoom(15)
            }
        }
    }

    function c(r, l) {
        new google.maps.Geocoder;
        var i, s, n, a = $(e.filterAddressEl).val().replace(/[^a-z0-9\s]/gi, ""),
            d = parseInt($(e.filterRadiusEl).val(), 10);
        if ("" == a && void 0 === r && void 0 === l) return t.enableMap && u(o), void f(o);
        if (void 0 !== r && void 0 !== l && d) c(r, l);
        else if (a && d) {
            i = a.split(" ").join("+"), s = t.gmapsAPI, n = "https://maps.googleapis.com/maps/api/geocode/json?address=" + i + "&key=" + s, void $.get(n, (function(t) {
                if ("ZERO_RESULTS" === t.status) return console.log("Address not valid"), void $(e.filterInvalidAddressEl).show();
                $(e.filterInvalidAddressEl).hide(), c(t.results[0].geometry.location.lat, t.results[0].geometry.location.lng)
            }))
        }

        function c(r, l) {
            var i = new google.maps.LatLng(r, l),
                s = o.filter((function(t) {
                    var e = new google.maps.LatLng(t.lat, t.lng);
                    return o = google.maps.geometry.spherical.computeDistanceBetween(e, i), .001 * o <= d;
                    var o
                }));
            s.length > 0 ? ($(e.filterNoResultsEl).hide(), t.enableMap && u(s), f(s)) : $(e.filterNoResultsEl).show()
        }
    }

    function f(t) {
        if ($(e.storeGridClass).empty(), $(e.storeCountryClass).hide(), 1 == t.length) var o = e.resultCountSingle;
        else o = e.resultCountPlural;
        0 == t.length ? ($(e.resultCountWrapEl).removeClass("active"), $(e.resultCountWrapEl).removeClass("active"), $(e.resultEmptyEl).addClass("active")) : ($(e.resultCountWrapEl).addClass("active"), $(e.resultCountWrapEl).addClass("active"), $(e.resultEmptyEl).removeClass("active")), $(e.resultCountEl).text(t.length + " " + o), $(e.resultCountEl).text(t.length + " " + o), e.sectionByCountry ? t.sort((function(t, e) {
            var o = t.addressCountry.toLowerCase(),
                r = e.addressCountry.toLowerCase(),
                l = t.title.toLowerCase(),
                i = e.title.toLowerCase();
            return o < r ? -1 : o > r ? 1 : l < i ? -1 : l > i ? 1 : 0
        })) : t.sort((function(t, e) {
            var o = t.title.toUpperCase(),
                r = e.title.toUpperCase();
            return o < r ? -1 : o > r ? 1 : 0
        }));
        for (var r = "", l = 0; l < t.length; l++) {
            var i = t[l];
            r = i.addressCountry;
            var s = d(i);
            e.sectionByCountry ? "" != r && ($("[data-country=" + r + "]").show(), $("[data-country=" + r + "] " + e.storeGridClass).append(s)) : $(e.storeGridClass).append(s), r = i.addressCountry
        }
    }

    function p(t, e, o) {
        e.setPosition(o), e.setContent(t ? "Error: The Geolocation service failed." : "Error: Your browser doesn't support geolocation."), e.open(map)
    }
    "blocks" == t.inputType ? (o = t.enableMap ? _.remove(t.storeJSON, (function(t) {
        return !(isNaN(t.lat) || isNaN(t.lng))
    })) : t.storeJSON, "country" != t.filterType && l()) : "" != t.csvPath && Papa.parse(t.csvPath, {
        download: !0,
        quoteChar: '"',
        delimiter: t.csvDelimiter,
        skipemptylines: !0,
        header: !0,
        complete: function(l, i) {
            var s = _.map(l.data, (function(e) {
                    return {
                        title: e[t.csvFieldCompany],
                        addressStreet: e[t.csvFieldAddress],
                        addressPostalCode: e[t.csvFieldPostalCode],
                        addressLocality: e[t.csvFieldCity],
                        addressRegion: e[t.csvFieldRegion],
                        addressCountry: e[t.csvFieldCountry],
                        addressString: n(e),
                        phone: e[t.csvFieldPhone],
                        email: e[t.csvFieldEmail],
                        lat: parseFloat(e[t.csvFieldLatitude]),
                        lng: parseFloat(e[t.csvFieldLongitude]),
                        url: e[t.csvFieldWebsite],
                        niceUrl: a(e[t.csvFieldWebsite]),
                        boutique: !!e[t.csvFieldBoutique],
                        stockist: !!e[t.csvFieldStockist],
                        showroom: !!e[t.csvFieldShowroom],
                        _search: e[t.csvFieldCompany].toLowerCase() + " " + n(e).toLowerCase()
                    }
                })),
                d = _.filter(s, (function(t) {
                    return !_.isUndefined(t.addressCountry)
                }));
            e.filterCountryEl.find("option").each((function() {
                var t = $(this).val(),
                    e = _.findIndex(d, (function(e) {
                        return e.addressCountry == t
                    }));
                "-" == t || "none" == t || (-1 == e ? $(this).detach() : r.push(t))
            })), o = d, t.enableAutoFilterLocation && $(e.filterLocationEl).click()
        }
    }), $('.stores__brand-stores').flickity({
      cellAlign: 'left',
      pageDots: false,
      wrapAround: true,
      autoPlay: true
    });

    $('.brand-store__flickity').each(function(){
      var config = $(this).data("flickity-config");
      this.flickityInstance = new Flickity(this, config);
    }); t.enableIpLookup && (void 0 !== window.ipLookup ? (console.log("Using saved ipLookup"), s(window.ipLookup.country_code), $(e.filterWrapEl).removeClass("loading_location")) : null != e.apiUrl && (console.log("Requesting ipLookup..."), console.log(e.apiUrl), $.getJSON(e.apiUrl, function(t) {
        window.ipLookup = t, console.log(t), s(t.country_code), $(e.filterWrapEl).removeClass("loading_location")
    }.bind(this)).fail((function(t, e, o) {
        console.log("ipstack request failed: " + e)
    })))), $("#filterSearch").on("click", (function(o) {
        t.enableMap || t.enableFilterLocation ? ($(e.filterLocationEl).data("lat", void 0), $(e.filterLocationEl).data("lng", void 0), $(e.filterLocationEl).attr("data-location", !1), o.preventDefault(), c()) : (o.preventDefault(), i())
    })), $(e.filterRadiusEl).on("change", (function(t) {
        "" != $(e.filterAddressEl).val() ? c() : "" != $(e.filterLocationEl).data("lat") ? c($(e.filterLocationEl).data("lat"), $(e.filterLocationEl).data("lng")) : c()
    })), $(e.filterLocationEl).on("click", (function(t) {
        if (t.preventDefault(), "true" == $(t.target).attr("data-location")) return $(t.target).attr("data-location", !1), $(e.filterLocationEl).data("lat", ""), $(e.filterLocationEl).data("lng", ""), void c();
        $(e.filterAddressEl).prop("disabled", !0), $(e.filterWrapEl).addClass("loading_location"), navigator.geolocation ? navigator.geolocation.getCurrentPosition((function(o) {
            $(e.filterAddressEl).val(null), c(o.coords.latitude, o.coords.longitude), $(t.target).data("lat", o.coords.latitude), $(t.target).data("lng", o.coords.longitude), $(e.filterAddressEl).prop("disabled", !1), $(t.target).attr("data-location", !0), $(e.filterWrapEl).removeClass("loading_location"), $(e.filterLocationError).hide()
        }), (function() {
            $(e.filterAddressEl).prop("disabled", !1), $(t.target).attr("data-location", !1), $(e.filterWrapEl).removeClass("loading_location"), c(), p(!0), $(e.filterLocationError).show()
        })) : (c(), p(!1), $(e.filterLocationError).show())
    })), $(e.filterTextEl).on("keyup", (function(t) {
        l()
    })), $(e.filterBoutiqueEl).on("change", (function() {
        setTimeout((function() {
            l()
        }), 300)
    })), $(e.filterStockistEl).on("change", (function() {
        setTimeout((function() {
            l()
        }), 300)
    })), $(e.filterShowroomEl).on("change", (function() {
        setTimeout((function() {
            l()
        }), 300)
    })), $(e.filterCountryEl).on("change", (function() {
        setTimeout((function() {
            l()
        }), 300)
    }))
   // General scripts



};




/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csstransforms-csstransforms3d-flexbox-placeholder-svg-touchevents-domprefixes-prefixes-setclasses-testallprops-testprop-teststyles !*/
!(function (e, t, n) {
    function i(e, t) {
        return typeof e === t;
    }
    function r() {
        var e, t, n, r, o, s, a;
        for (var l in b)
            if (b.hasOwnProperty(l)) {
                if (((e = []), (t = b[l]), t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length))) for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
                for (r = i(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++)
                    (s = e[o]), (a = s.split(".")), 1 === a.length ? (x[a[0]] = r) : (!x[a[0]] || x[a[0]] instanceof Boolean || (x[a[0]] = new Boolean(x[a[0]])), (x[a[0]][a[1]] = r)), m.push((r ? "" : "no-") + a.join("-"));
            }
    }
    function o(e) {
        var t = k.className,
            n = x._config.classPrefix || "";
        if ((S && (t = t.baseVal), x._config.enableJSClass)) {
            var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
            t = t.replace(i, "$1" + n + "js$2");
        }
        x._config.enableClasses && ((t += " " + n + e.join(" " + n)), S ? (k.className.baseVal = t) : (k.className = t));
    }
    function s() {
        return "function" != typeof t.createElement ? t.createElement(arguments[0]) : S ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments);
    }
    function a(e, t) {
        return !!~("" + e).indexOf(t);
    }
    function l(e) {
        return e
            .replace(/([a-z])-([a-z])/g, function (e, t, n) {
                return t + n.toUpperCase();
            })
            .replace(/^-/, "");
    }
    function u() {
        var e = t.body;
        return e || ((e = s(S ? "svg" : "body")), (e.fake = !0)), e;
    }
    function c(e, n, i, r) {
        var o,
            a,
            l,
            c,
            f = "modernizr",
            d = s("div"),
            p = u();
        if (parseInt(i, 10)) for (; i--; ) (l = s("div")), (l.id = r ? r[i] : f + (i + 1)), d.appendChild(l);
        return (
            (o = s("style")),
            (o.type = "text/css"),
            (o.id = "s" + f),
            (p.fake ? p : d).appendChild(o),
            p.appendChild(d),
            o.styleSheet ? (o.styleSheet.cssText = e) : o.appendChild(t.createTextNode(e)),
            (d.id = f),
            p.fake && ((p.style.background = ""), (p.style.overflow = "hidden"), (c = k.style.overflow), (k.style.overflow = "hidden"), k.appendChild(p)),
            (a = n(d, e)),
            p.fake ? (p.parentNode.removeChild(p), (k.style.overflow = c), k.offsetHeight) : d.parentNode.removeChild(d),
            !!a
        );
    }
    function f(e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    }
    function d(e, t, n) {
        var r;
        for (var o in e) if (e[o] in t) return n === !1 ? e[o] : ((r = t[e[o]]), i(r, "function") ? f(r, n || t) : r);
        return !1;
    }
    function p(e) {
        return e
            .replace(/([A-Z])/g, function (e, t) {
                return "-" + t.toLowerCase();
            })
            .replace(/^ms-/, "-ms-");
    }
    function h(t, i) {
        var r = t.length;
        if ("CSS" in e && "supports" in e.CSS) {
            for (; r--; ) if (e.CSS.supports(p(t[r]), i)) return !0;
            return !1;
        }
        if ("CSSSupportsRule" in e) {
            for (var o = []; r--; ) o.push("(" + p(t[r]) + ":" + i + ")");
            return (
                (o = o.join(" or ")),
                c("@supports (" + o + ") { #modernizr { position: absolute; } }", function (e) {
                    return "absolute" == getComputedStyle(e, null).position;
                })
            );
        }
        return n;
    }
    function g(e, t, r, o) {
        function u() {
            f && (delete P.style, delete P.modElem);
        }
        if (((o = !i(o, "undefined") && o), !i(r, "undefined"))) {
            var c = h(e, r);
            if (!i(c, "undefined")) return c;
        }
        for (var f, d, p, g, v, y = ["modernizr", "tspan", "samp"]; !P.style && y.length; ) (f = !0), (P.modElem = s(y.shift())), (P.style = P.modElem.style);
        for (p = e.length, d = 0; p > d; d++)
            if (((g = e[d]), (v = P.style[g]), a(g, "-") && (g = l(g)), P.style[g] !== n)) {
                if (o || i(r, "undefined")) return u(), "pfx" != t || g;
                try {
                    P.style[g] = r;
                } catch (e) {}
                if (P.style[g] != v) return u(), "pfx" != t || g;
            }
        return u(), !1;
    }
    function v(e, t, n, r, o) {
        var s = e.charAt(0).toUpperCase() + e.slice(1),
            a = (e + " " + j.join(s + " ") + s).split(" ");
        return i(t, "string") || i(t, "undefined") ? g(a, t, r, o) : ((a = (e + " " + T.join(s + " ") + s).split(" ")), d(a, t, n));
    }
    function y(e, t, i) {
        return v(e, n, n, t, i);
    }
    var m = [],
        b = [],
        w = {
            _version: "3.3.1",
            _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
            _q: [],
            on: function (e, t) {
                var n = this;
                setTimeout(function () {
                    t(n[e]);
                }, 0);
            },
            addTest: function (e, t, n) {
                b.push({ name: e, fn: t, options: n });
            },
            addAsyncTest: function (e) {
                b.push({ name: null, fn: e });
            },
        },
        x = function () {};
    (x.prototype = w), (x = new x()), x.addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
    var _ = w._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
    w._prefixes = _;
    var k = t.documentElement,
        S = "svg" === k.nodeName.toLowerCase(),
        C = "Moz O ms Webkit",
        T = w._config.usePrefixes ? C.toLowerCase().split(" ") : [];
    w._domPrefixes = T;
    var E = "CSS" in e && "supports" in e.CSS,
        A = "supportsCSS" in e;
    x.addTest("supports", E || A), x.addTest("placeholder", "placeholder" in s("input") && "placeholder" in s("textarea"));
    var j = w._config.usePrefixes ? C.split(" ") : [];
    w._cssomPrefixes = j;
    var D = (w.testStyles = c);
    x.addTest("touchevents", function () {
        var n;
        if ("ontouchstart" in e || (e.DocumentTouch && t instanceof DocumentTouch)) n = !0;
        else {
            var i = ["@media (", _.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
            D(i, function (e) {
                n = 9 === e.offsetTop;
            });
        }
        return n;
    });
    var L = { elem: s("modernizr") };
    x._q.push(function () {
        delete L.elem;
    });
    var P = { style: L.elem.style };
    x._q.unshift(function () {
        delete P.style;
    }),
        (w.testProp = function (e, t, i) {
            return g([e], n, t, i);
        }),
        (w.testAllProps = v),
        (w.testAllProps = y),
        x.addTest("csstransforms", function () {
            return -1 === navigator.userAgent.indexOf("Android 2.") && y("transform", "scale(1)", !0);
        }),
        x.addTest("csstransforms3d", function () {
            var e = !!y("perspective", "1px", !0),
                t = x._config.usePrefixes;
            if (e && (!t || "webkitPerspective" in k.style)) {
                var n,
                    i = "#modernizr{width:0;height:0}";
                x.supports ? (n = "@supports (perspective: 1px)") : ((n = "@media (transform-3d)"), t && (n += ",(-webkit-transform-3d)")),
                    (n += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}"),
                    D(i + n, function (t) {
                        e = 7 === t.offsetWidth && 18 === t.offsetHeight;
                    });
            }
            return e;
        }),
        x.addTest("flexbox", y("flexBasis", "1px", !0)),
        r(),
        o(m),
        delete w.addTest,
        delete w.addAsyncTest;
    for (var $ = 0; $ < x._q.length; $++) x._q[$]();
    e.Modernizr = x;
})(window, document),
    function () {
        function e(e, t, n) {
            switch (n.length) {
                case 0:
                    return e.call(t);
                case 1:
                    return e.call(t, n[0]);
                case 2:
                    return e.call(t, n[0], n[1]);
                case 3:
                    return e.call(t, n[0], n[1], n[2]);
            }
            return e.apply(t, n);
        }
        function t(e, t, n, i) {
            for (var r = -1, o = null == e ? 0 : e.length; ++r < o; ) {
                var s = e[r];
                t(i, s, n(s), e);
            }
            return i;
        }
        function n(e, t) {
            for (var n = -1, i = null == e ? 0 : e.length; ++n < i && !1 !== t(e[n], n, e); );
            return e;
        }
        function i(e, t) {
            for (var n = null == e ? 0 : e.length; n-- && !1 !== t(e[n], n, e); );
            return e;
        }
        function r(e, t) {
            for (var n = -1, i = null == e ? 0 : e.length; ++n < i; ) if (!t(e[n], n, e)) return !1;
            return !0;
        }
        function o(e, t) {
            for (var n = -1, i = null == e ? 0 : e.length, r = 0, o = []; ++n < i; ) {
                var s = e[n];
                t(s, n, e) && (o[r++] = s);
            }
            return o;
        }
        function s(e, t) {
            return !(null == e || !e.length) && -1 < g(e, t, 0);
        }
        function a(e, t, n) {
            for (var i = -1, r = null == e ? 0 : e.length; ++i < r; ) if (n(t, e[i])) return !0;
            return !1;
        }
        function l(e, t) {
            for (var n = -1, i = null == e ? 0 : e.length, r = Array(i); ++n < i; ) r[n] = t(e[n], n, e);
            return r;
        }
        function u(e, t) {
            for (var n = -1, i = t.length, r = e.length; ++n < i; ) e[r + n] = t[n];
            return e;
        }
        function c(e, t, n, i) {
            var r = -1,
                o = null == e ? 0 : e.length;
            for (i && o && (n = e[++r]); ++r < o; ) n = t(n, e[r], r, e);
            return n;
        }
        function f(e, t, n, i) {
            var r = null == e ? 0 : e.length;
            for (i && r && (n = e[--r]); r--; ) n = t(n, e[r], r, e);
            return n;
        }
        function d(e, t) {
            for (var n = -1, i = null == e ? 0 : e.length; ++n < i; ) if (t(e[n], n, e)) return !0;
            return !1;
        }
        function p(e, t, n) {
            var i;
            return (
                n(e, function (e, n, r) {
                    if (t(e, n, r)) return (i = n), !1;
                }),
                i
            );
        }
        function h(e, t, n, i) {
            var r = e.length;
            for (n += i ? 1 : -1; i ? n-- : ++n < r; ) if (t(e[n], n, e)) return n;
            return -1;
        }
        function g(e, t, n) {
            if (t === t)
                e: {
                    --n;
                    for (var i = e.length; ++n < i; )
                        if (e[n] === t) {
                            e = n;
                            break e;
                        }
                    e = -1;
                }
            else e = h(e, y, n);
            return e;
        }
        function v(e, t, n, i) {
            --n;
            for (var r = e.length; ++n < r; ) if (i(e[n], t)) return n;
            return -1;
        }
        function y(e) {
            return e !== e;
        }
        function m(e, t) {
            var n = null == e ? 0 : e.length;
            return n ? k(e, t) / n : H;
        }
        function b(e) {
            return function (t) {
                return null == t ? R : t[e];
            };
        }
        function w(e) {
            return function (t) {
                return null == e ? R : e[t];
            };
        }
        function x(e, t, n, i, r) {
            return (
                r(e, function (e, r, o) {
                    n = i ? ((i = !1), e) : t(n, e, r, o);
                }),
                n
            );
        }
        function _(e, t) {
            var n = e.length;
            for (e.sort(t); n--; ) e[n] = e[n].c;
            return e;
        }
        function k(e, t) {
            for (var n, i = -1, r = e.length; ++i < r; ) {
                var o = t(e[i]);
                o !== R && (n = n === R ? o : n + o);
            }
            return n;
        }
        function S(e, t) {
            for (var n = -1, i = Array(e); ++n < e; ) i[n] = t(n);
            return i;
        }
        function C(e, t) {
            return l(t, function (t) {
                return [t, e[t]];
            });
        }
        function T(e) {
            return function (t) {
                return e(t);
            };
        }
        function E(e, t) {
            return l(t, function (t) {
                return e[t];
            });
        }
        function A(e, t) {
            return e.has(t);
        }
        function j(e, t) {
            for (var n = -1, i = e.length; ++n < i && -1 < g(t, e[n], 0); );
            return n;
        }
        function D(e, t) {
            for (var n = e.length; n-- && -1 < g(t, e[n], 0); );
            return n;
        }
        function L(e) {
            return "\\" + ze[e];
        }
        function P(e) {
            var t = -1,
                n = Array(e.size);
            return (
                e.forEach(function (e, i) {
                    n[++t] = [i, e];
                }),
                n
            );
        }
        function $(e, t) {
            return function (n) {
                return e(t(n));
            };
        }
        function z(e, t) {
            for (var n = -1, i = e.length, r = 0, o = []; ++n < i; ) {
                var s = e[n];
                (s !== t && "__lodash_placeholder__" !== s) || ((e[n] = "__lodash_placeholder__"), (o[r++] = n));
            }
            return o;
        }
        function O(e) {
            var t = -1,
                n = Array(e.size);
            return (
                e.forEach(function (e) {
                    n[++t] = e;
                }),
                n
            );
        }
        function I(e) {
            var t = -1,
                n = Array(e.size);
            return (
                e.forEach(function (e) {
                    n[++t] = [e, e];
                }),
                n
            );
        }
        function N(e) {
            if (je.test(e)) {
                for (var t = (Ee.lastIndex = 0); Ee.test(e); ) ++t;
                e = t;
            } else e = Ze(e);
            return e;
        }
        function M(e) {
            return je.test(e) ? e.match(Ee) || [] : e.split("");
        }
        var R,
            q = 1 / 0,
            H = NaN,
            W = [
                ["ary", 128],
                ["bind", 1],
                ["bindKey", 2],
                ["curry", 8],
                ["curryRight", 16],
                ["flip", 512],
                ["partial", 32],
                ["partialRight", 64],
                ["rearg", 256],
            ],
            F = /\b__p\+='';/g,
            U = /\b(__p\+=)''\+/g,
            B = /(__e\(.*?\)|\b__t\))\+'';/g,
            X = /&(?:amp|lt|gt|quot|#39);/g,
            V = /[&<>"']/g,
            G = RegExp(X.source),
            Q = RegExp(V.source),
            Y = /<%-([\s\S]+?)%>/g,
            Z = /<%([\s\S]+?)%>/g,
            J = /<%=([\s\S]+?)%>/g,
            K = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            ee = /^\w*$/,
            te = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            ne = /[\\^$.*+?()[\]{}|]/g,
            ie = RegExp(ne.source),
            re = /^\s+|\s+$/g,
            oe = /^\s+/,
            se = /\s+$/,
            ae = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
            le = /\{\n\/\* \[wrapped with (.+)\] \*/,
            ue = /,? & /,
            ce = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
            fe = /\\(\\)?/g,
            de = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
            pe = /\w*$/,
            he = /^[-+]0x[0-9a-f]+$/i,
            ge = /^0b[01]+$/i,
            ve = /^\[object .+?Constructor\]$/,
            ye = /^0o[0-7]+$/i,
            me = /^(?:0|[1-9]\d*)$/,
            be = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
            we = /($^)/,
            xe = /['\n\r\u2028\u2029\\]/g,
            _e =
                "[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",
            ke = "(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])" + _e,
            Se = "(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",
            Ce = RegExp("['’]", "g"),
            Te = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g"),
            Ee = RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|" + Se + _e, "g"),
            Ae = RegExp(
                [
                    "[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])|\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])|\\d+",
                    ke,
                ].join("|"),
                "g"
            ),
            je = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),
            De = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
            Le = "Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(
                " "
            ),
            Pe = {};
        (Pe["[object Float32Array]"] = Pe["[object Float64Array]"] = Pe["[object Int8Array]"] = Pe["[object Int16Array]"] = Pe["[object Int32Array]"] = Pe["[object Uint8Array]"] = Pe["[object Uint8ClampedArray]"] = Pe[
            "[object Uint16Array]"
        ] = Pe["[object Uint32Array]"] = !0),
            (Pe["[object Arguments]"] = Pe["[object Array]"] = Pe["[object ArrayBuffer]"] = Pe["[object Boolean]"] = Pe["[object DataView]"] = Pe["[object Date]"] = Pe["[object Error]"] = Pe["[object Function]"] = Pe["[object Map]"] = Pe[
                "[object Number]"
            ] = Pe["[object Object]"] = Pe["[object RegExp]"] = Pe["[object Set]"] = Pe["[object String]"] = Pe["[object WeakMap]"] = !1);
        var $e = {};
        ($e["[object Arguments]"] = $e["[object Array]"] = $e["[object ArrayBuffer]"] = $e["[object DataView]"] = $e["[object Boolean]"] = $e["[object Date]"] = $e["[object Float32Array]"] = $e["[object Float64Array]"] = $e[
            "[object Int8Array]"
        ] = $e["[object Int16Array]"] = $e["[object Int32Array]"] = $e["[object Map]"] = $e["[object Number]"] = $e["[object Object]"] = $e["[object RegExp]"] = $e["[object Set]"] = $e["[object String]"] = $e["[object Symbol]"] = $e[
            "[object Uint8Array]"
        ] = $e["[object Uint8ClampedArray]"] = $e["[object Uint16Array]"] = $e["[object Uint32Array]"] = !0),
            ($e["[object Error]"] = $e["[object Function]"] = $e["[object WeakMap]"] = !1);
        var ze = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" },
            Oe = parseFloat,
            Ie = parseInt,
            Ne = "object" == typeof global && global && global.Object === Object && global,
            Me = "object" == typeof self && self && self.Object === Object && self,
            Re = Ne || Me || Function("return this")(),
            qe = "object" == typeof exports && exports && !exports.nodeType && exports,
            He = qe && "object" == typeof module && module && !module.nodeType && module,
            We = He && He.exports === qe,
            Fe = We && Ne.process,
            Ue = (function () {
                try {
                    var e = He && He.f && He.f("util").types;
                    return e ? e : Fe && Fe.binding && Fe.binding("util");
                } catch (e) {}
            })(),
            Be = Ue && Ue.isArrayBuffer,
            Xe = Ue && Ue.isDate,
            Ve = Ue && Ue.isMap,
            Ge = Ue && Ue.isRegExp,
            Qe = Ue && Ue.isSet,
            Ye = Ue && Ue.isTypedArray,
            Ze = b("length"),
            Je = w({
                À: "A",
                Á: "A",
                Â: "A",
                Ã: "A",
                Ä: "A",
                Å: "A",
                à: "a",
                á: "a",
                â: "a",
                ã: "a",
                ä: "a",
                å: "a",
                Ç: "C",
                ç: "c",
                Ð: "D",
                ð: "d",
                È: "E",
                É: "E",
                Ê: "E",
                Ë: "E",
                è: "e",
                é: "e",
                ê: "e",
                ë: "e",
                Ì: "I",
                Í: "I",
                Î: "I",
                Ï: "I",
                ì: "i",
                í: "i",
                î: "i",
                ï: "i",
                Ñ: "N",
                ñ: "n",
                Ò: "O",
                Ó: "O",
                Ô: "O",
                Õ: "O",
                Ö: "O",
                Ø: "O",
                ò: "o",
                ó: "o",
                ô: "o",
                õ: "o",
                ö: "o",
                ø: "o",
                Ù: "U",
                Ú: "U",
                Û: "U",
                Ü: "U",
                ù: "u",
                ú: "u",
                û: "u",
                ü: "u",
                Ý: "Y",
                ý: "y",
                ÿ: "y",
                Æ: "Ae",
                æ: "ae",
                Þ: "Th",
                þ: "th",
                ß: "ss",
                Ā: "A",
                Ă: "A",
                Ą: "A",
                ā: "a",
                ă: "a",
                ą: "a",
                Ć: "C",
                Ĉ: "C",
                Ċ: "C",
                Č: "C",
                ć: "c",
                ĉ: "c",
                ċ: "c",
                č: "c",
                Ď: "D",
                Đ: "D",
                ď: "d",
                đ: "d",
                Ē: "E",
                Ĕ: "E",
                Ė: "E",
                Ę: "E",
                Ě: "E",
                ē: "e",
                ĕ: "e",
                ė: "e",
                ę: "e",
                ě: "e",
                Ĝ: "G",
                Ğ: "G",
                Ġ: "G",
                Ģ: "G",
                ĝ: "g",
                ğ: "g",
                ġ: "g",
                ģ: "g",
                Ĥ: "H",
                Ħ: "H",
                ĥ: "h",
                ħ: "h",
                Ĩ: "I",
                Ī: "I",
                Ĭ: "I",
                Į: "I",
                İ: "I",
                ĩ: "i",
                ī: "i",
                ĭ: "i",
                į: "i",
                ı: "i",
                Ĵ: "J",
                ĵ: "j",
                Ķ: "K",
                ķ: "k",
                ĸ: "k",
                Ĺ: "L",
                Ļ: "L",
                Ľ: "L",
                Ŀ: "L",
                Ł: "L",
                ĺ: "l",
                ļ: "l",
                ľ: "l",
                ŀ: "l",
                ł: "l",
                Ń: "N",
                Ņ: "N",
                Ň: "N",
                Ŋ: "N",
                ń: "n",
                ņ: "n",
                ň: "n",
                ŋ: "n",
                Ō: "O",
                Ŏ: "O",
                Ő: "O",
                ō: "o",
                ŏ: "o",
                ő: "o",
                Ŕ: "R",
                Ŗ: "R",
                Ř: "R",
                ŕ: "r",
                ŗ: "r",
                ř: "r",
                Ś: "S",
                Ŝ: "S",
                Ş: "S",
                Š: "S",
                ś: "s",
                ŝ: "s",
                ş: "s",
                š: "s",
                Ţ: "T",
                Ť: "T",
                Ŧ: "T",
                ţ: "t",
                ť: "t",
                ŧ: "t",
                Ũ: "U",
                Ū: "U",
                Ŭ: "U",
                Ů: "U",
                Ű: "U",
                Ų: "U",
                ũ: "u",
                ū: "u",
                ŭ: "u",
                ů: "u",
                ű: "u",
                ų: "u",
                Ŵ: "W",
                ŵ: "w",
                Ŷ: "Y",
                ŷ: "y",
                Ÿ: "Y",
                Ź: "Z",
                Ż: "Z",
                Ž: "Z",
                ź: "z",
                ż: "z",
                ž: "z",
                Ĳ: "IJ",
                ĳ: "ij",
                Œ: "Oe",
                œ: "oe",
                ŉ: "'n",
                ſ: "s",
            }),
            Ke = w({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }),
            et = w({ "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }),
            tt = (function w(_e) {
                function ke(e) {
                    if (yr(e) && !oa(e) && !(e instanceof ze)) {
                        if (e instanceof Ee) return e;
                        if (oo.call(e, "__wrapped__")) return qi(e);
                    }
                    return new Ee(e);
                }
                function Se() {}
                function Ee(e, t) {
                    (this.__wrapped__ = e), (this.__actions__ = []), (this.__chain__ = !!t), (this.__index__ = 0), (this.__values__ = R);
                }
                function ze(e) {
                    (this.__wrapped__ = e), (this.__actions__ = []), (this.__dir__ = 1), (this.__filtered__ = !1), (this.__iteratees__ = []), (this.__takeCount__ = 4294967295), (this.__views__ = []);
                }
                function Ne(e) {
                    var t = -1,
                        n = null == e ? 0 : e.length;
                    for (this.clear(); ++t < n; ) {
                        var i = e[t];
                        this.set(i[0], i[1]);
                    }
                }
                function Me(e) {
                    var t = -1,
                        n = null == e ? 0 : e.length;
                    for (this.clear(); ++t < n; ) {
                        var i = e[t];
                        this.set(i[0], i[1]);
                    }
                }
                function qe(e) {
                    var t = -1,
                        n = null == e ? 0 : e.length;
                    for (this.clear(); ++t < n; ) {
                        var i = e[t];
                        this.set(i[0], i[1]);
                    }
                }
                function He(e) {
                    var t = -1,
                        n = null == e ? 0 : e.length;
                    for (this.__data__ = new qe(); ++t < n; ) this.add(e[t]);
                }
                function Fe(e) {
                    this.size = (this.__data__ = new Me(e)).size;
                }
                function Ue(e, t) {
                    var n,
                        i = oa(e),
                        r = !i && ra(e),
                        o = !i && !r && aa(e),
                        s = !i && !r && !o && da(e),
                        r = (i = i || r || o || s) ? S(e.length, Kr) : [],
                        a = r.length;
                    for (n in e) (!t && !oo.call(e, n)) || (i && ("length" == n || (o && ("offset" == n || "parent" == n)) || (s && ("buffer" == n || "byteLength" == n || "byteOffset" == n)) || Ei(n, a))) || r.push(n);
                    return r;
                }
                function Ze(e) {
                    var t = e.length;
                    return t ? e[on(0, t - 1)] : R;
                }
                function nt(e, t) {
                    return Ii(On(e), dt(t, 0, e.length));
                }
                function it(e) {
                    return Ii(On(e));
                }
                function rt(e, t, n) {
                    ((n === R || ur(e[t], n)) && (n !== R || t in e)) || ct(e, t, n);
                }
                function ot(e, t, n) {
                    var i = e[t];
                    (oo.call(e, t) && ur(i, n) && (n !== R || t in e)) || ct(e, t, n);
                }
                function st(e, t) {
                    for (var n = e.length; n--; ) if (ur(e[n][0], t)) return n;
                    return -1;
                }
                function at(e, t, n, i) {
                    return (
                        rs(e, function (e, r, o) {
                            t(i, e, n(e), o);
                        }),
                        i
                    );
                }
                function lt(e, t) {
                    return e && In(t, Lr(t), e);
                }
                function ut(e, t) {
                    return e && In(t, Pr(t), e);
                }
                function ct(e, t, n) {
                    "__proto__" == t && So ? So(e, t, { configurable: !0, enumerable: !0, value: n, writable: !0 }) : (e[t] = n);
                }
                function ft(e, t) {
                    for (var n = -1, i = t.length, r = Xr(i), o = null == e; ++n < i; ) r[n] = o ? R : jr(e, t[n]);
                    return r;
                }
                function dt(e, t, n) {
                    return e === e && (n !== R && (e = e <= n ? e : n), t !== R && (e = e >= t ? e : t)), e;
                }
                function pt(e, t, i, r, o, s) {
                    var a,
                        l = 1 & t,
                        u = 2 & t,
                        c = 4 & t;
                    if ((i && (a = o ? i(e, r, o, s) : i(e)), a !== R)) return a;
                    if (!vr(e)) return e;
                    if ((r = oa(e))) {
                        if (((a = ki(e)), !l)) return On(e, a);
                    } else {
                        var f = gs(e),
                            d = "[object Function]" == f || "[object GeneratorFunction]" == f;
                        if (aa(e)) return jn(e, l);
                        if ("[object Object]" == f || "[object Arguments]" == f || (d && !o)) {
                            if (((a = u || d ? {} : Si(e)), !l)) return u ? Mn(e, ut(a, e)) : Nn(e, lt(a, e));
                        } else {
                            if (!$e[f]) return o ? e : {};
                            a = Ci(e, f, l);
                        }
                    }
                    if ((s || (s = new Fe()), (o = s.get(e)))) return o;
                    if ((s.set(e, a), fa(e)))
                        return (
                            e.forEach(function (n) {
                                a.add(pt(n, t, i, n, e, s));
                            }),
                            a
                        );
                    if (ua(e))
                        return (
                            e.forEach(function (n, r) {
                                a.set(r, pt(n, t, i, r, e, s));
                            }),
                            a
                        );
                    var u = c ? (u ? gi : hi) : u ? Pr : Lr,
                        p = r ? R : u(e);
                    return (
                        n(p || e, function (n, r) {
                            p && ((r = n), (n = e[r])), ot(a, r, pt(n, t, i, r, e, s));
                        }),
                        a
                    );
                }
                function ht(e) {
                    var t = Lr(e);
                    return function (n) {
                        return gt(n, e, t);
                    };
                }
                function gt(e, t, n) {
                    var i = n.length;
                    if (null == e) return !i;
                    for (e = Zr(e); i--; ) {
                        var r = n[i],
                            o = t[r],
                            s = e[r];
                        if ((s === R && !(r in e)) || !o(s)) return !1;
                    }
                    return !0;
                }
                function vt(e, t, n) {
                    if ("function" != typeof e) throw new eo("Expected a function");
                    return ms(function () {
                        e.apply(R, n);
                    }, t);
                }
                function yt(e, t, n, i) {
                    var r = -1,
                        o = s,
                        u = !0,
                        c = e.length,
                        f = [],
                        d = t.length;
                    if (!c) return f;
                    n && (t = l(t, T(n))), i ? ((o = a), (u = !1)) : 200 <= t.length && ((o = A), (u = !1), (t = new He(t)));
                    e: for (; ++r < c; ) {
                        var p = e[r],
                            h = null == n ? p : n(p),
                            p = i || 0 !== p ? p : 0;
                        if (u && h === h) {
                            for (var g = d; g--; ) if (t[g] === h) continue e;
                            f.push(p);
                        } else o(t, h, i) || f.push(p);
                    }
                    return f;
                }
                function mt(e, t) {
                    var n = !0;
                    return (
                        rs(e, function (e, i, r) {
                            return (n = !!t(e, i, r));
                        }),
                        n
                    );
                }
                function bt(e, t, n) {
                    for (var i = -1, r = e.length; ++i < r; ) {
                        var o = e[i],
                            s = t(o);
                        if (null != s && (a === R ? s === s && !xr(s) : n(s, a)))
                            var a = s,
                                l = o;
                    }
                    return l;
                }
                function wt(e, t) {
                    var n = [];
                    return (
                        rs(e, function (e, i, r) {
                            t(e, i, r) && n.push(e);
                        }),
                        n
                    );
                }
                function xt(e, t, n, i, r) {
                    var o = -1,
                        s = e.length;
                    for (n || (n = Ti), r || (r = []); ++o < s; ) {
                        var a = e[o];
                        0 < t && n(a) ? (1 < t ? xt(a, t - 1, n, i, r) : u(r, a)) : i || (r[r.length] = a);
                    }
                    return r;
                }
                function _t(e, t) {
                    return e && ss(e, t, Lr);
                }
                function kt(e, t) {
                    return e && as(e, t, Lr);
                }
                function St(e, t) {
                    return o(t, function (t) {
                        return pr(e[t]);
                    });
                }
                function Ct(e, t) {
                    t = En(t, e);
                    for (var n = 0, i = t.length; null != e && n < i; ) e = e[Ni(t[n++])];
                    return n && n == i ? e : R;
                }
                function Tt(e, t, n) {
                    return (t = t(e)), oa(e) ? t : u(t, n(e));
                }
                function Et(e) {
                    if (null == e) e = e === R ? "[object Undefined]" : "[object Null]";
                    else if (ko && ko in Zr(e)) {
                        var t = oo.call(e, ko),
                            n = e[ko];
                        try {
                            e[ko] = R;
                            var i = !0;
                        } catch (e) {}
                        var r = lo.call(e);
                        i && (t ? (e[ko] = n) : delete e[ko]), (e = r);
                    } else e = lo.call(e);
                    return e;
                }
                function At(e, t) {
                    return e > t;
                }
                function jt(e, t) {
                    return null != e && oo.call(e, t);
                }
                function Dt(e, t) {
                    return null != e && t in Zr(e);
                }
                function Lt(e, t, n) {
                    for (var i = n ? a : s, r = e[0].length, o = e.length, u = o, c = Xr(o), f = 1 / 0, d = []; u--; ) {
                        var p = e[u];
                        u && t && (p = l(p, T(t))), (f = Io(p.length, f)), (c[u] = !n && (t || (120 <= r && 120 <= p.length)) ? new He(u && p) : R);
                    }
                    var p = e[0],
                        h = -1,
                        g = c[0];
                    e: for (; ++h < r && d.length < f; ) {
                        var v = p[h],
                            y = t ? t(v) : v,
                            v = n || 0 !== v ? v : 0;
                        if (g ? !A(g, y) : !i(d, y, n)) {
                            for (u = o; --u; ) {
                                var m = c[u];
                                if (m ? !A(m, y) : !i(e[u], y, n)) continue e;
                            }
                            g && g.push(y), d.push(v);
                        }
                    }
                    return d;
                }
                function Pt(e, t, n) {
                    var i = {};
                    return (
                        _t(e, function (e, r, o) {
                            t(i, n(e), r, o);
                        }),
                        i
                    );
                }
                function $t(t, n, i) {
                    return (n = En(n, t)), (t = 2 > n.length ? t : Ct(t, dn(n, 0, -1))), (n = null == t ? t : t[Ni(Bi(n))]), null == n ? R : e(n, t, i);
                }
                function zt(e) {
                    return yr(e) && "[object Arguments]" == Et(e);
                }
                function Ot(e) {
                    return yr(e) && "[object ArrayBuffer]" == Et(e);
                }
                function It(e) {
                    return yr(e) && "[object Date]" == Et(e);
                }
                function Nt(e, t, n, i, r) {
                    if (e === t) t = !0;
                    else if (null == e || null == t || (!yr(e) && !yr(t))) t = e !== e && t !== t;
                    else
                        e: {
                            var o = oa(e),
                                s = oa(t),
                                a = o ? "[object Array]" : gs(e),
                                l = s ? "[object Array]" : gs(t),
                                a = "[object Arguments]" == a ? "[object Object]" : a,
                                l = "[object Arguments]" == l ? "[object Object]" : l,
                                u = "[object Object]" == a,
                                s = "[object Object]" == l;
                            if ((l = a == l) && aa(e)) {
                                if (!aa(t)) {
                                    t = !1;
                                    break e;
                                }
                                (o = !0), (u = !1);
                            }
                            if (l && !u) r || (r = new Fe()), (t = o || da(e) ? fi(e, t, n, i, Nt, r) : di(e, t, a, n, i, Nt, r));
                            else {
                                if (!(1 & n) && ((o = u && oo.call(e, "__wrapped__")), (a = s && oo.call(t, "__wrapped__")), o || a)) {
                                    (e = o ? e.value() : e), (t = a ? t.value() : t), r || (r = new Fe()), (t = Nt(e, t, n, i, r));
                                    break e;
                                }
                                if (l)
                                    t: if ((r || (r = new Fe()), (o = 1 & n), (a = hi(e)), (s = a.length), (l = hi(t).length), s == l || o)) {
                                        for (u = s; u--; ) {
                                            var c = a[u];
                                            if (!(o ? c in t : oo.call(t, c))) {
                                                t = !1;
                                                break t;
                                            }
                                        }
                                        if ((l = r.get(e)) && r.get(t)) t = l == t;
                                        else {
                                            (l = !0), r.set(e, t), r.set(t, e);
                                            for (var f = o; ++u < s; ) {
                                                var c = a[u],
                                                    d = e[c],
                                                    p = t[c];
                                                if (i) var h = o ? i(p, d, c, t, e, r) : i(d, p, c, e, t, r);
                                                if (h === R ? d !== p && !Nt(d, p, n, i, r) : !h) {
                                                    l = !1;
                                                    break;
                                                }
                                                f || (f = "constructor" == c);
                                            }
                                            l &&
                                                !f &&
                                                ((n = e.constructor),
                                                (i = t.constructor),
                                                n != i && "constructor" in e && "constructor" in t && !("function" == typeof n && n instanceof n && "function" == typeof i && i instanceof i) && (l = !1)),
                                                r.delete(e),
                                                r.delete(t),
                                                (t = l);
                                        }
                                    } else t = !1;
                                else t = !1;
                            }
                        }
                    return t;
                }
                function Mt(e) {
                    return yr(e) && "[object Map]" == gs(e);
                }
                function Rt(e, t, n, i) {
                    var r = n.length,
                        o = r,
                        s = !i;
                    if (null == e) return !o;
                    for (e = Zr(e); r--; ) {
                        var a = n[r];
                        if (s && a[2] ? a[1] !== e[a[0]] : !(a[0] in e)) return !1;
                    }
                    for (; ++r < o; ) {
                        var a = n[r],
                            l = a[0],
                            u = e[l],
                            c = a[1];
                        if (s && a[2]) {
                            if (u === R && !(l in e)) return !1;
                        } else {
                            if (((a = new Fe()), i)) var f = i(u, c, l, e, t, a);
                            if (f === R ? !Nt(c, u, 3, i, a) : !f) return !1;
                        }
                    }
                    return !0;
                }
                function qt(e) {
                    return !(!vr(e) || (ao && ao in e)) && (pr(e) ? fo : ve).test(Mi(e));
                }
                function Ht(e) {
                    return yr(e) && "[object RegExp]" == Et(e);
                }
                function Wt(e) {
                    return yr(e) && "[object Set]" == gs(e);
                }
                function Ft(e) {
                    return yr(e) && gr(e.length) && !!Pe[Et(e)];
                }
                function Ut(e) {
                    return "function" == typeof e ? e : null == e ? Rr : "object" == typeof e ? (oa(e) ? Qt(e[0], e[1]) : Gt(e)) : Fr(e);
                }
                function Bt(e) {
                    if (!Li(e)) return zo(e);
                    var t,
                        n = [];
                    for (t in Zr(e)) oo.call(e, t) && "constructor" != t && n.push(t);
                    return n;
                }
                function Xt(e, t) {
                    return e < t;
                }
                function Vt(e, t) {
                    var n = -1,
                        i = cr(e) ? Xr(e.length) : [];
                    return (
                        rs(e, function (e, r, o) {
                            i[++n] = t(e, r, o);
                        }),
                        i
                    );
                }
                function Gt(e) {
                    var t = wi(e);
                    return 1 == t.length && t[0][2]
                        ? Pi(t[0][0], t[0][1])
                        : function (n) {
                              return n === e || Rt(n, e, t);
                          };
                }
                function Qt(e, t) {
                    return ji(e) && t === t && !vr(t)
                        ? Pi(Ni(e), t)
                        : function (n) {
                              var i = jr(n, e);
                              return i === R && i === t ? Dr(n, e) : Nt(t, i, 3);
                          };
                }
                function Yt(e, t, n, i, r) {
                    e !== t &&
                        ss(
                            t,
                            function (o, s) {
                                if (vr(o)) {
                                    r || (r = new Fe());
                                    var a = r,
                                        l = "__proto__" == s ? R : e[s],
                                        u = "__proto__" == s ? R : t[s],
                                        c = a.get(u);
                                    if (c) rt(e, s, c);
                                    else {
                                        var c = i ? i(l, u, s + "", e, t, a) : R,
                                            f = c === R;
                                        if (f) {
                                            var d = oa(u),
                                                p = !d && aa(u),
                                                h = !d && !p && da(u),
                                                c = u;
                                            d || p || h
                                                ? oa(l)
                                                    ? (c = l)
                                                    : fr(l)
                                                    ? (c = On(l))
                                                    : p
                                                    ? ((f = !1), (c = jn(u, !0)))
                                                    : h
                                                    ? ((f = !1), (c = Ln(u, !0)))
                                                    : (c = [])
                                                : br(u) || ra(u)
                                                ? ((c = l), ra(l) ? (c = Er(l)) : (!vr(l) || (n && pr(l))) && (c = Si(u)))
                                                : (f = !1);
                                        }
                                        f && (a.set(u, c), Yt(c, u, n, i, a), a.delete(u)), rt(e, s, c);
                                    }
                                } else (a = i ? i("__proto__" == s ? R : e[s], o, s + "", e, t, r) : R), a === R && (a = o), rt(e, s, a);
                            },
                            Pr
                        );
                }
                function Zt(e, t) {
                    var n = e.length;
                    if (n) return (t += 0 > t ? n : 0), Ei(t, n) ? e[t] : R;
                }
                function Jt(e, t, n) {
                    var i = -1;
                    return (
                        (t = l(t.length ? t : [Rr], T(mi()))),
                        (e = Vt(e, function (e) {
                            return {
                                a: l(t, function (t) {
                                    return t(e);
                                }),
                                b: ++i,
                                c: e,
                            };
                        })),
                        _(e, function (e, t) {
                            var i;
                            e: {
                                i = -1;
                                for (var r = e.a, o = t.a, s = r.length, a = n.length; ++i < s; ) {
                                    var l = Pn(r[i], o[i]);
                                    if (l) {
                                        i = i >= a ? l : l * ("desc" == n[i] ? -1 : 1);
                                        break e;
                                    }
                                }
                                i = e.b - t.b;
                            }
                            return i;
                        })
                    );
                }
                function Kt(e, t) {
                    return en(e, t, function (t, n) {
                        return Dr(e, n);
                    });
                }
                function en(e, t, n) {
                    for (var i = -1, r = t.length, o = {}; ++i < r; ) {
                        var s = t[i],
                            a = Ct(e, s);
                        n(a, s) && cn(o, En(s, e), a);
                    }
                    return o;
                }
                function tn(e) {
                    return function (t) {
                        return Ct(t, e);
                    };
                }
                function nn(e, t, n, i) {
                    var r = i ? v : g,
                        o = -1,
                        s = t.length,
                        a = e;
                    for (e === t && (t = On(t)), n && (a = l(e, T(n))); ++o < s; ) for (var u = 0, c = t[o], c = n ? n(c) : c; -1 < (u = r(a, c, u, i)); ) a !== e && wo.call(a, u, 1), wo.call(e, u, 1);
                    return e;
                }
                function rn(e, t) {
                    for (var n = e ? t.length : 0, i = n - 1; n--; ) {
                        var r = t[n];
                        if (n == i || r !== o) {
                            var o = r;
                            Ei(r) ? wo.call(e, r, 1) : wn(e, r);
                        }
                    }
                }
                function on(e, t) {
                    return e + jo(Ro() * (t - e + 1));
                }
                function sn(e, t) {
                    var n = "";
                    if (!e || 1 > t || 9007199254740991 < t) return n;
                    do t % 2 && (n += e), (t = jo(t / 2)) && (e += e);
                    while (t);
                    return n;
                }
                function an(e, t) {
                    return bs($i(e, t, Rr), e + "");
                }
                function ln(e) {
                    return Ze(zr(e));
                }
                function un(e, t) {
                    var n = zr(e);
                    return Ii(n, dt(t, 0, n.length));
                }
                function cn(e, t, n, i) {
                    if (!vr(e)) return e;
                    t = En(t, e);
                    for (var r = -1, o = t.length, s = o - 1, a = e; null != a && ++r < o; ) {
                        var l = Ni(t[r]),
                            u = n;
                        if (r != s) {
                            var c = a[l],
                                u = i ? i(c, l, a) : R;
                            u === R && (u = vr(c) ? c : Ei(t[r + 1]) ? [] : {});
                        }
                        ot(a, l, u), (a = a[l]);
                    }
                    return e;
                }
                function fn(e) {
                    return Ii(zr(e));
                }
                function dn(e, t, n) {
                    var i = -1,
                        r = e.length;
                    for (0 > t && (t = -t > r ? 0 : r + t), n = n > r ? r : n, 0 > n && (n += r), r = t > n ? 0 : (n - t) >>> 0, t >>>= 0, n = Xr(r); ++i < r; ) n[i] = e[i + t];
                    return n;
                }
                function pn(e, t) {
                    var n;
                    return (
                        rs(e, function (e, i, r) {
                            return (n = t(e, i, r)), !n;
                        }),
                        !!n
                    );
                }
                function hn(e, t, n) {
                    var i = 0,
                        r = null == e ? i : e.length;
                    if ("number" == typeof t && t === t && 2147483647 >= r) {
                        for (; i < r; ) {
                            var o = (i + r) >>> 1,
                                s = e[o];
                            null !== s && !xr(s) && (n ? s <= t : s < t) ? (i = o + 1) : (r = o);
                        }
                        return r;
                    }
                    return gn(e, t, Rr, n);
                }
                function gn(e, t, n, i) {
                    t = n(t);
                    for (var r = 0, o = null == e ? 0 : e.length, s = t !== t, a = null === t, l = xr(t), u = t === R; r < o; ) {
                        var c = jo((r + o) / 2),
                            f = n(e[c]),
                            d = f !== R,
                            p = null === f,
                            h = f === f,
                            g = xr(f);
                        (s ? i || h : u ? h && (i || d) : a ? h && d && (i || !p) : l ? h && d && !p && (i || !g) : p || g ? 0 : i ? f <= t : f < t) ? (r = c + 1) : (o = c);
                    }
                    return Io(o, 4294967294);
                }
                function vn(e, t) {
                    for (var n = -1, i = e.length, r = 0, o = []; ++n < i; ) {
                        var s = e[n],
                            a = t ? t(s) : s;
                        if (!n || !ur(a, l)) {
                            var l = a;
                            o[r++] = 0 === s ? 0 : s;
                        }
                    }
                    return o;
                }
                function yn(e) {
                    return "number" == typeof e ? e : xr(e) ? H : +e;
                }
                function mn(e) {
                    if ("string" == typeof e) return e;
                    if (oa(e)) return l(e, mn) + "";
                    if (xr(e)) return ns ? ns.call(e) : "";
                    var t = e + "";
                    return "0" == t && 1 / e == -q ? "-0" : t;
                }
                function bn(e, t, n) {
                    var i = -1,
                        r = s,
                        o = e.length,
                        l = !0,
                        u = [],
                        c = u;
                    if (n) (l = !1), (r = a);
                    else if (200 <= o) {
                        if ((r = t ? null : fs(e))) return O(r);
                        (l = !1), (r = A), (c = new He());
                    } else c = t ? [] : u;
                    e: for (; ++i < o; ) {
                        var f = e[i],
                            d = t ? t(f) : f,
                            f = n || 0 !== f ? f : 0;
                        if (l && d === d) {
                            for (var p = c.length; p--; ) if (c[p] === d) continue e;
                            t && c.push(d), u.push(f);
                        } else r(c, d, n) || (c !== u && c.push(d), u.push(f));
                    }
                    return u;
                }
                function wn(e, t) {
                    return (t = En(t, e)), (e = 2 > t.length ? e : Ct(e, dn(t, 0, -1))), null == e || delete e[Ni(Bi(t))];
                }
                function xn(e, t, n, i) {
                    for (var r = e.length, o = i ? r : -1; (i ? o-- : ++o < r) && t(e[o], o, e); );
                    return n ? dn(e, i ? 0 : o, i ? o + 1 : r) : dn(e, i ? o + 1 : 0, i ? r : o);
                }
                function _n(e, t) {
                    var n = e;
                    return (
                        n instanceof ze && (n = n.value()),
                        c(
                            t,
                            function (e, t) {
                                return t.func.apply(t.thisArg, u([e], t.args));
                            },
                            n
                        )
                    );
                }
                function kn(e, t, n) {
                    var i = e.length;
                    if (2 > i) return i ? bn(e[0]) : [];
                    for (var r = -1, o = Xr(i); ++r < i; ) for (var s = e[r], a = -1; ++a < i; ) a != r && (o[r] = yt(o[r] || s, e[a], t, n));
                    return bn(xt(o, 1), t, n);
                }
                function Sn(e, t, n) {
                    for (var i = -1, r = e.length, o = t.length, s = {}; ++i < r; ) n(s, e[i], i < o ? t[i] : R);
                    return s;
                }
                function Cn(e) {
                    return fr(e) ? e : [];
                }
                function Tn(e) {
                    return "function" == typeof e ? e : Rr;
                }
                function En(e, t) {
                    return oa(e) ? e : ji(e, t) ? [e] : ws(Ar(e));
                }
                function An(e, t, n) {
                    var i = e.length;
                    return (n = n === R ? i : n), !t && n >= i ? e : dn(e, t, n);
                }
                function jn(e, t) {
                    if (t) return e.slice();
                    var n = e.length,
                        n = vo ? vo(n) : new e.constructor(n);
                    return e.copy(n), n;
                }
                function Dn(e) {
                    var t = new e.constructor(e.byteLength);
                    return new go(t).set(new go(e)), t;
                }
                function Ln(e, t) {
                    return new e.constructor(t ? Dn(e.buffer) : e.buffer, e.byteOffset, e.length);
                }
                function Pn(e, t) {
                    if (e !== t) {
                        var n = e !== R,
                            i = null === e,
                            r = e === e,
                            o = xr(e),
                            s = t !== R,
                            a = null === t,
                            l = t === t,
                            u = xr(t);
                        if ((!a && !u && !o && e > t) || (o && s && l && !a && !u) || (i && s && l) || (!n && l) || !r) return 1;
                        if ((!i && !o && !u && e < t) || (u && n && r && !i && !o) || (a && n && r) || (!s && r) || !l) return -1;
                    }
                    return 0;
                }
                function $n(e, t, n, i) {
                    var r = -1,
                        o = e.length,
                        s = n.length,
                        a = -1,
                        l = t.length,
                        u = Oo(o - s, 0),
                        c = Xr(l + u);
                    for (i = !i; ++a < l; ) c[a] = t[a];
                    for (; ++r < s; ) (i || r < o) && (c[n[r]] = e[r]);
                    for (; u--; ) c[a++] = e[r++];
                    return c;
                }
                function zn(e, t, n, i) {
                    var r = -1,
                        o = e.length,
                        s = -1,
                        a = n.length,
                        l = -1,
                        u = t.length,
                        c = Oo(o - a, 0),
                        f = Xr(c + u);
                    for (i = !i; ++r < c; ) f[r] = e[r];
                    for (c = r; ++l < u; ) f[c + l] = t[l];
                    for (; ++s < a; ) (i || r < o) && (f[c + n[s]] = e[r++]);
                    return f;
                }
                function On(e, t) {
                    var n = -1,
                        i = e.length;
                    for (t || (t = Xr(i)); ++n < i; ) t[n] = e[n];
                    return t;
                }
                function In(e, t, n, i) {
                    var r = !n;
                    n || (n = {});
                    for (var o = -1, s = t.length; ++o < s; ) {
                        var a = t[o],
                            l = i ? i(n[a], e[a], a, n, e) : R;
                        l === R && (l = e[a]), r ? ct(n, a, l) : ot(n, a, l);
                    }
                    return n;
                }
                function Nn(e, t) {
                    return In(e, ps(e), t);
                }
                function Mn(e, t) {
                    return In(e, hs(e), t);
                }
                function Rn(e, n) {
                    return function (i, r) {
                        var o = oa(i) ? t : at,
                            s = n ? n() : {};
                        return o(i, e, mi(r, 2), s);
                    };
                }
                function qn(e) {
                    return an(function (t, n) {
                        var i = -1,
                            r = n.length,
                            o = 1 < r ? n[r - 1] : R,
                            s = 2 < r ? n[2] : R,
                            o = 3 < e.length && "function" == typeof o ? (r--, o) : R;
                        for (s && Ai(n[0], n[1], s) && ((o = 3 > r ? R : o), (r = 1)), t = Zr(t); ++i < r; ) (s = n[i]) && e(t, s, i, o);
                        return t;
                    });
                }
                function Hn(e, t) {
                    return function (n, i) {
                        if (null == n) return n;
                        if (!cr(n)) return e(n, i);
                        for (var r = n.length, o = t ? r : -1, s = Zr(n); (t ? o-- : ++o < r) && !1 !== i(s[o], o, s); );
                        return n;
                    };
                }
                function Wn(e) {
                    return function (t, n, i) {
                        var r = -1,
                            o = Zr(t);
                        i = i(t);
                        for (var s = i.length; s--; ) {
                            var a = i[e ? s : ++r];
                            if (!1 === n(o[a], a, o)) break;
                        }
                        return t;
                    };
                }
                function Fn(e, t, n) {
                    function i() {
                        return (this && this !== Re && this instanceof i ? o : e).apply(r ? n : this, arguments);
                    }
                    var r = 1 & t,
                        o = Xn(e);
                    return i;
                }
                function Un(e) {
                    return function (t) {
                        t = Ar(t);
                        var n = je.test(t) ? M(t) : R,
                            i = n ? n[0] : t.charAt(0);
                        return (t = n ? An(n, 1).join("") : t.slice(1)), i[e]() + t;
                    };
                }
                function Bn(e) {
                    return function (t) {
                        return c(Nr(Ir(t).replace(Ce, "")), e, "");
                    };
                }
                function Xn(e) {
                    return function () {
                        var t = arguments;
                        switch (t.length) {
                            case 0:
                                return new e();
                            case 1:
                                return new e(t[0]);
                            case 2:
                                return new e(t[0], t[1]);
                            case 3:
                                return new e(t[0], t[1], t[2]);
                            case 4:
                                return new e(t[0], t[1], t[2], t[3]);
                            case 5:
                                return new e(t[0], t[1], t[2], t[3], t[4]);
                            case 6:
                                return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
                            case 7:
                                return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                        }
                        var n = is(e.prototype),
                            t = e.apply(n, t);
                        return vr(t) ? t : n;
                    };
                }
                function Vn(t, n, i) {
                    function r() {
                        for (var s = arguments.length, a = Xr(s), l = s, u = yi(r); l--; ) a[l] = arguments[l];
                        return (l = 3 > s && a[0] !== u && a[s - 1] !== u ? [] : z(a, u)), (s -= l.length), s < i ? ri(t, n, Yn, r.placeholder, R, a, l, R, R, i - s) : e(this && this !== Re && this instanceof r ? o : t, this, a);
                    }
                    var o = Xn(t);
                    return r;
                }
                function Gn(e) {
                    return function (t, n, i) {
                        var r = Zr(t);
                        if (!cr(t)) {
                            var o = mi(n, 3);
                            (t = Lr(t)),
                                (n = function (e) {
                                    return o(r[e], e, r);
                                });
                        }
                        return (n = e(t, n, i)), -1 < n ? r[o ? t[n] : n] : R;
                    };
                }
                function Qn(e) {
                    return pi(function (t) {
                        var n = t.length,
                            i = n,
                            r = Ee.prototype.thru;
                        for (e && t.reverse(); i--; ) {
                            var o = t[i];
                            if ("function" != typeof o) throw new eo("Expected a function");
                            if (r && !s && "wrapper" == vi(o)) var s = new Ee([], !0);
                        }
                        for (i = s ? i : n; ++i < n; )
                            var o = t[i], r = vi(o), a = "wrapper" == r ? ds(o) : R, s = a && Di(a[0]) && 424 == a[1] && !a[4].length && 1 == a[9] ? s[vi(a[0])].apply(s, a[3]) : 1 == o.length && Di(o) ? s[r]() : s.thru(o);
                        return function () {
                            var e = arguments,
                                i = e[0];
                            if (s && 1 == e.length && oa(i)) return s.plant(i).value();
                            for (var r = 0, e = n ? t[r].apply(this, e) : i; ++r < n; ) e = t[r].call(this, e);
                            return e;
                        };
                    });
                }
                function Yn(e, t, n, i, r, o, s, a, l, u) {
                    function c() {
                        for (var y = arguments.length, m = Xr(y), b = y; b--; ) m[b] = arguments[b];
                        if (h) {
                            var w,
                                x = yi(c),
                                b = m.length;
                            for (w = 0; b--; ) m[b] === x && ++w;
                        }
                        if ((i && (m = $n(m, i, r, h)), o && (m = zn(m, o, s, h)), (y -= w), h && y < u)) return (x = z(m, x)), ri(e, t, Yn, c.placeholder, n, m, x, a, l, u - y);
                        if (((x = d ? n : this), (b = p ? x[e] : e), (y = m.length), a)) {
                            w = m.length;
                            for (var _ = Io(a.length, w), k = On(m); _--; ) {
                                var S = a[_];
                                m[_] = Ei(S, w) ? k[S] : R;
                            }
                        } else g && 1 < y && m.reverse();
                        return f && l < y && (m.length = l), this && this !== Re && this instanceof c && (b = v || Xn(b)), b.apply(x, m);
                    }
                    var f = 128 & t,
                        d = 1 & t,
                        p = 2 & t,
                        h = 24 & t,
                        g = 512 & t,
                        v = p ? R : Xn(e);
                    return c;
                }
                function Zn(e, t) {
                    return function (n, i) {
                        return Pt(n, e, t(i));
                    };
                }
                function Jn(e, t) {
                    return function (n, i) {
                        var r;
                        if (n === R && i === R) return t;
                        if ((n !== R && (r = n), i !== R)) {
                            if (r === R) return i;
                            "string" == typeof n || "string" == typeof i ? ((n = mn(n)), (i = mn(i))) : ((n = yn(n)), (i = yn(i))), (r = e(n, i));
                        }
                        return r;
                    };
                }
                function Kn(t) {
                    return pi(function (n) {
                        return (
                            (n = l(n, T(mi()))),
                            an(function (i) {
                                var r = this;
                                return t(n, function (t) {
                                    return e(t, r, i);
                                });
                            })
                        );
                    });
                }
                function ei(e, t) {
                    t = t === R ? " " : mn(t);
                    var n = t.length;
                    return 2 > n ? (n ? sn(t, e) : t) : ((n = sn(t, Ao(e / N(t)))), je.test(t) ? An(M(n), 0, e).join("") : n.slice(0, e));
                }
                function ti(t, n, i, r) {
                    function o() {
                        for (var n = -1, l = arguments.length, u = -1, c = r.length, f = Xr(c + l), d = this && this !== Re && this instanceof o ? a : t; ++u < c; ) f[u] = r[u];
                        for (; l--; ) f[u++] = arguments[++n];
                        return e(d, s ? i : this, f);
                    }
                    var s = 1 & n,
                        a = Xn(t);
                    return o;
                }
                function ni(e) {
                    return function (t, n, i) {
                        i && "number" != typeof i && Ai(t, n, i) && (n = i = R), (t = kr(t)), n === R ? ((n = t), (t = 0)) : (n = kr(n)), (i = i === R ? (t < n ? 1 : -1) : kr(i));
                        var r = -1;
                        n = Oo(Ao((n - t) / (i || 1)), 0);
                        for (var o = Xr(n); n--; ) (o[e ? n : ++r] = t), (t += i);
                        return o;
                    };
                }
                function ii(e) {
                    return function (t, n) {
                        return ("string" == typeof t && "string" == typeof n) || ((t = Tr(t)), (n = Tr(n))), e(t, n);
                    };
                }
                function ri(e, t, n, i, r, o, s, a, l, u) {
                    var c = 8 & t,
                        f = c ? s : R;
                    s = c ? R : s;
                    var d = c ? o : R;
                    return (o = c ? R : o), (t = (t | (c ? 32 : 64)) & ~(c ? 64 : 32)), 4 & t || (t &= -4), (r = [e, t, r, d, f, o, s, a, l, u]), (n = n.apply(R, r)), Di(e) && ys(n, r), (n.placeholder = i), zi(n, e, t);
                }
                function oi(e) {
                    var t = Yr[e];
                    return function (e, n) {
                        if (((e = Tr(e)), (n = null == n ? 0 : Io(Sr(n), 292)))) {
                            var i = (Ar(e) + "e").split("e"),
                                i = t(i[0] + "e" + (+i[1] + n)),
                                i = (Ar(i) + "e").split("e");
                            return +(i[0] + "e" + (+i[1] - n));
                        }
                        return t(e);
                    };
                }
                function si(e) {
                    return function (t) {
                        var n = gs(t);
                        return "[object Map]" == n ? P(t) : "[object Set]" == n ? I(t) : C(t, e(t));
                    };
                }
                function ai(e, t, n, i, r, o, s, a) {
                    var l = 2 & t;
                    if (!l && "function" != typeof e) throw new eo("Expected a function");
                    var u = i ? i.length : 0;
                    if ((u || ((t &= -97), (i = r = R)), (s = s === R ? s : Oo(Sr(s), 0)), (a = a === R ? a : Sr(a)), (u -= r ? r.length : 0), 64 & t)) {
                        var c = i,
                            f = r;
                        i = r = R;
                    }
                    var d = l ? R : ds(e);
                    return (
                        (o = [e, t, n, i, r, c, f, o, s, a]),
                        d &&
                            ((n = o[1]), (e = d[1]), (t = n | e), (i = (128 == e && 8 == n) || (128 == e && 256 == n && o[7].length <= d[8]) || (384 == e && d[7].length <= d[8] && 8 == n)), 131 > t || i) &&
                            (1 & e && ((o[2] = d[2]), (t |= 1 & n ? 0 : 4)),
                            (n = d[3]) && ((i = o[3]), (o[3] = i ? $n(i, n, d[4]) : n), (o[4] = i ? z(o[3], "__lodash_placeholder__") : d[4])),
                            (n = d[5]) && ((i = o[5]), (o[5] = i ? zn(i, n, d[6]) : n), (o[6] = i ? z(o[5], "__lodash_placeholder__") : d[6])),
                            (n = d[7]) && (o[7] = n),
                            128 & e && (o[8] = null == o[8] ? d[8] : Io(o[8], d[8])),
                            null == o[9] && (o[9] = d[9]),
                            (o[0] = d[0]),
                            (o[1] = t)),
                        (e = o[0]),
                        (t = o[1]),
                        (n = o[2]),
                        (i = o[3]),
                        (r = o[4]),
                        (a = o[9] = o[9] === R ? (l ? 0 : e.length) : Oo(o[9] - u, 0)),
                        !a && 24 & t && (t &= -25),
                        zi((d ? ls : ys)(t && 1 != t ? (8 == t || 16 == t ? Vn(e, t, a) : (32 != t && 33 != t) || r.length ? Yn.apply(R, o) : ti(e, t, n, i)) : Fn(e, t, n), o), e, t)
                    );
                }
                function li(e, t, n, i) {
                    return e === R || (ur(e, no[n]) && !oo.call(i, n)) ? t : e;
                }
                function ui(e, t, n, i, r, o) {
                    return vr(e) && vr(t) && (o.set(t, e), Yt(e, t, R, ui, o), o.delete(t)), e;
                }
                function ci(e) {
                    return br(e) ? R : e;
                }
                function fi(e, t, n, i, r, o) {
                    var s = 1 & n,
                        a = e.length,
                        l = t.length;
                    if (a != l && !(s && l > a)) return !1;
                    if ((l = o.get(e)) && o.get(t)) return l == t;
                    var l = -1,
                        u = !0,
                        c = 2 & n ? new He() : R;
                    for (o.set(e, t), o.set(t, e); ++l < a; ) {
                        var f = e[l],
                            p = t[l];
                        if (i) var h = s ? i(p, f, l, t, e, o) : i(f, p, l, e, t, o);
                        if (h !== R) {
                            if (h) continue;
                            u = !1;
                            break;
                        }
                        if (c) {
                            if (
                                !d(t, function (e, t) {
                                    if (!A(c, t) && (f === e || r(f, e, n, i, o))) return c.push(t);
                                })
                            ) {
                                u = !1;
                                break;
                            }
                        } else if (f !== p && !r(f, p, n, i, o)) {
                            u = !1;
                            break;
                        }
                    }
                    return o.delete(e), o.delete(t), u;
                }
                function di(e, t, n, i, r, o, s) {
                    switch (n) {
                        case "[object DataView]":
                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) break;
                            (e = e.buffer), (t = t.buffer);
                        case "[object ArrayBuffer]":
                            if (e.byteLength != t.byteLength || !o(new go(e), new go(t))) break;
                            return !0;
                        case "[object Boolean]":
                        case "[object Date]":
                        case "[object Number]":
                            return ur(+e, +t);
                        case "[object Error]":
                            return e.name == t.name && e.message == t.message;
                        case "[object RegExp]":
                        case "[object String]":
                            return e == t + "";
                        case "[object Map]":
                            var a = P;
                        case "[object Set]":
                            if ((a || (a = O), e.size != t.size && !(1 & i))) break;
                            return (n = s.get(e)) ? n == t : ((i |= 2), s.set(e, t), (t = fi(a(e), a(t), i, r, o, s)), s.delete(e), t);
                        case "[object Symbol]":
                            if (ts) return ts.call(e) == ts.call(t);
                    }
                    return !1;
                }
                function pi(e) {
                    return bs($i(e, R, Fi), e + "");
                }
                function hi(e) {
                    return Tt(e, Lr, ps);
                }
                function gi(e) {
                    return Tt(e, Pr, hs);
                }
                function vi(e) {
                    for (var t = e.name + "", n = Go[t], i = oo.call(Go, t) ? n.length : 0; i--; ) {
                        var r = n[i],
                            o = r.func;
                        if (null == o || o == e) return r.name;
                    }
                    return t;
                }
                function yi(e) {
                    return (oo.call(ke, "placeholder") ? ke : e).placeholder;
                }
                function mi() {
                    var e = ke.iteratee || qr,
                        e = e === qr ? Ut : e;
                    return arguments.length ? e(arguments[0], arguments[1]) : e;
                }
                function bi(e, t) {
                    var n = e.__data__,
                        i = typeof t;
                    return ("string" == i || "number" == i || "symbol" == i || "boolean" == i ? "__proto__" !== t : null === t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
                }
                function wi(e) {
                    for (var t = Lr(e), n = t.length; n--; ) {
                        var i = t[n],
                            r = e[i];
                        t[n] = [i, r, r === r && !vr(r)];
                    }
                    return t;
                }
                function xi(e, t) {
                    var n = null == e ? R : e[t];
                    return qt(n) ? n : R;
                }
                function _i(e, t, n) {
                    t = En(t, e);
                    for (var i = -1, r = t.length, o = !1; ++i < r; ) {
                        var s = Ni(t[i]);
                        if (!(o = null != e && n(e, s))) break;
                        e = e[s];
                    }
                    return o || ++i != r ? o : ((r = null == e ? 0 : e.length), !!r && gr(r) && Ei(s, r) && (oa(e) || ra(e)));
                }
                function ki(e) {
                    var t = e.length,
                        n = new e.constructor(t);
                    return t && "string" == typeof e[0] && oo.call(e, "index") && ((n.index = e.index), (n.input = e.input)), n;
                }
                function Si(e) {
                    return "function" != typeof e.constructor || Li(e) ? {} : is(yo(e));
                }
                function Ci(e, t, n) {
                    var i = e.constructor;
                    switch (t) {
                        case "[object ArrayBuffer]":
                            return Dn(e);
                        case "[object Boolean]":
                        case "[object Date]":
                            return new i(+e);
                        case "[object DataView]":
                            return (t = n ? Dn(e.buffer) : e.buffer), new e.constructor(t, e.byteOffset, e.byteLength);
                        case "[object Float32Array]":
                        case "[object Float64Array]":
                        case "[object Int8Array]":
                        case "[object Int16Array]":
                        case "[object Int32Array]":
                        case "[object Uint8Array]":
                        case "[object Uint8ClampedArray]":
                        case "[object Uint16Array]":
                        case "[object Uint32Array]":
                            return Ln(e, n);
                        case "[object Map]":
                            return new i();
                        case "[object Number]":
                        case "[object String]":
                            return new i(e);
                        case "[object RegExp]":
                            return (t = new e.constructor(e.source, pe.exec(e))), (t.lastIndex = e.lastIndex), t;
                        case "[object Set]":
                            return new i();
                        case "[object Symbol]":
                            return ts ? Zr(ts.call(e)) : {};
                    }
                }
                function Ti(e) {
                    return oa(e) || ra(e) || !!(xo && e && e[xo]);
                }
                function Ei(e, t) {
                    var n = typeof e;
                    return (t = null == t ? 9007199254740991 : t), !!t && ("number" == n || ("symbol" != n && me.test(e))) && -1 < e && 0 == e % 1 && e < t;
                }
                function Ai(e, t, n) {
                    if (!vr(n)) return !1;
                    var i = typeof t;
                    return !!("number" == i ? cr(n) && Ei(t, n.length) : "string" == i && t in n) && ur(n[t], e);
                }
                function ji(e, t) {
                    if (oa(e)) return !1;
                    var n = typeof e;
                    return !("number" != n && "symbol" != n && "boolean" != n && null != e && !xr(e)) || ee.test(e) || !K.test(e) || (null != t && e in Zr(t));
                }
                function Di(e) {
                    var t = vi(e),
                        n = ke[t];
                    return "function" == typeof n && t in ze.prototype && (e === n || ((t = ds(n)), !!t && e === t[0]));
                }
                function Li(e) {
                    var t = e && e.constructor;
                    return e === (("function" == typeof t && t.prototype) || no);
                }
                function Pi(e, t) {
                    return function (n) {
                        return null != n && n[e] === t && (t !== R || e in Zr(n));
                    };
                }
                function $i(t, n, i) {
                    return (
                        (n = Oo(n === R ? t.length - 1 : n, 0)),
                        function () {
                            for (var r = arguments, o = -1, s = Oo(r.length - n, 0), a = Xr(s); ++o < s; ) a[o] = r[n + o];
                            for (o = -1, s = Xr(n + 1); ++o < n; ) s[o] = r[o];
                            return (s[n] = i(a)), e(t, this, s);
                        }
                    );
                }
                function zi(e, t, n) {
                    var i = t + "";
                    t = bs;
                    var r,
                        o = Ri;
                    return (
                        (r = (r = i.match(le)) ? r[1].split(ue) : []),
                        (n = o(r, n)),
                        (o = n.length) && ((r = o - 1), (n[r] = (1 < o ? "& " : "") + n[r]), (n = n.join(2 < o ? ", " : " ")), (i = i.replace(ae, "{\n/* [wrapped with " + n + "] */\n"))),
                        t(e, i)
                    );
                }
                function Oi(e) {
                    var t = 0,
                        n = 0;
                    return function () {
                        var i = No(),
                            r = 16 - (i - n);
                        if (((n = i), 0 < r)) {
                            if (800 <= ++t) return arguments[0];
                        } else t = 0;
                        return e.apply(R, arguments);
                    };
                }
                function Ii(e, t) {
                    var n = -1,
                        i = e.length,
                        r = i - 1;
                    for (t = t === R ? i : t; ++n < t; ) {
                        var i = on(n, r),
                            o = e[i];
                        (e[i] = e[n]), (e[n] = o);
                    }
                    return (e.length = t), e;
                }
                function Ni(e) {
                    if ("string" == typeof e || xr(e)) return e;
                    var t = e + "";
                    return "0" == t && 1 / e == -q ? "-0" : t;
                }
                function Mi(e) {
                    if (null != e) {
                        try {
                            return ro.call(e);
                        } catch (e) {}
                        return e + "";
                    }
                    return "";
                }
                function Ri(e, t) {
                    return (
                        n(W, function (n) {
                            var i = "_." + n[0];
                            t & n[1] && !s(e, i) && e.push(i);
                        }),
                        e.sort()
                    );
                }
                function qi(e) {
                    if (e instanceof ze) return e.clone();
                    var t = new Ee(e.__wrapped__, e.__chain__);
                    return (t.__actions__ = On(e.__actions__)), (t.__index__ = e.__index__), (t.__values__ = e.__values__), t;
                }
                function Hi(e, t, n) {
                    var i = null == e ? 0 : e.length;
                    return i ? ((n = null == n ? 0 : Sr(n)), 0 > n && (n = Oo(i + n, 0)), h(e, mi(t, 3), n)) : -1;
                }
                function Wi(e, t, n) {
                    var i = null == e ? 0 : e.length;
                    if (!i) return -1;
                    var r = i - 1;
                    return n !== R && ((r = Sr(n)), (r = 0 > n ? Oo(i + r, 0) : Io(r, i - 1))), h(e, mi(t, 3), r, !0);
                }
                function Fi(e) {
                    return (null == e ? 0 : e.length) ? xt(e, 1) : [];
                }
                function Ui(e) {
                    return e && e.length ? e[0] : R;
                }
                function Bi(e) {
                    var t = null == e ? 0 : e.length;
                    return t ? e[t - 1] : R;
                }
                function Xi(e, t) {
                    return e && e.length && t && t.length ? nn(e, t) : e;
                }
                function Vi(e) {
                    return null == e ? e : qo.call(e);
                }
                function Gi(e) {
                    if (!e || !e.length) return [];
                    var t = 0;
                    return (
                        (e = o(e, function (e) {
                            if (fr(e)) return (t = Oo(e.length, t)), !0;
                        })),
                        S(t, function (t) {
                            return l(e, b(t));
                        })
                    );
                }
                function Qi(t, n) {
                    if (!t || !t.length) return [];
                    var i = Gi(t);
                    return null == n
                        ? i
                        : l(i, function (t) {
                              return e(n, R, t);
                          });
                }
                function Yi(e) {
                    return (e = ke(e)), (e.__chain__ = !0), e;
                }
                function Zi(e, t) {
                    return t(e);
                }
                function Ji() {
                    return this;
                }
                function Ki(e, t) {
                    return (oa(e) ? n : rs)(e, mi(t, 3));
                }
                function er(e, t) {
                    return (oa(e) ? i : os)(e, mi(t, 3));
                }
                function tr(e, t) {
                    return (oa(e) ? l : Vt)(e, mi(t, 3));
                }
                function nr(e, t, n) {
                    return (t = n ? R : t), (t = e && null == t ? e.length : t), ai(e, 128, R, R, R, R, t);
                }
                function ir(e, t) {
                    var n;
                    if ("function" != typeof t) throw new eo("Expected a function");
                    return (
                        (e = Sr(e)),
                        function () {
                            return 0 < --e && (n = t.apply(this, arguments)), 1 >= e && (t = R), n;
                        }
                    );
                }
                function rr(e, t, n) {
                    return (t = n ? R : t), (e = ai(e, 8, R, R, R, R, R, t)), (e.placeholder = rr.placeholder), e;
                }
                function or(e, t, n) {
                    return (t = n ? R : t), (e = ai(e, 16, R, R, R, R, R, t)), (e.placeholder = or.placeholder), e;
                }
                function sr(e, t, n) {
                    function i(t) {
                        var n = l,
                            i = u;
                        return (l = u = R), (h = t), (f = e.apply(i, n));
                    }
                    function r(e) {
                        var n = e - p;
                        return (e -= h), p === R || n >= t || 0 > n || (v && e >= c);
                    }
                    function o() {
                        var e = Vs();
                        if (r(e)) return s(e);
                        var n,
                            i = ms;
                        (n = e - h), (e = t - (e - p)), (n = v ? Io(e, c - n) : e), (d = i(o, n));
                    }
                    function s(e) {
                        return (d = R), y && l ? i(e) : ((l = u = R), f);
                    }
                    function a() {
                        var e = Vs(),
                            n = r(e);
                        if (((l = arguments), (u = this), (p = e), n)) {
                            if (d === R) return (h = e = p), (d = ms(o, t)), g ? i(e) : f;
                            if (v) return (d = ms(o, t)), i(p);
                        }
                        return d === R && (d = ms(o, t)), f;
                    }
                    var l,
                        u,
                        c,
                        f,
                        d,
                        p,
                        h = 0,
                        g = !1,
                        v = !1,
                        y = !0;
                    if ("function" != typeof e) throw new eo("Expected a function");
                    return (
                        (t = Tr(t) || 0),
                        vr(n) && ((g = !!n.leading), (c = (v = "maxWait" in n) ? Oo(Tr(n.maxWait) || 0, t) : c), (y = "trailing" in n ? !!n.trailing : y)),
                        (a.cancel = function () {
                            d !== R && cs(d), (h = 0), (l = p = u = d = R);
                        }),
                        (a.flush = function () {
                            return d === R ? f : s(Vs());
                        }),
                        a
                    );
                }
                function ar(e, t) {
                    function n() {
                        var i = arguments,
                            r = t ? t.apply(this, i) : i[0],
                            o = n.cache;
                        return o.has(r) ? o.get(r) : ((i = e.apply(this, i)), (n.cache = o.set(r, i) || o), i);
                    }
                    if ("function" != typeof e || (null != t && "function" != typeof t)) throw new eo("Expected a function");
                    return (n.cache = new (ar.Cache || qe)()), n;
                }
                function lr(e) {
                    if ("function" != typeof e) throw new eo("Expected a function");
                    return function () {
                        var t = arguments;
                        switch (t.length) {
                            case 0:
                                return !e.call(this);
                            case 1:
                                return !e.call(this, t[0]);
                            case 2:
                                return !e.call(this, t[0], t[1]);
                            case 3:
                                return !e.call(this, t[0], t[1], t[2]);
                        }
                        return !e.apply(this, t);
                    };
                }
                function ur(e, t) {
                    return e === t || (e !== e && t !== t);
                }
                function cr(e) {
                    return null != e && gr(e.length) && !pr(e);
                }
                function fr(e) {
                    return yr(e) && cr(e);
                }
                function dr(e) {
                    if (!yr(e)) return !1;
                    var t = Et(e);
                    return "[object Error]" == t || "[object DOMException]" == t || ("string" == typeof e.message && "string" == typeof e.name && !br(e));
                }
                function pr(e) {
                    return !!vr(e) && ((e = Et(e)), "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e);
                }
                function hr(e) {
                    return "number" == typeof e && e == Sr(e);
                }
                function gr(e) {
                    return "number" == typeof e && -1 < e && 0 == e % 1 && 9007199254740991 >= e;
                }
                function vr(e) {
                    var t = typeof e;
                    return null != e && ("object" == t || "function" == t);
                }
                function yr(e) {
                    return null != e && "object" == typeof e;
                }
                function mr(e) {
                    return "number" == typeof e || (yr(e) && "[object Number]" == Et(e));
                }
                function br(e) {
                    return !(!yr(e) || "[object Object]" != Et(e)) && ((e = yo(e)), null === e || ((e = oo.call(e, "constructor") && e.constructor), "function" == typeof e && e instanceof e && ro.call(e) == uo));
                }
                function wr(e) {
                    return "string" == typeof e || (!oa(e) && yr(e) && "[object String]" == Et(e));
                }
                function xr(e) {
                    return "symbol" == typeof e || (yr(e) && "[object Symbol]" == Et(e));
                }
                function _r(e) {
                    if (!e) return [];
                    if (cr(e)) return wr(e) ? M(e) : On(e);
                    if (_o && e[_o]) {
                        e = e[_o]();
                        for (var t, n = []; !(t = e.next()).done; ) n.push(t.value);
                        return n;
                    }
                    return (t = gs(e)), ("[object Map]" == t ? P : "[object Set]" == t ? O : zr)(e);
                }
                function kr(e) {
                    return e ? ((e = Tr(e)), e === q || e === -q ? 1.7976931348623157e308 * (0 > e ? -1 : 1) : e === e ? e : 0) : 0 === e ? e : 0;
                }
                function Sr(e) {
                    e = kr(e);
                    var t = e % 1;
                    return e === e ? (t ? e - t : e) : 0;
                }
                function Cr(e) {
                    return e ? dt(Sr(e), 0, 4294967295) : 0;
                }
                function Tr(e) {
                    if ("number" == typeof e) return e;
                    if (xr(e)) return H;
                    if ((vr(e) && ((e = "function" == typeof e.valueOf ? e.valueOf() : e), (e = vr(e) ? e + "" : e)), "string" != typeof e)) return 0 === e ? e : +e;
                    e = e.replace(re, "");
                    var t = ge.test(e);
                    return t || ye.test(e) ? Ie(e.slice(2), t ? 2 : 8) : he.test(e) ? H : +e;
                }
                function Er(e) {
                    return In(e, Pr(e));
                }
                function Ar(e) {
                    return null == e ? "" : mn(e);
                }
                function jr(e, t, n) {
                    return (e = null == e ? R : Ct(e, t)), e === R ? n : e;
                }
                function Dr(e, t) {
                    return null != e && _i(e, t, Dt);
                }
                function Lr(e) {
                    return cr(e) ? Ue(e) : Bt(e);
                }
                function Pr(e) {
                    if (cr(e)) e = Ue(e, !0);
                    else if (vr(e)) {
                        var t,
                            n = Li(e),
                            i = [];
                        for (t in e) ("constructor" != t || (!n && oo.call(e, t))) && i.push(t);
                        e = i;
                    } else {
                        if (((t = []), null != e)) for (n in Zr(e)) t.push(n);
                        e = t;
                    }
                    return e;
                }
                function $r(e, t) {
                    if (null == e) return {};
                    var n = l(gi(e), function (e) {
                        return [e];
                    });
                    return (
                        (t = mi(t)),
                        en(e, n, function (e, n) {
                            return t(e, n[0]);
                        })
                    );
                }
                function zr(e) {
                    return null == e ? [] : E(e, Lr(e));
                }
                function Or(e) {
                    return Ma(Ar(e).toLowerCase());
                }
                function Ir(e) {
                    return (e = Ar(e)) && e.replace(be, Je).replace(Te, "");
                }
                function Nr(e, t, n) {
                    return (e = Ar(e)), (t = n ? R : t), t === R ? (De.test(e) ? e.match(Ae) || [] : e.match(ce) || []) : e.match(t) || [];
                }
                function Mr(e) {
                    return function () {
                        return e;
                    };
                }
                function Rr(e) {
                    return e;
                }
                function qr(e) {
                    return Ut("function" == typeof e ? e : pt(e, 1));
                }
                function Hr(e, t, i) {
                    var r = Lr(t),
                        o = St(t, r);
                    null != i || (vr(t) && (o.length || !r.length)) || ((i = t), (t = e), (e = this), (o = St(t, Lr(t))));
                    var s = !(vr(i) && "chain" in i && !i.chain),
                        a = pr(e);
                    return (
                        n(o, function (n) {
                            var i = t[n];
                            (e[n] = i),
                                a &&
                                    (e.prototype[n] = function () {
                                        var t = this.__chain__;
                                        if (s || t) {
                                            var n = e(this.__wrapped__);
                                            return (n.__actions__ = On(this.__actions__)).push({ func: i, args: arguments, thisArg: e }), (n.__chain__ = t), n;
                                        }
                                        return i.apply(e, u([this.value()], arguments));
                                    });
                        }),
                        e
                    );
                }
                function Wr() {}
                function Fr(e) {
                    return ji(e) ? b(Ni(e)) : tn(e);
                }
                function Ur() {
                    return [];
                }
                function Br() {
                    return !1;
                }
                _e = null == _e ? Re : tt.defaults(Re.Object(), _e, tt.pick(Re, Le));
                var Xr = _e.Array,
                    Vr = _e.Date,
                    Gr = _e.Error,
                    Qr = _e.Function,
                    Yr = _e.Math,
                    Zr = _e.Object,
                    Jr = _e.RegExp,
                    Kr = _e.String,
                    eo = _e.TypeError,
                    to = Xr.prototype,
                    no = Zr.prototype,
                    io = _e["__core-js_shared__"],
                    ro = Qr.prototype.toString,
                    oo = no.hasOwnProperty,
                    so = 0,
                    ao = (function () {
                        var e = /[^.]+$/.exec((io && io.keys && io.keys.IE_PROTO) || "");
                        return e ? "Symbol(src)_1." + e : "";
                    })(),
                    lo = no.toString,
                    uo = ro.call(Zr),
                    co = Re._,
                    fo = Jr(
                        "^" +
                            ro
                                .call(oo)
                                .replace(ne, "\\$&")
                                .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") +
                            "$"
                    ),
                    po = We ? _e.Buffer : R,
                    ho = _e.Symbol,
                    go = _e.Uint8Array,
                    vo = po ? po.g : R,
                    yo = $(Zr.getPrototypeOf, Zr),
                    mo = Zr.create,
                    bo = no.propertyIsEnumerable,
                    wo = to.splice,
                    xo = ho ? ho.isConcatSpreadable : R,
                    _o = ho ? ho.iterator : R,
                    ko = ho ? ho.toStringTag : R,
                    So = (function () {
                        try {
                            var e = xi(Zr, "defineProperty");
                            return e({}, "", {}), e;
                        } catch (e) {}
                    })(),
                    Co = _e.clearTimeout !== Re.clearTimeout && _e.clearTimeout,
                    To = Vr && Vr.now !== Re.Date.now && Vr.now,
                    Eo = _e.setTimeout !== Re.setTimeout && _e.setTimeout,
                    Ao = Yr.ceil,
                    jo = Yr.floor,
                    Do = Zr.getOwnPropertySymbols,
                    Lo = po ? po.isBuffer : R,
                    Po = _e.isFinite,
                    $o = to.join,
                    zo = $(Zr.keys, Zr),
                    Oo = Yr.max,
                    Io = Yr.min,
                    No = Vr.now,
                    Mo = _e.parseInt,
                    Ro = Yr.random,
                    qo = to.reverse,
                    Ho = xi(_e, "DataView"),
                    Wo = xi(_e, "Map"),
                    Fo = xi(_e, "Promise"),
                    Uo = xi(_e, "Set"),
                    Bo = xi(_e, "WeakMap"),
                    Xo = xi(Zr, "create"),
                    Vo = Bo && new Bo(),
                    Go = {},
                    Qo = Mi(Ho),
                    Yo = Mi(Wo),
                    Zo = Mi(Fo),
                    Jo = Mi(Uo),
                    Ko = Mi(Bo),
                    es = ho ? ho.prototype : R,
                    ts = es ? es.valueOf : R,
                    ns = es ? es.toString : R,
                    is = (function () {
                        function e() {}
                        return function (t) {
                            return vr(t) ? (mo ? mo(t) : ((e.prototype = t), (t = new e()), (e.prototype = R), t)) : {};
                        };
                    })();
                (ke.templateSettings = { escape: Y, evaluate: Z, interpolate: J, variable: "", imports: { _: ke } }),
                    (ke.prototype = Se.prototype),
                    (ke.prototype.constructor = ke),
                    (Ee.prototype = is(Se.prototype)),
                    (Ee.prototype.constructor = Ee),
                    (ze.prototype = is(Se.prototype)),
                    (ze.prototype.constructor = ze),
                    (Ne.prototype.clear = function () {
                        (this.__data__ = Xo ? Xo(null) : {}), (this.size = 0);
                    }),
                    (Ne.prototype.delete = function (e) {
                        return (e = this.has(e) && delete this.__data__[e]), (this.size -= e ? 1 : 0), e;
                    }),
                    (Ne.prototype.get = function (e) {
                        var t = this.__data__;
                        return Xo ? ((e = t[e]), "__lodash_hash_undefined__" === e ? R : e) : oo.call(t, e) ? t[e] : R;
                    }),
                    (Ne.prototype.has = function (e) {
                        var t = this.__data__;
                        return Xo ? t[e] !== R : oo.call(t, e);
                    }),
                    (Ne.prototype.set = function (e, t) {
                        var n = this.__data__;
                        return (this.size += this.has(e) ? 0 : 1), (n[e] = Xo && t === R ? "__lodash_hash_undefined__" : t), this;
                    }),
                    (Me.prototype.clear = function () {
                        (this.__data__ = []), (this.size = 0);
                    }),
                    (Me.prototype.delete = function (e) {
                        var t = this.__data__;
                        return (e = st(t, e)), !(0 > e || (e == t.length - 1 ? t.pop() : wo.call(t, e, 1), --this.size, 0));
                    }),
                    (Me.prototype.get = function (e) {
                        var t = this.__data__;
                        return (e = st(t, e)), 0 > e ? R : t[e][1];
                    }),
                    (Me.prototype.has = function (e) {
                        return -1 < st(this.__data__, e);
                    }),
                    (Me.prototype.set = function (e, t) {
                        var n = this.__data__,
                            i = st(n, e);
                        return 0 > i ? (++this.size, n.push([e, t])) : (n[i][1] = t), this;
                    }),
                    (qe.prototype.clear = function () {
                        (this.size = 0), (this.__data__ = { hash: new Ne(), map: new (Wo || Me)(), string: new Ne() });
                    }),
                    (qe.prototype.delete = function (e) {
                        return (e = bi(this, e).delete(e)), (this.size -= e ? 1 : 0), e;
                    }),
                    (qe.prototype.get = function (e) {
                        return bi(this, e).get(e);
                    }),
                    (qe.prototype.has = function (e) {
                        return bi(this, e).has(e);
                    }),
                    (qe.prototype.set = function (e, t) {
                        var n = bi(this, e),
                            i = n.size;
                        return n.set(e, t), (this.size += n.size == i ? 0 : 1), this;
                    }),
                    (He.prototype.add = He.prototype.push = function (e) {
                        return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                    }),
                    (He.prototype.has = function (e) {
                        return this.__data__.has(e);
                    }),
                    (Fe.prototype.clear = function () {
                        (this.__data__ = new Me()), (this.size = 0);
                    }),
                    (Fe.prototype.delete = function (e) {
                        var t = this.__data__;
                        return (e = t.delete(e)), (this.size = t.size), e;
                    }),
                    (Fe.prototype.get = function (e) {
                        return this.__data__.get(e);
                    }),
                    (Fe.prototype.has = function (e) {
                        return this.__data__.has(e);
                    }),
                    (Fe.prototype.set = function (e, t) {
                        var n = this.__data__;
                        if (n instanceof Me) {
                            var i = n.__data__;
                            if (!Wo || 199 > i.length) return i.push([e, t]), (this.size = ++n.size), this;
                            n = this.__data__ = new qe(i);
                        }
                        return n.set(e, t), (this.size = n.size), this;
                    });
                var rs = Hn(_t),
                    os = Hn(kt, !0),
                    ss = Wn(),
                    as = Wn(!0),
                    ls = Vo
                        ? function (e, t) {
                              return Vo.set(e, t), e;
                          }
                        : Rr,
                    us = So
                        ? function (e, t) {
                              return So(e, "toString", { configurable: !0, enumerable: !1, value: Mr(t), writable: !0 });
                          }
                        : Rr,
                    cs =
                        Co ||
                        function (e) {
                            return Re.clearTimeout(e);
                        },
                    fs =
                        Uo && 1 / O(new Uo([, -0]))[1] == q
                            ? function (e) {
                                  return new Uo(e);
                              }
                            : Wr,
                    ds = Vo
                        ? function (e) {
                              return Vo.get(e);
                          }
                        : Wr,
                    ps = Do
                        ? function (e) {
                              return null == e
                                  ? []
                                  : ((e = Zr(e)),
                                    o(Do(e), function (t) {
                                        return bo.call(e, t);
                                    }));
                          }
                        : Ur,
                    hs = Do
                        ? function (e) {
                              for (var t = []; e; ) u(t, ps(e)), (e = yo(e));
                              return t;
                          }
                        : Ur,
                    gs = Et;
                ((Ho && "[object DataView]" != gs(new Ho(new ArrayBuffer(1)))) ||
                    (Wo && "[object Map]" != gs(new Wo())) ||
                    (Fo && "[object Promise]" != gs(Fo.resolve())) ||
                    (Uo && "[object Set]" != gs(new Uo())) ||
                    (Bo && "[object WeakMap]" != gs(new Bo()))) &&
                    (gs = function (e) {
                        var t = Et(e);
                        if ((e = (e = "[object Object]" == t ? e.constructor : R) ? Mi(e) : ""))
                            switch (e) {
                                case Qo:
                                    return "[object DataView]";
                                case Yo:
                                    return "[object Map]";
                                case Zo:
                                    return "[object Promise]";
                                case Jo:
                                    return "[object Set]";
                                case Ko:
                                    return "[object WeakMap]";
                            }
                        return t;
                    });
                var vs = io ? pr : Br,
                    ys = Oi(ls),
                    ms =
                        Eo ||
                        function (e, t) {
                            return Re.setTimeout(e, t);
                        },
                    bs = Oi(us),
                    ws = (function (e) {
                        e = ar(e, function (e) {
                            return 500 === t.size && t.clear(), e;
                        });
                        var t = e.cache;
                        return e;
                    })(function (e) {
                        var t = [];
                        return (
                            46 === e.charCodeAt(0) && t.push(""),
                            e.replace(te, function (e, n, i, r) {
                                t.push(i ? r.replace(fe, "$1") : n || e);
                            }),
                            t
                        );
                    }),
                    xs = an(function (e, t) {
                        return fr(e) ? yt(e, xt(t, 1, fr, !0)) : [];
                    }),
                    _s = an(function (e, t) {
                        var n = Bi(t);
                        return fr(n) && (n = R), fr(e) ? yt(e, xt(t, 1, fr, !0), mi(n, 2)) : [];
                    }),
                    ks = an(function (e, t) {
                        var n = Bi(t);
                        return fr(n) && (n = R), fr(e) ? yt(e, xt(t, 1, fr, !0), R, n) : [];
                    }),
                    Ss = an(function (e) {
                        var t = l(e, Cn);
                        return t.length && t[0] === e[0] ? Lt(t) : [];
                    }),
                    Cs = an(function (e) {
                        var t = Bi(e),
                            n = l(e, Cn);
                        return t === Bi(n) ? (t = R) : n.pop(), n.length && n[0] === e[0] ? Lt(n, mi(t, 2)) : [];
                    }),
                    Ts = an(function (e) {
                        var t = Bi(e),
                            n = l(e, Cn);
                        return (t = "function" == typeof t ? t : R) && n.pop(), n.length && n[0] === e[0] ? Lt(n, R, t) : [];
                    }),
                    Es = an(Xi),
                    As = pi(function (e, t) {
                        var n = null == e ? 0 : e.length,
                            i = ft(e, t);
                        return (
                            rn(
                                e,
                                l(t, function (e) {
                                    return Ei(e, n) ? +e : e;
                                }).sort(Pn)
                            ),
                            i
                        );
                    }),
                    js = an(function (e) {
                        return bn(xt(e, 1, fr, !0));
                    }),
                    Ds = an(function (e) {
                        var t = Bi(e);
                        return fr(t) && (t = R), bn(xt(e, 1, fr, !0), mi(t, 2));
                    }),
                    Ls = an(function (e) {
                        var t = Bi(e),
                            t = "function" == typeof t ? t : R;
                        return bn(xt(e, 1, fr, !0), R, t);
                    }),
                    Ps = an(function (e, t) {
                        return fr(e) ? yt(e, t) : [];
                    }),
                    $s = an(function (e) {
                        return kn(o(e, fr));
                    }),
                    zs = an(function (e) {
                        var t = Bi(e);
                        return fr(t) && (t = R), kn(o(e, fr), mi(t, 2));
                    }),
                    Os = an(function (e) {
                        var t = Bi(e),
                            t = "function" == typeof t ? t : R;
                        return kn(o(e, fr), R, t);
                    }),
                    Is = an(Gi),
                    Ns = an(function (e) {
                        var t = e.length,
                            t = 1 < t ? e[t - 1] : R,
                            t = "function" == typeof t ? (e.pop(), t) : R;
                        return Qi(e, t);
                    }),
                    Ms = pi(function (e) {
                        function t(t) {
                            return ft(t, e);
                        }
                        var n = e.length,
                            i = n ? e[0] : 0,
                            r = this.__wrapped__;
                        return !(1 < n || this.__actions__.length) && r instanceof ze && Ei(i)
                            ? ((r = r.slice(i, +i + (n ? 1 : 0))),
                              r.__actions__.push({ func: Zi, args: [t], thisArg: R }),
                              new Ee(r, this.__chain__).thru(function (e) {
                                  return n && !e.length && e.push(R), e;
                              }))
                            : this.thru(t);
                    }),
                    Rs = Rn(function (e, t, n) {
                        oo.call(e, n) ? ++e[n] : ct(e, n, 1);
                    }),
                    qs = Gn(Hi),
                    Hs = Gn(Wi),
                    Ws = Rn(function (e, t, n) {
                        oo.call(e, n) ? e[n].push(t) : ct(e, n, [t]);
                    }),
                    Fs = an(function (t, n, i) {
                        var r = -1,
                            o = "function" == typeof n,
                            s = cr(t) ? Xr(t.length) : [];
                        return (
                            rs(t, function (t) {
                                s[++r] = o ? e(n, t, i) : $t(t, n, i);
                            }),
                            s
                        );
                    }),
                    Us = Rn(function (e, t, n) {
                        ct(e, n, t);
                    }),
                    Bs = Rn(
                        function (e, t, n) {
                            e[n ? 0 : 1].push(t);
                        },
                        function () {
                            return [[], []];
                        }
                    ),
                    Xs = an(function (e, t) {
                        if (null == e) return [];
                        var n = t.length;
                        return 1 < n && Ai(e, t[0], t[1]) ? (t = []) : 2 < n && Ai(t[0], t[1], t[2]) && (t = [t[0]]), Jt(e, xt(t, 1), []);
                    }),
                    Vs =
                        To ||
                        function () {
                            return Re.Date.now();
                        },
                    Gs = an(function (e, t, n) {
                        var i = 1;
                        if (n.length)
                            var r = z(n, yi(Gs)),
                                i = 32 | i;
                        return ai(e, i, t, n, r);
                    }),
                    Qs = an(function (e, t, n) {
                        var i = 3;
                        if (n.length)
                            var r = z(n, yi(Qs)),
                                i = 32 | i;
                        return ai(t, i, e, n, r);
                    }),
                    Ys = an(function (e, t) {
                        return vt(e, 1, t);
                    }),
                    Zs = an(function (e, t, n) {
                        return vt(e, Tr(t) || 0, n);
                    });
                ar.Cache = qe;
                var Js = an(function (t, n) {
                        n = 1 == n.length && oa(n[0]) ? l(n[0], T(mi())) : l(xt(n, 1), T(mi()));
                        var i = n.length;
                        return an(function (r) {
                            for (var o = -1, s = Io(r.length, i); ++o < s; ) r[o] = n[o].call(this, r[o]);
                            return e(t, this, r);
                        });
                    }),
                    Ks = an(function (e, t) {
                        return ai(e, 32, R, t, z(t, yi(Ks)));
                    }),
                    ea = an(function (e, t) {
                        return ai(e, 64, R, t, z(t, yi(ea)));
                    }),
                    ta = pi(function (e, t) {
                        return ai(e, 256, R, R, R, t);
                    }),
                    na = ii(At),
                    ia = ii(function (e, t) {
                        return e >= t;
                    }),
                    ra = zt(
                        (function () {
                            return arguments;
                        })()
                    )
                        ? zt
                        : function (e) {
                              return yr(e) && oo.call(e, "callee") && !bo.call(e, "callee");
                          },
                    oa = Xr.isArray,
                    sa = Be ? T(Be) : Ot,
                    aa = Lo || Br,
                    la = Xe ? T(Xe) : It,
                    ua = Ve ? T(Ve) : Mt,
                    ca = Ge ? T(Ge) : Ht,
                    fa = Qe ? T(Qe) : Wt,
                    da = Ye ? T(Ye) : Ft,
                    pa = ii(Xt),
                    ha = ii(function (e, t) {
                        return e <= t;
                    }),
                    ga = qn(function (e, t) {
                        if (Li(t) || cr(t)) In(t, Lr(t), e);
                        else for (var n in t) oo.call(t, n) && ot(e, n, t[n]);
                    }),
                    va = qn(function (e, t) {
                        In(t, Pr(t), e);
                    }),
                    ya = qn(function (e, t, n, i) {
                        In(t, Pr(t), e, i);
                    }),
                    ma = qn(function (e, t, n, i) {
                        In(t, Lr(t), e, i);
                    }),
                    ba = pi(ft),
                    wa = an(function (e, t) {
                        e = Zr(e);
                        var n = -1,
                            i = t.length,
                            r = 2 < i ? t[2] : R;
                        for (r && Ai(t[0], t[1], r) && (i = 1); ++n < i; )
                            for (var r = t[n], o = Pr(r), s = -1, a = o.length; ++s < a; ) {
                                var l = o[s],
                                    u = e[l];
                                (u === R || (ur(u, no[l]) && !oo.call(e, l))) && (e[l] = r[l]);
                            }
                        return e;
                    }),
                    xa = an(function (t) {
                        return t.push(R, ui), e(Ta, R, t);
                    }),
                    _a = Zn(function (e, t, n) {
                        null != t && "function" != typeof t.toString && (t = lo.call(t)), (e[t] = n);
                    }, Mr(Rr)),
                    ka = Zn(function (e, t, n) {
                        null != t && "function" != typeof t.toString && (t = lo.call(t)), oo.call(e, t) ? e[t].push(n) : (e[t] = [n]);
                    }, mi),
                    Sa = an($t),
                    Ca = qn(function (e, t, n) {
                        Yt(e, t, n);
                    }),
                    Ta = qn(function (e, t, n, i) {
                        Yt(e, t, n, i);
                    }),
                    Ea = pi(function (e, t) {
                        var n = {};
                        if (null == e) return n;
                        var i = !1;
                        (t = l(t, function (t) {
                            return (t = En(t, e)), i || (i = 1 < t.length), t;
                        })),
                            In(e, gi(e), n),
                            i && (n = pt(n, 7, ci));
                        for (var r = t.length; r--; ) wn(n, t[r]);
                        return n;
                    }),
                    Aa = pi(function (e, t) {
                        return null == e ? {} : Kt(e, t);
                    }),
                    ja = si(Lr),
                    Da = si(Pr),
                    La = Bn(function (e, t, n) {
                        return (t = t.toLowerCase()), e + (n ? Or(t) : t);
                    }),
                    Pa = Bn(function (e, t, n) {
                        return e + (n ? "-" : "") + t.toLowerCase();
                    }),
                    $a = Bn(function (e, t, n) {
                        return e + (n ? " " : "") + t.toLowerCase();
                    }),
                    za = Un("toLowerCase"),
                    Oa = Bn(function (e, t, n) {
                        return e + (n ? "_" : "") + t.toLowerCase();
                    }),
                    Ia = Bn(function (e, t, n) {
                        return e + (n ? " " : "") + Ma(t);
                    }),
                    Na = Bn(function (e, t, n) {
                        return e + (n ? " " : "") + t.toUpperCase();
                    }),
                    Ma = Un("toUpperCase"),
                    Ra = an(function (t, n) {
                        try {
                            return e(t, R, n);
                        } catch (e) {
                            return dr(e) ? e : new Gr(e);
                        }
                    }),
                    qa = pi(function (e, t) {
                        return (
                            n(t, function (t) {
                                (t = Ni(t)), ct(e, t, Gs(e[t], e));
                            }),
                            e
                        );
                    }),
                    Ha = Qn(),
                    Wa = Qn(!0),
                    Fa = an(function (e, t) {
                        return function (n) {
                            return $t(n, e, t);
                        };
                    }),
                    Ua = an(function (e, t) {
                        return function (n) {
                            return $t(e, n, t);
                        };
                    }),
                    Ba = Kn(l),
                    Xa = Kn(r),
                    Va = Kn(d),
                    Ga = ni(),
                    Qa = ni(!0),
                    Ya = Jn(function (e, t) {
                        return e + t;
                    }, 0),
                    Za = oi("ceil"),
                    Ja = Jn(function (e, t) {
                        return e / t;
                    }, 1),
                    Ka = oi("floor"),
                    el = Jn(function (e, t) {
                        return e * t;
                    }, 1),
                    tl = oi("round"),
                    nl = Jn(function (e, t) {
                        return e - t;
                    }, 0);
                return (
                    (ke.after = function (e, t) {
                        if ("function" != typeof t) throw new eo("Expected a function");
                        return (
                            (e = Sr(e)),
                            function () {
                                if (1 > --e) return t.apply(this, arguments);
                            }
                        );
                    }),
                    (ke.ary = nr),
                    (ke.assign = ga),
                    (ke.assignIn = va),
                    (ke.assignInWith = ya),
                    (ke.assignWith = ma),
                    (ke.at = ba),
                    (ke.before = ir),
                    (ke.bind = Gs),
                    (ke.bindAll = qa),
                    (ke.bindKey = Qs),
                    (ke.castArray = function () {
                        if (!arguments.length) return [];
                        var e = arguments[0];
                        return oa(e) ? e : [e];
                    }),
                    (ke.chain = Yi),
                    (ke.chunk = function (e, t, n) {
                        if (((t = (n ? Ai(e, t, n) : t === R) ? 1 : Oo(Sr(t), 0)), (n = null == e ? 0 : e.length), !n || 1 > t)) return [];
                        for (var i = 0, r = 0, o = Xr(Ao(n / t)); i < n; ) o[r++] = dn(e, i, (i += t));
                        return o;
                    }),
                    (ke.compact = function (e) {
                        for (var t = -1, n = null == e ? 0 : e.length, i = 0, r = []; ++t < n; ) {
                            var o = e[t];
                            o && (r[i++] = o);
                        }
                        return r;
                    }),
                    (ke.concat = function () {
                        var e = arguments.length;
                        if (!e) return [];
                        for (var t = Xr(e - 1), n = arguments[0]; e--; ) t[e - 1] = arguments[e];
                        return u(oa(n) ? On(n) : [n], xt(t, 1));
                    }),
                    (ke.cond = function (t) {
                        var n = null == t ? 0 : t.length,
                            i = mi();
                        return (
                            (t = n
                                ? l(t, function (e) {
                                      if ("function" != typeof e[1]) throw new eo("Expected a function");
                                      return [i(e[0]), e[1]];
                                  })
                                : []),
                            an(function (i) {
                                for (var r = -1; ++r < n; ) {
                                    var o = t[r];
                                    if (e(o[0], this, i)) return e(o[1], this, i);
                                }
                            })
                        );
                    }),
                    (ke.conforms = function (e) {
                        return ht(pt(e, 1));
                    }),
                    (ke.constant = Mr),
                    (ke.countBy = Rs),
                    (ke.create = function (e, t) {
                        var n = is(e);
                        return null == t ? n : lt(n, t);
                    }),
                    (ke.curry = rr),
                    (ke.curryRight = or),
                    (ke.debounce = sr),
                    (ke.defaults = wa),
                    (ke.defaultsDeep = xa),
                    (ke.defer = Ys),
                    (ke.delay = Zs),
                    (ke.difference = xs),
                    (ke.differenceBy = _s),
                    (ke.differenceWith = ks),
                    (ke.drop = function (e, t, n) {
                        var i = null == e ? 0 : e.length;
                        return i ? ((t = n || t === R ? 1 : Sr(t)), dn(e, 0 > t ? 0 : t, i)) : [];
                    }),
                    (ke.dropRight = function (e, t, n) {
                        var i = null == e ? 0 : e.length;
                        return i ? ((t = n || t === R ? 1 : Sr(t)), (t = i - t), dn(e, 0, 0 > t ? 0 : t)) : [];
                    }),
                    (ke.dropRightWhile = function (e, t) {
                        return e && e.length ? xn(e, mi(t, 3), !0, !0) : [];
                    }),
                    (ke.dropWhile = function (e, t) {
                        return e && e.length ? xn(e, mi(t, 3), !0) : [];
                    }),
                    (ke.fill = function (e, t, n, i) {
                        var r = null == e ? 0 : e.length;
                        if (!r) return [];
                        for (n && "number" != typeof n && Ai(e, t, n) && ((n = 0), (i = r)), r = e.length, n = Sr(n), 0 > n && (n = -n > r ? 0 : r + n), i = i === R || i > r ? r : Sr(i), 0 > i && (i += r), i = n > i ? 0 : Cr(i); n < i; )
                            e[n++] = t;
                        return e;
                    }),
                    (ke.filter = function (e, t) {
                        return (oa(e) ? o : wt)(e, mi(t, 3));
                    }),
                    (ke.flatMap = function (e, t) {
                        return xt(tr(e, t), 1);
                    }),
                    (ke.flatMapDeep = function (e, t) {
                        return xt(tr(e, t), q);
                    }),
                    (ke.flatMapDepth = function (e, t, n) {
                        return (n = n === R ? 1 : Sr(n)), xt(tr(e, t), n);
                    }),
                    (ke.flatten = Fi),
                    (ke.flattenDeep = function (e) {
                        return (null == e ? 0 : e.length) ? xt(e, q) : [];
                    }),
                    (ke.flattenDepth = function (e, t) {
                        return null != e && e.length ? ((t = t === R ? 1 : Sr(t)), xt(e, t)) : [];
                    }),
                    (ke.flip = function (e) {
                        return ai(e, 512);
                    }),
                    (ke.flow = Ha),
                    (ke.flowRight = Wa),
                    (ke.fromPairs = function (e) {
                        for (var t = -1, n = null == e ? 0 : e.length, i = {}; ++t < n; ) {
                            var r = e[t];
                            i[r[0]] = r[1];
                        }
                        return i;
                    }),
                    (ke.functions = function (e) {
                        return null == e ? [] : St(e, Lr(e));
                    }),
                    (ke.functionsIn = function (e) {
                        return null == e ? [] : St(e, Pr(e));
                    }),
                    (ke.groupBy = Ws),
                    (ke.initial = function (e) {
                        return (null == e ? 0 : e.length) ? dn(e, 0, -1) : [];
                    }),
                    (ke.intersection = Ss),
                    (ke.intersectionBy = Cs),
                    (ke.intersectionWith = Ts),
                    (ke.invert = _a),
                    (ke.invertBy = ka),
                    (ke.invokeMap = Fs),
                    (ke.iteratee = qr),
                    (ke.keyBy = Us),
                    (ke.keys = Lr),
                    (ke.keysIn = Pr),
                    (ke.map = tr),
                    (ke.mapKeys = function (e, t) {
                        var n = {};
                        return (
                            (t = mi(t, 3)),
                            _t(e, function (e, i, r) {
                                ct(n, t(e, i, r), e);
                            }),
                            n
                        );
                    }),
                    (ke.mapValues = function (e, t) {
                        var n = {};
                        return (
                            (t = mi(t, 3)),
                            _t(e, function (e, i, r) {
                                ct(n, i, t(e, i, r));
                            }),
                            n
                        );
                    }),
                    (ke.matches = function (e) {
                        return Gt(pt(e, 1));
                    }),
                    (ke.matchesProperty = function (e, t) {
                        return Qt(e, pt(t, 1));
                    }),
                    (ke.memoize = ar),
                    (ke.merge = Ca),
                    (ke.mergeWith = Ta),
                    (ke.method = Fa),
                    (ke.methodOf = Ua),
                    (ke.mixin = Hr),
                    (ke.negate = lr),
                    (ke.nthArg = function (e) {
                        return (
                            (e = Sr(e)),
                            an(function (t) {
                                return Zt(t, e);
                            })
                        );
                    }),
                    (ke.omit = Ea),
                    (ke.omitBy = function (e, t) {
                        return $r(e, lr(mi(t)));
                    }),
                    (ke.once = function (e) {
                        return ir(2, e);
                    }),
                    (ke.orderBy = function (e, t, n, i) {
                        return null == e ? [] : (oa(t) || (t = null == t ? [] : [t]), (n = i ? R : n), oa(n) || (n = null == n ? [] : [n]), Jt(e, t, n));
                    }),
                    (ke.over = Ba),
                    (ke.overArgs = Js),
                    (ke.overEvery = Xa),
                    (ke.overSome = Va),
                    (ke.partial = Ks),
                    (ke.partialRight = ea),
                    (ke.partition = Bs),
                    (ke.pick = Aa),
                    (ke.pickBy = $r),
                    (ke.property = Fr),
                    (ke.propertyOf = function (e) {
                        return function (t) {
                            return null == e ? R : Ct(e, t);
                        };
                    }),
                    (ke.pull = Es),
                    (ke.pullAll = Xi),
                    (ke.pullAllBy = function (e, t, n) {
                        return e && e.length && t && t.length ? nn(e, t, mi(n, 2)) : e;
                    }),
                    (ke.pullAllWith = function (e, t, n) {
                        return e && e.length && t && t.length ? nn(e, t, R, n) : e;
                    }),
                    (ke.pullAt = As),
                    (ke.range = Ga),
                    (ke.rangeRight = Qa),
                    (ke.rearg = ta),
                    (ke.reject = function (e, t) {
                        return (oa(e) ? o : wt)(e, lr(mi(t, 3)));
                    }),
                    (ke.remove = function (e, t) {
                        var n = [];
                        if (!e || !e.length) return n;
                        var i = -1,
                            r = [],
                            o = e.length;
                        for (t = mi(t, 3); ++i < o; ) {
                            var s = e[i];
                            t(s, i, e) && (n.push(s), r.push(i));
                        }
                        return rn(e, r), n;
                    }),
                    (ke.rest = function (e, t) {
                        if ("function" != typeof e) throw new eo("Expected a function");
                        return (t = t === R ? t : Sr(t)), an(e, t);
                    }),
                    (ke.reverse = Vi),
                    (ke.sampleSize = function (e, t, n) {
                        return (t = (n ? Ai(e, t, n) : t === R) ? 1 : Sr(t)), (oa(e) ? nt : un)(e, t);
                    }),
                    (ke.set = function (e, t, n) {
                        return null == e ? e : cn(e, t, n);
                    }),
                    (ke.setWith = function (e, t, n, i) {
                        return (i = "function" == typeof i ? i : R), null == e ? e : cn(e, t, n, i);
                    }),
                    (ke.shuffle = function (e) {
                        return (oa(e) ? it : fn)(e);
                    }),
                    (ke.slice = function (e, t, n) {
                        var i = null == e ? 0 : e.length;
                        return i ? (n && "number" != typeof n && Ai(e, t, n) ? ((t = 0), (n = i)) : ((t = null == t ? 0 : Sr(t)), (n = n === R ? i : Sr(n))), dn(e, t, n)) : [];
                    }),
                    (ke.sortBy = Xs),
                    (ke.sortedUniq = function (e) {
                        return e && e.length ? vn(e) : [];
                    }),
                    (ke.sortedUniqBy = function (e, t) {
                        return e && e.length ? vn(e, mi(t, 2)) : [];
                    }),
                    (ke.split = function (e, t, n) {
                        return (
                            n && "number" != typeof n && Ai(e, t, n) && (t = n = R),
                            (n = n === R ? 4294967295 : n >>> 0),
                            n ? ((e = Ar(e)) && ("string" == typeof t || (null != t && !ca(t))) && ((t = mn(t)), !t && je.test(e)) ? An(M(e), 0, n) : e.split(t, n)) : []
                        );
                    }),
                    (ke.spread = function (t, n) {
                        if ("function" != typeof t) throw new eo("Expected a function");
                        return (
                            (n = null == n ? 0 : Oo(Sr(n), 0)),
                            an(function (i) {
                                var r = i[n];
                                return (i = An(i, 0, n)), r && u(i, r), e(t, this, i);
                            })
                        );
                    }),
                    (ke.tail = function (e) {
                        var t = null == e ? 0 : e.length;
                        return t ? dn(e, 1, t) : [];
                    }),
                    (ke.take = function (e, t, n) {
                        return e && e.length ? ((t = n || t === R ? 1 : Sr(t)), dn(e, 0, 0 > t ? 0 : t)) : [];
                    }),
                    (ke.takeRight = function (e, t, n) {
                        var i = null == e ? 0 : e.length;
                        return i ? ((t = n || t === R ? 1 : Sr(t)), (t = i - t), dn(e, 0 > t ? 0 : t, i)) : [];
                    }),
                    (ke.takeRightWhile = function (e, t) {
                        return e && e.length ? xn(e, mi(t, 3), !1, !0) : [];
                    }),
                    (ke.takeWhile = function (e, t) {
                        return e && e.length ? xn(e, mi(t, 3)) : [];
                    }),
                    (ke.tap = function (e, t) {
                        return t(e), e;
                    }),
                    (ke.throttle = function (e, t, n) {
                        var i = !0,
                            r = !0;
                        if ("function" != typeof e) throw new eo("Expected a function");
                        return vr(n) && ((i = "leading" in n ? !!n.leading : i), (r = "trailing" in n ? !!n.trailing : r)), sr(e, t, { leading: i, maxWait: t, trailing: r });
                    }),
                    (ke.thru = Zi),
                    (ke.toArray = _r),
                    (ke.toPairs = ja),
                    (ke.toPairsIn = Da),
                    (ke.toPath = function (e) {
                        return oa(e) ? l(e, Ni) : xr(e) ? [e] : On(ws(Ar(e)));
                    }),
                    (ke.toPlainObject = Er),
                    (ke.transform = function (e, t, i) {
                        var r = oa(e),
                            o = r || aa(e) || da(e);
                        if (((t = mi(t, 4)), null == i)) {
                            var s = e && e.constructor;
                            i = o ? (r ? new s() : []) : vr(e) && pr(s) ? is(yo(e)) : {};
                        }
                        return (
                            (o ? n : _t)(e, function (e, n, r) {
                                return t(i, e, n, r);
                            }),
                            i
                        );
                    }),
                    (ke.unary = function (e) {
                        return nr(e, 1);
                    }),
                    (ke.union = js),
                    (ke.unionBy = Ds),
                    (ke.unionWith = Ls),
                    (ke.uniq = function (e) {
                        return e && e.length ? bn(e) : [];
                    }),
                    (ke.uniqBy = function (e, t) {
                        return e && e.length ? bn(e, mi(t, 2)) : [];
                    }),
                    (ke.uniqWith = function (e, t) {
                        return (t = "function" == typeof t ? t : R), e && e.length ? bn(e, R, t) : [];
                    }),
                    (ke.unset = function (e, t) {
                        return null == e || wn(e, t);
                    }),
                    (ke.unzip = Gi),
                    (ke.unzipWith = Qi),
                    (ke.update = function (e, t, n) {
                        return null == e ? e : cn(e, t, Tn(n)(Ct(e, t)), void 0);
                    }),
                    (ke.updateWith = function (e, t, n, i) {
                        return (i = "function" == typeof i ? i : R), null != e && (e = cn(e, t, Tn(n)(Ct(e, t)), i)), e;
                    }),
                    (ke.values = zr),
                    (ke.valuesIn = function (e) {
                        return null == e ? [] : E(e, Pr(e));
                    }),
                    (ke.without = Ps),
                    (ke.words = Nr),
                    (ke.wrap = function (e, t) {
                        return Ks(Tn(t), e);
                    }),
                    (ke.xor = $s),
                    (ke.xorBy = zs),
                    (ke.xorWith = Os),
                    (ke.zip = Is),
                    (ke.zipObject = function (e, t) {
                        return Sn(e || [], t || [], ot);
                    }),
                    (ke.zipObjectDeep = function (e, t) {
                        return Sn(e || [], t || [], cn);
                    }),
                    (ke.zipWith = Ns),
                    (ke.entries = ja),
                    (ke.entriesIn = Da),
                    (ke.extend = va),
                    (ke.extendWith = ya),
                    Hr(ke, ke),
                    (ke.add = Ya),
                    (ke.attempt = Ra),
                    (ke.camelCase = La),
                    (ke.capitalize = Or),
                    (ke.ceil = Za),
                    (ke.clamp = function (e, t, n) {
                        return n === R && ((n = t), (t = R)), n !== R && ((n = Tr(n)), (n = n === n ? n : 0)), t !== R && ((t = Tr(t)), (t = t === t ? t : 0)), dt(Tr(e), t, n);
                    }),
                    (ke.clone = function (e) {
                        return pt(e, 4);
                    }),
                    (ke.cloneDeep = function (e) {
                        return pt(e, 5);
                    }),
                    (ke.cloneDeepWith = function (e, t) {
                        return (t = "function" == typeof t ? t : R), pt(e, 5, t);
                    }),
                    (ke.cloneWith = function (e, t) {
                        return (t = "function" == typeof t ? t : R), pt(e, 4, t);
                    }),
                    (ke.conformsTo = function (e, t) {
                        return null == t || gt(e, t, Lr(t));
                    }),
                    (ke.deburr = Ir),
                    (ke.defaultTo = function (e, t) {
                        return null == e || e !== e ? t : e;
                    }),
                    (ke.divide = Ja),
                    (ke.endsWith = function (e, t, n) {
                        (e = Ar(e)), (t = mn(t));
                        var i = e.length,
                            i = (n = n === R ? i : dt(Sr(n), 0, i));
                        return (n -= t.length), 0 <= n && e.slice(n, i) == t;
                    }),
                    (ke.eq = ur),
                    (ke.escape = function (e) {
                        return (e = Ar(e)) && Q.test(e) ? e.replace(V, Ke) : e;
                    }),
                    (ke.escapeRegExp = function (e) {
                        return (e = Ar(e)) && ie.test(e) ? e.replace(ne, "\\$&") : e;
                    }),
                    (ke.every = function (e, t, n) {
                        var i = oa(e) ? r : mt;
                        return n && Ai(e, t, n) && (t = R), i(e, mi(t, 3));
                    }),
                    (ke.find = qs),
                    (ke.findIndex = Hi),
                    (ke.findKey = function (e, t) {
                        return p(e, mi(t, 3), _t);
                    }),
                    (ke.findLast = Hs),
                    (ke.findLastIndex = Wi),
                    (ke.findLastKey = function (e, t) {
                        return p(e, mi(t, 3), kt);
                    }),
                    (ke.floor = Ka),
                    (ke.forEach = Ki),
                    (ke.forEachRight = er),
                    (ke.forIn = function (e, t) {
                        return null == e ? e : ss(e, mi(t, 3), Pr);
                    }),
                    (ke.forInRight = function (e, t) {
                        return null == e ? e : as(e, mi(t, 3), Pr);
                    }),
                    (ke.forOwn = function (e, t) {
                        return e && _t(e, mi(t, 3));
                    }),
                    (ke.forOwnRight = function (e, t) {
                        return e && kt(e, mi(t, 3));
                    }),
                    (ke.get = jr),
                    (ke.gt = na),
                    (ke.gte = ia),
                    (ke.has = function (e, t) {
                        return null != e && _i(e, t, jt);
                    }),
                    (ke.hasIn = Dr),
                    (ke.head = Ui),
                    (ke.identity = Rr),
                    (ke.includes = function (e, t, n, i) {
                        return (e = cr(e) ? e : zr(e)), (n = n && !i ? Sr(n) : 0), (i = e.length), 0 > n && (n = Oo(i + n, 0)), wr(e) ? n <= i && -1 < e.indexOf(t, n) : !!i && -1 < g(e, t, n);
                    }),
                    (ke.indexOf = function (e, t, n) {
                        var i = null == e ? 0 : e.length;
                        return i ? ((n = null == n ? 0 : Sr(n)), 0 > n && (n = Oo(i + n, 0)), g(e, t, n)) : -1;
                    }),
                    (ke.inRange = function (e, t, n) {
                        return (t = kr(t)), n === R ? ((n = t), (t = 0)) : (n = kr(n)), (e = Tr(e)), e >= Io(t, n) && e < Oo(t, n);
                    }),
                    (ke.invoke = Sa),
                    (ke.isArguments = ra),
                    (ke.isArray = oa),
                    (ke.isArrayBuffer = sa),
                    (ke.isArrayLike = cr),
                    (ke.isArrayLikeObject = fr),
                    (ke.isBoolean = function (e) {
                        return !0 === e || !1 === e || (yr(e) && "[object Boolean]" == Et(e));
                    }),
                    (ke.isBuffer = aa),
                    (ke.isDate = la),
                    (ke.isElement = function (e) {
                        return yr(e) && 1 === e.nodeType && !br(e);
                    }),
                    (ke.isEmpty = function (e) {
                        if (null == e) return !0;
                        if (cr(e) && (oa(e) || "string" == typeof e || "function" == typeof e.splice || aa(e) || da(e) || ra(e))) return !e.length;
                        var t = gs(e);
                        if ("[object Map]" == t || "[object Set]" == t) return !e.size;
                        if (Li(e)) return !Bt(e).length;
                        for (var n in e) if (oo.call(e, n)) return !1;
                        return !0;
                    }),
                    (ke.isEqual = function (e, t) {
                        return Nt(e, t);
                    }),
                    (ke.isEqualWith = function (e, t, n) {
                        var i = (n = "function" == typeof n ? n : R) ? n(e, t) : R;
                        return i === R ? Nt(e, t, R, n) : !!i;
                    }),
                    (ke.isError = dr),
                    (ke.isFinite = function (e) {
                        return "number" == typeof e && Po(e);
                    }),
                    (ke.isFunction = pr),
                    (ke.isInteger = hr),
                    (ke.isLength = gr),
                    (ke.isMap = ua),
                    (ke.isMatch = function (e, t) {
                        return e === t || Rt(e, t, wi(t));
                    }),
                    (ke.isMatchWith = function (e, t, n) {
                        return (n = "function" == typeof n ? n : R), Rt(e, t, wi(t), n);
                    }),
                    (ke.isNaN = function (e) {
                        return mr(e) && e != +e;
                    }),
                    (ke.isNative = function (e) {
                        if (vs(e)) throw new Gr("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
                        return qt(e);
                    }),
                    (ke.isNil = function (e) {
                        return null == e;
                    }),
                    (ke.isNull = function (e) {
                        return null === e;
                    }),
                    (ke.isNumber = mr),
                    (ke.isObject = vr),
                    (ke.isObjectLike = yr),
                    (ke.isPlainObject = br),
                    (ke.isRegExp = ca),
                    (ke.isSafeInteger = function (e) {
                        return hr(e) && -9007199254740991 <= e && 9007199254740991 >= e;
                    }),
                    (ke.isSet = fa),
                    (ke.isString = wr),
                    (ke.isSymbol = xr),
                    (ke.isTypedArray = da),
                    (ke.isUndefined = function (e) {
                        return e === R;
                    }),
                    (ke.isWeakMap = function (e) {
                        return yr(e) && "[object WeakMap]" == gs(e);
                    }),
                    (ke.isWeakSet = function (e) {
                        return yr(e) && "[object WeakSet]" == Et(e);
                    }),
                    (ke.join = function (e, t) {
                        return null == e ? "" : $o.call(e, t);
                    }),
                    (ke.kebabCase = Pa),
                    (ke.last = Bi),
                    (ke.lastIndexOf = function (e, t, n) {
                        var i = null == e ? 0 : e.length;
                        if (!i) return -1;
                        var r = i;
                        if ((n !== R && ((r = Sr(n)), (r = 0 > r ? Oo(i + r, 0) : Io(r, i - 1))), t === t)) {
                            for (n = r + 1; n-- && e[n] !== t; );
                            e = n;
                        } else e = h(e, y, r, !0);
                        return e;
                    }),
                    (ke.lowerCase = $a),
                    (ke.lowerFirst = za),
                    (ke.lt = pa),
                    (ke.lte = ha),
                    (ke.max = function (e) {
                        return e && e.length ? bt(e, Rr, At) : R;
                    }),
                    (ke.maxBy = function (e, t) {
                        return e && e.length ? bt(e, mi(t, 2), At) : R;
                    }),
                    (ke.mean = function (e) {
                        return m(e, Rr);
                    }),
                    (ke.meanBy = function (e, t) {
                        return m(e, mi(t, 2));
                    }),
                    (ke.min = function (e) {
                        return e && e.length ? bt(e, Rr, Xt) : R;
                    }),
                    (ke.minBy = function (e, t) {
                        return e && e.length ? bt(e, mi(t, 2), Xt) : R;
                    }),
                    (ke.stubArray = Ur),
                    (ke.stubFalse = Br),
                    (ke.stubObject = function () {
                        return {};
                    }),
                    (ke.stubString = function () {
                        return "";
                    }),
                    (ke.stubTrue = function () {
                        return !0;
                    }),
                    (ke.multiply = el),
                    (ke.nth = function (e, t) {
                        return e && e.length ? Zt(e, Sr(t)) : R;
                    }),
                    (ke.noConflict = function () {
                        return Re._ === this && (Re._ = co), this;
                    }),
                    (ke.noop = Wr),
                    (ke.now = Vs),
                    (ke.pad = function (e, t, n) {
                        e = Ar(e);
                        var i = (t = Sr(t)) ? N(e) : 0;
                        return !t || i >= t ? e : ((t = (t - i) / 2), ei(jo(t), n) + e + ei(Ao(t), n));
                    }),
                    (ke.padEnd = function (e, t, n) {
                        e = Ar(e);
                        var i = (t = Sr(t)) ? N(e) : 0;
                        return t && i < t ? e + ei(t - i, n) : e;
                    }),
                    (ke.padStart = function (e, t, n) {
                        e = Ar(e);
                        var i = (t = Sr(t)) ? N(e) : 0;
                        return t && i < t ? ei(t - i, n) + e : e;
                    }),
                    (ke.parseInt = function (e, t, n) {
                        return n || null == t ? (t = 0) : t && (t = +t), Mo(Ar(e).replace(oe, ""), t || 0);
                    }),
                    (ke.random = function (e, t, n) {
                        if (
                            (n && "boolean" != typeof n && Ai(e, t, n) && (t = n = R),
                            n === R && ("boolean" == typeof t ? ((n = t), (t = R)) : "boolean" == typeof e && ((n = e), (e = R))),
                            e === R && t === R ? ((e = 0), (t = 1)) : ((e = kr(e)), t === R ? ((t = e), (e = 0)) : (t = kr(t))),
                            e > t)
                        ) {
                            var i = e;
                            (e = t), (t = i);
                        }
                        return n || e % 1 || t % 1 ? ((n = Ro()), Io(e + n * (t - e + Oe("1e-" + ((n + "").length - 1))), t)) : on(e, t);
                    }),
                    (ke.reduce = function (e, t, n) {
                        var i = oa(e) ? c : x,
                            r = 3 > arguments.length;
                        return i(e, mi(t, 4), n, r, rs);
                    }),
                    (ke.reduceRight = function (e, t, n) {
                        var i = oa(e) ? f : x,
                            r = 3 > arguments.length;
                        return i(e, mi(t, 4), n, r, os);
                    }),
                    (ke.repeat = function (e, t, n) {
                        return (t = (n ? Ai(e, t, n) : t === R) ? 1 : Sr(t)), sn(Ar(e), t);
                    }),
                    (ke.replace = function () {
                        var e = arguments,
                            t = Ar(e[0]);
                        return 3 > e.length ? t : t.replace(e[1], e[2]);
                    }),
                    (ke.result = function (e, t, n) {
                        t = En(t, e);
                        var i = -1,
                            r = t.length;
                        for (r || ((r = 1), (e = R)); ++i < r; ) {
                            var o = null == e ? R : e[Ni(t[i])];
                            o === R && ((i = r), (o = n)), (e = pr(o) ? o.call(e) : o);
                        }
                        return e;
                    }),
                    (ke.round = tl),
                    (ke.runInContext = w),
                    (ke.sample = function (e) {
                        return (oa(e) ? Ze : ln)(e);
                    }),
                    (ke.size = function (e) {
                        if (null == e) return 0;
                        if (cr(e)) return wr(e) ? N(e) : e.length;
                        var t = gs(e);
                        return "[object Map]" == t || "[object Set]" == t ? e.size : Bt(e).length;
                    }),
                    (ke.snakeCase = Oa),
                    (ke.some = function (e, t, n) {
                        var i = oa(e) ? d : pn;
                        return n && Ai(e, t, n) && (t = R), i(e, mi(t, 3));
                    }),
                    (ke.sortedIndex = function (e, t) {
                        return hn(e, t);
                    }),
                    (ke.sortedIndexBy = function (e, t, n) {
                        return gn(e, t, mi(n, 2));
                    }),
                    (ke.sortedIndexOf = function (e, t) {
                        var n = null == e ? 0 : e.length;
                        if (n) {
                            var i = hn(e, t);
                            if (i < n && ur(e[i], t)) return i;
                        }
                        return -1;
                    }),
                    (ke.sortedLastIndex = function (e, t) {
                        return hn(e, t, !0);
                    }),
                    (ke.sortedLastIndexBy = function (e, t, n) {
                        return gn(e, t, mi(n, 2), !0);
                    }),
                    (ke.sortedLastIndexOf = function (e, t) {
                        if (null == e ? 0 : e.length) {
                            var n = hn(e, t, !0) - 1;
                            if (ur(e[n], t)) return n;
                        }
                        return -1;
                    }),
                    (ke.startCase = Ia),
                    (ke.startsWith = function (e, t, n) {
                        return (e = Ar(e)), (n = null == n ? 0 : dt(Sr(n), 0, e.length)), (t = mn(t)), e.slice(n, n + t.length) == t;
                    }),
                    (ke.subtract = nl),
                    (ke.sum = function (e) {
                        return e && e.length ? k(e, Rr) : 0;
                    }),
                    (ke.sumBy = function (e, t) {
                        return e && e.length ? k(e, mi(t, 2)) : 0;
                    }),
                    (ke.template = function (e, t, n) {
                        var i = ke.templateSettings;
                        n && Ai(e, t, n) && (t = R), (e = Ar(e)), (t = ya({}, t, i, li)), (n = ya({}, t.imports, i.imports, li));
                        var r,
                            o,
                            s = Lr(n),
                            a = E(n, s),
                            l = 0;
                        n = t.interpolate || we;
                        var u = "__p+='";
                        n = Jr((t.escape || we).source + "|" + n.source + "|" + (n === J ? de : we).source + "|" + (t.evaluate || we).source + "|$", "g");
                        var c = "sourceURL" in t ? "//# sourceURL=" + t.sourceURL + "\n" : "";
                        if (
                            (e.replace(n, function (t, n, i, s, a, c) {
                                return (
                                    i || (i = s),
                                    (u += e.slice(l, c).replace(xe, L)),
                                    n && ((r = !0), (u += "'+__e(" + n + ")+'")),
                                    a && ((o = !0), (u += "';" + a + ";\n__p+='")),
                                    i && (u += "'+((__t=(" + i + "))==null?'':__t)+'"),
                                    (l = c + t.length),
                                    t
                                );
                            }),
                            (u += "';"),
                            (t = t.variable) || (u = "with(obj){" + u + "}"),
                            (u = (o ? u.replace(F, "") : u).replace(U, "$1").replace(B, "$1;")),
                            (u =
                                "function(" +
                                (t || "obj") +
                                "){" +
                                (t ? "" : "obj||(obj={});") +
                                "var __t,__p=''" +
                                (r ? ",__e=_.escape" : "") +
                                (o ? ",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}" : ";") +
                                u +
                                "return __p}"),
                            (t = Ra(function () {
                                return Qr(s, c + "return " + u).apply(R, a);
                            })),
                            (t.source = u),
                            dr(t))
                        )
                            throw t;
                        return t;
                    }),
                    (ke.times = function (e, t) {
                        if (((e = Sr(e)), 1 > e || 9007199254740991 < e)) return [];
                        var n = 4294967295,
                            i = Io(e, 4294967295);
                        for (t = mi(t), e -= 4294967295, i = S(i, t); ++n < e; ) t(n);
                        return i;
                    }),
                    (ke.toFinite = kr),
                    (ke.toInteger = Sr),
                    (ke.toLength = Cr),
                    (ke.toLower = function (e) {
                        return Ar(e).toLowerCase();
                    }),
                    (ke.toNumber = Tr),
                    (ke.toSafeInteger = function (e) {
                        return e ? dt(Sr(e), -9007199254740991, 9007199254740991) : 0 === e ? e : 0;
                    }),
                    (ke.toString = Ar),
                    (ke.toUpper = function (e) {
                        return Ar(e).toUpperCase();
                    }),
                    (ke.trim = function (e, t, n) {
                        return (e = Ar(e)) && (n || t === R) ? e.replace(re, "") : e && (t = mn(t)) ? ((e = M(e)), (n = M(t)), (t = j(e, n)), (n = D(e, n) + 1), An(e, t, n).join("")) : e;
                    }),
                    (ke.trimEnd = function (e, t, n) {
                        return (e = Ar(e)) && (n || t === R) ? e.replace(se, "") : e && (t = mn(t)) ? ((e = M(e)), (t = D(e, M(t)) + 1), An(e, 0, t).join("")) : e;
                    }),
                    (ke.trimStart = function (e, t, n) {
                        return (e = Ar(e)) && (n || t === R) ? e.replace(oe, "") : e && (t = mn(t)) ? ((e = M(e)), (t = j(e, M(t))), An(e, t).join("")) : e;
                    }),
                    (ke.truncate = function (e, t) {
                        var n = 30,
                            i = "...";
                        if (vr(t))
                            var r = "separator" in t ? t.separator : r,
                                n = "length" in t ? Sr(t.length) : n,
                                i = "omission" in t ? mn(t.omission) : i;
                        e = Ar(e);
                        var o = e.length;
                        if (je.test(e))
                            var s = M(e),
                                o = s.length;
                        if (n >= o) return e;
                        if (((o = n - N(i)), 1 > o)) return i;
                        if (((n = s ? An(s, 0, o).join("") : e.slice(0, o)), r === R)) return n + i;
                        if ((s && (o += n.length - o), ca(r))) {
                            if (e.slice(o).search(r)) {
                                var a = n;
                                for (r.global || (r = Jr(r.source, Ar(pe.exec(r)) + "g")), r.lastIndex = 0; (s = r.exec(a)); ) var l = s.index;
                                n = n.slice(0, l === R ? o : l);
                            }
                        } else e.indexOf(mn(r), o) != o && ((r = n.lastIndexOf(r)), -1 < r && (n = n.slice(0, r)));
                        return n + i;
                    }),
                    (ke.unescape = function (e) {
                        return (e = Ar(e)) && G.test(e) ? e.replace(X, et) : e;
                    }),
                    (ke.uniqueId = function (e) {
                        var t = ++so;
                        return Ar(e) + t;
                    }),
                    (ke.upperCase = Na),
                    (ke.upperFirst = Ma),
                    (ke.each = Ki),
                    (ke.eachRight = er),
                    (ke.first = Ui),
                    Hr(
                        ke,
                        (function () {
                            var e = {};
                            return (
                                _t(ke, function (t, n) {
                                    oo.call(ke.prototype, n) || (e[n] = t);
                                }),
                                e
                            );
                        })(),
                        { chain: !1 }
                    ),
                    (ke.VERSION = "4.17.10"),
                    n("bind bindKey curry curryRight partial partialRight".split(" "), function (e) {
                        ke[e].placeholder = ke;
                    }),
                    n(["drop", "take"], function (e, t) {
                        (ze.prototype[e] = function (n) {
                            n = n === R ? 1 : Oo(Sr(n), 0);
                            var i = this.__filtered__ && !t ? new ze(this) : this.clone();
                            return i.__filtered__ ? (i.__takeCount__ = Io(n, i.__takeCount__)) : i.__views__.push({ size: Io(n, 4294967295), type: e + (0 > i.__dir__ ? "Right" : "") }), i;
                        }),
                            (ze.prototype[e + "Right"] = function (t) {
                                return this.reverse()[e](t).reverse();
                            });
                    }),
                    n(["filter", "map", "takeWhile"], function (e, t) {
                        var n = t + 1,
                            i = 1 == n || 3 == n;
                        ze.prototype[e] = function (e) {
                            var t = this.clone();
                            return t.__iteratees__.push({ iteratee: mi(e, 3), type: n }), (t.__filtered__ = t.__filtered__ || i), t;
                        };
                    }),
                    n(["head", "last"], function (e, t) {
                        var n = "take" + (t ? "Right" : "");
                        ze.prototype[e] = function () {
                            return this[n](1).value()[0];
                        };
                    }),
                    n(["initial", "tail"], function (e, t) {
                        var n = "drop" + (t ? "" : "Right");
                        ze.prototype[e] = function () {
                            return this.__filtered__ ? new ze(this) : this[n](1);
                        };
                    }),
                    (ze.prototype.compact = function () {
                        return this.filter(Rr);
                    }),
                    (ze.prototype.find = function (e) {
                        return this.filter(e).head();
                    }),
                    (ze.prototype.findLast = function (e) {
                        return this.reverse().find(e);
                    }),
                    (ze.prototype.invokeMap = an(function (e, t) {
                        return "function" == typeof e
                            ? new ze(this)
                            : this.map(function (n) {
                                  return $t(n, e, t);
                              });
                    })),
                    (ze.prototype.reject = function (e) {
                        return this.filter(lr(mi(e)));
                    }),
                    (ze.prototype.slice = function (e, t) {
                        e = Sr(e);
                        var n = this;
                        return n.__filtered__ && (0 < e || 0 > t) ? new ze(n) : (0 > e ? (n = n.takeRight(-e)) : e && (n = n.drop(e)), t !== R && ((t = Sr(t)), (n = 0 > t ? n.dropRight(-t) : n.take(t - e))), n);
                    }),
                    (ze.prototype.takeRightWhile = function (e) {
                        return this.reverse().takeWhile(e).reverse();
                    }),
                    (ze.prototype.toArray = function () {
                        return this.take(4294967295);
                    }),
                    _t(ze.prototype, function (e, t) {
                        var n = /^(?:filter|find|map|reject)|While$/.test(t),
                            i = /^(?:head|last)$/.test(t),
                            r = ke[i ? "take" + ("last" == t ? "Right" : "") : t],
                            o = i || /^find/.test(t);
                        r &&
                            (ke.prototype[t] = function () {
                                function t(e) {
                                    return (e = r.apply(ke, u([e], a))), i && d ? e[0] : e;
                                }
                                var s = this.__wrapped__,
                                    a = i ? [1] : arguments,
                                    l = s instanceof ze,
                                    c = a[0],
                                    f = l || oa(s);
                                f && n && "function" == typeof c && 1 != c.length && (l = f = !1);
                                var d = this.__chain__,
                                    p = !!this.__actions__.length,
                                    c = o && !d,
                                    l = l && !p;
                                return !o && f
                                    ? ((s = l ? s : new ze(this)), (s = e.apply(s, a)), s.__actions__.push({ func: Zi, args: [t], thisArg: R }), new Ee(s, d))
                                    : c && l
                                    ? e.apply(this, a)
                                    : ((s = this.thru(t)), c ? (i ? s.value()[0] : s.value()) : s);
                            });
                    }),
                    n("pop push shift sort splice unshift".split(" "), function (e) {
                        var t = to[e],
                            n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                            i = /^(?:pop|shift)$/.test(e);
                        ke.prototype[e] = function () {
                            var e = arguments;
                            if (i && !this.__chain__) {
                                var r = this.value();
                                return t.apply(oa(r) ? r : [], e);
                            }
                            return this[n](function (n) {
                                return t.apply(oa(n) ? n : [], e);
                            });
                        };
                    }),
                    _t(ze.prototype, function (e, t) {
                        var n = ke[t];
                        if (n) {
                            var i = n.name + "";
                            (Go[i] || (Go[i] = [])).push({ name: t, func: n });
                        }
                    }),
                    (Go[Yn(R, 2).name] = [{ name: "wrapper", func: R }]),
                    (ze.prototype.clone = function () {
                        var e = new ze(this.__wrapped__);
                        return (
                            (e.__actions__ = On(this.__actions__)),
                            (e.__dir__ = this.__dir__),
                            (e.__filtered__ = this.__filtered__),
                            (e.__iteratees__ = On(this.__iteratees__)),
                            (e.__takeCount__ = this.__takeCount__),
                            (e.__views__ = On(this.__views__)),
                            e
                        );
                    }),
                    (ze.prototype.reverse = function () {
                        if (this.__filtered__) {
                            var e = new ze(this);
                            (e.__dir__ = -1), (e.__filtered__ = !0);
                        } else (e = this.clone()), (e.__dir__ *= -1);
                        return e;
                    }),
                    (ze.prototype.value = function () {
                        var e,
                            t = this.__wrapped__.value(),
                            n = this.__dir__,
                            i = oa(t),
                            r = 0 > n,
                            o = i ? t.length : 0;
                        e = o;
                        for (var s = this.__views__, a = 0, l = -1, u = s.length; ++l < u; ) {
                            var c = s[l],
                                f = c.size;
                            switch (c.type) {
                                case "drop":
                                    a += f;
                                    break;
                                case "dropRight":
                                    e -= f;
                                    break;
                                case "take":
                                    e = Io(e, a + f);
                                    break;
                                case "takeRight":
                                    a = Oo(a, e - f);
                            }
                        }
                        if (((e = { start: a, end: e }), (s = e.start), (a = e.end), (e = a - s), (s = r ? a : s - 1), (a = this.__iteratees__), (l = a.length), (u = 0), (c = Io(e, this.__takeCount__)), !i || (!r && o == e && c == e)))
                            return _n(t, this.__actions__);
                        i = [];
                        e: for (; e-- && u < c; ) {
                            for (s += n, r = -1, o = t[s]; ++r < l; ) {
                                var d = a[r],
                                    f = d.type,
                                    d = (0, d.iteratee)(o);
                                if (2 == f) o = d;
                                else if (!d) {
                                    if (1 == f) continue e;
                                    break e;
                                }
                            }
                            i[u++] = o;
                        }
                        return i;
                    }),
                    (ke.prototype.at = Ms),
                    (ke.prototype.chain = function () {
                        return Yi(this);
                    }),
                    (ke.prototype.commit = function () {
                        return new Ee(this.value(), this.__chain__);
                    }),
                    (ke.prototype.next = function () {
                        this.__values__ === R && (this.__values__ = _r(this.value()));
                        var e = this.__index__ >= this.__values__.length;
                        return { done: e, value: e ? R : this.__values__[this.__index__++] };
                    }),
                    (ke.prototype.plant = function (e) {
                        for (var t, n = this; n instanceof Se; ) {
                            var i = qi(n);
                            (i.__index__ = 0), (i.__values__ = R), t ? (r.__wrapped__ = i) : (t = i);
                            var r = i,
                                n = n.__wrapped__;
                        }
                        return (r.__wrapped__ = e), t;
                    }),
                    (ke.prototype.reverse = function () {
                        var e = this.__wrapped__;
                        return e instanceof ze ? (this.__actions__.length && (e = new ze(this)), (e = e.reverse()), e.__actions__.push({ func: Zi, args: [Vi], thisArg: R }), new Ee(e, this.__chain__)) : this.thru(Vi);
                    }),
                    (ke.prototype.toJSON = ke.prototype.valueOf = ke.prototype.value = function () {
                        return _n(this.__wrapped__, this.__actions__);
                    }),
                    (ke.prototype.first = ke.prototype.head),
                    _o && (ke.prototype[_o] = Ji),
                    ke
                );
            })();
        "function" == typeof define && "object" == typeof define.amd && define.amd
            ? ((Re._ = tt),
              define(function () {
                  return tt;
              }))
            : He
            ? (((He.exports = tt)._ = tt), (qe._ = tt))
            : (Re._ = tt);
    }.call(this) /*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */,
    !(function (e, t) {
        "use strict";
        "object" == typeof module && "object" == typeof module.exports
            ? (module.exports = e.document
                  ? t(e, !0)
                  : function (e) {
                        if (!e.document) throw new Error("jQuery requires a window with a document");
                        return t(e);
                    })
            : t(e);
    })("undefined" != typeof window ? window : this, function (e, t) {
        "use strict";
        function n(e, t, n) {
            var i,
                r = (t = t || se).createElement("script");
            if (((r.text = e), n)) for (i in we) n[i] && (r[i] = n[i]);
            t.head.appendChild(r).parentNode.removeChild(r);
        }
        function i(e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? de[pe.call(e)] || "object" : typeof e;
        }
        function r(e) {
            var t = !!e && "length" in e && e.length,
                n = i(e);
            return !me(e) && !be(e) && ("array" === n || 0 === t || ("number" == typeof t && t > 0 && t - 1 in e));
        }
        function o(e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
        }
        function s(e, t, n) {
            return me(t)
                ? xe.grep(e, function (e, i) {
                      return !!t.call(e, i, e) !== n;
                  })
                : t.nodeType
                ? xe.grep(e, function (e) {
                      return (e === t) !== n;
                  })
                : "string" != typeof t
                ? xe.grep(e, function (e) {
                      return fe.call(t, e) > -1 !== n;
                  })
                : xe.filter(t, e, n);
        }
        function a(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType; );
            return e;
        }
        function l(e) {
            var t = {};
            return (
                xe.each(e.match(Pe) || [], function (e, n) {
                    t[n] = !0;
                }),
                t
            );
        }
        function u(e) {
            return e;
        }
        function c(e) {
            throw e;
        }
        function f(e, t, n, i) {
            var r;
            try {
                e && me((r = e.promise)) ? r.call(e).done(t).fail(n) : e && me((r = e.then)) ? r.call(e, t, n) : t.apply(void 0, [e].slice(i));
            } catch (e) {
                n.apply(void 0, [e]);
            }
        }
        function d() {
            se.removeEventListener("DOMContentLoaded", d), e.removeEventListener("load", d), xe.ready();
        }
        function p(e, t) {
            return t.toUpperCase();
        }
        function h(e) {
            return e.replace(Ie, "ms-").replace(Ne, p);
        }
        function g() {
            this.expando = xe.expando + g.uid++;
        }
        function v(e) {
            return "true" === e || ("false" !== e && ("null" === e ? null : e === +e + "" ? +e : He.test(e) ? JSON.parse(e) : e));
        }
        function y(e, t, n) {
            var i;
            if (void 0 === n && 1 === e.nodeType)
                if (((i = "data-" + t.replace(We, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(i)))) {
                    try {
                        n = v(n);
                    } catch (e) {}
                    qe.set(e, t, n);
                } else n = void 0;
            return n;
        }
        function m(e, t, n, i) {
            var r,
                o,
                s = 20,
                a = i
                    ? function () {
                          return i.cur();
                      }
                    : function () {
                          return xe.css(e, t, "");
                      },
                l = a(),
                u = (n && n[3]) || (xe.cssNumber[t] ? "" : "px"),
                c = (xe.cssNumber[t] || ("px" !== u && +l)) && Ue.exec(xe.css(e, t));
            if (c && c[3] !== u) {
                for (l /= 2, u = u || c[3], c = +l || 1; s--; ) xe.style(e, t, c + u), (1 - o) * (1 - (o = a() / l || 0.5)) <= 0 && (s = 0), (c /= o);
                (c *= 2), xe.style(e, t, c + u), (n = n || []);
            }
            return n && ((c = +c || +l || 0), (r = n[1] ? c + (n[1] + 1) * n[2] : +n[2]), i && ((i.unit = u), (i.start = c), (i.end = r))), r;
        }
        function b(e) {
            var t,
                n = e.ownerDocument,
                i = e.nodeName,
                r = Ge[i];
            return r || ((t = n.body.appendChild(n.createElement(i))), (r = xe.css(t, "display")), t.parentNode.removeChild(t), "none" === r && (r = "block"), (Ge[i] = r), r);
        }
        function w(e, t) {
            for (var n, i, r = [], o = 0, s = e.length; o < s; o++)
                (i = e[o]).style &&
                    ((n = i.style.display),
                    t ? ("none" === n && ((r[o] = Re.get(i, "display") || null), r[o] || (i.style.display = "")), "" === i.style.display && Xe(i) && (r[o] = b(i))) : "none" !== n && ((r[o] = "none"), Re.set(i, "display", n)));
            for (o = 0; o < s; o++) null != r[o] && (e[o].style.display = r[o]);
            return e;
        }
        function x(e, t) {
            var n;
            return (n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : []), void 0 === t || (t && o(e, t)) ? xe.merge([e], n) : n;
        }
        function _(e, t) {
            for (var n = 0, i = e.length; n < i; n++) Re.set(e[n], "globalEval", !t || Re.get(t[n], "globalEval"));
        }
        function k(e, t, n, r, o) {
            for (var s, a, l, u, c, f, d = t.createDocumentFragment(), p = [], h = 0, g = e.length; h < g; h++)
                if ((s = e[h]) || 0 === s)
                    if ("object" === i(s)) xe.merge(p, s.nodeType ? [s] : s);
                    else if (Ke.test(s)) {
                        for (a = a || d.appendChild(t.createElement("div")), l = (Ye.exec(s) || ["", ""])[1].toLowerCase(), u = Je[l] || Je._default, a.innerHTML = u[1] + xe.htmlPrefilter(s) + u[2], f = u[0]; f--; ) a = a.lastChild;
                        xe.merge(p, a.childNodes), ((a = d.firstChild).textContent = "");
                    } else p.push(t.createTextNode(s));
            for (d.textContent = "", h = 0; (s = p[h++]); )
                if (r && xe.inArray(s, r) > -1) o && o.push(s);
                else if (((c = xe.contains(s.ownerDocument, s)), (a = x(d.appendChild(s), "script")), c && _(a), n)) for (f = 0; (s = a[f++]); ) Ze.test(s.type || "") && n.push(s);
            return d;
        }
        function S() {
            return !0;
        }
        function C() {
            return !1;
        }
        function T() {
            try {
                return se.activeElement;
            } catch (e) {}
        }
        function E(e, t, n, i, r, o) {
            var s, a;
            if ("object" == typeof t) {
                "string" != typeof n && ((i = i || n), (n = void 0));
                for (a in t) E(e, a, n, i, t[a], o);
                return e;
            }
            if ((null == i && null == r ? ((r = n), (i = n = void 0)) : null == r && ("string" == typeof n ? ((r = i), (i = void 0)) : ((r = i), (i = n), (n = void 0))), !1 === r)) r = C;
            else if (!r) return e;
            return (
                1 === o &&
                    ((s = r),
                    ((r = function (e) {
                        return xe().off(e), s.apply(this, arguments);
                    }).guid = s.guid || (s.guid = xe.guid++))),
                e.each(function () {
                    xe.event.add(this, t, r, i, n);
                })
            );
        }
        function A(e, t) {
            return o(e, "table") && o(11 !== t.nodeType ? t : t.firstChild, "tr") ? xe(e).children("tbody")[0] || e : e;
        }
        function j(e) {
            return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
        }
        function D(e) {
            return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
        }
        function L(e, t) {
            var n, i, r, o, s, a, l, u;
            if (1 === t.nodeType) {
                if (Re.hasData(e) && ((o = Re.access(e)), (s = Re.set(t, o)), (u = o.events))) {
                    delete s.handle, (s.events = {});
                    for (r in u) for (n = 0, i = u[r].length; n < i; n++) xe.event.add(t, r, u[r][n]);
                }
                qe.hasData(e) && ((a = qe.access(e)), (l = xe.extend({}, a)), qe.set(t, l));
            }
        }
        function P(e, t) {
            var n = t.nodeName.toLowerCase();
            "input" === n && Qe.test(e.type) ? (t.checked = e.checked) : ("input" !== n && "textarea" !== n) || (t.defaultValue = e.defaultValue);
        }
        function $(e, t, i, r) {
            t = ue.apply([], t);
            var o,
                s,
                a,
                l,
                u,
                c,
                f = 0,
                d = e.length,
                p = d - 1,
                h = t[0],
                g = me(h);
            if (g || (d > 1 && "string" == typeof h && !ye.checkClone && st.test(h)))
                return e.each(function (n) {
                    var o = e.eq(n);
                    g && (t[0] = h.call(this, n, o.html())), $(o, t, i, r);
                });
            if (d && ((o = k(t, e[0].ownerDocument, !1, e, r)), (s = o.firstChild), 1 === o.childNodes.length && (o = s), s || r)) {
                for (l = (a = xe.map(x(o, "script"), j)).length; f < d; f++) (u = o), f !== p && ((u = xe.clone(u, !0, !0)), l && xe.merge(a, x(u, "script"))), i.call(e[f], u, f);
                if (l)
                    for (c = a[a.length - 1].ownerDocument, xe.map(a, D), f = 0; f < l; f++)
                        (u = a[f]),
                            Ze.test(u.type || "") && !Re.access(u, "globalEval") && xe.contains(c, u) && (u.src && "module" !== (u.type || "").toLowerCase() ? xe._evalUrl && xe._evalUrl(u.src) : n(u.textContent.replace(at, ""), c, u));
            }
            return e;
        }
        function z(e, t, n) {
            for (var i, r = t ? xe.filter(t, e) : e, o = 0; null != (i = r[o]); o++) n || 1 !== i.nodeType || xe.cleanData(x(i)), i.parentNode && (n && xe.contains(i.ownerDocument, i) && _(x(i, "script")), i.parentNode.removeChild(i));
            return e;
        }
        function O(e, t, n) {
            var i,
                r,
                o,
                s,
                a = e.style;
            return (
                (n = n || ut(e)) &&
                    ("" !== (s = n.getPropertyValue(t) || n[t]) || xe.contains(e.ownerDocument, e) || (s = xe.style(e, t)),
                    !ye.pixelBoxStyles() && lt.test(s) && ct.test(t) && ((i = a.width), (r = a.minWidth), (o = a.maxWidth), (a.minWidth = a.maxWidth = a.width = s), (s = n.width), (a.width = i), (a.minWidth = r), (a.maxWidth = o))),
                void 0 !== s ? s + "" : s
            );
        }
        function I(e, t) {
            return {
                get: function () {
                    return e() ? void delete this.get : (this.get = t).apply(this, arguments);
                },
            };
        }
        function N(e) {
            if (e in vt) return e;
            for (var t = e[0].toUpperCase() + e.slice(1), n = gt.length; n--; ) if ((e = gt[n] + t) in vt) return e;
        }
        function M(e) {
            var t = xe.cssProps[e];
            return t || (t = xe.cssProps[e] = N(e) || e), t;
        }
        function R(e, t, n) {
            var i = Ue.exec(t);
            return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
        }
        function q(e, t, n, i, r, o) {
            var s = "width" === t ? 1 : 0,
                a = 0,
                l = 0;
            if (n === (i ? "border" : "content")) return 0;
            for (; s < 4; s += 2)
                "margin" === n && (l += xe.css(e, n + Be[s], !0, r)),
                    i
                        ? ("content" === n && (l -= xe.css(e, "padding" + Be[s], !0, r)), "margin" !== n && (l -= xe.css(e, "border" + Be[s] + "Width", !0, r)))
                        : ((l += xe.css(e, "padding" + Be[s], !0, r)), "padding" !== n ? (l += xe.css(e, "border" + Be[s] + "Width", !0, r)) : (a += xe.css(e, "border" + Be[s] + "Width", !0, r)));
            return !i && o >= 0 && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - l - a - 0.5))), l;
        }
        function H(e, t, n) {
            var i = ut(e),
                r = O(e, t, i),
                o = "border-box" === xe.css(e, "boxSizing", !1, i),
                s = o;
            if (lt.test(r)) {
                if (!n) return r;
                r = "auto";
            }
            return (
                (s = s && (ye.boxSizingReliable() || r === e.style[t])),
                ("auto" === r || (!parseFloat(r) && "inline" === xe.css(e, "display", !1, i))) && ((r = e["offset" + t[0].toUpperCase() + t.slice(1)]), (s = !0)),
                (r = parseFloat(r) || 0) + q(e, t, n || (o ? "border" : "content"), s, i, r) + "px"
            );
        }
        function W(e, t, n, i, r) {
            return new W.prototype.init(e, t, n, i, r);
        }
        function F() {
            mt && (!1 === se.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(F) : e.setTimeout(F, xe.fx.interval), xe.fx.tick());
        }
        function U() {
            return (
                e.setTimeout(function () {
                    yt = void 0;
                }),
                (yt = Date.now())
            );
        }
        function B(e, t) {
            var n,
                i = 0,
                r = { height: e };
            for (t = t ? 1 : 0; i < 4; i += 2 - t) r["margin" + (n = Be[i])] = r["padding" + n] = e;
            return t && (r.opacity = r.width = e), r;
        }
        function X(e, t, n) {
            for (var i, r = (Q.tweeners[t] || []).concat(Q.tweeners["*"]), o = 0, s = r.length; o < s; o++) if ((i = r[o].call(n, t, e))) return i;
        }
        function V(e, t, n) {
            var i,
                r,
                o,
                s,
                a,
                l,
                u,
                c,
                f = "width" in t || "height" in t,
                d = this,
                p = {},
                h = e.style,
                g = e.nodeType && Xe(e),
                v = Re.get(e, "fxshow");
            n.queue ||
                (null == (s = xe._queueHooks(e, "fx")).unqueued &&
                    ((s.unqueued = 0),
                    (a = s.empty.fire),
                    (s.empty.fire = function () {
                        s.unqueued || a();
                    })),
                s.unqueued++,
                d.always(function () {
                    d.always(function () {
                        s.unqueued--, xe.queue(e, "fx").length || s.empty.fire();
                    });
                }));
            for (i in t)
                if (((r = t[i]), bt.test(r))) {
                    if ((delete t[i], (o = o || "toggle" === r), r === (g ? "hide" : "show"))) {
                        if ("show" !== r || !v || void 0 === v[i]) continue;
                        g = !0;
                    }
                    p[i] = (v && v[i]) || xe.style(e, i);
                }
            if ((l = !xe.isEmptyObject(t)) || !xe.isEmptyObject(p)) {
                f &&
                    1 === e.nodeType &&
                    ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                    null == (u = v && v.display) && (u = Re.get(e, "display")),
                    "none" === (c = xe.css(e, "display")) && (u ? (c = u) : (w([e], !0), (u = e.style.display || u), (c = xe.css(e, "display")), w([e]))),
                    ("inline" === c || ("inline-block" === c && null != u)) &&
                        "none" === xe.css(e, "float") &&
                        (l ||
                            (d.done(function () {
                                h.display = u;
                            }),
                            null == u && ((c = h.display), (u = "none" === c ? "" : c))),
                        (h.display = "inline-block"))),
                    n.overflow &&
                        ((h.overflow = "hidden"),
                        d.always(function () {
                            (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
                        })),
                    (l = !1);
                for (i in p)
                    l ||
                        (v ? "hidden" in v && (g = v.hidden) : (v = Re.access(e, "fxshow", { display: u })),
                        o && (v.hidden = !g),
                        g && w([e], !0),
                        d.done(function () {
                            g || w([e]), Re.remove(e, "fxshow");
                            for (i in p) xe.style(e, i, p[i]);
                        })),
                        (l = X(g ? v[i] : 0, i, d)),
                        i in v || ((v[i] = l.start), g && ((l.end = l.start), (l.start = 0)));
            }
        }
        function G(e, t) {
            var n, i, r, o, s;
            for (n in e)
                if (((i = h(n)), (r = t[i]), (o = e[n]), Array.isArray(o) && ((r = o[1]), (o = e[n] = o[0])), n !== i && ((e[i] = o), delete e[n]), (s = xe.cssHooks[i]) && "expand" in s)) {
                    (o = s.expand(o)), delete e[i];
                    for (n in o) n in e || ((e[n] = o[n]), (t[n] = r));
                } else t[i] = r;
        }
        function Q(e, t, n) {
            var i,
                r,
                o = 0,
                s = Q.prefilters.length,
                a = xe.Deferred().always(function () {
                    delete l.elem;
                }),
                l = function () {
                    if (r) return !1;
                    for (var t = yt || U(), n = Math.max(0, u.startTime + u.duration - t), i = 1 - (n / u.duration || 0), o = 0, s = u.tweens.length; o < s; o++) u.tweens[o].run(i);
                    return a.notifyWith(e, [u, i, n]), i < 1 && s ? n : (s || a.notifyWith(e, [u, 1, 0]), a.resolveWith(e, [u]), !1);
                },
                u = a.promise({
                    elem: e,
                    props: xe.extend({}, t),
                    opts: xe.extend(!0, { specialEasing: {}, easing: xe.easing._default }, n),
                    originalProperties: t,
                    originalOptions: n,
                    startTime: yt || U(),
                    duration: n.duration,
                    tweens: [],
                    createTween: function (t, n) {
                        var i = xe.Tween(e, u.opts, t, n, u.opts.specialEasing[t] || u.opts.easing);
                        return u.tweens.push(i), i;
                    },
                    stop: function (t) {
                        var n = 0,
                            i = t ? u.tweens.length : 0;
                        if (r) return this;
                        for (r = !0; n < i; n++) u.tweens[n].run(1);
                        return t ? (a.notifyWith(e, [u, 1, 0]), a.resolveWith(e, [u, t])) : a.rejectWith(e, [u, t]), this;
                    },
                }),
                c = u.props;
            for (G(c, u.opts.specialEasing); o < s; o++) if ((i = Q.prefilters[o].call(u, e, c, u.opts))) return me(i.stop) && (xe._queueHooks(u.elem, u.opts.queue).stop = i.stop.bind(i)), i;
            return (
                xe.map(c, X, u),
                me(u.opts.start) && u.opts.start.call(e, u),
                u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always),
                xe.fx.timer(xe.extend(l, { elem: e, anim: u, queue: u.opts.queue })),
                u
            );
        }
        function Y(e) {
            return (e.match(Pe) || []).join(" ");
        }
        function Z(e) {
            return (e.getAttribute && e.getAttribute("class")) || "";
        }
        function J(e) {
            return Array.isArray(e) ? e : "string" == typeof e ? e.match(Pe) || [] : [];
        }
        function K(e, t, n, r) {
            var o;
            if (Array.isArray(t))
                xe.each(t, function (t, i) {
                    n || Lt.test(e) ? r(e, i) : K(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, r);
                });
            else if (n || "object" !== i(t)) r(e, t);
            else for (o in t) K(e + "[" + o + "]", t[o], n, r);
        }
        function ee(e) {
            return function (t, n) {
                "string" != typeof t && ((n = t), (t = "*"));
                var i,
                    r = 0,
                    o = t.toLowerCase().match(Pe) || [];
                if (me(n)) for (; (i = o[r++]); ) "+" === i[0] ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n);
            };
        }
        function te(e, t, n, i) {
            function r(a) {
                var l;
                return (
                    (o[a] = !0),
                    xe.each(e[a] || [], function (e, a) {
                        var u = a(t, n, i);
                        return "string" != typeof u || s || o[u] ? (s ? !(l = u) : void 0) : (t.dataTypes.unshift(u), r(u), !1);
                    }),
                    l
                );
            }
            var o = {},
                s = e === Ft;
            return r(t.dataTypes[0]) || (!o["*"] && r("*"));
        }
        function ne(e, t) {
            var n,
                i,
                r = xe.ajaxSettings.flatOptions || {};
            for (n in t) void 0 !== t[n] && ((r[n] ? e : i || (i = {}))[n] = t[n]);
            return i && xe.extend(!0, e, i), e;
        }
        function ie(e, t, n) {
            for (var i, r, o, s, a = e.contents, l = e.dataTypes; "*" === l[0]; ) l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
            if (i)
                for (r in a)
                    if (a[r] && a[r].test(i)) {
                        l.unshift(r);
                        break;
                    }
            if (l[0] in n) o = l[0];
            else {
                for (r in n) {
                    if (!l[0] || e.converters[r + " " + l[0]]) {
                        o = r;
                        break;
                    }
                    s || (s = r);
                }
                o = o || s;
            }
            if (o) return o !== l[0] && l.unshift(o), n[o];
        }
        function re(e, t, n, i) {
            var r,
                o,
                s,
                a,
                l,
                u = {},
                c = e.dataTypes.slice();
            if (c[1]) for (s in e.converters) u[s.toLowerCase()] = e.converters[s];
            for (o = c.shift(); o; )
                if ((e.responseFields[o] && (n[e.responseFields[o]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (l = o), (o = c.shift())))
                    if ("*" === o) o = l;
                    else if ("*" !== l && l !== o) {
                        if (!(s = u[l + " " + o] || u["* " + o]))
                            for (r in u)
                                if ((a = r.split(" "))[1] === o && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
                                    !0 === s ? (s = u[r]) : !0 !== u[r] && ((o = a[0]), c.unshift(a[1]));
                                    break;
                                }
                        if (!0 !== s)
                            if (s && e.throws) t = s(t);
                            else
                                try {
                                    t = s(t);
                                } catch (e) {
                                    return { state: "parsererror", error: s ? e : "No conversion from " + l + " to " + o };
                                }
                    }
            return { state: "success", data: t };
        }
        var oe = [],
            se = e.document,
            ae = Object.getPrototypeOf,
            le = oe.slice,
            ue = oe.concat,
            ce = oe.push,
            fe = oe.indexOf,
            de = {},
            pe = de.toString,
            he = de.hasOwnProperty,
            ge = he.toString,
            ve = ge.call(Object),
            ye = {},
            me = function (e) {
                return "function" == typeof e && "number" != typeof e.nodeType;
            },
            be = function (e) {
                return null != e && e === e.window;
            },
            we = { type: !0, src: !0, noModule: !0 },
            xe = function (e, t) {
                return new xe.fn.init(e, t);
            },
            _e = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        (xe.fn = xe.prototype = {
            jquery: "3.3.1",
            constructor: xe,
            length: 0,
            toArray: function () {
                return le.call(this);
            },
            get: function (e) {
                return null == e ? le.call(this) : e < 0 ? this[e + this.length] : this[e];
            },
            pushStack: function (e) {
                var t = xe.merge(this.constructor(), e);
                return (t.prevObject = this), t;
            },
            each: function (e) {
                return xe.each(this, e);
            },
            map: function (e) {
                return this.pushStack(
                    xe.map(this, function (t, n) {
                        return e.call(t, n, t);
                    })
                );
            },
            slice: function () {
                return this.pushStack(le.apply(this, arguments));
            },
            first: function () {
                return this.eq(0);
            },
            last: function () {
                return this.eq(-1);
            },
            eq: function (e) {
                var t = this.length,
                    n = +e + (e < 0 ? t : 0);
                return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
            },
            end: function () {
                return this.prevObject || this.constructor();
            },
            push: ce,
            sort: oe.sort,
            splice: oe.splice,
        }),
            (xe.extend = xe.fn.extend = function () {
                var e,
                    t,
                    n,
                    i,
                    r,
                    o,
                    s = arguments[0] || {},
                    a = 1,
                    l = arguments.length,
                    u = !1;
                for ("boolean" == typeof s && ((u = s), (s = arguments[a] || {}), a++), "object" == typeof s || me(s) || (s = {}), a === l && ((s = this), a--); a < l; a++)
                    if (null != (e = arguments[a]))
                        for (t in e)
                            (n = s[t]),
                                s !== (i = e[t]) &&
                                    (u && i && (xe.isPlainObject(i) || (r = Array.isArray(i)))
                                        ? (r ? ((r = !1), (o = n && Array.isArray(n) ? n : [])) : (o = n && xe.isPlainObject(n) ? n : {}), (s[t] = xe.extend(u, o, i)))
                                        : void 0 !== i && (s[t] = i));
                return s;
            }),
            xe.extend({
                expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function (e) {
                    throw new Error(e);
                },
                noop: function () {},
                isPlainObject: function (e) {
                    var t, n;
                    return !(!e || "[object Object]" !== pe.call(e) || ((t = ae(e)) && ("function" != typeof (n = he.call(t, "constructor") && t.constructor) || ge.call(n) !== ve)));
                },
                isEmptyObject: function (e) {
                    var t;
                    for (t in e) return !1;
                    return !0;
                },
                globalEval: function (e) {
                    n(e);
                },
                each: function (e, t) {
                    var n,
                        i = 0;
                    if (r(e)) for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
                    else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
                    return e;
                },
                trim: function (e) {
                    return null == e ? "" : (e + "").replace(_e, "");
                },
                makeArray: function (e, t) {
                    var n = t || [];
                    return null != e && (r(Object(e)) ? xe.merge(n, "string" == typeof e ? [e] : e) : ce.call(n, e)), n;
                },
                inArray: function (e, t, n) {
                    return null == t ? -1 : fe.call(t, e, n);
                },
                merge: function (e, t) {
                    for (var n = +t.length, i = 0, r = e.length; i < n; i++) e[r++] = t[i];
                    return (e.length = r), e;
                },
                grep: function (e, t, n) {
                    for (var i, r = [], o = 0, s = e.length, a = !n; o < s; o++) (i = !t(e[o], o)) !== a && r.push(e[o]);
                    return r;
                },
                map: function (e, t, n) {
                    var i,
                        o,
                        s = 0,
                        a = [];
                    if (r(e)) for (i = e.length; s < i; s++) null != (o = t(e[s], s, n)) && a.push(o);
                    else for (s in e) null != (o = t(e[s], s, n)) && a.push(o);
                    return ue.apply([], a);
                },
                guid: 1,
                support: ye,
            }),
            "function" == typeof Symbol && (xe.fn[Symbol.iterator] = oe[Symbol.iterator]),
            xe.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
                de["[object " + t + "]"] = t.toLowerCase();
            });
        var ke = (function (e) {
            function t(e, t, n, i) {
                var r,
                    o,
                    s,
                    a,
                    l,
                    u,
                    c,
                    d = t && t.ownerDocument,
                    h = t ? t.nodeType : 9;
                if (((n = n || []), "string" != typeof e || !e || (1 !== h && 9 !== h && 11 !== h))) return n;
                if (!i && ((t ? t.ownerDocument || t : H) !== $ && P(t), (t = t || $), O)) {
                    if (11 !== h && (l = ye.exec(e)))
                        if ((r = l[1])) {
                            if (9 === h) {
                                if (!(s = t.getElementById(r))) return n;
                                if (s.id === r) return n.push(s), n;
                            } else if (d && (s = d.getElementById(r)) && R(t, s) && s.id === r) return n.push(s), n;
                        } else {
                            if (l[2]) return J.apply(n, t.getElementsByTagName(e)), n;
                            if ((r = l[3]) && _.getElementsByClassName && t.getElementsByClassName) return J.apply(n, t.getElementsByClassName(r)), n;
                        }
                    if (_.qsa && !X[e + " "] && (!I || !I.test(e))) {
                        if (1 !== h) (d = t), (c = e);
                        else if ("object" !== t.nodeName.toLowerCase()) {
                            for ((a = t.getAttribute("id")) ? (a = a.replace(xe, _e)) : t.setAttribute("id", (a = q)), o = (u = T(e)).length; o--; ) u[o] = "#" + a + " " + p(u[o]);
                            (c = u.join(",")), (d = (me.test(e) && f(t.parentNode)) || t);
                        }
                        if (c)
                            try {
                                return J.apply(n, d.querySelectorAll(c)), n;
                            } catch (e) {
                            } finally {
                                a === q && t.removeAttribute("id");
                            }
                    }
                }
                return A(e.replace(ae, "$1"), t, n, i);
            }
            function n() {
                function e(n, i) {
                    return t.push(n + " ") > k.cacheLength && delete e[t.shift()], (e[n + " "] = i);
                }
                var t = [];
                return e;
            }
            function i(e) {
                return (e[q] = !0), e;
            }
            function r(e) {
                var t = $.createElement("fieldset");
                try {
                    return !!e(t);
                } catch (e) {
                    return !1;
                } finally {
                    t.parentNode && t.parentNode.removeChild(t), (t = null);
                }
            }
            function o(e, t) {
                for (var n = e.split("|"), i = n.length; i--; ) k.attrHandle[n[i]] = t;
            }
            function s(e, t) {
                var n = t && e,
                    i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
                if (i) return i;
                if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
                return e ? 1 : -1;
            }
            function a(e) {
                return function (t) {
                    return "input" === t.nodeName.toLowerCase() && t.type === e;
                };
            }
            function l(e) {
                return function (t) {
                    var n = t.nodeName.toLowerCase();
                    return ("input" === n || "button" === n) && t.type === e;
                };
            }
            function u(e) {
                return function (t) {
                    return "form" in t
                        ? t.parentNode && !1 === t.disabled
                            ? "label" in t
                                ? "label" in t.parentNode
                                    ? t.parentNode.disabled === e
                                    : t.disabled === e
                                : t.isDisabled === e || (t.isDisabled !== !e && Se(t) === e)
                            : t.disabled === e
                        : "label" in t && t.disabled === e;
                };
            }
            function c(e) {
                return i(function (t) {
                    return (
                        (t = +t),
                        i(function (n, i) {
                            for (var r, o = e([], n.length, t), s = o.length; s--; ) n[(r = o[s])] && (n[r] = !(i[r] = n[r]));
                        })
                    );
                });
            }
            function f(e) {
                return e && "undefined" != typeof e.getElementsByTagName && e;
            }
            function d() {}
            function p(e) {
                for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
                return i;
            }
            function h(e, t, n) {
                var i = t.dir,
                    r = t.next,
                    o = r || i,
                    s = n && "parentNode" === o,
                    a = F++;
                return t.first
                    ? function (t, n, r) {
                          for (; (t = t[i]); ) if (1 === t.nodeType || s) return e(t, n, r);
                          return !1;
                      }
                    : function (t, n, l) {
                          var u,
                              c,
                              f,
                              d = [W, a];
                          if (l) {
                              for (; (t = t[i]); ) if ((1 === t.nodeType || s) && e(t, n, l)) return !0;
                          } else
                              for (; (t = t[i]); )
                                  if (1 === t.nodeType || s)
                                      if (((f = t[q] || (t[q] = {})), (c = f[t.uniqueID] || (f[t.uniqueID] = {})), r && r === t.nodeName.toLowerCase())) t = t[i] || t;
                                      else {
                                          if ((u = c[o]) && u[0] === W && u[1] === a) return (d[2] = u[2]);
                                          if (((c[o] = d), (d[2] = e(t, n, l)))) return !0;
                                      }
                          return !1;
                      };
            }
            function g(e) {
                return e.length > 1
                    ? function (t, n, i) {
                          for (var r = e.length; r--; ) if (!e[r](t, n, i)) return !1;
                          return !0;
                      }
                    : e[0];
            }
            function v(e, n, i) {
                for (var r = 0, o = n.length; r < o; r++) t(e, n[r], i);
                return i;
            }
            function y(e, t, n, i, r) {
                for (var o, s = [], a = 0, l = e.length, u = null != t; a < l; a++) (o = e[a]) && ((n && !n(o, i, r)) || (s.push(o), u && t.push(a)));
                return s;
            }
            function m(e, t, n, r, o, s) {
                return (
                    r && !r[q] && (r = m(r)),
                    o && !o[q] && (o = m(o, s)),
                    i(function (i, s, a, l) {
                        var u,
                            c,
                            f,
                            d = [],
                            p = [],
                            h = s.length,
                            g = i || v(t || "*", a.nodeType ? [a] : a, []),
                            m = !e || (!i && t) ? g : y(g, d, e, a, l),
                            b = n ? (o || (i ? e : h || r) ? [] : s) : m;
                        if ((n && n(m, b, a, l), r)) for (u = y(b, p), r(u, [], a, l), c = u.length; c--; ) (f = u[c]) && (b[p[c]] = !(m[p[c]] = f));
                        if (i) {
                            if (o || e) {
                                if (o) {
                                    for (u = [], c = b.length; c--; ) (f = b[c]) && u.push((m[c] = f));
                                    o(null, (b = []), u, l);
                                }
                                for (c = b.length; c--; ) (f = b[c]) && (u = o ? ee(i, f) : d[c]) > -1 && (i[u] = !(s[u] = f));
                            }
                        } else (b = y(b === s ? b.splice(h, b.length) : b)), o ? o(null, s, b, l) : J.apply(s, b);
                    })
                );
            }
            function b(e) {
                for (
                    var t,
                        n,
                        i,
                        r = e.length,
                        o = k.relative[e[0].type],
                        s = o || k.relative[" "],
                        a = o ? 1 : 0,
                        l = h(
                            function (e) {
                                return e === t;
                            },
                            s,
                            !0
                        ),
                        u = h(
                            function (e) {
                                return ee(t, e) > -1;
                            },
                            s,
                            !0
                        ),
                        c = [
                            function (e, n, i) {
                                var r = (!o && (i || n !== j)) || ((t = n).nodeType ? l(e, n, i) : u(e, n, i));
                                return (t = null), r;
                            },
                        ];
                    a < r;
                    a++
                )
                    if ((n = k.relative[e[a].type])) c = [h(g(c), n)];
                    else {
                        if ((n = k.filter[e[a].type].apply(null, e[a].matches))[q]) {
                            for (i = ++a; i < r && !k.relative[e[i].type]; i++);
                            return m(a > 1 && g(c), a > 1 && p(e.slice(0, a - 1).concat({ value: " " === e[a - 2].type ? "*" : "" })).replace(ae, "$1"), n, a < i && b(e.slice(a, i)), i < r && b((e = e.slice(i))), i < r && p(e));
                        }
                        c.push(n);
                    }
                return g(c);
            }
            function w(e, n) {
                var r = n.length > 0,
                    o = e.length > 0,
                    s = function (i, s, a, l, u) {
                        var c,
                            f,
                            d,
                            p = 0,
                            h = "0",
                            g = i && [],
                            v = [],
                            m = j,
                            b = i || (o && k.find.TAG("*", u)),
                            w = (W += null == m ? 1 : Math.random() || 0.1),
                            x = b.length;
                        for (u && (j = s === $ || s || u); h !== x && null != (c = b[h]); h++) {
                            if (o && c) {
                                for (f = 0, s || c.ownerDocument === $ || (P(c), (a = !O)); (d = e[f++]); )
                                    if (d(c, s || $, a)) {
                                        l.push(c);
                                        break;
                                    }
                                u && (W = w);
                            }
                            r && ((c = !d && c) && p--, i && g.push(c));
                        }
                        if (((p += h), r && h !== p)) {
                            for (f = 0; (d = n[f++]); ) d(g, v, s, a);
                            if (i) {
                                if (p > 0) for (; h--; ) g[h] || v[h] || (v[h] = Y.call(l));
                                v = y(v);
                            }
                            J.apply(l, v), u && !i && v.length > 0 && p + n.length > 1 && t.uniqueSort(l);
                        }
                        return u && ((W = w), (j = m)), g;
                    };
                return r ? i(s) : s;
            }
            var x,
                _,
                k,
                S,
                C,
                T,
                E,
                A,
                j,
                D,
                L,
                P,
                $,
                z,
                O,
                I,
                N,
                M,
                R,
                q = "sizzle" + 1 * new Date(),
                H = e.document,
                W = 0,
                F = 0,
                U = n(),
                B = n(),
                X = n(),
                V = function (e, t) {
                    return e === t && (L = !0), 0;
                },
                G = {}.hasOwnProperty,
                Q = [],
                Y = Q.pop,
                Z = Q.push,
                J = Q.push,
                K = Q.slice,
                ee = function (e, t) {
                    for (var n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;
                    return -1;
                },
                te = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                ne = "[\\x20\\t\\r\\n\\f]",
                ie = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
                re = "\\[" + ne + "*(" + ie + ")(?:" + ne + "*([*^$|!~]?=)" + ne + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + ie + "))|)" + ne + "*\\]",
                oe = ":(" + ie + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + re + ")*)|.*)\\)|)",
                se = new RegExp(ne + "+", "g"),
                ae = new RegExp("^" + ne + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ne + "+$", "g"),
                le = new RegExp("^" + ne + "*," + ne + "*"),
                ue = new RegExp("^" + ne + "*([>+~]|" + ne + ")" + ne + "*"),
                ce = new RegExp("=" + ne + "*([^\\]'\"]*?)" + ne + "*\\]", "g"),
                fe = new RegExp(oe),
                de = new RegExp("^" + ie + "$"),
                pe = {
                    ID: new RegExp("^#(" + ie + ")"),
                    CLASS: new RegExp("^\\.(" + ie + ")"),
                    TAG: new RegExp("^(" + ie + "|[*])"),
                    ATTR: new RegExp("^" + re),
                    PSEUDO: new RegExp("^" + oe),
                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ne + "*(even|odd|(([+-]|)(\\d*)n|)" + ne + "*(?:([+-]|)" + ne + "*(\\d+)|))" + ne + "*\\)|)", "i"),
                    bool: new RegExp("^(?:" + te + ")$", "i"),
                    needsContext: new RegExp("^" + ne + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ne + "*((?:-\\d)?\\d*)" + ne + "*\\)|)(?=[^-]|$)", "i"),
                },
                he = /^(?:input|select|textarea|button)$/i,
                ge = /^h\d$/i,
                ve = /^[^{]+\{\s*\[native \w/,
                ye = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                me = /[+~]/,
                be = new RegExp("\\\\([\\da-f]{1,6}" + ne + "?|(" + ne + ")|.)", "ig"),
                we = function (e, t, n) {
                    var i = "0x" + t - 65536;
                    return i !== i || n ? t : i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320);
                },
                xe = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                _e = function (e, t) {
                    return t ? ("\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
                },
                ke = function () {
                    P();
                },
                Se = h(
                    function (e) {
                        return !0 === e.disabled && ("form" in e || "label" in e);
                    },
                    { dir: "parentNode", next: "legend" }
                );
            try {
                J.apply((Q = K.call(H.childNodes)), H.childNodes), Q[H.childNodes.length].nodeType;
            } catch (e) {
                J = {
                    apply: Q.length
                        ? function (e, t) {
                              Z.apply(e, K.call(t));
                          }
                        : function (e, t) {
                              for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                              e.length = n - 1;
                          },
                };
            }
            (_ = t.support = {}),
                (C = t.isXML = function (e) {
                    var t = e && (e.ownerDocument || e).documentElement;
                    return !!t && "HTML" !== t.nodeName;
                }),
                (P = t.setDocument = function (e) {
                    var t,
                        n,
                        i = e ? e.ownerDocument || e : H;
                    return i !== $ && 9 === i.nodeType && i.documentElement
                        ? (($ = i),
                          (z = $.documentElement),
                          (O = !C($)),
                          H !== $ && (n = $.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", ke, !1) : n.attachEvent && n.attachEvent("onunload", ke)),
                          (_.attributes = r(function (e) {
                              return (e.className = "i"), !e.getAttribute("className");
                          })),
                          (_.getElementsByTagName = r(function (e) {
                              return e.appendChild($.createComment("")), !e.getElementsByTagName("*").length;
                          })),
                          (_.getElementsByClassName = ve.test($.getElementsByClassName)),
                          (_.getById = r(function (e) {
                              return (z.appendChild(e).id = q), !$.getElementsByName || !$.getElementsByName(q).length;
                          })),
                          _.getById
                              ? ((k.filter.ID = function (e) {
                                    var t = e.replace(be, we);
                                    return function (e) {
                                        return e.getAttribute("id") === t;
                                    };
                                }),
                                (k.find.ID = function (e, t) {
                                    if ("undefined" != typeof t.getElementById && O) {
                                        var n = t.getElementById(e);
                                        return n ? [n] : [];
                                    }
                                }))
                              : ((k.filter.ID = function (e) {
                                    var t = e.replace(be, we);
                                    return function (e) {
                                        var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                                        return n && n.value === t;
                                    };
                                }),
                                (k.find.ID = function (e, t) {
                                    if ("undefined" != typeof t.getElementById && O) {
                                        var n,
                                            i,
                                            r,
                                            o = t.getElementById(e);
                                        if (o) {
                                            if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                                            for (r = t.getElementsByName(e), i = 0; (o = r[i++]); ) if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                                        }
                                        return [];
                                    }
                                })),
                          (k.find.TAG = _.getElementsByTagName
                              ? function (e, t) {
                                    return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : _.qsa ? t.querySelectorAll(e) : void 0;
                                }
                              : function (e, t) {
                                    var n,
                                        i = [],
                                        r = 0,
                                        o = t.getElementsByTagName(e);
                                    if ("*" === e) {
                                        for (; (n = o[r++]); ) 1 === n.nodeType && i.push(n);
                                        return i;
                                    }
                                    return o;
                                }),
                          (k.find.CLASS =
                              _.getElementsByClassName &&
                              function (e, t) {
                                  if ("undefined" != typeof t.getElementsByClassName && O) return t.getElementsByClassName(e);
                              }),
                          (N = []),
                          (I = []),
                          (_.qsa = ve.test($.querySelectorAll)) &&
                              (r(function (e) {
                                  (z.appendChild(e).innerHTML = "<a id='" + q + "'></a><select id='" + q + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                      e.querySelectorAll("[msallowcapture^='']").length && I.push("[*^$]=" + ne + "*(?:''|\"\")"),
                                      e.querySelectorAll("[selected]").length || I.push("\\[" + ne + "*(?:value|" + te + ")"),
                                      e.querySelectorAll("[id~=" + q + "-]").length || I.push("~="),
                                      e.querySelectorAll(":checked").length || I.push(":checked"),
                                      e.querySelectorAll("a#" + q + "+*").length || I.push(".#.+[+~]");
                              }),
                              r(function (e) {
                                  e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                  var t = $.createElement("input");
                                  t.setAttribute("type", "hidden"),
                                      e.appendChild(t).setAttribute("name", "D"),
                                      e.querySelectorAll("[name=d]").length && I.push("name" + ne + "*[*^$|!~]?="),
                                      2 !== e.querySelectorAll(":enabled").length && I.push(":enabled", ":disabled"),
                                      (z.appendChild(e).disabled = !0),
                                      2 !== e.querySelectorAll(":disabled").length && I.push(":enabled", ":disabled"),
                                      e.querySelectorAll("*,:x"),
                                      I.push(",.*:");
                              })),
                          (_.matchesSelector = ve.test((M = z.matches || z.webkitMatchesSelector || z.mozMatchesSelector || z.oMatchesSelector || z.msMatchesSelector))) &&
                              r(function (e) {
                                  (_.disconnectedMatch = M.call(e, "*")), M.call(e, "[s!='']:x"), N.push("!=", oe);
                              }),
                          (I = I.length && new RegExp(I.join("|"))),
                          (N = N.length && new RegExp(N.join("|"))),
                          (t = ve.test(z.compareDocumentPosition)),
                          (R =
                              t || ve.test(z.contains)
                                  ? function (e, t) {
                                        var n = 9 === e.nodeType ? e.documentElement : e,
                                            i = t && t.parentNode;
                                        return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)));
                                    }
                                  : function (e, t) {
                                        if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                        return !1;
                                    }),
                          (V = t
                              ? function (e, t) {
                                    if (e === t) return (L = !0), 0;
                                    var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                    return (
                                        n ||
                                        (1 & (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!_.sortDetached && t.compareDocumentPosition(e) === n)
                                            ? e === $ || (e.ownerDocument === H && R(H, e))
                                                ? -1
                                                : t === $ || (t.ownerDocument === H && R(H, t))
                                                ? 1
                                                : D
                                                ? ee(D, e) - ee(D, t)
                                                : 0
                                            : 4 & n
                                            ? -1
                                            : 1)
                                    );
                                }
                              : function (e, t) {
                                    if (e === t) return (L = !0), 0;
                                    var n,
                                        i = 0,
                                        r = e.parentNode,
                                        o = t.parentNode,
                                        a = [e],
                                        l = [t];
                                    if (!r || !o) return e === $ ? -1 : t === $ ? 1 : r ? -1 : o ? 1 : D ? ee(D, e) - ee(D, t) : 0;
                                    if (r === o) return s(e, t);
                                    for (n = e; (n = n.parentNode); ) a.unshift(n);
                                    for (n = t; (n = n.parentNode); ) l.unshift(n);
                                    for (; a[i] === l[i]; ) i++;
                                    return i ? s(a[i], l[i]) : a[i] === H ? -1 : l[i] === H ? 1 : 0;
                                }),
                          $)
                        : $;
                }),
                (t.matches = function (e, n) {
                    return t(e, null, null, n);
                }),
                (t.matchesSelector = function (e, n) {
                    if (((e.ownerDocument || e) !== $ && P(e), (n = n.replace(ce, "='$1']")), _.matchesSelector && O && !X[n + " "] && (!N || !N.test(n)) && (!I || !I.test(n))))
                        try {
                            var i = M.call(e, n);
                            if (i || _.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return i;
                        } catch (e) {}
                    return t(n, $, null, [e]).length > 0;
                }),
                (t.contains = function (e, t) {
                    return (e.ownerDocument || e) !== $ && P(e), R(e, t);
                }),
                (t.attr = function (e, t) {
                    (e.ownerDocument || e) !== $ && P(e);
                    var n = k.attrHandle[t.toLowerCase()],
                        i = n && G.call(k.attrHandle, t.toLowerCase()) ? n(e, t, !O) : void 0;
                    return void 0 !== i ? i : _.attributes || !O ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
                }),
                (t.escape = function (e) {
                    return (e + "").replace(xe, _e);
                }),
                (t.error = function (e) {
                    throw new Error("Syntax error, unrecognized expression: " + e);
                }),
                (t.uniqueSort = function (e) {
                    var t,
                        n = [],
                        i = 0,
                        r = 0;
                    if (((L = !_.detectDuplicates), (D = !_.sortStable && e.slice(0)), e.sort(V), L)) {
                        for (; (t = e[r++]); ) t === e[r] && (i = n.push(r));
                        for (; i--; ) e.splice(n[i], 1);
                    }
                    return (D = null), e;
                }),
                (S = t.getText = function (e) {
                    var t,
                        n = "",
                        i = 0,
                        r = e.nodeType;
                    if (r) {
                        if (1 === r || 9 === r || 11 === r) {
                            if ("string" == typeof e.textContent) return e.textContent;
                            for (e = e.firstChild; e; e = e.nextSibling) n += S(e);
                        } else if (3 === r || 4 === r) return e.nodeValue;
                    } else for (; (t = e[i++]); ) n += S(t);
                    return n;
                }),
                ((k = t.selectors = {
                    cacheLength: 50,
                    createPseudo: i,
                    match: pe,
                    attrHandle: {},
                    find: {},
                    relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
                    preFilter: {
                        ATTR: function (e) {
                            return (e[1] = e[1].replace(be, we)), (e[3] = (e[3] || e[4] || e[5] || "").replace(be, we)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                        },
                        CHILD: function (e) {
                            return (
                                (e[1] = e[1].toLowerCase()),
                                "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && t.error(e[0]),
                                e
                            );
                        },
                        PSEUDO: function (e) {
                            var t,
                                n = !e[6] && e[2];
                            return pe.CHILD.test(e[0])
                                ? null
                                : (e[3] ? (e[2] = e[4] || e[5] || "") : n && fe.test(n) && (t = T(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))), e.slice(0, 3));
                        },
                    },
                    filter: {
                        TAG: function (e) {
                            var t = e.replace(be, we).toLowerCase();
                            return "*" === e
                                ? function () {
                                      return !0;
                                  }
                                : function (e) {
                                      return e.nodeName && e.nodeName.toLowerCase() === t;
                                  };
                        },
                        CLASS: function (e) {
                            var t = U[e + " "];
                            return (
                                t ||
                                ((t = new RegExp("(^|" + ne + ")" + e + "(" + ne + "|$)")) &&
                                    U(e, function (e) {
                                        return t.test(("string" == typeof e.className && e.className) || ("undefined" != typeof e.getAttribute && e.getAttribute("class")) || "");
                                    }))
                            );
                        },
                        ATTR: function (e, n, i) {
                            return function (r) {
                                var o = t.attr(r, e);
                                return null == o
                                    ? "!=" === n
                                    : !n ||
                                          ((o += ""),
                                          "=" === n
                                              ? o === i
                                              : "!=" === n
                                              ? o !== i
                                              : "^=" === n
                                              ? i && 0 === o.indexOf(i)
                                              : "*=" === n
                                              ? i && o.indexOf(i) > -1
                                              : "$=" === n
                                              ? i && o.slice(-i.length) === i
                                              : "~=" === n
                                              ? (" " + o.replace(se, " ") + " ").indexOf(i) > -1
                                              : "|=" === n && (o === i || o.slice(0, i.length + 1) === i + "-"));
                            };
                        },
                        CHILD: function (e, t, n, i, r) {
                            var o = "nth" !== e.slice(0, 3),
                                s = "last" !== e.slice(-4),
                                a = "of-type" === t;
                            return 1 === i && 0 === r
                                ? function (e) {
                                      return !!e.parentNode;
                                  }
                                : function (t, n, l) {
                                      var u,
                                          c,
                                          f,
                                          d,
                                          p,
                                          h,
                                          g = o !== s ? "nextSibling" : "previousSibling",
                                          v = t.parentNode,
                                          y = a && t.nodeName.toLowerCase(),
                                          m = !l && !a,
                                          b = !1;
                                      if (v) {
                                          if (o) {
                                              for (; g; ) {
                                                  for (d = t; (d = d[g]); ) if (a ? d.nodeName.toLowerCase() === y : 1 === d.nodeType) return !1;
                                                  h = g = "only" === e && !h && "nextSibling";
                                              }
                                              return !0;
                                          }
                                          if (((h = [s ? v.firstChild : v.lastChild]), s && m)) {
                                              for (
                                                  b = (p = (u = (c = (f = (d = v)[q] || (d[q] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] || [])[0] === W && u[1]) && u[2], d = p && v.childNodes[p];
                                                  (d = (++p && d && d[g]) || (b = p = 0) || h.pop());

                                              )
                                                  if (1 === d.nodeType && ++b && d === t) {
                                                      c[e] = [W, p, b];
                                                      break;
                                                  }
                                          } else if ((m && (b = p = (u = (c = (f = (d = t)[q] || (d[q] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] || [])[0] === W && u[1]), !1 === b))
                                              for (
                                                  ;
                                                  (d = (++p && d && d[g]) || (b = p = 0) || h.pop()) &&
                                                  ((a ? d.nodeName.toLowerCase() !== y : 1 !== d.nodeType) || !++b || (m && ((c = (f = d[q] || (d[q] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] = [W, b]), d !== t));

                                              );
                                          return (b -= r) === i || (b % i == 0 && b / i >= 0);
                                      }
                                  };
                        },
                        PSEUDO: function (e, n) {
                            var r,
                                o = k.pseudos[e] || k.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
                            return o[q]
                                ? o(n)
                                : o.length > 1
                                ? ((r = [e, e, "", n]),
                                  k.setFilters.hasOwnProperty(e.toLowerCase())
                                      ? i(function (e, t) {
                                            for (var i, r = o(e, n), s = r.length; s--; ) e[(i = ee(e, r[s]))] = !(t[i] = r[s]);
                                        })
                                      : function (e) {
                                            return o(e, 0, r);
                                        })
                                : o;
                        },
                    },
                    pseudos: {
                        not: i(function (e) {
                            var t = [],
                                n = [],
                                r = E(e.replace(ae, "$1"));
                            return r[q]
                                ? i(function (e, t, n, i) {
                                      for (var o, s = r(e, null, i, []), a = e.length; a--; ) (o = s[a]) && (e[a] = !(t[a] = o));
                                  })
                                : function (e, i, o) {
                                      return (t[0] = e), r(t, null, o, n), (t[0] = null), !n.pop();
                                  };
                        }),
                        has: i(function (e) {
                            return function (n) {
                                return t(e, n).length > 0;
                            };
                        }),
                        contains: i(function (e) {
                            return (
                                (e = e.replace(be, we)),
                                function (t) {
                                    return (t.textContent || t.innerText || S(t)).indexOf(e) > -1;
                                }
                            );
                        }),
                        lang: i(function (e) {
                            return (
                                de.test(e || "") || t.error("unsupported lang: " + e),
                                (e = e.replace(be, we).toLowerCase()),
                                function (t) {
                                    var n;
                                    do if ((n = O ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                                    while ((t = t.parentNode) && 1 === t.nodeType);
                                    return !1;
                                }
                            );
                        }),
                        target: function (t) {
                            var n = e.location && e.location.hash;
                            return n && n.slice(1) === t.id;
                        },
                        root: function (e) {
                            return e === z;
                        },
                        focus: function (e) {
                            return e === $.activeElement && (!$.hasFocus || $.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                        },
                        enabled: u(!1),
                        disabled: u(!0),
                        checked: function (e) {
                            var t = e.nodeName.toLowerCase();
                            return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                        },
                        selected: function (e) {
                            return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                        },
                        empty: function (e) {
                            for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                            return !0;
                        },
                        parent: function (e) {
                            return !k.pseudos.empty(e);
                        },
                        header: function (e) {
                            return ge.test(e.nodeName);
                        },
                        input: function (e) {
                            return he.test(e.nodeName);
                        },
                        button: function (e) {
                            var t = e.nodeName.toLowerCase();
                            return ("input" === t && "button" === e.type) || "button" === t;
                        },
                        text: function (e) {
                            var t;
                            return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                        },
                        first: c(function () {
                            return [0];
                        }),
                        last: c(function (e, t) {
                            return [t - 1];
                        }),
                        eq: c(function (e, t, n) {
                            return [n < 0 ? n + t : n];
                        }),
                        even: c(function (e, t) {
                            for (var n = 0; n < t; n += 2) e.push(n);
                            return e;
                        }),
                        odd: c(function (e, t) {
                            for (var n = 1; n < t; n += 2) e.push(n);
                            return e;
                        }),
                        lt: c(function (e, t, n) {
                            for (var i = n < 0 ? n + t : n; --i >= 0; ) e.push(i);
                            return e;
                        }),
                        gt: c(function (e, t, n) {
                            for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
                            return e;
                        }),
                    },
                }).pseudos.nth = k.pseudos.eq);
            for (x in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) k.pseudos[x] = a(x);
            for (x in { submit: !0, reset: !0 }) k.pseudos[x] = l(x);
            return (
                (d.prototype = k.filters = k.pseudos),
                (k.setFilters = new d()),
                (T = t.tokenize = function (e, n) {
                    var i,
                        r,
                        o,
                        s,
                        a,
                        l,
                        u,
                        c = B[e + " "];
                    if (c) return n ? 0 : c.slice(0);
                    for (a = e, l = [], u = k.preFilter; a; ) {
                        (i && !(r = le.exec(a))) || (r && (a = a.slice(r[0].length) || a), l.push((o = []))), (i = !1), (r = ue.exec(a)) && ((i = r.shift()), o.push({ value: i, type: r[0].replace(ae, " ") }), (a = a.slice(i.length)));
                        for (s in k.filter) !(r = pe[s].exec(a)) || (u[s] && !(r = u[s](r))) || ((i = r.shift()), o.push({ value: i, type: s, matches: r }), (a = a.slice(i.length)));
                        if (!i) break;
                    }
                    return n ? a.length : a ? t.error(e) : B(e, l).slice(0);
                }),
                (E = t.compile = function (e, t) {
                    var n,
                        i = [],
                        r = [],
                        o = X[e + " "];
                    if (!o) {
                        for (t || (t = T(e)), n = t.length; n--; ) (o = b(t[n]))[q] ? i.push(o) : r.push(o);
                        (o = X(e, w(r, i))).selector = e;
                    }
                    return o;
                }),
                (A = t.select = function (e, t, n, i) {
                    var r,
                        o,
                        s,
                        a,
                        l,
                        u = "function" == typeof e && e,
                        c = !i && T((e = u.selector || e));
                    if (((n = n || []), 1 === c.length)) {
                        if ((o = c[0] = c[0].slice(0)).length > 2 && "ID" === (s = o[0]).type && 9 === t.nodeType && O && k.relative[o[1].type]) {
                            if (!(t = (k.find.ID(s.matches[0].replace(be, we), t) || [])[0])) return n;
                            u && (t = t.parentNode), (e = e.slice(o.shift().value.length));
                        }
                        for (r = pe.needsContext.test(e) ? 0 : o.length; r-- && ((s = o[r]), !k.relative[(a = s.type)]); )
                            if ((l = k.find[a]) && (i = l(s.matches[0].replace(be, we), (me.test(o[0].type) && f(t.parentNode)) || t))) {
                                if ((o.splice(r, 1), !(e = i.length && p(o)))) return J.apply(n, i), n;
                                break;
                            }
                    }
                    return (u || E(e, c))(i, t, !O, n, !t || (me.test(e) && f(t.parentNode)) || t), n;
                }),
                (_.sortStable = q.split("").sort(V).join("") === q),
                (_.detectDuplicates = !!L),
                P(),
                (_.sortDetached = r(function (e) {
                    return 1 & e.compareDocumentPosition($.createElement("fieldset"));
                })),
                r(function (e) {
                    return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
                }) ||
                    o("type|href|height|width", function (e, t, n) {
                        if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                    }),
                (_.attributes &&
                    r(function (e) {
                        return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                    })) ||
                    o("value", function (e, t, n) {
                        if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                    }),
                r(function (e) {
                    return null == e.getAttribute("disabled");
                }) ||
                    o(te, function (e, t, n) {
                        var i;
                        if (!n) return !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
                    }),
                t
            );
        })(e);
        (xe.find = ke), (xe.expr = ke.selectors), (xe.expr[":"] = xe.expr.pseudos), (xe.uniqueSort = xe.unique = ke.uniqueSort), (xe.text = ke.getText), (xe.isXMLDoc = ke.isXML), (xe.contains = ke.contains), (xe.escapeSelector = ke.escape);
        var Se = function (e, t, n) {
                for (var i = [], r = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
                    if (1 === e.nodeType) {
                        if (r && xe(e).is(n)) break;
                        i.push(e);
                    }
                return i;
            },
            Ce = function (e, t) {
                for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
                return n;
            },
            Te = xe.expr.match.needsContext,
            Ee = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
        (xe.filter = function (e, t, n) {
            var i = t[0];
            return (
                n && (e = ":not(" + e + ")"),
                1 === t.length && 1 === i.nodeType
                    ? xe.find.matchesSelector(i, e)
                        ? [i]
                        : []
                    : xe.find.matches(
                          e,
                          xe.grep(t, function (e) {
                              return 1 === e.nodeType;
                          })
                      )
            );
        }),
            xe.fn.extend({
                find: function (e) {
                    var t,
                        n,
                        i = this.length,
                        r = this;
                    if ("string" != typeof e)
                        return this.pushStack(
                            xe(e).filter(function () {
                                for (t = 0; t < i; t++) if (xe.contains(r[t], this)) return !0;
                            })
                        );
                    for (n = this.pushStack([]), t = 0; t < i; t++) xe.find(e, r[t], n);
                    return i > 1 ? xe.uniqueSort(n) : n;
                },
                filter: function (e) {
                    return this.pushStack(s(this, e || [], !1));
                },
                not: function (e) {
                    return this.pushStack(s(this, e || [], !0));
                },
                is: function (e) {
                    return !!s(this, "string" == typeof e && Te.test(e) ? xe(e) : e || [], !1).length;
                },
            });
        var Ae,
            je = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
        ((xe.fn.init = function (e, t, n) {
            var i, r;
            if (!e) return this;
            if (((n = n || Ae), "string" == typeof e)) {
                if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : je.exec(e)) || (!i[1] && t)) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
                if (i[1]) {
                    if (((t = t instanceof xe ? t[0] : t), xe.merge(this, xe.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : se, !0)), Ee.test(i[1]) && xe.isPlainObject(t)))
                        for (i in t) me(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                    return this;
                }
                return (r = se.getElementById(i[2])) && ((this[0] = r), (this.length = 1)), this;
            }
            return e.nodeType ? ((this[0] = e), (this.length = 1), this) : me(e) ? (void 0 !== n.ready ? n.ready(e) : e(xe)) : xe.makeArray(e, this);
        }).prototype = xe.fn),
            (Ae = xe(se));
        var De = /^(?:parents|prev(?:Until|All))/,
            Le = { children: !0, contents: !0, next: !0, prev: !0 };
        xe.fn.extend({
            has: function (e) {
                var t = xe(e, this),
                    n = t.length;
                return this.filter(function () {
                    for (var e = 0; e < n; e++) if (xe.contains(this, t[e])) return !0;
                });
            },
            closest: function (e, t) {
                var n,
                    i = 0,
                    r = this.length,
                    o = [],
                    s = "string" != typeof e && xe(e);
                if (!Te.test(e))
                    for (; i < r; i++)
                        for (n = this[i]; n && n !== t; n = n.parentNode)
                            if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && xe.find.matchesSelector(n, e))) {
                                o.push(n);
                                break;
                            }
                return this.pushStack(o.length > 1 ? xe.uniqueSort(o) : o);
            },
            index: function (e) {
                return e ? ("string" == typeof e ? fe.call(xe(e), this[0]) : fe.call(this, e.jquery ? e[0] : e)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            },
            add: function (e, t) {
                return this.pushStack(xe.uniqueSort(xe.merge(this.get(), xe(e, t))));
            },
            addBack: function (e) {
                return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
            },
        }),
            xe.each(
                {
                    parent: function (e) {
                        var t = e.parentNode;
                        return t && 11 !== t.nodeType ? t : null;
                    },
                    parents: function (e) {
                        return Se(e, "parentNode");
                    },
                    parentsUntil: function (e, t, n) {
                        return Se(e, "parentNode", n);
                    },
                    next: function (e) {
                        return a(e, "nextSibling");
                    },
                    prev: function (e) {
                        return a(e, "previousSibling");
                    },
                    nextAll: function (e) {
                        return Se(e, "nextSibling");
                    },
                    prevAll: function (e) {
                        return Se(e, "previousSibling");
                    },
                    nextUntil: function (e, t, n) {
                        return Se(e, "nextSibling", n);
                    },
                    prevUntil: function (e, t, n) {
                        return Se(e, "previousSibling", n);
                    },
                    siblings: function (e) {
                        return Ce((e.parentNode || {}).firstChild, e);
                    },
                    children: function (e) {
                        return Ce(e.firstChild);
                    },
                    contents: function (e) {
                        return o(e, "iframe") ? e.contentDocument : (o(e, "template") && (e = e.content || e), xe.merge([], e.childNodes));
                    },
                },
                function (e, t) {
                    xe.fn[e] = function (n, i) {
                        var r = xe.map(this, t, n);
                        return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (r = xe.filter(i, r)), this.length > 1 && (Le[e] || xe.uniqueSort(r), De.test(e) && r.reverse()), this.pushStack(r);
                    };
                }
            );
        var Pe = /[^\x20\t\r\n\f]+/g;
        (xe.Callbacks = function (e) {
            e = "string" == typeof e ? l(e) : xe.extend({}, e);
            var t,
                n,
                r,
                o,
                s = [],
                a = [],
                u = -1,
                c = function () {
                    for (o = o || e.once, r = t = !0; a.length; u = -1) for (n = a.shift(); ++u < s.length; ) !1 === s[u].apply(n[0], n[1]) && e.stopOnFalse && ((u = s.length), (n = !1));
                    e.memory || (n = !1), (t = !1), o && (s = n ? [] : "");
                },
                f = {
                    add: function () {
                        return (
                            s &&
                                (n && !t && ((u = s.length - 1), a.push(n)),
                                (function t(n) {
                                    xe.each(n, function (n, r) {
                                        me(r) ? (e.unique && f.has(r)) || s.push(r) : r && r.length && "string" !== i(r) && t(r);
                                    });
                                })(arguments),
                                n && !t && c()),
                            this
                        );
                    },
                    remove: function () {
                        return (
                            xe.each(arguments, function (e, t) {
                                for (var n; (n = xe.inArray(t, s, n)) > -1; ) s.splice(n, 1), n <= u && u--;
                            }),
                            this
                        );
                    },
                    has: function (e) {
                        return e ? xe.inArray(e, s) > -1 : s.length > 0;
                    },
                    empty: function () {
                        return s && (s = []), this;
                    },
                    disable: function () {
                        return (o = a = []), (s = n = ""), this;
                    },
                    disabled: function () {
                        return !s;
                    },
                    lock: function () {
                        return (o = a = []), n || t || (s = n = ""), this;
                    },
                    locked: function () {
                        return !!o;
                    },
                    fireWith: function (e, n) {
                        return o || ((n = [e, (n = n || []).slice ? n.slice() : n]), a.push(n), t || c()), this;
                    },
                    fire: function () {
                        return f.fireWith(this, arguments), this;
                    },
                    fired: function () {
                        return !!r;
                    },
                };
            return f;
        }),
            xe.extend({
                Deferred: function (t) {
                    var n = [
                            ["notify", "progress", xe.Callbacks("memory"), xe.Callbacks("memory"), 2],
                            ["resolve", "done", xe.Callbacks("once memory"), xe.Callbacks("once memory"), 0, "resolved"],
                            ["reject", "fail", xe.Callbacks("once memory"), xe.Callbacks("once memory"), 1, "rejected"],
                        ],
                        i = "pending",
                        r = {
                            state: function () {
                                return i;
                            },
                            always: function () {
                                return o.done(arguments).fail(arguments), this;
                            },
                            catch: function (e) {
                                return r.then(null, e);
                            },
                            pipe: function () {
                                var e = arguments;
                                return xe
                                    .Deferred(function (t) {
                                        xe.each(n, function (n, i) {
                                            var r = me(e[i[4]]) && e[i[4]];
                                            o[i[1]](function () {
                                                var e = r && r.apply(this, arguments);
                                                e && me(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[i[0] + "With"](this, r ? [e] : arguments);
                                            });
                                        }),
                                            (e = null);
                                    })
                                    .promise();
                            },
                            then: function (t, i, r) {
                                function o(t, n, i, r) {
                                    return function () {
                                        var a = this,
                                            l = arguments,
                                            f = function () {
                                                var e, f;
                                                if (!(t < s)) {
                                                    if ((e = i.apply(a, l)) === n.promise()) throw new TypeError("Thenable self-resolution");
                                                    (f = e && ("object" == typeof e || "function" == typeof e) && e.then),
                                                        me(f)
                                                            ? r
                                                                ? f.call(e, o(s, n, u, r), o(s, n, c, r))
                                                                : (s++, f.call(e, o(s, n, u, r), o(s, n, c, r), o(s, n, u, n.notifyWith)))
                                                            : (i !== u && ((a = void 0), (l = [e])), (r || n.resolveWith)(a, l));
                                                }
                                            },
                                            d = r
                                                ? f
                                                : function () {
                                                      try {
                                                          f();
                                                      } catch (e) {
                                                          xe.Deferred.exceptionHook && xe.Deferred.exceptionHook(e, d.stackTrace), t + 1 >= s && (i !== c && ((a = void 0), (l = [e])), n.rejectWith(a, l));
                                                      }
                                                  };
                                        t ? d() : (xe.Deferred.getStackHook && (d.stackTrace = xe.Deferred.getStackHook()), e.setTimeout(d));
                                    };
                                }
                                var s = 0;
                                return xe
                                    .Deferred(function (e) {
                                        n[0][3].add(o(0, e, me(r) ? r : u, e.notifyWith)), n[1][3].add(o(0, e, me(t) ? t : u)), n[2][3].add(o(0, e, me(i) ? i : c));
                                    })
                                    .promise();
                            },
                            promise: function (e) {
                                return null != e ? xe.extend(e, r) : r;
                            },
                        },
                        o = {};
                    return (
                        xe.each(n, function (e, t) {
                            var s = t[2],
                                a = t[5];
                            (r[t[1]] = s.add),
                                a &&
                                    s.add(
                                        function () {
                                            i = a;
                                        },
                                        n[3 - e][2].disable,
                                        n[3 - e][3].disable,
                                        n[0][2].lock,
                                        n[0][3].lock
                                    ),
                                s.add(t[3].fire),
                                (o[t[0]] = function () {
                                    return o[t[0] + "With"](this === o ? void 0 : this, arguments), this;
                                }),
                                (o[t[0] + "With"] = s.fireWith);
                        }),
                        r.promise(o),
                        t && t.call(o, o),
                        o
                    );
                },
                when: function (e) {
                    var t = arguments.length,
                        n = t,
                        i = Array(n),
                        r = le.call(arguments),
                        o = xe.Deferred(),
                        s = function (e) {
                            return function (n) {
                                (i[e] = this), (r[e] = arguments.length > 1 ? le.call(arguments) : n), --t || o.resolveWith(i, r);
                            };
                        };
                    if (t <= 1 && (f(e, o.done(s(n)).resolve, o.reject, !t), "pending" === o.state() || me(r[n] && r[n].then))) return o.then();
                    for (; n--; ) f(r[n], s(n), o.reject);
                    return o.promise();
                },
            });
        var $e = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        (xe.Deferred.exceptionHook = function (t, n) {
            e.console && e.console.warn && t && $e.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n);
        }),
            (xe.readyException = function (t) {
                e.setTimeout(function () {
                    throw t;
                });
            });
        var ze = xe.Deferred();
        (xe.fn.ready = function (e) {
            return (
                ze.then(e).catch(function (e) {
                    xe.readyException(e);
                }),
                this
            );
        }),
            xe.extend({
                isReady: !1,
                readyWait: 1,
                ready: function (e) {
                    (!0 === e ? --xe.readyWait : xe.isReady) || ((xe.isReady = !0), (!0 !== e && --xe.readyWait > 0) || ze.resolveWith(se, [xe]));
                },
            }),
            (xe.ready.then = ze.then),
            "complete" === se.readyState || ("loading" !== se.readyState && !se.documentElement.doScroll) ? e.setTimeout(xe.ready) : (se.addEventListener("DOMContentLoaded", d), e.addEventListener("load", d));
        var Oe = function (e, t, n, r, o, s, a) {
                var l = 0,
                    u = e.length,
                    c = null == n;
                if ("object" === i(n)) {
                    o = !0;
                    for (l in n) Oe(e, t, l, n[l], !0, s, a);
                } else if (
                    void 0 !== r &&
                    ((o = !0),
                    me(r) || (a = !0),
                    c &&
                        (a
                            ? (t.call(e, r), (t = null))
                            : ((c = t),
                              (t = function (e, t, n) {
                                  return c.call(xe(e), n);
                              }))),
                    t)
                )
                    for (; l < u; l++) t(e[l], n, a ? r : r.call(e[l], l, t(e[l], n)));
                return o ? e : c ? t.call(e) : u ? t(e[0], n) : s;
            },
            Ie = /^-ms-/,
            Ne = /-([a-z])/g,
            Me = function (e) {
                return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
            };
        (g.uid = 1),
            (g.prototype = {
                cache: function (e) {
                    var t = e[this.expando];
                    return t || ((t = {}), Me(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
                },
                set: function (e, t, n) {
                    var i,
                        r = this.cache(e);
                    if ("string" == typeof t) r[h(t)] = n;
                    else for (i in t) r[h(i)] = t[i];
                    return r;
                },
                get: function (e, t) {
                    return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][h(t)];
                },
                access: function (e, t, n) {
                    return void 0 === t || (t && "string" == typeof t && void 0 === n) ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
                },
                remove: function (e, t) {
                    var n,
                        i = e[this.expando];
                    if (void 0 !== i) {
                        if (void 0 !== t) {
                            n = (t = Array.isArray(t) ? t.map(h) : (t = h(t)) in i ? [t] : t.match(Pe) || []).length;
                            for (; n--; ) delete i[t[n]];
                        }
                        (void 0 === t || xe.isEmptyObject(i)) && (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                    }
                },
                hasData: function (e) {
                    var t = e[this.expando];
                    return void 0 !== t && !xe.isEmptyObject(t);
                },
            });
        var Re = new g(),
            qe = new g(),
            He = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            We = /[A-Z]/g;
        xe.extend({
            hasData: function (e) {
                return qe.hasData(e) || Re.hasData(e);
            },
            data: function (e, t, n) {
                return qe.access(e, t, n);
            },
            removeData: function (e, t) {
                qe.remove(e, t);
            },
            _data: function (e, t, n) {
                return Re.access(e, t, n);
            },
            _removeData: function (e, t) {
                Re.remove(e, t);
            },
        }),
            xe.fn.extend({
                data: function (e, t) {
                    var n,
                        i,
                        r,
                        o = this[0],
                        s = o && o.attributes;
                    if (void 0 === e) {
                        if (this.length && ((r = qe.get(o)), 1 === o.nodeType && !Re.get(o, "hasDataAttrs"))) {
                            for (n = s.length; n--; ) s[n] && 0 === (i = s[n].name).indexOf("data-") && ((i = h(i.slice(5))), y(o, i, r[i]));
                            Re.set(o, "hasDataAttrs", !0);
                        }
                        return r;
                    }
                    return "object" == typeof e
                        ? this.each(function () {
                              qe.set(this, e);
                          })
                        : Oe(
                              this,
                              function (t) {
                                  var n;
                                  if (o && void 0 === t) {
                                      if (void 0 !== (n = qe.get(o, e))) return n;
                                      if (void 0 !== (n = y(o, e))) return n;
                                  } else
                                      this.each(function () {
                                          qe.set(this, e, t);
                                      });
                              },
                              null,
                              t,
                              arguments.length > 1,
                              null,
                              !0
                          );
                },
                removeData: function (e) {
                    return this.each(function () {
                        qe.remove(this, e);
                    });
                },
            }),
            xe.extend({
                queue: function (e, t, n) {
                    var i;
                    if (e) return (t = (t || "fx") + "queue"), (i = Re.get(e, t)), n && (!i || Array.isArray(n) ? (i = Re.access(e, t, xe.makeArray(n))) : i.push(n)), i || [];
                },
                dequeue: function (e, t) {
                    t = t || "fx";
                    var n = xe.queue(e, t),
                        i = n.length,
                        r = n.shift(),
                        o = xe._queueHooks(e, t),
                        s = function () {
                            xe.dequeue(e, t);
                        };
                    "inprogress" === r && ((r = n.shift()), i--), r && ("fx" === t && n.unshift("inprogress"), delete o.stop, r.call(e, s, o)), !i && o && o.empty.fire();
                },
                _queueHooks: function (e, t) {
                    var n = t + "queueHooks";
                    return (
                        Re.get(e, n) ||
                        Re.access(e, n, {
                            empty: xe.Callbacks("once memory").add(function () {
                                Re.remove(e, [t + "queue", n]);
                            }),
                        })
                    );
                },
            }),
            xe.fn.extend({
                queue: function (e, t) {
                    var n = 2;
                    return (
                        "string" != typeof e && ((t = e), (e = "fx"), n--),
                        arguments.length < n
                            ? xe.queue(this[0], e)
                            : void 0 === t
                            ? this
                            : this.each(function () {
                                  var n = xe.queue(this, e, t);
                                  xe._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && xe.dequeue(this, e);
                              })
                    );
                },
                dequeue: function (e) {
                    return this.each(function () {
                        xe.dequeue(this, e);
                    });
                },
                clearQueue: function (e) {
                    return this.queue(e || "fx", []);
                },
                promise: function (e, t) {
                    var n,
                        i = 1,
                        r = xe.Deferred(),
                        o = this,
                        s = this.length,
                        a = function () {
                            --i || r.resolveWith(o, [o]);
                        };
                    for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; s--; ) (n = Re.get(o[s], e + "queueHooks")) && n.empty && (i++, n.empty.add(a));
                    return a(), r.promise(t);
                },
            });
        var Fe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            Ue = new RegExp("^(?:([+-])=|)(" + Fe + ")([a-z%]*)$", "i"),
            Be = ["Top", "Right", "Bottom", "Left"],
            Xe = function (e, t) {
                return "none" === (e = t || e).style.display || ("" === e.style.display && xe.contains(e.ownerDocument, e) && "none" === xe.css(e, "display"));
            },
            Ve = function (e, t, n, i) {
                var r,
                    o,
                    s = {};
                for (o in t) (s[o] = e.style[o]), (e.style[o] = t[o]);
                r = n.apply(e, i || []);
                for (o in t) e.style[o] = s[o];
                return r;
            },
            Ge = {};
        xe.fn.extend({
            show: function () {
                return w(this, !0);
            },
            hide: function () {
                return w(this);
            },
            toggle: function (e) {
                return "boolean" == typeof e
                    ? e
                        ? this.show()
                        : this.hide()
                    : this.each(function () {
                          Xe(this) ? xe(this).show() : xe(this).hide();
                      });
            },
        });
        var Qe = /^(?:checkbox|radio)$/i,
            Ye = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
            Ze = /^$|^module$|\/(?:java|ecma)script/i,
            Je = {
                option: [1, "<select multiple='multiple'>", "</select>"],
                thead: [1, "<table>", "</table>"],
                col: [2, "<table><colgroup>", "</colgroup></table>"],
                tr: [2, "<table><tbody>", "</tbody></table>"],
                td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                _default: [0, "", ""],
            };
        (Je.optgroup = Je.option), (Je.tbody = Je.tfoot = Je.colgroup = Je.caption = Je.thead), (Je.th = Je.td);
        var Ke = /<|&#?\w+;/;
        !(function () {
            var e = se.createDocumentFragment().appendChild(se.createElement("div")),
                t = se.createElement("input");
            t.setAttribute("type", "radio"),
                t.setAttribute("checked", "checked"),
                t.setAttribute("name", "t"),
                e.appendChild(t),
                (ye.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked),
                (e.innerHTML = "<textarea>x</textarea>"),
                (ye.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue);
        })();
        var et = se.documentElement,
            tt = /^key/,
            nt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            it = /^([^.]*)(?:\.(.+)|)/;
        (xe.event = {
            global: {},
            add: function (e, t, n, i, r) {
                var o,
                    s,
                    a,
                    l,
                    u,
                    c,
                    f,
                    d,
                    p,
                    h,
                    g,
                    v = Re.get(e);
                if (v)
                    for (
                        n.handler && ((n = (o = n).handler), (r = o.selector)),
                            r && xe.find.matchesSelector(et, r),
                            n.guid || (n.guid = xe.guid++),
                            (l = v.events) || (l = v.events = {}),
                            (s = v.handle) ||
                                (s = v.handle = function (t) {
                                    return "undefined" != typeof xe && xe.event.triggered !== t.type ? xe.event.dispatch.apply(e, arguments) : void 0;
                                }),
                            u = (t = (t || "").match(Pe) || [""]).length;
                        u--;

                    )
                        (p = g = (a = it.exec(t[u]) || [])[1]),
                            (h = (a[2] || "").split(".").sort()),
                            p &&
                                ((f = xe.event.special[p] || {}),
                                (p = (r ? f.delegateType : f.bindType) || p),
                                (f = xe.event.special[p] || {}),
                                (c = xe.extend({ type: p, origType: g, data: i, handler: n, guid: n.guid, selector: r, needsContext: r && xe.expr.match.needsContext.test(r), namespace: h.join(".") }, o)),
                                (d = l[p]) || (((d = l[p] = []).delegateCount = 0), (f.setup && !1 !== f.setup.call(e, i, h, s)) || (e.addEventListener && e.addEventListener(p, s))),
                                f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
                                r ? d.splice(d.delegateCount++, 0, c) : d.push(c),
                                (xe.event.global[p] = !0));
            },
            remove: function (e, t, n, i, r) {
                var o,
                    s,
                    a,
                    l,
                    u,
                    c,
                    f,
                    d,
                    p,
                    h,
                    g,
                    v = Re.hasData(e) && Re.get(e);
                if (v && (l = v.events)) {
                    for (u = (t = (t || "").match(Pe) || [""]).length; u--; )
                        if (((a = it.exec(t[u]) || []), (p = g = a[1]), (h = (a[2] || "").split(".").sort()), p)) {
                            for (f = xe.event.special[p] || {}, d = l[(p = (i ? f.delegateType : f.bindType) || p)] || [], a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = o = d.length; o--; )
                                (c = d[o]),
                                    (!r && g !== c.origType) ||
                                        (n && n.guid !== c.guid) ||
                                        (a && !a.test(c.namespace)) ||
                                        (i && i !== c.selector && ("**" !== i || !c.selector)) ||
                                        (d.splice(o, 1), c.selector && d.delegateCount--, f.remove && f.remove.call(e, c));
                            s && !d.length && ((f.teardown && !1 !== f.teardown.call(e, h, v.handle)) || xe.removeEvent(e, p, v.handle), delete l[p]);
                        } else for (p in l) xe.event.remove(e, p + t[u], n, i, !0);
                    xe.isEmptyObject(l) && Re.remove(e, "handle events");
                }
            },
            dispatch: function (e) {
                var t,
                    n,
                    i,
                    r,
                    o,
                    s,
                    a = xe.event.fix(e),
                    l = new Array(arguments.length),
                    u = (Re.get(this, "events") || {})[a.type] || [],
                    c = xe.event.special[a.type] || {};
                for (l[0] = a, t = 1; t < arguments.length; t++) l[t] = arguments[t];
                if (((a.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, a))) {
                    for (s = xe.event.handlers.call(this, a, u), t = 0; (r = s[t++]) && !a.isPropagationStopped(); )
                        for (a.currentTarget = r.elem, n = 0; (o = r.handlers[n++]) && !a.isImmediatePropagationStopped(); )
                            (a.rnamespace && !a.rnamespace.test(o.namespace)) ||
                                ((a.handleObj = o), (a.data = o.data), void 0 !== (i = ((xe.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, l)) && !1 === (a.result = i) && (a.preventDefault(), a.stopPropagation()));
                    return c.postDispatch && c.postDispatch.call(this, a), a.result;
                }
            },
            handlers: function (e, t) {
                var n,
                    i,
                    r,
                    o,
                    s,
                    a = [],
                    l = t.delegateCount,
                    u = e.target;
                if (l && u.nodeType && !("click" === e.type && e.button >= 1))
                    for (; u !== this; u = u.parentNode || this)
                        if (1 === u.nodeType && ("click" !== e.type || !0 !== u.disabled)) {
                            for (o = [], s = {}, n = 0; n < l; n++) void 0 === s[(r = (i = t[n]).selector + " ")] && (s[r] = i.needsContext ? xe(r, this).index(u) > -1 : xe.find(r, this, null, [u]).length), s[r] && o.push(i);
                            o.length && a.push({ elem: u, handlers: o });
                        }
                return (u = this), l < t.length && a.push({ elem: u, handlers: t.slice(l) }), a;
            },
            addProp: function (e, t) {
                Object.defineProperty(xe.Event.prototype, e, {
                    enumerable: !0,
                    configurable: !0,
                    get: me(t)
                        ? function () {
                              if (this.originalEvent) return t(this.originalEvent);
                          }
                        : function () {
                              if (this.originalEvent) return this.originalEvent[e];
                          },
                    set: function (t) {
                        Object.defineProperty(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
                    },
                });
            },
            fix: function (e) {
                return e[xe.expando] ? e : new xe.Event(e);
            },
            special: {
                load: { noBubble: !0 },
                focus: {
                    trigger: function () {
                        if (this !== T() && this.focus) return this.focus(), !1;
                    },
                    delegateType: "focusin",
                },
                blur: {
                    trigger: function () {
                        if (this === T() && this.blur) return this.blur(), !1;
                    },
                    delegateType: "focusout",
                },
                click: {
                    trigger: function () {
                        if ("checkbox" === this.type && this.click && o(this, "input")) return this.click(), !1;
                    },
                    _default: function (e) {
                        return o(e.target, "a");
                    },
                },
                beforeunload: {
                    postDispatch: function (e) {
                        void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                    },
                },
            },
        }),
            (xe.removeEvent = function (e, t, n) {
                e.removeEventListener && e.removeEventListener(t, n);
            }),
            (xe.Event = function (e, t) {
                return this instanceof xe.Event
                    ? (e && e.type
                          ? ((this.originalEvent = e),
                            (this.type = e.type),
                            (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? S : C),
                            (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                            (this.currentTarget = e.currentTarget),
                            (this.relatedTarget = e.relatedTarget))
                          : (this.type = e),
                      t && xe.extend(this, t),
                      (this.timeStamp = (e && e.timeStamp) || Date.now()),
                      (this[xe.expando] = !0),
                      void 0)
                    : new xe.Event(e, t);
            }),
            (xe.Event.prototype = {
                constructor: xe.Event,
                isDefaultPrevented: C,
                isPropagationStopped: C,
                isImmediatePropagationStopped: C,
                isSimulated: !1,
                preventDefault: function () {
                    var e = this.originalEvent;
                    (this.isDefaultPrevented = S), e && !this.isSimulated && e.preventDefault();
                },
                stopPropagation: function () {
                    var e = this.originalEvent;
                    (this.isPropagationStopped = S), e && !this.isSimulated && e.stopPropagation();
                },
                stopImmediatePropagation: function () {
                    var e = this.originalEvent;
                    (this.isImmediatePropagationStopped = S), e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
                },
            }),
            xe.each(
                {
                    altKey: !0,
                    bubbles: !0,
                    cancelable: !0,
                    changedTouches: !0,
                    ctrlKey: !0,
                    detail: !0,
                    eventPhase: !0,
                    metaKey: !0,
                    pageX: !0,
                    pageY: !0,
                    shiftKey: !0,
                    view: !0,
                    char: !0,
                    charCode: !0,
                    key: !0,
                    keyCode: !0,
                    button: !0,
                    buttons: !0,
                    clientX: !0,
                    clientY: !0,
                    offsetX: !0,
                    offsetY: !0,
                    pointerId: !0,
                    pointerType: !0,
                    screenX: !0,
                    screenY: !0,
                    targetTouches: !0,
                    toElement: !0,
                    touches: !0,
                    which: function (e) {
                        var t = e.button;
                        return null == e.which && tt.test(e.type) ? (null != e.charCode ? e.charCode : e.keyCode) : !e.which && void 0 !== t && nt.test(e.type) ? (1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0) : e.which;
                    },
                },
                xe.event.addProp
            ),
            xe.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
                xe.event.special[e] = {
                    delegateType: t,
                    bindType: t,
                    handle: function (e) {
                        var n,
                            i = this,
                            r = e.relatedTarget,
                            o = e.handleObj;
                        return (r && (r === i || xe.contains(i, r))) || ((e.type = o.origType), (n = o.handler.apply(this, arguments)), (e.type = t)), n;
                    },
                };
            }),
            xe.fn.extend({
                on: function (e, t, n, i) {
                    return E(this, e, t, n, i);
                },
                one: function (e, t, n, i) {
                    return E(this, e, t, n, i, 1);
                },
                off: function (e, t, n) {
                    var i, r;
                    if (e && e.preventDefault && e.handleObj) return (i = e.handleObj), xe(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
                    if ("object" == typeof e) {
                        for (r in e) this.off(r, t, e[r]);
                        return this;
                    }
                    return (
                        (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                        !1 === n && (n = C),
                        this.each(function () {
                            xe.event.remove(this, e, n, t);
                        })
                    );
                },
            });
        var rt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
            ot = /<script|<style|<link/i,
            st = /checked\s*(?:[^=]|=\s*.checked.)/i,
            at = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
        xe.extend({
            htmlPrefilter: function (e) {
                return e.replace(rt, "<$1></$2>");
            },
            clone: function (e, t, n) {
                var i,
                    r,
                    o,
                    s,
                    a = e.cloneNode(!0),
                    l = xe.contains(e.ownerDocument, e);
                if (!(ye.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || xe.isXMLDoc(e))) for (s = x(a), i = 0, r = (o = x(e)).length; i < r; i++) P(o[i], s[i]);
                if (t)
                    if (n) for (o = o || x(e), s = s || x(a), i = 0, r = o.length; i < r; i++) L(o[i], s[i]);
                    else L(e, a);
                return (s = x(a, "script")).length > 0 && _(s, !l && x(e, "script")), a;
            },
            cleanData: function (e) {
                for (var t, n, i, r = xe.event.special, o = 0; void 0 !== (n = e[o]); o++)
                    if (Me(n)) {
                        if ((t = n[Re.expando])) {
                            if (t.events) for (i in t.events) r[i] ? xe.event.remove(n, i) : xe.removeEvent(n, i, t.handle);
                            n[Re.expando] = void 0;
                        }
                        n[qe.expando] && (n[qe.expando] = void 0);
                    }
            },
        }),
            xe.fn.extend({
                detach: function (e) {
                    return z(this, e, !0);
                },
                remove: function (e) {
                    return z(this, e);
                },
                text: function (e) {
                    return Oe(
                        this,
                        function (e) {
                            return void 0 === e
                                ? xe.text(this)
                                : this.empty().each(function () {
                                      (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                                  });
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                append: function () {
                    return $(this, arguments, function (e) {
                        (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || A(this, e).appendChild(e);
                    });
                },
                prepend: function () {
                    return $(this, arguments, function (e) {
                        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                            var t = A(this, e);
                            t.insertBefore(e, t.firstChild);
                        }
                    });
                },
                before: function () {
                    return $(this, arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this);
                    });
                },
                after: function () {
                    return $(this, arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                    });
                },
                empty: function () {
                    for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (xe.cleanData(x(e, !1)), (e.textContent = ""));
                    return this;
                },
                clone: function (e, t) {
                    return (
                        (e = null != e && e),
                        (t = null == t ? e : t),
                        this.map(function () {
                            return xe.clone(this, e, t);
                        })
                    );
                },
                html: function (e) {
                    return Oe(
                        this,
                        function (e) {
                            var t = this[0] || {},
                                n = 0,
                                i = this.length;
                            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                            if ("string" == typeof e && !ot.test(e) && !Je[(Ye.exec(e) || ["", ""])[1].toLowerCase()]) {
                                e = xe.htmlPrefilter(e);
                                try {
                                    for (; n < i; n++) 1 === (t = this[n] || {}).nodeType && (xe.cleanData(x(t, !1)), (t.innerHTML = e));
                                    t = 0;
                                } catch (e) {}
                            }
                            t && this.empty().append(e);
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                replaceWith: function () {
                    var e = [];
                    return $(
                        this,
                        arguments,
                        function (t) {
                            var n = this.parentNode;
                            xe.inArray(this, e) < 0 && (xe.cleanData(x(this)), n && n.replaceChild(t, this));
                        },
                        e
                    );
                },
            }),
            xe.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
                xe.fn[e] = function (e) {
                    for (var n, i = [], r = xe(e), o = r.length - 1, s = 0; s <= o; s++) (n = s === o ? this : this.clone(!0)), xe(r[s])[t](n), ce.apply(i, n.get());
                    return this.pushStack(i);
                };
            });
        var lt = new RegExp("^(" + Fe + ")(?!px)[a-z%]+$", "i"),
            ut = function (t) {
                var n = t.ownerDocument.defaultView;
                return (n && n.opener) || (n = e), n.getComputedStyle(t);
            },
            ct = new RegExp(Be.join("|"), "i");
        !(function () {
            function t() {
                if (u) {
                    (l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                        (u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                        et.appendChild(l).appendChild(u);
                    var t = e.getComputedStyle(u);
                    (i = "1%" !== t.top),
                        (a = 12 === n(t.marginLeft)),
                        (u.style.right = "60%"),
                        (s = 36 === n(t.right)),
                        (r = 36 === n(t.width)),
                        (u.style.position = "absolute"),
                        (o = 36 === u.offsetWidth || "absolute"),
                        et.removeChild(l),
                        (u = null);
                }
            }
            function n(e) {
                return Math.round(parseFloat(e));
            }
            var i,
                r,
                o,
                s,
                a,
                l = se.createElement("div"),
                u = se.createElement("div");
            u.style &&
                ((u.style.backgroundClip = "content-box"),
                (u.cloneNode(!0).style.backgroundClip = ""),
                (ye.clearCloneStyle = "content-box" === u.style.backgroundClip),
                xe.extend(ye, {
                    boxSizingReliable: function () {
                        return t(), r;
                    },
                    pixelBoxStyles: function () {
                        return t(), s;
                    },
                    pixelPosition: function () {
                        return t(), i;
                    },
                    reliableMarginLeft: function () {
                        return t(), a;
                    },
                    scrollboxSize: function () {
                        return t(), o;
                    },
                }));
        })();
        var ft = /^(none|table(?!-c[ea]).+)/,
            dt = /^--/,
            pt = { position: "absolute", visibility: "hidden", display: "block" },
            ht = { letterSpacing: "0", fontWeight: "400" },
            gt = ["Webkit", "Moz", "ms"],
            vt = se.createElement("div").style;
        xe.extend({
            cssHooks: {
                opacity: {
                    get: function (e, t) {
                        if (t) {
                            var n = O(e, "opacity");
                            return "" === n ? "1" : n;
                        }
                    },
                },
            },
            cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 },
            cssProps: {},
            style: function (e, t, n, i) {
                if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                    var r,
                        o,
                        s,
                        a = h(t),
                        l = dt.test(t),
                        u = e.style;
                    if ((l || (t = M(a)), (s = xe.cssHooks[t] || xe.cssHooks[a]), void 0 === n)) return s && "get" in s && void 0 !== (r = s.get(e, !1, i)) ? r : u[t];
                    "string" == (o = typeof n) && (r = Ue.exec(n)) && r[1] && ((n = m(e, t, r)), (o = "number")),
                        null != n &&
                            n === n &&
                            ("number" === o && (n += (r && r[3]) || (xe.cssNumber[a] ? "" : "px")),
                            ye.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (u[t] = "inherit"),
                            (s && "set" in s && void 0 === (n = s.set(e, n, i))) || (l ? u.setProperty(t, n) : (u[t] = n)));
                }
            },
            css: function (e, t, n, i) {
                var r,
                    o,
                    s,
                    a = h(t);
                return (
                    dt.test(t) || (t = M(a)),
                    (s = xe.cssHooks[t] || xe.cssHooks[a]) && "get" in s && (r = s.get(e, !0, n)),
                    void 0 === r && (r = O(e, t, i)),
                    "normal" === r && t in ht && (r = ht[t]),
                    "" === n || n ? ((o = parseFloat(r)), !0 === n || isFinite(o) ? o || 0 : r) : r
                );
            },
        }),
            xe.each(["height", "width"], function (e, t) {
                xe.cssHooks[t] = {
                    get: function (e, n, i) {
                        if (n)
                            return !ft.test(xe.css(e, "display")) || (e.getClientRects().length && e.getBoundingClientRect().width)
                                ? H(e, t, i)
                                : Ve(e, pt, function () {
                                      return H(e, t, i);
                                  });
                    },
                    set: function (e, n, i) {
                        var r,
                            o = ut(e),
                            s = "border-box" === xe.css(e, "boxSizing", !1, o),
                            a = i && q(e, t, i, s, o);
                        return (
                            s && ye.scrollboxSize() === o.position && (a -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - q(e, t, "border", !1, o) - 0.5)),
                            a && (r = Ue.exec(n)) && "px" !== (r[3] || "px") && ((e.style[t] = n), (n = xe.css(e, t))),
                            R(e, n, a)
                        );
                    },
                };
            }),
            (xe.cssHooks.marginLeft = I(ye.reliableMarginLeft, function (e, t) {
                if (t)
                    return (
                        (parseFloat(O(e, "marginLeft")) ||
                            e.getBoundingClientRect().left -
                                Ve(e, { marginLeft: 0 }, function () {
                                    return e.getBoundingClientRect().left;
                                })) + "px"
                    );
            })),
            xe.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
                (xe.cssHooks[e + t] = {
                    expand: function (n) {
                        for (var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) r[e + Be[i] + t] = o[i] || o[i - 2] || o[0];
                        return r;
                    },
                }),
                    "margin" !== e && (xe.cssHooks[e + t].set = R);
            }),
            xe.fn.extend({
                css: function (e, t) {
                    return Oe(
                        this,
                        function (e, t, n) {
                            var i,
                                r,
                                o = {},
                                s = 0;
                            if (Array.isArray(t)) {
                                for (i = ut(e), r = t.length; s < r; s++) o[t[s]] = xe.css(e, t[s], !1, i);
                                return o;
                            }
                            return void 0 !== n ? xe.style(e, t, n) : xe.css(e, t);
                        },
                        e,
                        t,
                        arguments.length > 1
                    );
                },
            }),
            (xe.Tween = W),
            (W.prototype = {
                constructor: W,
                init: function (e, t, n, i, r, o) {
                    (this.elem = e), (this.prop = n), (this.easing = r || xe.easing._default), (this.options = t), (this.start = this.now = this.cur()), (this.end = i), (this.unit = o || (xe.cssNumber[n] ? "" : "px"));
                },
                cur: function () {
                    var e = W.propHooks[this.prop];
                    return e && e.get ? e.get(this) : W.propHooks._default.get(this);
                },
                run: function (e) {
                    var t,
                        n = W.propHooks[this.prop];
                    return (
                        this.options.duration ? (this.pos = t = xe.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration)) : (this.pos = t = e),
                        (this.now = (this.end - this.start) * t + this.start),
                        this.options.step && this.options.step.call(this.elem, this.now, this),
                        n && n.set ? n.set(this) : W.propHooks._default.set(this),
                        this
                    );
                },
            }),
            (W.prototype.init.prototype = W.prototype),
            (W.propHooks = {
                _default: {
                    get: function (e) {
                        var t;
                        return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop]) ? e.elem[e.prop] : (t = xe.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
                    },
                    set: function (e) {
                        xe.fx.step[e.prop] ? xe.fx.step[e.prop](e) : 1 !== e.elem.nodeType || (null == e.elem.style[xe.cssProps[e.prop]] && !xe.cssHooks[e.prop]) ? (e.elem[e.prop] = e.now) : xe.style(e.elem, e.prop, e.now + e.unit);
                    },
                },
            }),
            (W.propHooks.scrollTop = W.propHooks.scrollLeft = {
                set: function (e) {
                    e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                },
            }),
            (xe.easing = {
                linear: function (e) {
                    return e;
                },
                swing: function (e) {
                    return 0.5 - Math.cos(e * Math.PI) / 2;
                },
                _default: "swing",
            }),
            (xe.fx = W.prototype.init),
            (xe.fx.step = {});
        var yt,
            mt,
            bt = /^(?:toggle|show|hide)$/,
            wt = /queueHooks$/;
        (xe.Animation = xe.extend(Q, {
            tweeners: {
                "*": [
                    function (e, t) {
                        var n = this.createTween(e, t);
                        return m(n.elem, e, Ue.exec(t), n), n;
                    },
                ],
            },
            tweener: function (e, t) {
                me(e) ? ((t = e), (e = ["*"])) : (e = e.match(Pe));
                for (var n, i = 0, r = e.length; i < r; i++) (n = e[i]), (Q.tweeners[n] = Q.tweeners[n] || []), Q.tweeners[n].unshift(t);
            },
            prefilters: [V],
            prefilter: function (e, t) {
                t ? Q.prefilters.unshift(e) : Q.prefilters.push(e);
            },
        })),
            (xe.speed = function (e, t, n) {
                var i = e && "object" == typeof e ? xe.extend({}, e) : { complete: n || (!n && t) || (me(e) && e), duration: e, easing: (n && t) || (t && !me(t) && t) };
                return (
                    xe.fx.off ? (i.duration = 0) : "number" != typeof i.duration && (i.duration in xe.fx.speeds ? (i.duration = xe.fx.speeds[i.duration]) : (i.duration = xe.fx.speeds._default)),
                    (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
                    (i.old = i.complete),
                    (i.complete = function () {
                        me(i.old) && i.old.call(this), i.queue && xe.dequeue(this, i.queue);
                    }),
                    i
                );
            }),
            xe.fn.extend({
                fadeTo: function (e, t, n, i) {
                    return this.filter(Xe).css("opacity", 0).show().end().animate({ opacity: t }, e, n, i);
                },
                animate: function (e, t, n, i) {
                    var r = xe.isEmptyObject(e),
                        o = xe.speed(t, n, i),
                        s = function () {
                            var t = Q(this, xe.extend({}, e), o);
                            (r || Re.get(this, "finish")) && t.stop(!0);
                        };
                    return (s.finish = s), r || !1 === o.queue ? this.each(s) : this.queue(o.queue, s);
                },
                stop: function (e, t, n) {
                    var i = function (e) {
                        var t = e.stop;
                        delete e.stop, t(n);
                    };
                    return (
                        "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                        t && !1 !== e && this.queue(e || "fx", []),
                        this.each(function () {
                            var t = !0,
                                r = null != e && e + "queueHooks",
                                o = xe.timers,
                                s = Re.get(this);
                            if (r) s[r] && s[r].stop && i(s[r]);
                            else for (r in s) s[r] && s[r].stop && wt.test(r) && i(s[r]);
                            for (r = o.length; r--; ) o[r].elem !== this || (null != e && o[r].queue !== e) || (o[r].anim.stop(n), (t = !1), o.splice(r, 1));
                            (!t && n) || xe.dequeue(this, e);
                        })
                    );
                },
                finish: function (e) {
                    return (
                        !1 !== e && (e = e || "fx"),
                        this.each(function () {
                            var t,
                                n = Re.get(this),
                                i = n[e + "queue"],
                                r = n[e + "queueHooks"],
                                o = xe.timers,
                                s = i ? i.length : 0;
                            for (n.finish = !0, xe.queue(this, e, []), r && r.stop && r.stop.call(this, !0), t = o.length; t--; ) o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
                            for (t = 0; t < s; t++) i[t] && i[t].finish && i[t].finish.call(this);
                            delete n.finish;
                        })
                    );
                },
            }),
            xe.each(["toggle", "show", "hide"], function (e, t) {
                var n = xe.fn[t];
                xe.fn[t] = function (e, i, r) {
                    return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(B(t, !0), e, i, r);
                };
            }),
            xe.each({ slideDown: B("show"), slideUp: B("hide"), slideToggle: B("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
                xe.fn[e] = function (e, n, i) {
                    return this.animate(t, e, n, i);
                };
            }),
            (xe.timers = []),
            (xe.fx.tick = function () {
                var e,
                    t = 0,
                    n = xe.timers;
                for (yt = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
                n.length || xe.fx.stop(), (yt = void 0);
            }),
            (xe.fx.timer = function (e) {
                xe.timers.push(e), xe.fx.start();
            }),
            (xe.fx.interval = 13),
            (xe.fx.start = function () {
                mt || ((mt = !0), F());
            }),
            (xe.fx.stop = function () {
                mt = null;
            }),
            (xe.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (xe.fn.delay = function (t, n) {
                return (
                    (t = xe.fx ? xe.fx.speeds[t] || t : t),
                    (n = n || "fx"),
                    this.queue(n, function (n, i) {
                        var r = e.setTimeout(n, t);
                        i.stop = function () {
                            e.clearTimeout(r);
                        };
                    })
                );
            }),
            (function () {
                var e = se.createElement("input"),
                    t = se.createElement("select").appendChild(se.createElement("option"));
                (e.type = "checkbox"), (ye.checkOn = "" !== e.value), (ye.optSelected = t.selected), ((e = se.createElement("input")).value = "t"), (e.type = "radio"), (ye.radioValue = "t" === e.value);
            })();
        var xt,
            _t = xe.expr.attrHandle;
        xe.fn.extend({
            attr: function (e, t) {
                return Oe(this, xe.attr, e, t, arguments.length > 1);
            },
            removeAttr: function (e) {
                return this.each(function () {
                    xe.removeAttr(this, e);
                });
            },
        }),
            xe.extend({
                attr: function (e, t, n) {
                    var i,
                        r,
                        o = e.nodeType;
                    if (3 !== o && 8 !== o && 2 !== o)
                        return "undefined" == typeof e.getAttribute
                            ? xe.prop(e, t, n)
                            : ((1 === o && xe.isXMLDoc(e)) || (r = xe.attrHooks[t.toLowerCase()] || (xe.expr.match.bool.test(t) ? xt : void 0)),
                              void 0 !== n
                                  ? null === n
                                      ? void xe.removeAttr(e, t)
                                      : r && "set" in r && void 0 !== (i = r.set(e, n, t))
                                      ? i
                                      : (e.setAttribute(t, n + ""), n)
                                  : r && "get" in r && null !== (i = r.get(e, t))
                                  ? i
                                  : null == (i = xe.find.attr(e, t))
                                  ? void 0
                                  : i);
                },
                attrHooks: {
                    type: {
                        set: function (e, t) {
                            if (!ye.radioValue && "radio" === t && o(e, "input")) {
                                var n = e.value;
                                return e.setAttribute("type", t), n && (e.value = n), t;
                            }
                        },
                    },
                },
                removeAttr: function (e, t) {
                    var n,
                        i = 0,
                        r = t && t.match(Pe);
                    if (r && 1 === e.nodeType) for (; (n = r[i++]); ) e.removeAttribute(n);
                },
            }),
            (xt = {
                set: function (e, t, n) {
                    return !1 === t ? xe.removeAttr(e, n) : e.setAttribute(n, n), n;
                },
            }),
            xe.each(xe.expr.match.bool.source.match(/\w+/g), function (e, t) {
                var n = _t[t] || xe.find.attr;
                _t[t] = function (e, t, i) {
                    var r,
                        o,
                        s = t.toLowerCase();
                    return i || ((o = _t[s]), (_t[s] = r), (r = null != n(e, t, i) ? s : null), (_t[s] = o)), r;
                };
            });
        var kt = /^(?:input|select|textarea|button)$/i,
            St = /^(?:a|area)$/i;
        xe.fn.extend({
            prop: function (e, t) {
                return Oe(this, xe.prop, e, t, arguments.length > 1);
            },
            removeProp: function (e) {
                return this.each(function () {
                    delete this[xe.propFix[e] || e];
                });
            },
        }),
            xe.extend({
                prop: function (e, t, n) {
                    var i,
                        r,
                        o = e.nodeType;
                    if (3 !== o && 8 !== o && 2 !== o)
                        return (
                            (1 === o && xe.isXMLDoc(e)) || ((t = xe.propFix[t] || t), (r = xe.propHooks[t])),
                            void 0 !== n ? (r && "set" in r && void 0 !== (i = r.set(e, n, t)) ? i : (e[t] = n)) : r && "get" in r && null !== (i = r.get(e, t)) ? i : e[t]
                        );
                },
                propHooks: {
                    tabIndex: {
                        get: function (e) {
                            var t = xe.find.attr(e, "tabindex");
                            return t ? parseInt(t, 10) : kt.test(e.nodeName) || (St.test(e.nodeName) && e.href) ? 0 : -1;
                        },
                    },
                },
                propFix: { for: "htmlFor", class: "className" },
            }),
            ye.optSelected ||
                (xe.propHooks.selected = {
                    get: function (e) {
                        var t = e.parentNode;
                        return t && t.parentNode && t.parentNode.selectedIndex, null;
                    },
                    set: function (e) {
                        var t = e.parentNode;
                        t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                    },
                }),
            xe.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
                xe.propFix[this.toLowerCase()] = this;
            }),
            xe.fn.extend({
                addClass: function (e) {
                    var t,
                        n,
                        i,
                        r,
                        o,
                        s,
                        a,
                        l = 0;
                    if (me(e))
                        return this.each(function (t) {
                            xe(this).addClass(e.call(this, t, Z(this)));
                        });
                    if ((t = J(e)).length)
                        for (; (n = this[l++]); )
                            if (((r = Z(n)), (i = 1 === n.nodeType && " " + Y(r) + " "))) {
                                for (s = 0; (o = t[s++]); ) i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                                r !== (a = Y(i)) && n.setAttribute("class", a);
                            }
                    return this;
                },
                removeClass: function (e) {
                    var t,
                        n,
                        i,
                        r,
                        o,
                        s,
                        a,
                        l = 0;
                    if (me(e))
                        return this.each(function (t) {
                            xe(this).removeClass(e.call(this, t, Z(this)));
                        });
                    if (!arguments.length) return this.attr("class", "");
                    if ((t = J(e)).length)
                        for (; (n = this[l++]); )
                            if (((r = Z(n)), (i = 1 === n.nodeType && " " + Y(r) + " "))) {
                                for (s = 0; (o = t[s++]); ) for (; i.indexOf(" " + o + " ") > -1; ) i = i.replace(" " + o + " ", " ");
                                r !== (a = Y(i)) && n.setAttribute("class", a);
                            }
                    return this;
                },
                toggleClass: function (e, t) {
                    var n = typeof e,
                        i = "string" === n || Array.isArray(e);
                    return "boolean" == typeof t && i
                        ? t
                            ? this.addClass(e)
                            : this.removeClass(e)
                        : me(e)
                        ? this.each(function (n) {
                              xe(this).toggleClass(e.call(this, n, Z(this), t), t);
                          })
                        : this.each(function () {
                              var t, r, o, s;
                              if (i) for (r = 0, o = xe(this), s = J(e); (t = s[r++]); ) o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                              else (void 0 !== e && "boolean" !== n) || ((t = Z(this)) && Re.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : Re.get(this, "__className__") || ""));
                          });
                },
                hasClass: function (e) {
                    var t,
                        n,
                        i = 0;
                    for (t = " " + e + " "; (n = this[i++]); ) if (1 === n.nodeType && (" " + Y(Z(n)) + " ").indexOf(t) > -1) return !0;
                    return !1;
                },
            });
        var Ct = /\r/g;
        xe.fn.extend({
            val: function (e) {
                var t,
                    n,
                    i,
                    r = this[0];
                return arguments.length
                    ? ((i = me(e)),
                      this.each(function (n) {
                          var r;
                          1 === this.nodeType &&
                              (null == (r = i ? e.call(this, n, xe(this).val()) : e)
                                  ? (r = "")
                                  : "number" == typeof r
                                  ? (r += "")
                                  : Array.isArray(r) &&
                                    (r = xe.map(r, function (e) {
                                        return null == e ? "" : e + "";
                                    })),
                              ((t = xe.valHooks[this.type] || xe.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, r, "value")) || (this.value = r));
                      }))
                    : r
                    ? (t = xe.valHooks[r.type] || xe.valHooks[r.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(r, "value"))
                        ? n
                        : "string" == typeof (n = r.value)
                        ? n.replace(Ct, "")
                        : null == n
                        ? ""
                        : n
                    : void 0;
            },
        }),
            xe.extend({
                valHooks: {
                    option: {
                        get: function (e) {
                            var t = xe.find.attr(e, "value");
                            return null != t ? t : Y(xe.text(e));
                        },
                    },
                    select: {
                        get: function (e) {
                            var t,
                                n,
                                i,
                                r = e.options,
                                s = e.selectedIndex,
                                a = "select-one" === e.type,
                                l = a ? null : [],
                                u = a ? s + 1 : r.length;
                            for (i = s < 0 ? u : a ? s : 0; i < u; i++)
                                if (((n = r[i]).selected || i === s) && !n.disabled && (!n.parentNode.disabled || !o(n.parentNode, "optgroup"))) {
                                    if (((t = xe(n).val()), a)) return t;
                                    l.push(t);
                                }
                            return l;
                        },
                        set: function (e, t) {
                            for (var n, i, r = e.options, o = xe.makeArray(t), s = r.length; s--; ) ((i = r[s]).selected = xe.inArray(xe.valHooks.option.get(i), o) > -1) && (n = !0);
                            return n || (e.selectedIndex = -1), o;
                        },
                    },
                },
            }),
            xe.each(["radio", "checkbox"], function () {
                (xe.valHooks[this] = {
                    set: function (e, t) {
                        if (Array.isArray(t)) return (e.checked = xe.inArray(xe(e).val(), t) > -1);
                    },
                }),
                    ye.checkOn ||
                        (xe.valHooks[this].get = function (e) {
                            return null === e.getAttribute("value") ? "on" : e.value;
                        });
            }),
            (ye.focusin = "onfocusin" in e);
        var Tt = /^(?:focusinfocus|focusoutblur)$/,
            Et = function (e) {
                e.stopPropagation();
            };
        xe.extend(xe.event, {
            trigger: function (t, n, i, r) {
                var o,
                    s,
                    a,
                    l,
                    u,
                    c,
                    f,
                    d,
                    p = [i || se],
                    h = he.call(t, "type") ? t.type : t,
                    g = he.call(t, "namespace") ? t.namespace.split(".") : [];
                if (
                    ((s = d = a = i = i || se),
                    3 !== i.nodeType &&
                        8 !== i.nodeType &&
                        !Tt.test(h + xe.event.triggered) &&
                        (h.indexOf(".") > -1 && ((h = (g = h.split(".")).shift()), g.sort()),
                        (u = h.indexOf(":") < 0 && "on" + h),
                        (t = t[xe.expando] ? t : new xe.Event(h, "object" == typeof t && t)),
                        (t.isTrigger = r ? 2 : 3),
                        (t.namespace = g.join(".")),
                        (t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                        (t.result = void 0),
                        t.target || (t.target = i),
                        (n = null == n ? [t] : xe.makeArray(n, [t])),
                        (f = xe.event.special[h] || {}),
                        r || !f.trigger || !1 !== f.trigger.apply(i, n)))
                ) {
                    if (!r && !f.noBubble && !be(i)) {
                        for (l = f.delegateType || h, Tt.test(l + h) || (s = s.parentNode); s; s = s.parentNode) p.push(s), (a = s);
                        a === (i.ownerDocument || se) && p.push(a.defaultView || a.parentWindow || e);
                    }
                    for (o = 0; (s = p[o++]) && !t.isPropagationStopped(); )
                        (d = s),
                            (t.type = o > 1 ? l : f.bindType || h),
                            (c = (Re.get(s, "events") || {})[t.type] && Re.get(s, "handle")) && c.apply(s, n),
                            (c = u && s[u]) && c.apply && Me(s) && ((t.result = c.apply(s, n)), !1 === t.result && t.preventDefault());
                    return (
                        (t.type = h),
                        r ||
                            t.isDefaultPrevented() ||
                            (f._default && !1 !== f._default.apply(p.pop(), n)) ||
                            !Me(i) ||
                            (u &&
                                me(i[h]) &&
                                !be(i) &&
                                ((a = i[u]) && (i[u] = null),
                                (xe.event.triggered = h),
                                t.isPropagationStopped() && d.addEventListener(h, Et),
                                i[h](),
                                t.isPropagationStopped() && d.removeEventListener(h, Et),
                                (xe.event.triggered = void 0),
                                a && (i[u] = a))),
                        t.result
                    );
                }
            },
            simulate: function (e, t, n) {
                var i = xe.extend(new xe.Event(), n, { type: e, isSimulated: !0 });
                xe.event.trigger(i, null, t);
            },
        }),
            xe.fn.extend({
                trigger: function (e, t) {
                    return this.each(function () {
                        xe.event.trigger(e, t, this);
                    });
                },
                triggerHandler: function (e, t) {
                    var n = this[0];
                    if (n) return xe.event.trigger(e, t, n, !0);
                },
            }),
            ye.focusin ||
                xe.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                    var n = function (e) {
                        xe.event.simulate(t, e.target, xe.event.fix(e));
                    };
                    xe.event.special[t] = {
                        setup: function () {
                            var i = this.ownerDocument || this,
                                r = Re.access(i, t);
                            r || i.addEventListener(e, n, !0), Re.access(i, t, (r || 0) + 1);
                        },
                        teardown: function () {
                            var i = this.ownerDocument || this,
                                r = Re.access(i, t) - 1;
                            r ? Re.access(i, t, r) : (i.removeEventListener(e, n, !0), Re.remove(i, t));
                        },
                    };
                });
        var At = e.location,
            jt = Date.now(),
            Dt = /\?/;
        xe.parseXML = function (t) {
            var n;
            if (!t || "string" != typeof t) return null;
            try {
                n = new e.DOMParser().parseFromString(t, "text/xml");
            } catch (e) {
                n = void 0;
            }
            return (n && !n.getElementsByTagName("parsererror").length) || xe.error("Invalid XML: " + t), n;
        };
        var Lt = /\[\]$/,
            Pt = /\r?\n/g,
            $t = /^(?:submit|button|image|reset|file)$/i,
            zt = /^(?:input|select|textarea|keygen)/i;
        (xe.param = function (e, t) {
            var n,
                i = [],
                r = function (e, t) {
                    var n = me(t) ? t() : t;
                    i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
                };
            if (Array.isArray(e) || (e.jquery && !xe.isPlainObject(e)))
                xe.each(e, function () {
                    r(this.name, this.value);
                });
            else for (n in e) K(n, e[n], t, r);
            return i.join("&");
        }),
            xe.fn.extend({
                serialize: function () {
                    return xe.param(this.serializeArray());
                },
                serializeArray: function () {
                    return this.map(function () {
                        var e = xe.prop(this, "elements");
                        return e ? xe.makeArray(e) : this;
                    })
                        .filter(function () {
                            var e = this.type;
                            return this.name && !xe(this).is(":disabled") && zt.test(this.nodeName) && !$t.test(e) && (this.checked || !Qe.test(e));
                        })
                        .map(function (e, t) {
                            var n = xe(this).val();
                            return null == n
                                ? null
                                : Array.isArray(n)
                                ? xe.map(n, function (e) {
                                      return { name: t.name, value: e.replace(Pt, "\r\n") };
                                  })
                                : { name: t.name, value: n.replace(Pt, "\r\n") };
                        })
                        .get();
                },
            });
        var Ot = /%20/g,
            It = /#.*$/,
            Nt = /([?&])_=[^&]*/,
            Mt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Rt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
            qt = /^(?:GET|HEAD)$/,
            Ht = /^\/\//,
            Wt = {},
            Ft = {},
            Ut = "*/".concat("*"),
            Bt = se.createElement("a");
        (Bt.href = At.href),
            xe.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: At.href,
                    type: "GET",
                    isLocal: Rt.test(At.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: { "*": Ut, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                    contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                    responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                    converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": xe.parseXML },
                    flatOptions: { url: !0, context: !0 },
                },
                ajaxSetup: function (e, t) {
                    return t ? ne(ne(e, xe.ajaxSettings), t) : ne(xe.ajaxSettings, e);
                },
                ajaxPrefilter: ee(Wt),
                ajaxTransport: ee(Ft),
                ajax: function (t, n) {
                    function i(t, n, i, a) {
                        var u,
                            d,
                            p,
                            w,
                            x,
                            _ = n;
                        c ||
                            ((c = !0),
                            l && e.clearTimeout(l),
                            (r = void 0),
                            (s = a || ""),
                            (k.readyState = t > 0 ? 4 : 0),
                            (u = (t >= 200 && t < 300) || 304 === t),
                            i && (w = ie(h, k, i)),
                            (w = re(h, w, k, u)),
                            u
                                ? (h.ifModified && ((x = k.getResponseHeader("Last-Modified")) && (xe.lastModified[o] = x), (x = k.getResponseHeader("etag")) && (xe.etag[o] = x)),
                                  204 === t || "HEAD" === h.type ? (_ = "nocontent") : 304 === t ? (_ = "notmodified") : ((_ = w.state), (d = w.data), (u = !(p = w.error))))
                                : ((p = _), (!t && _) || ((_ = "error"), t < 0 && (t = 0))),
                            (k.status = t),
                            (k.statusText = (n || _) + ""),
                            u ? y.resolveWith(g, [d, _, k]) : y.rejectWith(g, [k, _, p]),
                            k.statusCode(b),
                            (b = void 0),
                            f && v.trigger(u ? "ajaxSuccess" : "ajaxError", [k, h, u ? d : p]),
                            m.fireWith(g, [k, _]),
                            f && (v.trigger("ajaxComplete", [k, h]), --xe.active || xe.event.trigger("ajaxStop")));
                    }
                    "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
                    var r,
                        o,
                        s,
                        a,
                        l,
                        u,
                        c,
                        f,
                        d,
                        p,
                        h = xe.ajaxSetup({}, n),
                        g = h.context || h,
                        v = h.context && (g.nodeType || g.jquery) ? xe(g) : xe.event,
                        y = xe.Deferred(),
                        m = xe.Callbacks("once memory"),
                        b = h.statusCode || {},
                        w = {},
                        x = {},
                        _ = "canceled",
                        k = {
                            readyState: 0,
                            getResponseHeader: function (e) {
                                var t;
                                if (c) {
                                    if (!a) for (a = {}; (t = Mt.exec(s)); ) a[t[1].toLowerCase()] = t[2];
                                    t = a[e.toLowerCase()];
                                }
                                return null == t ? null : t;
                            },
                            getAllResponseHeaders: function () {
                                return c ? s : null;
                            },
                            setRequestHeader: function (e, t) {
                                return null == c && ((e = x[e.toLowerCase()] = x[e.toLowerCase()] || e), (w[e] = t)), this;
                            },
                            overrideMimeType: function (e) {
                                return null == c && (h.mimeType = e), this;
                            },
                            statusCode: function (e) {
                                var t;
                                if (e)
                                    if (c) k.always(e[k.status]);
                                    else for (t in e) b[t] = [b[t], e[t]];
                                return this;
                            },
                            abort: function (e) {
                                var t = e || _;
                                return r && r.abort(t), i(0, t), this;
                            },
                        };
                    if (
                        (y.promise(k),
                        (h.url = ((t || h.url || At.href) + "").replace(Ht, At.protocol + "//")),
                        (h.type = n.method || n.type || h.method || h.type),
                        (h.dataTypes = (h.dataType || "*").toLowerCase().match(Pe) || [""]),
                        null == h.crossDomain)
                    ) {
                        u = se.createElement("a");
                        try {
                            (u.href = h.url), (u.href = u.href), (h.crossDomain = Bt.protocol + "//" + Bt.host != u.protocol + "//" + u.host);
                        } catch (e) {
                            h.crossDomain = !0;
                        }
                    }
                    if ((h.data && h.processData && "string" != typeof h.data && (h.data = xe.param(h.data, h.traditional)), te(Wt, h, n, k), c)) return k;
                    (f = xe.event && h.global) && 0 == xe.active++ && xe.event.trigger("ajaxStart"),
                        (h.type = h.type.toUpperCase()),
                        (h.hasContent = !qt.test(h.type)),
                        (o = h.url.replace(It, "")),
                        h.hasContent
                            ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(Ot, "+"))
                            : ((p = h.url.slice(o.length)),
                              h.data && (h.processData || "string" == typeof h.data) && ((o += (Dt.test(o) ? "&" : "?") + h.data), delete h.data),
                              !1 === h.cache && ((o = o.replace(Nt, "$1")), (p = (Dt.test(o) ? "&" : "?") + "_=" + jt++ + p)),
                              (h.url = o + p)),
                        h.ifModified && (xe.lastModified[o] && k.setRequestHeader("If-Modified-Since", xe.lastModified[o]), xe.etag[o] && k.setRequestHeader("If-None-Match", xe.etag[o])),
                        ((h.data && h.hasContent && !1 !== h.contentType) || n.contentType) && k.setRequestHeader("Content-Type", h.contentType),
                        k.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + Ut + "; q=0.01" : "") : h.accepts["*"]);
                    for (d in h.headers) k.setRequestHeader(d, h.headers[d]);
                    if (h.beforeSend && (!1 === h.beforeSend.call(g, k, h) || c)) return k.abort();
                    if (((_ = "abort"), m.add(h.complete), k.done(h.success), k.fail(h.error), (r = te(Ft, h, n, k)))) {
                        if (((k.readyState = 1), f && v.trigger("ajaxSend", [k, h]), c)) return k;
                        h.async &&
                            h.timeout > 0 &&
                            (l = e.setTimeout(function () {
                                k.abort("timeout");
                            }, h.timeout));
                        try {
                            (c = !1), r.send(w, i);
                        } catch (e) {
                            if (c) throw e;
                            i(-1, e);
                        }
                    } else i(-1, "No Transport");
                    return k;
                },
                getJSON: function (e, t, n) {
                    return xe.get(e, t, n, "json");
                },
                getScript: function (e, t) {
                    return xe.get(e, void 0, t, "script");
                },
            }),
            xe.each(["get", "post"], function (e, t) {
                xe[t] = function (e, n, i, r) {
                    return me(n) && ((r = r || i), (i = n), (n = void 0)), xe.ajax(xe.extend({ url: e, type: t, dataType: r, data: n, success: i }, xe.isPlainObject(e) && e));
                };
            }),
            (xe._evalUrl = function (e) {
                return xe.ajax({ url: e, type: "GET", dataType: "script", cache: !0, async: !1, global: !1, throws: !0 });
            }),
            xe.fn.extend({
                wrapAll: function (e) {
                    var t;
                    return (
                        this[0] &&
                            (me(e) && (e = e.call(this[0])),
                            (t = xe(e, this[0].ownerDocument).eq(0).clone(!0)),
                            this[0].parentNode && t.insertBefore(this[0]),
                            t
                                .map(function () {
                                    for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                                    return e;
                                })
                                .append(this)),
                        this
                    );
                },
                wrapInner: function (e) {
                    return me(e)
                        ? this.each(function (t) {
                              xe(this).wrapInner(e.call(this, t));
                          })
                        : this.each(function () {
                              var t = xe(this),
                                  n = t.contents();
                              n.length ? n.wrapAll(e) : t.append(e);
                          });
                },
                wrap: function (e) {
                    var t = me(e);
                    return this.each(function (n) {
                        xe(this).wrapAll(t ? e.call(this, n) : e);
                    });
                },
                unwrap: function (e) {
                    return (
                        this.parent(e)
                            .not("body")
                            .each(function () {
                                xe(this).replaceWith(this.childNodes);
                            }),
                        this
                    );
                },
            }),
            (xe.expr.pseudos.hidden = function (e) {
                return !xe.expr.pseudos.visible(e);
            }),
            (xe.expr.pseudos.visible = function (e) {
                return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
            }),
            (xe.ajaxSettings.xhr = function () {
                try {
                    return new e.XMLHttpRequest();
                } catch (e) {}
            });
        var Xt = { 0: 200, 1223: 204 },
            Vt = xe.ajaxSettings.xhr();
        (ye.cors = !!Vt && "withCredentials" in Vt),
            (ye.ajax = Vt = !!Vt),
            xe.ajaxTransport(function (t) {
                var n, i;
                if (ye.cors || (Vt && !t.crossDomain))
                    return {
                        send: function (r, o) {
                            var s,
                                a = t.xhr();
                            if ((a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)) for (s in t.xhrFields) a[s] = t.xhrFields[s];
                            t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType), t.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest");
                            for (s in r) a.setRequestHeader(s, r[s]);
                            (n = function (e) {
                                return function () {
                                    n &&
                                        ((n = i = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null),
                                        "abort" === e
                                            ? a.abort()
                                            : "error" === e
                                            ? "number" != typeof a.status
                                                ? o(0, "error")
                                                : o(a.status, a.statusText)
                                            : o(
                                                  Xt[a.status] || a.status,
                                                  a.statusText,
                                                  "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? { binary: a.response } : { text: a.responseText },
                                                  a.getAllResponseHeaders()
                                              ));
                                };
                            }),
                                (a.onload = n()),
                                (i = a.onerror = a.ontimeout = n("error")),
                                void 0 !== a.onabort
                                    ? (a.onabort = i)
                                    : (a.onreadystatechange = function () {
                                          4 === a.readyState &&
                                              e.setTimeout(function () {
                                                  n && i();
                                              });
                                      }),
                                (n = n("abort"));
                            try {
                                a.send((t.hasContent && t.data) || null);
                            } catch (e) {
                                if (n) throw e;
                            }
                        },
                        abort: function () {
                            n && n();
                        },
                    };
            }),
            xe.ajaxPrefilter(function (e) {
                e.crossDomain && (e.contents.script = !1);
            }),
            xe.ajaxSetup({
                accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
                contents: { script: /\b(?:java|ecma)script\b/ },
                converters: {
                    "text script": function (e) {
                        return xe.globalEval(e), e;
                    },
                },
            }),
            xe.ajaxPrefilter("script", function (e) {
                void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
            }),
            xe.ajaxTransport("script", function (e) {
                if (e.crossDomain) {
                    var t, n;
                    return {
                        send: function (i, r) {
                            (t = xe("<script>")
                                .prop({ charset: e.scriptCharset, src: e.url })
                                .on(
                                    "load error",
                                    (n = function (e) {
                                        t.remove(), (n = null), e && r("error" === e.type ? 404 : 200, e.type);
                                    })
                                )),
                                se.head.appendChild(t[0]);
                        },
                        abort: function () {
                            n && n();
                        },
                    };
                }
            });
        var Gt = [],
            Qt = /(=)\?(?=&|$)|\?\?/;
        xe.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
                var e = Gt.pop() || xe.expando + "_" + jt++;
                return (this[e] = !0), e;
            },
        }),
            xe.ajaxPrefilter("json jsonp", function (t, n, i) {
                var r,
                    o,
                    s,
                    a = !1 !== t.jsonp && (Qt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Qt.test(t.data) && "data");
                if (a || "jsonp" === t.dataTypes[0])
                    return (
                        (r = t.jsonpCallback = me(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                        a ? (t[a] = t[a].replace(Qt, "$1" + r)) : !1 !== t.jsonp && (t.url += (Dt.test(t.url) ? "&" : "?") + t.jsonp + "=" + r),
                        (t.converters["script json"] = function () {
                            return s || xe.error(r + " was not called"), s[0];
                        }),
                        (t.dataTypes[0] = "json"),
                        (o = e[r]),
                        (e[r] = function () {
                            s = arguments;
                        }),
                        i.always(function () {
                            void 0 === o ? xe(e).removeProp(r) : (e[r] = o), t[r] && ((t.jsonpCallback = n.jsonpCallback), Gt.push(r)), s && me(o) && o(s[0]), (s = o = void 0);
                        }),
                        "script"
                    );
            }),
            (ye.createHTMLDocument = (function () {
                var e = se.implementation.createHTMLDocument("").body;
                return (e.innerHTML = "<form></form><form></form>"), 2 === e.childNodes.length;
            })()),
            (xe.parseHTML = function (e, t, n) {
                if ("string" != typeof e) return [];
                "boolean" == typeof t && ((n = t), (t = !1));
                var i, r, o;
                return (
                    t || (ye.createHTMLDocument ? (((i = (t = se.implementation.createHTMLDocument("")).createElement("base")).href = se.location.href), t.head.appendChild(i)) : (t = se)),
                    (r = Ee.exec(e)),
                    (o = !n && []),
                    r ? [t.createElement(r[1])] : ((r = k([e], t, o)), o && o.length && xe(o).remove(), xe.merge([], r.childNodes))
                );
            }),
            (xe.fn.load = function (e, t, n) {
                var i,
                    r,
                    o,
                    s = this,
                    a = e.indexOf(" ");
                return (
                    a > -1 && ((i = Y(e.slice(a))), (e = e.slice(0, a))),
                    me(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (r = "POST"),
                    s.length > 0 &&
                        xe
                            .ajax({ url: e, type: r || "GET", dataType: "html", data: t })
                            .done(function (e) {
                                (o = arguments), s.html(i ? xe("<div>").append(xe.parseHTML(e)).find(i) : e);
                            })
                            .always(
                                n &&
                                    function (e, t) {
                                        s.each(function () {
                                            n.apply(this, o || [e.responseText, t, e]);
                                        });
                                    }
                            ),
                    this
                );
            }),
            xe.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
                xe.fn[t] = function (e) {
                    return this.on(t, e);
                };
            }),
            (xe.expr.pseudos.animated = function (e) {
                return xe.grep(xe.timers, function (t) {
                    return e === t.elem;
                }).length;
            }),
            (xe.offset = {
                setOffset: function (e, t, n) {
                    var i,
                        r,
                        o,
                        s,
                        a,
                        l,
                        u,
                        c = xe.css(e, "position"),
                        f = xe(e),
                        d = {};
                    "static" === c && (e.style.position = "relative"),
                        (a = f.offset()),
                        (o = xe.css(e, "top")),
                        (l = xe.css(e, "left")),
                        (u = ("absolute" === c || "fixed" === c) && (o + l).indexOf("auto") > -1) ? ((s = (i = f.position()).top), (r = i.left)) : ((s = parseFloat(o) || 0), (r = parseFloat(l) || 0)),
                        me(t) && (t = t.call(e, n, xe.extend({}, a))),
                        null != t.top && (d.top = t.top - a.top + s),
                        null != t.left && (d.left = t.left - a.left + r),
                        "using" in t ? t.using.call(e, d) : f.css(d);
                },
            }),
            xe.fn.extend({
                offset: function (e) {
                    if (arguments.length)
                        return void 0 === e
                            ? this
                            : this.each(function (t) {
                                  xe.offset.setOffset(this, e, t);
                              });
                    var t,
                        n,
                        i = this[0];
                    return i ? (i.getClientRects().length ? ((t = i.getBoundingClientRect()), (n = i.ownerDocument.defaultView), { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset }) : { top: 0, left: 0 }) : void 0;
                },
                position: function () {
                    if (this[0]) {
                        var e,
                            t,
                            n,
                            i = this[0],
                            r = { top: 0, left: 0 };
                        if ("fixed" === xe.css(i, "position")) t = i.getBoundingClientRect();
                        else {
                            for (t = this.offset(), n = i.ownerDocument, e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === xe.css(e, "position"); ) e = e.parentNode;
                            e && e !== i && 1 === e.nodeType && (((r = xe(e).offset()).top += xe.css(e, "borderTopWidth", !0)), (r.left += xe.css(e, "borderLeftWidth", !0)));
                        }
                        return { top: t.top - r.top - xe.css(i, "marginTop", !0), left: t.left - r.left - xe.css(i, "marginLeft", !0) };
                    }
                },
                offsetParent: function () {
                    return this.map(function () {
                        for (var e = this.offsetParent; e && "static" === xe.css(e, "position"); ) e = e.offsetParent;
                        return e || et;
                    });
                },
            }),
            xe.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
                var n = "pageYOffset" === t;
                xe.fn[e] = function (i) {
                    return Oe(
                        this,
                        function (e, i, r) {
                            var o;
                            return be(e) ? (o = e) : 9 === e.nodeType && (o = e.defaultView), void 0 === r ? (o ? o[t] : e[i]) : void (o ? o.scrollTo(n ? o.pageXOffset : r, n ? r : o.pageYOffset) : (e[i] = r));
                        },
                        e,
                        i,
                        arguments.length
                    );
                };
            }),
            xe.each(["top", "left"], function (e, t) {
                xe.cssHooks[t] = I(ye.pixelPosition, function (e, n) {
                    if (n) return (n = O(e, t)), lt.test(n) ? xe(e).position()[t] + "px" : n;
                });
            }),
            xe.each({ Height: "height", Width: "width" }, function (e, t) {
                xe.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, i) {
                    xe.fn[i] = function (r, o) {
                        var s = arguments.length && (n || "boolean" != typeof r),
                            a = n || (!0 === r || !0 === o ? "margin" : "border");
                        return Oe(
                            this,
                            function (t, n, r) {
                                var o;
                                return be(t)
                                    ? 0 === i.indexOf("outer")
                                        ? t["inner" + e]
                                        : t.document.documentElement["client" + e]
                                    : 9 === t.nodeType
                                    ? ((o = t.documentElement), Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e]))
                                    : void 0 === r
                                    ? xe.css(t, n, a)
                                    : xe.style(t, n, r, a);
                            },
                            t,
                            s ? r : void 0,
                            s
                        );
                    };
                });
            }),
            xe.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
                xe.fn[t] = function (e, n) {
                    return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
                };
            }),
            xe.fn.extend({
                hover: function (e, t) {
                    return this.mouseenter(e).mouseleave(t || e);
                },
            }),
            xe.fn.extend({
                bind: function (e, t, n) {
                    return this.on(e, null, t, n);
                },
                unbind: function (e, t) {
                    return this.off(e, null, t);
                },
                delegate: function (e, t, n, i) {
                    return this.on(t, e, n, i);
                },
                undelegate: function (e, t, n) {
                    return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
                },
            }),
            (xe.proxy = function (e, t) {
                var n, i, r;
                if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), me(e)))
                    return (
                        (i = le.call(arguments, 2)),
                        (r = function () {
                            return e.apply(t || this, i.concat(le.call(arguments)));
                        }),
                        (r.guid = e.guid = e.guid || xe.guid++),
                        r
                    );
            }),
            (xe.holdReady = function (e) {
                e ? xe.readyWait++ : xe.ready(!0);
            }),
            (xe.isArray = Array.isArray),
            (xe.parseJSON = JSON.parse),
            (xe.nodeName = o),
            (xe.isFunction = me),
            (xe.isWindow = be),
            (xe.camelCase = h),
            (xe.type = i),
            (xe.now = Date.now),
            (xe.isNumeric = function (e) {
                var t = xe.type(e);
                return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
            }),
            "function" == typeof define &&
                define.amd &&
                define("jquery", [], function () {
                    return xe;
                });
        var Yt = e.jQuery,
            Zt = e.$;
        return (
            (xe.noConflict = function (t) {
                return e.$ === xe && (e.$ = Zt), t && e.jQuery === xe && (e.jQuery = Yt), xe;
            }),
            t || (e.jQuery = e.$ = xe),
            xe
        );
    })
    /*!
     * Flickity PACKAGED v2.1.2
     * Touch, responsive, flickable carousels
     *
     * Licensed GPLv3 for open source use
     * or Flickity Commercial License for commercial use
     *
     * https://flickity.metafizzy.co
     * Copyright 2015-2018 Metafizzy
     */,
    !(function (e, t) {
        "function" == typeof define && define.amd
            ? define("jquery-bridget/jquery-bridget", ["jquery"], function (n) {
                  return t(e, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("jquery")))
            : (e.jQueryBridget = t(e, e.jQuery));
    })(window, function (e, t) {
        "use strict";
        function n(n, o, a) {
            function l(e, t, i) {
                var r,
                    o = "$()." + n + '("' + t + '")';
                return (
                    e.each(function (e, l) {
                        var u = a.data(l, n);
                        if (!u) return void s(n + " not initialized. Cannot call methods, i.e. " + o);
                        var c = u[t];
                        if (!c || "_" == t.charAt(0)) return void s(o + " is not a valid method");
                        var f = c.apply(u, i);
                        r = void 0 === r ? f : r;
                    }),
                    void 0 !== r ? r : e
                );
            }
            function u(e, t) {
                e.each(function (e, i) {
                    var r = a.data(i, n);
                    r ? (r.option(t), r._init()) : ((r = new o(i, t)), a.data(i, n, r));
                });
            }
            (a = a || t || e.jQuery),
                a &&
                    (o.prototype.option ||
                        (o.prototype.option = function (e) {
                            a.isPlainObject(e) && (this.options = a.extend(!0, this.options, e));
                        }),
                    (a.fn[n] = function (e) {
                        if ("string" == typeof e) {
                            var t = r.call(arguments, 1);
                            return l(this, e, t);
                        }
                        return u(this, e), this;
                    }),
                    i(a));
        }
        function i(e) {
            !e || (e && e.bridget) || (e.bridget = n);
        }
        var r = Array.prototype.slice,
            o = e.console,
            s =
                "undefined" == typeof o
                    ? function () {}
                    : function (e) {
                          o.error(e);
                      };
        return i(t || e.jQuery), n;
    }),
    (function (e, t) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", t) : "object" == typeof module && module.exports ? (module.exports = t()) : (e.EvEmitter = t());
    })("undefined" != typeof window ? window : this, function () {
        function e() {}
        var t = e.prototype;
        return (
            (t.on = function (e, t) {
                if (e && t) {
                    var n = (this._events = this._events || {}),
                        i = (n[e] = n[e] || []);
                    return i.indexOf(t) == -1 && i.push(t), this;
                }
            }),
            (t.once = function (e, t) {
                if (e && t) {
                    this.on(e, t);
                    var n = (this._onceEvents = this._onceEvents || {}),
                        i = (n[e] = n[e] || {});
                    return (i[t] = !0), this;
                }
            }),
            (t.off = function (e, t) {
                var n = this._events && this._events[e];
                if (n && n.length) {
                    var i = n.indexOf(t);
                    return i != -1 && n.splice(i, 1), this;
                }
            }),
            (t.emitEvent = function (e, t) {
                var n = this._events && this._events[e];
                if (n && n.length) {
                    (n = n.slice(0)), (t = t || []);
                    for (var i = this._onceEvents && this._onceEvents[e], r = 0; r < n.length; r++) {
                        var o = n[r],
                            s = i && i[o];
                        s && (this.off(e, o), delete i[o]), o.apply(this, t);
                    }
                    return this;
                }
            }),
            (t.allOff = function () {
                delete this._events, delete this._onceEvents;
            }),
            e
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd ? define("get-size/get-size", t) : "object" == typeof module && module.exports ? (module.exports = t()) : (e.getSize = t());
    })(window, function () {
        "use strict";
        function e(e) {
            var t = parseFloat(e),
                n = e.indexOf("%") == -1 && !isNaN(t);
            return n && t;
        }
        function t() {}
        function n() {
            for (var e = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, t = 0; t < u; t++) {
                var n = l[t];
                e[n] = 0;
            }
            return e;
        }
        function i(e) {
            var t = getComputedStyle(e);
            return t || a("Style returned " + t + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), t;
        }
        function r() {
            if (!c) {
                c = !0;
                var t = document.createElement("div");
                (t.style.width = "200px"), (t.style.padding = "1px 2px 3px 4px"), (t.style.borderStyle = "solid"), (t.style.borderWidth = "1px 2px 3px 4px"), (t.style.boxSizing = "border-box");
                var n = document.body || document.documentElement;
                n.appendChild(t);
                var r = i(t);
                (s = 200 == Math.round(e(r.width))), (o.isBoxSizeOuter = s), n.removeChild(t);
            }
        }
        function o(t) {
            if ((r(), "string" == typeof t && (t = document.querySelector(t)), t && "object" == typeof t && t.nodeType)) {
                var o = i(t);
                if ("none" == o.display) return n();
                var a = {};
                (a.width = t.offsetWidth), (a.height = t.offsetHeight);
                for (var c = (a.isBorderBox = "border-box" == o.boxSizing), f = 0; f < u; f++) {
                    var d = l[f],
                        p = o[d],
                        h = parseFloat(p);
                    a[d] = isNaN(h) ? 0 : h;
                }
                var g = a.paddingLeft + a.paddingRight,
                    v = a.paddingTop + a.paddingBottom,
                    y = a.marginLeft + a.marginRight,
                    m = a.marginTop + a.marginBottom,
                    b = a.borderLeftWidth + a.borderRightWidth,
                    w = a.borderTopWidth + a.borderBottomWidth,
                    x = c && s,
                    _ = e(o.width);
                _ !== !1 && (a.width = _ + (x ? 0 : g + b));
                var k = e(o.height);
                return k !== !1 && (a.height = k + (x ? 0 : v + w)), (a.innerWidth = a.width - (g + b)), (a.innerHeight = a.height - (v + w)), (a.outerWidth = a.width + y), (a.outerHeight = a.height + m), a;
            }
        }
        var s,
            a =
                "undefined" == typeof console
                    ? t
                    : function (e) {
                          console.error(e);
                      },
            l = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            u = l.length,
            c = !1;
        return o;
    }),
    (function (e, t) {
        "use strict";
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", t) : "object" == typeof module && module.exports ? (module.exports = t()) : (e.matchesSelector = t());
    })(window, function () {
        "use strict";
        var e = (function () {
            var e = window.Element.prototype;
            if (e.matches) return "matches";
            if (e.matchesSelector) return "matchesSelector";
            for (var t = ["webkit", "moz", "ms", "o"], n = 0; n < t.length; n++) {
                var i = t[n],
                    r = i + "MatchesSelector";
                if (e[r]) return r;
            }
        })();
        return function (t, n) {
            return t[e](n);
        };
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (n) {
                  return t(e, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("desandro-matches-selector")))
            : (e.fizzyUIUtils = t(e, e.matchesSelector));
    })(window, function (e, t) {
        var n = {};
        (n.extend = function (e, t) {
            for (var n in t) e[n] = t[n];
            return e;
        }),
            (n.modulo = function (e, t) {
                return ((e % t) + t) % t;
            });
        var i = Array.prototype.slice;
        (n.makeArray = function (e) {
            if (Array.isArray(e)) return e;
            if (null === e || void 0 === e) return [];
            var t = "object" == typeof e && "number" == typeof e.length;
            return t ? i.call(e) : [e];
        }),
            (n.removeFrom = function (e, t) {
                var n = e.indexOf(t);
                n != -1 && e.splice(n, 1);
            }),
            (n.getParent = function (e, n) {
                for (; e.parentNode && e != document.body; ) if (((e = e.parentNode), t(e, n))) return e;
            }),
            (n.getQueryElement = function (e) {
                return "string" == typeof e ? document.querySelector(e) : e;
            }),
            (n.handleEvent = function (e) {
                var t = "on" + e.type;
                this[t] && this[t](e);
            }),
            (n.filterFindElements = function (e, i) {
                e = n.makeArray(e);
                var r = [];
                return (
                    e.forEach(function (e) {
                        if (e instanceof HTMLElement) {
                            if (!i) return void r.push(e);
                            t(e, i) && r.push(e);
                            for (var n = e.querySelectorAll(i), o = 0; o < n.length; o++) r.push(n[o]);
                        }
                    }),
                    r
                );
            }),
            (n.debounceMethod = function (e, t, n) {
                n = n || 100;
                var i = e.prototype[t],
                    r = t + "Timeout";
                e.prototype[t] = function () {
                    var e = this[r];
                    clearTimeout(e);
                    var t = arguments,
                        o = this;
                    this[r] = setTimeout(function () {
                        i.apply(o, t), delete o[r];
                    }, n);
                };
            }),
            (n.docReady = function (e) {
                var t = document.readyState;
                "complete" == t || "interactive" == t ? setTimeout(e) : document.addEventListener("DOMContentLoaded", e);
            }),
            (n.toDashed = function (e) {
                return e
                    .replace(/(.)([A-Z])/g, function (e, t, n) {
                        return t + "-" + n;
                    })
                    .toLowerCase();
            });
        var r = e.console;
        return (
            (n.htmlInit = function (t, i) {
                n.docReady(function () {
                    var o = n.toDashed(i),
                        s = "data-" + o,
                        a = document.querySelectorAll("[" + s + "]"),
                        l = document.querySelectorAll(".js-" + o),
                        u = n.makeArray(a).concat(n.makeArray(l)),
                        c = s + "-options",
                        f = e.jQuery;
                    u.forEach(function (e) {
                        var n,
                            o = e.getAttribute(s) || e.getAttribute(c);
                        try {
                            n = o && JSON.parse(o);
                        } catch (t) {
                            return void (r && r.error("Error parsing " + s + " on " + e.className + ": " + t));
                        }
                        var a = new t(e, n);
                        f && f.data(e, i, a);
                    });
                });
            }),
            n
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("flickity/js/cell", ["get-size/get-size"], function (n) {
                  return t(e, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("get-size")))
            : ((e.Flickity = e.Flickity || {}), (e.Flickity.Cell = t(e, e.getSize)));
    })(window, function (e, t) {
        function n(e, t) {
            (this.element = e), (this.parent = t), this.create();
        }
        var i = n.prototype;
        return (
            (i.create = function () {
                (this.element.style.position = "absolute"), this.element.setAttribute("aria-selected", "false"), (this.x = 0), (this.shift = 0);
            }),
            (i.destroy = function () {
                this.element.style.position = "";
                var e = this.parent.originSide;
                this.element.removeAttribute("aria-selected"), (this.element.style[e] = "");
            }),
            (i.getSize = function () {
                this.size = t(this.element);
            }),
            (i.setPosition = function (e) {
                (this.x = e), this.updateTarget(), this.renderPosition(e);
            }),
            (i.updateTarget = i.setDefaultTarget = function () {
                var e = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
                this.target = this.x + this.size[e] + this.size.width * this.parent.cellAlign;
            }),
            (i.renderPosition = function (e) {
                var t = this.parent.originSide;
                this.element.style[t] = this.parent.getPositionValue(e);
            }),
            (i.wrapShift = function (e) {
                (this.shift = e), this.renderPosition(this.x + this.parent.slideableWidth * e);
            }),
            (i.remove = function () {
                this.element.parentNode.removeChild(this.element);
            }),
            n
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd ? define("flickity/js/slide", t) : "object" == typeof module && module.exports ? (module.exports = t()) : ((e.Flickity = e.Flickity || {}), (e.Flickity.Slide = t()));
    })(window, function () {
        "use strict";
        function e(e) {
            (this.parent = e), (this.isOriginLeft = "left" == e.originSide), (this.cells = []), (this.outerWidth = 0), (this.height = 0);
        }
        var t = e.prototype;
        return (
            (t.addCell = function (e) {
                if ((this.cells.push(e), (this.outerWidth += e.size.outerWidth), (this.height = Math.max(e.size.outerHeight, this.height)), 1 == this.cells.length)) {
                    this.x = e.x;
                    var t = this.isOriginLeft ? "marginLeft" : "marginRight";
                    this.firstMargin = e.size[t];
                }
            }),
            (t.updateTarget = function () {
                var e = this.isOriginLeft ? "marginRight" : "marginLeft",
                    t = this.getLastCell(),
                    n = t ? t.size[e] : 0,
                    i = this.outerWidth - (this.firstMargin + n);
                this.target = this.x + this.firstMargin + i * this.parent.cellAlign;
            }),
            (t.getLastCell = function () {
                return this.cells[this.cells.length - 1];
            }),
            (t.select = function () {
                this.changeSelected(!0);
            }),
            (t.unselect = function () {
                this.changeSelected(!1);
            }),
            (t.changeSelected = function (e) {
                var t = e ? "add" : "remove";
                this.cells.forEach(function (n) {
                    n.element.classList[t]("is-selected"), n.element.setAttribute("aria-selected", e.toString());
                });
            }),
            (t.getCellElements = function () {
                return this.cells.map(function (e) {
                    return e.element;
                });
            }),
            e
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function (n) {
                  return t(e, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("fizzy-ui-utils")))
            : ((e.Flickity = e.Flickity || {}), (e.Flickity.animatePrototype = t(e, e.fizzyUIUtils)));
    })(window, function (e, t) {
        var n = {};
        return (
            (n.startAnimation = function () {
                this.isAnimating || ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
            }),
            (n.animate = function () {
                this.applyDragForce(), this.applySelectedAttraction();
                var e = this.x;
                if ((this.integratePhysics(), this.positionSlider(), this.settle(e), this.isAnimating)) {
                    var t = this;
                    requestAnimationFrame(function () {
                        t.animate();
                    });
                }
            }),
            (n.positionSlider = function () {
                var e = this.x;
                this.options.wrapAround && this.cells.length > 1 && ((e = t.modulo(e, this.slideableWidth)), (e -= this.slideableWidth), this.shiftWrapCells(e)), (e += this.cursorPosition), (e = this.options.rightToLeft ? -e : e);
                var n = this.getPositionValue(e);
                this.slider.style.transform = this.isAnimating ? "translate3d(" + n + ",0,0)" : "translateX(" + n + ")";
                var i = this.slides[0];
                if (i) {
                    var r = -this.x - i.target,
                        o = r / this.slidesWidth;
                    this.dispatchEvent("scroll", null, [o, r]);
                }
            }),
            (n.positionSliderAtSelected = function () {
                this.cells.length && ((this.x = -this.selectedSlide.target), (this.velocity = 0), this.positionSlider());
            }),
            (n.getPositionValue = function (e) {
                return this.options.percentPosition ? 0.01 * Math.round((e / this.size.innerWidth) * 1e4) + "%" : Math.round(e) + "px";
            }),
            (n.settle = function (e) {
                this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * e) || this.restingFrames++,
                    this.restingFrames > 2 && ((this.isAnimating = !1), delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]));
            }),
            (n.shiftWrapCells = function (e) {
                var t = this.cursorPosition + e;
                this._shiftCells(this.beforeShiftCells, t, -1);
                var n = this.size.innerWidth - (e + this.slideableWidth + this.cursorPosition);
                this._shiftCells(this.afterShiftCells, n, 1);
            }),
            (n._shiftCells = function (e, t, n) {
                for (var i = 0; i < e.length; i++) {
                    var r = e[i],
                        o = t > 0 ? n : 0;
                    r.wrapShift(o), (t -= r.size.outerWidth);
                }
            }),
            (n._unshiftCells = function (e) {
                if (e && e.length) for (var t = 0; t < e.length; t++) e[t].wrapShift(0);
            }),
            (n.integratePhysics = function () {
                (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
            }),
            (n.applyForce = function (e) {
                this.velocity += e;
            }),
            (n.getFrictionFactor = function () {
                return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
            }),
            (n.getRestingPosition = function () {
                return this.x + this.velocity / (1 - this.getFrictionFactor());
            }),
            (n.applyDragForce = function () {
                if (this.isDraggable && this.isPointerDown) {
                    var e = this.dragX - this.x,
                        t = e - this.velocity;
                    this.applyForce(t);
                }
            }),
            (n.applySelectedAttraction = function () {
                var e = this.isDraggable && this.isPointerDown;
                if (!e && !this.isFreeScrolling && this.slides.length) {
                    var t = this.selectedSlide.target * -1 - this.x,
                        n = t * this.options.selectedAttraction;
                    this.applyForce(n);
                }
            }),
            n
        );
    }),
    (function (e, t) {
        if ("function" == typeof define && define.amd)
            define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function (n, i, r, o, s, a) {
                return t(e, n, i, r, o, s, a);
            });
        else if ("object" == typeof module && module.exports) module.exports = t(e, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
        else {
            var n = e.Flickity;
            e.Flickity = t(e, e.EvEmitter, e.getSize, e.fizzyUIUtils, n.Cell, n.Slide, n.animatePrototype);
        }
    })(window, function (e, t, n, i, r, o, s) {
        function a(e, t) {
            for (e = i.makeArray(e); e.length; ) t.appendChild(e.shift());
        }
        function l(e, t) {
            var n = i.getQueryElement(e);
            if (!n) return void (f && f.error("Bad element for Flickity: " + (n || e)));
            if (((this.element = n), this.element.flickityGUID)) {
                var r = p[this.element.flickityGUID];
                return r.option(t), r;
            }
            u && (this.$element = u(this.element)), (this.options = i.extend({}, this.constructor.defaults)), this.option(t), this._create();
        }
        var u = e.jQuery,
            c = e.getComputedStyle,
            f = e.console,
            d = 0,
            p = {};
        (l.defaults = { accessibility: !0, cellAlign: "center", freeScrollFriction: 0.075, friction: 0.28, namespaceJQueryEvents: !0, percentPosition: !0, resize: !0, selectedAttraction: 0.025, setGallerySize: !0 }), (l.createMethods = []);
        var h = l.prototype;
        i.extend(h, t.prototype),
            (h._create = function () {
                var t = (this.guid = ++d);
                (this.element.flickityGUID = t),
                    (p[t] = this),
                    (this.selectedIndex = 0),
                    (this.restingFrames = 0),
                    (this.x = 0),
                    (this.velocity = 0),
                    (this.originSide = this.options.rightToLeft ? "right" : "left"),
                    (this.viewport = document.createElement("div")),
                    (this.viewport.className = "flickity-viewport"),
                    this._createSlider(),
                    (this.options.resize || this.options.watchCSS) && e.addEventListener("resize", this);
                for (var n in this.options.on) {
                    var i = this.options.on[n];
                    this.on(n, i);
                }
                l.createMethods.forEach(function (e) {
                    this[e]();
                }, this),
                    this.options.watchCSS ? this.watchCSS() : this.activate();
            }),
            (h.option = function (e) {
                i.extend(this.options, e);
            }),
            (h.activate = function () {
                if (!this.isActive) {
                    (this.isActive = !0), this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize();
                    var e = this._filterFindCellElements(this.element.children);
                    a(e, this.slider),
                        this.viewport.appendChild(this.slider),
                        this.element.appendChild(this.viewport),
                        this.reloadCells(),
                        this.options.accessibility && ((this.element.tabIndex = 0), this.element.addEventListener("keydown", this)),
                        this.emitEvent("activate");
                    var t,
                        n = this.options.initialIndex;
                    (t = this.isInitActivated ? this.selectedIndex : void 0 !== n && this.cells[n] ? n : 0), this.select(t, !1, !0), (this.isInitActivated = !0), this.dispatchEvent("ready");
                }
            }),
            (h._createSlider = function () {
                var e = document.createElement("div");
                (e.className = "flickity-slider"), (e.style[this.originSide] = 0), (this.slider = e);
            }),
            (h._filterFindCellElements = function (e) {
                return i.filterFindElements(e, this.options.cellSelector);
            }),
            (h.reloadCells = function () {
                (this.cells = this._makeCells(this.slider.children)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize();
            }),
            (h._makeCells = function (e) {
                var t = this._filterFindCellElements(e),
                    n = t.map(function (e) {
                        return new r(e, this);
                    }, this);
                return n;
            }),
            (h.getLastCell = function () {
                return this.cells[this.cells.length - 1];
            }),
            (h.getLastSlide = function () {
                return this.slides[this.slides.length - 1];
            }),
            (h.positionCells = function () {
                this._sizeCells(this.cells), this._positionCells(0);
            }),
            (h._positionCells = function (e) {
                (e = e || 0), (this.maxCellHeight = e ? this.maxCellHeight || 0 : 0);
                var t = 0;
                if (e > 0) {
                    var n = this.cells[e - 1];
                    t = n.x + n.size.outerWidth;
                }
                for (var i = this.cells.length, r = e; r < i; r++) {
                    var o = this.cells[r];
                    o.setPosition(t), (t += o.size.outerWidth), (this.maxCellHeight = Math.max(o.size.outerHeight, this.maxCellHeight));
                }
                (this.slideableWidth = t), this.updateSlides(), this._containSlides(), (this.slidesWidth = i ? this.getLastSlide().target - this.slides[0].target : 0);
            }),
            (h._sizeCells = function (e) {
                e.forEach(function (e) {
                    e.getSize();
                });
            }),
            (h.updateSlides = function () {
                if (((this.slides = []), this.cells.length)) {
                    var e = new o(this);
                    this.slides.push(e);
                    var t = "left" == this.originSide,
                        n = t ? "marginRight" : "marginLeft",
                        i = this._getCanCellFit();
                    this.cells.forEach(function (t, r) {
                        if (!e.cells.length) return void e.addCell(t);
                        var s = e.outerWidth - e.firstMargin + (t.size.outerWidth - t.size[n]);
                        i.call(this, r, s) ? e.addCell(t) : (e.updateTarget(), (e = new o(this)), this.slides.push(e), e.addCell(t));
                    }, this),
                        e.updateTarget(),
                        this.updateSelectedSlide();
                }
            }),
            (h._getCanCellFit = function () {
                var e = this.options.groupCells;
                if (!e)
                    return function () {
                        return !1;
                    };
                if ("number" == typeof e) {
                    var t = parseInt(e, 10);
                    return function (e) {
                        return e % t !== 0;
                    };
                }
                var n = "string" == typeof e && e.match(/^(\d+)%$/),
                    i = n ? parseInt(n[1], 10) / 100 : 1;
                return function (e, t) {
                    return t <= (this.size.innerWidth + 1) * i;
                };
            }),
            (h._init = h.reposition = function () {
                this.positionCells(), this.positionSliderAtSelected();
            }),
            (h.getSize = function () {
                (this.size = n(this.element)), this.setCellAlign(), (this.cursorPosition = this.size.innerWidth * this.cellAlign);
            });
        var g = { center: { left: 0.5, right: 0.5 }, left: { left: 0, right: 1 }, right: { right: 0, left: 1 } };
        return (
            (h.setCellAlign = function () {
                var e = g[this.options.cellAlign];
                this.cellAlign = e ? e[this.originSide] : this.options.cellAlign;
            }),
            (h.setGallerySize = function () {
                if (this.options.setGallerySize) {
                    var e = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                    this.viewport.style.height = e + "px";
                }
            }),
            (h._getWrapShiftCells = function () {
                if (this.options.wrapAround) {
                    this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                    var e = this.cursorPosition,
                        t = this.cells.length - 1;
                    (this.beforeShiftCells = this._getGapCells(e, t, -1)), (e = this.size.innerWidth - this.cursorPosition), (this.afterShiftCells = this._getGapCells(e, 0, 1));
                }
            }),
            (h._getGapCells = function (e, t, n) {
                for (var i = []; e > 0; ) {
                    var r = this.cells[t];
                    if (!r) break;
                    i.push(r), (t += n), (e -= r.size.outerWidth);
                }
                return i;
            }),
            (h._containSlides = function () {
                if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                    var e = this.options.rightToLeft,
                        t = e ? "marginRight" : "marginLeft",
                        n = e ? "marginLeft" : "marginRight",
                        i = this.slideableWidth - this.getLastCell().size[n],
                        r = i < this.size.innerWidth,
                        o = this.cursorPosition + this.cells[0].size[t],
                        s = i - this.size.innerWidth * (1 - this.cellAlign);
                    this.slides.forEach(function (e) {
                        r ? (e.target = i * this.cellAlign) : ((e.target = Math.max(e.target, o)), (e.target = Math.min(e.target, s)));
                    }, this);
                }
            }),
            (h.dispatchEvent = function (e, t, n) {
                var i = t ? [t].concat(n) : n;
                if ((this.emitEvent(e, i), u && this.$element)) {
                    e += this.options.namespaceJQueryEvents ? ".flickity" : "";
                    var r = e;
                    if (t) {
                        var o = u.Event(t);
                        (o.type = e), (r = o);
                    }
                    this.$element.trigger(r, n);
                }
            }),
            (h.select = function (e, t, n) {
                if (this.isActive && ((e = parseInt(e, 10)), this._wrapSelect(e), (this.options.wrapAround || t) && (e = i.modulo(e, this.slides.length)), this.slides[e])) {
                    var r = this.selectedIndex;
                    (this.selectedIndex = e),
                        this.updateSelectedSlide(),
                        n ? this.positionSliderAtSelected() : this.startAnimation(),
                        this.options.adaptiveHeight && this.setGallerySize(),
                        this.dispatchEvent("select", null, [e]),
                        e != r && this.dispatchEvent("change", null, [e]),
                        this.dispatchEvent("cellSelect");
                }
            }),
            (h._wrapSelect = function (e) {
                var t = this.slides.length,
                    n = this.options.wrapAround && t > 1;
                if (!n) return e;
                var r = i.modulo(e, t),
                    o = Math.abs(r - this.selectedIndex),
                    s = Math.abs(r + t - this.selectedIndex),
                    a = Math.abs(r - t - this.selectedIndex);
                !this.isDragSelect && s < o ? (e += t) : !this.isDragSelect && a < o && (e -= t), e < 0 ? (this.x -= this.slideableWidth) : e >= t && (this.x += this.slideableWidth);
            }),
            (h.previous = function (e, t) {
                this.select(this.selectedIndex - 1, e, t);
            }),
            (h.next = function (e, t) {
                this.select(this.selectedIndex + 1, e, t);
            }),
            (h.updateSelectedSlide = function () {
                var e = this.slides[this.selectedIndex];
                e &&
                    (this.unselectSelectedSlide(),
                    (this.selectedSlide = e),
                    e.select(),
                    (this.selectedCells = e.cells),
                    (this.selectedElements = e.getCellElements()),
                    (this.selectedCell = e.cells[0]),
                    (this.selectedElement = this.selectedElements[0]));
            }),
            (h.unselectSelectedSlide = function () {
                this.selectedSlide && this.selectedSlide.unselect();
            }),
            (h.selectCell = function (e, t, n) {
                var i = this.queryCell(e);
                if (i) {
                    var r = this.getCellSlideIndex(i);
                    this.select(r, t, n);
                }
            }),
            (h.getCellSlideIndex = function (e) {
                for (var t = 0; t < this.slides.length; t++) {
                    var n = this.slides[t],
                        i = n.cells.indexOf(e);
                    if (i != -1) return t;
                }
            }),
            (h.getCell = function (e) {
                for (var t = 0; t < this.cells.length; t++) {
                    var n = this.cells[t];
                    if (n.element == e) return n;
                }
            }),
            (h.getCells = function (e) {
                e = i.makeArray(e);
                var t = [];
                return (
                    e.forEach(function (e) {
                        var n = this.getCell(e);
                        n && t.push(n);
                    }, this),
                    t
                );
            }),
            (h.getCellElements = function () {
                return this.cells.map(function (e) {
                    return e.element;
                });
            }),
            (h.getParentCell = function (e) {
                var t = this.getCell(e);
                return t ? t : ((e = i.getParent(e, ".flickity-slider > *")), this.getCell(e));
            }),
            (h.getAdjacentCellElements = function (e, t) {
                if (!e) return this.selectedSlide.getCellElements();
                t = void 0 === t ? this.selectedIndex : t;
                var n = this.slides.length;
                if (1 + 2 * e >= n) return this.getCellElements();
                for (var r = [], o = t - e; o <= t + e; o++) {
                    var s = this.options.wrapAround ? i.modulo(o, n) : o,
                        a = this.slides[s];
                    a && (r = r.concat(a.getCellElements()));
                }
                return r;
            }),
            (h.queryCell = function (e) {
                return "number" == typeof e ? this.cells[e] : ("string" == typeof e && (e = this.element.querySelector(e)), this.getCell(e));
            }),
            (h.uiChange = function () {
                this.emitEvent("uiChange");
            }),
            (h.childUIPointerDown = function (e) {
                this.emitEvent("childUIPointerDown", [e]);
            }),
            (h.onresize = function () {
                this.watchCSS(), this.resize();
            }),
            i.debounceMethod(l, "onresize", 150),
            (h.resize = function () {
                if (this.isActive) {
                    this.getSize(), this.options.wrapAround && (this.x = i.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
                    var e = this.selectedElements && this.selectedElements[0];
                    this.selectCell(e, !1, !0);
                }
            }),
            (h.watchCSS = function () {
                var e = this.options.watchCSS;
                if (e) {
                    var t = c(this.element, ":after").content;
                    t.indexOf("flickity") != -1 ? this.activate() : this.deactivate();
                }
            }),
            (h.onkeydown = function (e) {
                var t = document.activeElement && document.activeElement != this.element;
                if (this.options.accessibility && !t) {
                    var n = l.keyboardHandlers[e.keyCode];
                    n && n.call(this);
                }
            }),
            (l.keyboardHandlers = {
                37: function () {
                    var e = this.options.rightToLeft ? "next" : "previous";
                    this.uiChange(), this[e]();
                },
                39: function () {
                    var e = this.options.rightToLeft ? "previous" : "next";
                    this.uiChange(), this[e]();
                },
            }),
            (h.focus = function () {
                var t = e.pageYOffset;
                this.element.focus({ preventScroll: !0 }), e.pageYOffset != t && e.scrollTo(e.pageXOffset, t);
            }),
            (h.deactivate = function () {
                this.isActive &&
                    (this.element.classList.remove("flickity-enabled"),
                    this.element.classList.remove("flickity-rtl"),
                    this.unselectSelectedSlide(),
                    this.cells.forEach(function (e) {
                        e.destroy();
                    }),
                    this.element.removeChild(this.viewport),
                    a(this.slider.children, this.element),
                    this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)),
                    (this.isActive = !1),
                    this.emitEvent("deactivate"));
            }),
            (h.destroy = function () {
                this.deactivate(), e.removeEventListener("resize", this), this.emitEvent("destroy"), u && this.$element && u.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete p[this.guid];
            }),
            i.extend(h, s),
            (l.data = function (e) {
                e = i.getQueryElement(e);
                var t = e && e.flickityGUID;
                return t && p[t];
            }),
            i.htmlInit(l, "flickity"),
            u && u.bridget && u.bridget("flickity", l),
            (l.setJQuery = function (e) {
                u = e;
            }),
            (l.Cell = r),
            l
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function (n) {
                  return t(e, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("ev-emitter")))
            : (e.Unipointer = t(e, e.EvEmitter));
    })(window, function (e, t) {
        function n() {}
        function i() {}
        var r = (i.prototype = Object.create(t.prototype));
        (r.bindStartEvent = function (e) {
            this._bindStartEvent(e, !0);
        }),
            (r.unbindStartEvent = function (e) {
                this._bindStartEvent(e, !1);
            }),
            (r._bindStartEvent = function (t, n) {
                n = void 0 === n || n;
                var i = n ? "addEventListener" : "removeEventListener",
                    r = "mousedown";
                e.PointerEvent ? (r = "pointerdown") : "ontouchstart" in e && (r = "touchstart"), t[i](r, this);
            }),
            (r.handleEvent = function (e) {
                var t = "on" + e.type;
                this[t] && this[t](e);
            }),
            (r.getTouch = function (e) {
                for (var t = 0; t < e.length; t++) {
                    var n = e[t];
                    if (n.identifier == this.pointerIdentifier) return n;
                }
            }),
            (r.onmousedown = function (e) {
                var t = e.button;
                (t && 0 !== t && 1 !== t) || this._pointerDown(e, e);
            }),
            (r.ontouchstart = function (e) {
                this._pointerDown(e, e.changedTouches[0]);
            }),
            (r.onpointerdown = function (e) {
                this._pointerDown(e, e);
            }),
            (r._pointerDown = function (e, t) {
                e.button || this.isPointerDown || ((this.isPointerDown = !0), (this.pointerIdentifier = void 0 !== t.pointerId ? t.pointerId : t.identifier), this.pointerDown(e, t));
            }),
            (r.pointerDown = function (e, t) {
                this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t]);
            });
        var o = { mousedown: ["mousemove", "mouseup"], touchstart: ["touchmove", "touchend", "touchcancel"], pointerdown: ["pointermove", "pointerup", "pointercancel"] };
        return (
            (r._bindPostStartEvents = function (t) {
                if (t) {
                    var n = o[t.type];
                    n.forEach(function (t) {
                        e.addEventListener(t, this);
                    }, this),
                        (this._boundPointerEvents = n);
                }
            }),
            (r._unbindPostStartEvents = function () {
                this._boundPointerEvents &&
                    (this._boundPointerEvents.forEach(function (t) {
                        e.removeEventListener(t, this);
                    }, this),
                    delete this._boundPointerEvents);
            }),
            (r.onmousemove = function (e) {
                this._pointerMove(e, e);
            }),
            (r.onpointermove = function (e) {
                e.pointerId == this.pointerIdentifier && this._pointerMove(e, e);
            }),
            (r.ontouchmove = function (e) {
                var t = this.getTouch(e.changedTouches);
                t && this._pointerMove(e, t);
            }),
            (r._pointerMove = function (e, t) {
                this.pointerMove(e, t);
            }),
            (r.pointerMove = function (e, t) {
                this.emitEvent("pointerMove", [e, t]);
            }),
            (r.onmouseup = function (e) {
                this._pointerUp(e, e);
            }),
            (r.onpointerup = function (e) {
                e.pointerId == this.pointerIdentifier && this._pointerUp(e, e);
            }),
            (r.ontouchend = function (e) {
                var t = this.getTouch(e.changedTouches);
                t && this._pointerUp(e, t);
            }),
            (r._pointerUp = function (e, t) {
                this._pointerDone(), this.pointerUp(e, t);
            }),
            (r.pointerUp = function (e, t) {
                this.emitEvent("pointerUp", [e, t]);
            }),
            (r._pointerDone = function () {
                this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
            }),
            (r._pointerReset = function () {
                (this.isPointerDown = !1), delete this.pointerIdentifier;
            }),
            (r.pointerDone = n),
            (r.onpointercancel = function (e) {
                e.pointerId == this.pointerIdentifier && this._pointerCancel(e, e);
            }),
            (r.ontouchcancel = function (e) {
                var t = this.getTouch(e.changedTouches);
                t && this._pointerCancel(e, t);
            }),
            (r._pointerCancel = function (e, t) {
                this._pointerDone(), this.pointerCancel(e, t);
            }),
            (r.pointerCancel = function (e, t) {
                this.emitEvent("pointerCancel", [e, t]);
            }),
            (i.getPointerPoint = function (e) {
                return { x: e.pageX, y: e.pageY };
            }),
            i
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("unidragger/unidragger", ["unipointer/unipointer"], function (n) {
                  return t(e, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("unipointer")))
            : (e.Unidragger = t(e, e.Unipointer));
    })(window, function (e, t) {
        function n() {}
        var i = (n.prototype = Object.create(t.prototype));
        (i.bindHandles = function () {
            this._bindHandles(!0);
        }),
            (i.unbindHandles = function () {
                this._bindHandles(!1);
            }),
            (i._bindHandles = function (t) {
                t = void 0 === t || t;
                for (var n = t ? "addEventListener" : "removeEventListener", i = t ? this._touchActionValue : "", r = 0; r < this.handles.length; r++) {
                    var o = this.handles[r];
                    this._bindStartEvent(o, t), o[n]("click", this), e.PointerEvent && (o.style.touchAction = i);
                }
            }),
            (i._touchActionValue = "none"),
            (i.pointerDown = function (e, t) {
                var n = this.okayPointerDown(e);
                n && ((this.pointerDownPointer = t), e.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t]));
            });
        var r = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
            o = { radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0 };
        return (
            (i.okayPointerDown = function (e) {
                var t = r[e.target.nodeName],
                    n = o[e.target.type],
                    i = !t || n;
                return i || this._pointerReset(), i;
            }),
            (i.pointerDownBlur = function () {
                var e = document.activeElement,
                    t = e && e.blur && e != document.body;
                t && e.blur();
            }),
            (i.pointerMove = function (e, t) {
                var n = this._dragPointerMove(e, t);
                this.emitEvent("pointerMove", [e, t, n]), this._dragMove(e, t, n);
            }),
            (i._dragPointerMove = function (e, t) {
                var n = { x: t.pageX - this.pointerDownPointer.pageX, y: t.pageY - this.pointerDownPointer.pageY };
                return !this.isDragging && this.hasDragStarted(n) && this._dragStart(e, t), n;
            }),
            (i.hasDragStarted = function (e) {
                return Math.abs(e.x) > 3 || Math.abs(e.y) > 3;
            }),
            (i.pointerUp = function (e, t) {
                this.emitEvent("pointerUp", [e, t]), this._dragPointerUp(e, t);
            }),
            (i._dragPointerUp = function (e, t) {
                this.isDragging ? this._dragEnd(e, t) : this._staticClick(e, t);
            }),
            (i._dragStart = function (e, t) {
                (this.isDragging = !0), (this.isPreventingClicks = !0), this.dragStart(e, t);
            }),
            (i.dragStart = function (e, t) {
                this.emitEvent("dragStart", [e, t]);
            }),
            (i._dragMove = function (e, t, n) {
                this.isDragging && this.dragMove(e, t, n);
            }),
            (i.dragMove = function (e, t, n) {
                e.preventDefault(), this.emitEvent("dragMove", [e, t, n]);
            }),
            (i._dragEnd = function (e, t) {
                (this.isDragging = !1),
                    setTimeout(
                        function () {
                            delete this.isPreventingClicks;
                        }.bind(this)
                    ),
                    this.dragEnd(e, t);
            }),
            (i.dragEnd = function (e, t) {
                this.emitEvent("dragEnd", [e, t]);
            }),
            (i.onclick = function (e) {
                this.isPreventingClicks && e.preventDefault();
            }),
            (i._staticClick = function (e, t) {
                (this.isIgnoringMouseUp && "mouseup" == e.type) ||
                    (this.staticClick(e, t),
                    "mouseup" != e.type &&
                        ((this.isIgnoringMouseUp = !0),
                        setTimeout(
                            function () {
                                delete this.isIgnoringMouseUp;
                            }.bind(this),
                            400
                        )));
            }),
            (i.staticClick = function (e, t) {
                this.emitEvent("staticClick", [e, t]);
            }),
            (n.getPointerPoint = t.getPointerPoint),
            n
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function (n, i, r) {
                  return t(e, n, i, r);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")))
            : (e.Flickity = t(e, e.Flickity, e.Unidragger, e.fizzyUIUtils));
    })(window, function (e, t, n, i) {
        function r() {
            return { x: e.pageXOffset, y: e.pageYOffset };
        }
        i.extend(t.defaults, { draggable: ">1", dragThreshold: 3 }), t.createMethods.push("_createDrag");
        var o = t.prototype;
        i.extend(o, n.prototype), (o._touchActionValue = "pan-y");
        var s = "createTouch" in document,
            a = !1;
        (o._createDrag = function () {
            this.on("activate", this.onActivateDrag),
                this.on("uiChange", this._uiChangeDrag),
                this.on("childUIPointerDown", this._childUIPointerDownDrag),
                this.on("deactivate", this.onDeactivateDrag),
                this.on("cellChange", this.updateDraggable),
                s && !a && (e.addEventListener("touchmove", function () {}), (a = !0));
        }),
            (o.onActivateDrag = function () {
                (this.handles = [this.viewport]), this.bindHandles(), this.updateDraggable();
            }),
            (o.onDeactivateDrag = function () {
                this.unbindHandles(), this.element.classList.remove("is-draggable");
            }),
            (o.updateDraggable = function () {
                ">1" == this.options.draggable ? (this.isDraggable = this.slides.length > 1) : (this.isDraggable = this.options.draggable),
                    this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable");
            }),
            (o.bindDrag = function () {
                (this.options.draggable = !0), this.updateDraggable();
            }),
            (o.unbindDrag = function () {
                (this.options.draggable = !1), this.updateDraggable();
            }),
            (o._uiChangeDrag = function () {
                delete this.isFreeScrolling;
            }),
            (o._childUIPointerDownDrag = function (e) {
                e.preventDefault(), this.pointerDownFocus(e);
            }),
            (o.pointerDown = function (t, n) {
                if (!this.isDraggable) return void this._pointerDownDefault(t, n);
                var i = this.okayPointerDown(t);
                i &&
                    (this._pointerDownPreventDefault(t),
                    this.pointerDownFocus(t),
                    document.activeElement != this.element && this.pointerDownBlur(),
                    (this.dragX = this.x),
                    this.viewport.classList.add("is-pointer-down"),
                    (this.pointerDownScroll = r()),
                    e.addEventListener("scroll", this),
                    this._pointerDownDefault(t, n));
            }),
            (o._pointerDownDefault = function (e, t) {
                (this.pointerDownPointer = t), this._bindPostStartEvents(e), this.dispatchEvent("pointerDown", e, [t]);
            });
        var l = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
        return (
            (o.pointerDownFocus = function (e) {
                var t = l[e.target.nodeName];
                t || this.focus();
            }),
            (o._pointerDownPreventDefault = function (e) {
                var t = "touchstart" == e.type,
                    n = "touch" == e.pointerType,
                    i = l[e.target.nodeName];
                t || n || i || e.preventDefault();
            }),
            (o.hasDragStarted = function (e) {
                return Math.abs(e.x) > this.options.dragThreshold;
            }),
            (o.pointerUp = function (e, t) {
                delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", e, [t]), this._dragPointerUp(e, t);
            }),
            (o.pointerDone = function () {
                e.removeEventListener("scroll", this), delete this.pointerDownScroll;
            }),
            (o.dragStart = function (t, n) {
                this.isDraggable && ((this.dragStartPosition = this.x), this.startAnimation(), e.removeEventListener("scroll", this), this.dispatchEvent("dragStart", t, [n]));
            }),
            (o.pointerMove = function (e, t) {
                var n = this._dragPointerMove(e, t);
                this.dispatchEvent("pointerMove", e, [t, n]), this._dragMove(e, t, n);
            }),
            (o.dragMove = function (e, t, n) {
                if (this.isDraggable) {
                    e.preventDefault(), (this.previousDragX = this.dragX);
                    var i = this.options.rightToLeft ? -1 : 1;
                    this.options.wrapAround && (n.x = n.x % this.slideableWidth);
                    var r = this.dragStartPosition + n.x * i;
                    if (!this.options.wrapAround && this.slides.length) {
                        var o = Math.max(-this.slides[0].target, this.dragStartPosition);
                        r = r > o ? 0.5 * (r + o) : r;
                        var s = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                        r = r < s ? 0.5 * (r + s) : r;
                    }
                    (this.dragX = r), (this.dragMoveTime = new Date()), this.dispatchEvent("dragMove", e, [t, n]);
                }
            }),
            (o.dragEnd = function (e, t) {
                if (this.isDraggable) {
                    this.options.freeScroll && (this.isFreeScrolling = !0);
                    var n = this.dragEndRestingSelect();
                    if (this.options.freeScroll && !this.options.wrapAround) {
                        var i = this.getRestingPosition();
                        this.isFreeScrolling = -i > this.slides[0].target && -i < this.getLastSlide().target;
                    } else this.options.freeScroll || n != this.selectedIndex || (n += this.dragEndBoostSelect());
                    delete this.previousDragX, (this.isDragSelect = this.options.wrapAround), this.select(n), delete this.isDragSelect, this.dispatchEvent("dragEnd", e, [t]);
                }
            }),
            (o.dragEndRestingSelect = function () {
                var e = this.getRestingPosition(),
                    t = Math.abs(this.getSlideDistance(-e, this.selectedIndex)),
                    n = this._getClosestResting(e, t, 1),
                    i = this._getClosestResting(e, t, -1),
                    r = n.distance < i.distance ? n.index : i.index;
                return r;
            }),
            (o._getClosestResting = function (e, t, n) {
                for (
                    var i = this.selectedIndex,
                        r = 1 / 0,
                        o =
                            this.options.contain && !this.options.wrapAround
                                ? function (e, t) {
                                      return e <= t;
                                  }
                                : function (e, t) {
                                      return e < t;
                                  };
                    o(t, r) && ((i += n), (r = t), (t = this.getSlideDistance(-e, i)), null !== t);

                )
                    t = Math.abs(t);
                return { distance: r, index: i - n };
            }),
            (o.getSlideDistance = function (e, t) {
                var n = this.slides.length,
                    r = this.options.wrapAround && n > 1,
                    o = r ? i.modulo(t, n) : t,
                    s = this.slides[o];
                if (!s) return null;
                var a = r ? this.slideableWidth * Math.floor(t / n) : 0;
                return e - (s.target + a);
            }),
            (o.dragEndBoostSelect = function () {
                if (void 0 === this.previousDragX || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) return 0;
                var e = this.getSlideDistance(-this.dragX, this.selectedIndex),
                    t = this.previousDragX - this.dragX;
                return e > 0 && t > 0 ? 1 : e < 0 && t < 0 ? -1 : 0;
            }),
            (o.staticClick = function (e, t) {
                var n = this.getParentCell(e.target),
                    i = n && n.element,
                    r = n && this.cells.indexOf(n);
                this.dispatchEvent("staticClick", e, [t, i, r]);
            }),
            (o.onscroll = function () {
                var e = r(),
                    t = this.pointerDownScroll.x - e.x,
                    n = this.pointerDownScroll.y - e.y;
                (Math.abs(t) > 3 || Math.abs(n) > 3) && this._pointerDone();
            }),
            t
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("tap-listener/tap-listener", ["unipointer/unipointer"], function (n) {
                  return t(e, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("unipointer")))
            : (e.TapListener = t(e, e.Unipointer));
    })(window, function (e, t) {
        function n(e) {
            this.bindTap(e);
        }
        var i = (n.prototype = Object.create(t.prototype));
        return (
            (i.bindTap = function (e) {
                e && (this.unbindTap(), (this.tapElement = e), this._bindStartEvent(e, !0));
            }),
            (i.unbindTap = function () {
                this.tapElement && (this._bindStartEvent(this.tapElement, !0), delete this.tapElement);
            }),
            (i.pointerUp = function (n, i) {
                if (!this.isIgnoringMouseUp || "mouseup" != n.type) {
                    var r = t.getPointerPoint(i),
                        o = this.tapElement.getBoundingClientRect(),
                        s = e.pageXOffset,
                        a = e.pageYOffset,
                        l = r.x >= o.left + s && r.x <= o.right + s && r.y >= o.top + a && r.y <= o.bottom + a;
                    if ((l && this.emitEvent("tap", [n, i]), "mouseup" != n.type)) {
                        this.isIgnoringMouseUp = !0;
                        var u = this;
                        setTimeout(function () {
                            delete u.isIgnoringMouseUp;
                        }, 400);
                    }
                }
            }),
            (i.destroy = function () {
                this.pointerDone(), this.unbindTap();
            }),
            n
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("flickity/js/prev-next-button", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function (n, i, r) {
                  return t(e, n, i, r);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")))
            : t(e, e.Flickity, e.TapListener, e.fizzyUIUtils);
    })(window, function (e, t, n, i) {
        "use strict";
        function r(e, t) {
            (this.direction = e), (this.parent = t), this._create();
        }
        function o(e) {
            return "string" == typeof e ? e : "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z";
        }
        var s = "http://www.w3.org/2000/svg";
        (r.prototype = Object.create(n.prototype)),
            (r.prototype._create = function () {
                (this.isEnabled = !0), (this.isPrevious = this.direction == -1);
                var e = this.parent.options.rightToLeft ? 1 : -1;
                this.isLeft = this.direction == e;
                var t = (this.element = document.createElement("button"));
                (t.className = "flickity-button flickity-prev-next-button"),
                    (t.className += this.isPrevious ? " previous" : " next"),
                    t.setAttribute("type", "button"),
                    this.disable(),
                    t.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
                var n = this.createSVG();
                t.appendChild(n), this.on("tap", this.onTap), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
            }),
            (r.prototype.activate = function () {
                this.bindTap(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element);
            }),
            (r.prototype.deactivate = function () {
                this.parent.element.removeChild(this.element), n.prototype.destroy.call(this), this.element.removeEventListener("click", this);
            }),
            (r.prototype.createSVG = function () {
                var e = document.createElementNS(s, "svg");
                e.setAttribute("class", "flickity-button-icon"), e.setAttribute("viewBox", "0 0 100 100");
                var t = document.createElementNS(s, "path"),
                    n = o(this.parent.options.arrowShape);
                return t.setAttribute("d", n), t.setAttribute("class", "arrow"), this.isLeft || t.setAttribute("transform", "translate(100, 100) rotate(180) "), e.appendChild(t), e;
            }),
            (r.prototype.onTap = function () {
                if (this.isEnabled) {
                    this.parent.uiChange();
                    var e = this.isPrevious ? "previous" : "next";
                    this.parent[e]();
                }
            }),
            (r.prototype.handleEvent = i.handleEvent),
            (r.prototype.onclick = function (e) {
                var t = document.activeElement;
                t && t == this.element && this.onTap(e, e);
            }),
            (r.prototype.enable = function () {
                this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
            }),
            (r.prototype.disable = function () {
                this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
            }),
            (r.prototype.update = function () {
                var e = this.parent.slides;
                if (this.parent.options.wrapAround && e.length > 1) return void this.enable();
                var t = e.length ? e.length - 1 : 0,
                    n = this.isPrevious ? 0 : t,
                    i = this.parent.selectedIndex == n ? "disable" : "enable";
                this[i]();
            }),
            (r.prototype.destroy = function () {
                this.deactivate();
            }),
            i.extend(t.defaults, { prevNextButtons: !0, arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 } }),
            t.createMethods.push("_createPrevNextButtons");
        var a = t.prototype;
        return (
            (a._createPrevNextButtons = function () {
                this.options.prevNextButtons && ((this.prevButton = new r(-1, this)), (this.nextButton = new r(1, this)), this.on("activate", this.activatePrevNextButtons));
            }),
            (a.activatePrevNextButtons = function () {
                this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons);
            }),
            (a.deactivatePrevNextButtons = function () {
                this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons);
            }),
            (t.PrevNextButton = r),
            t
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("flickity/js/page-dots", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function (n, i, r) {
                  return t(e, n, i, r);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")))
            : t(e, e.Flickity, e.TapListener, e.fizzyUIUtils);
    })(window, function (e, t, n, i) {
        function r(e) {
            (this.parent = e), this._create();
        }
        (r.prototype = new n()),
            (r.prototype._create = function () {
                (this.holder = document.createElement("ol")), (this.holder.className = "flickity-page-dots"), (this.dots = []), this.on("tap", this.onTap), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
            }),
            (r.prototype.activate = function () {
                this.setDots(), this.bindTap(this.holder), this.parent.element.appendChild(this.holder);
            }),
            (r.prototype.deactivate = function () {
                this.parent.element.removeChild(this.holder), n.prototype.destroy.call(this);
            }),
            (r.prototype.setDots = function () {
                var e = this.parent.slides.length - this.dots.length;
                e > 0 ? this.addDots(e) : e < 0 && this.removeDots(-e);
            }),
            (r.prototype.addDots = function (e) {
                for (var t = document.createDocumentFragment(), n = [], i = this.dots.length, r = i + e, o = i; o < r; o++) {
                    var s = document.createElement("li");
                    (s.className = "dot"), s.setAttribute("aria-label", "Page dot " + (o + 1)), t.appendChild(s), n.push(s);
                }
                this.holder.appendChild(t), (this.dots = this.dots.concat(n));
            }),
            (r.prototype.removeDots = function (e) {
                var t = this.dots.splice(this.dots.length - e, e);
                t.forEach(function (e) {
                    this.holder.removeChild(e);
                }, this);
            }),
            (r.prototype.updateSelected = function () {
                this.selectedDot && ((this.selectedDot.className = "dot"), this.selectedDot.removeAttribute("aria-current")),
                    this.dots.length && ((this.selectedDot = this.dots[this.parent.selectedIndex]), (this.selectedDot.className = "dot is-selected"), this.selectedDot.setAttribute("aria-current", "step"));
            }),
            (r.prototype.onTap = function (e) {
                var t = e.target;
                if ("LI" == t.nodeName) {
                    this.parent.uiChange();
                    var n = this.dots.indexOf(t);
                    this.parent.select(n);
                }
            }),
            (r.prototype.destroy = function () {
                this.deactivate();
            }),
            (t.PageDots = r),
            i.extend(t.defaults, { pageDots: !0 }),
            t.createMethods.push("_createPageDots");
        var o = t.prototype;
        return (
            (o._createPageDots = function () {
                this.options.pageDots &&
                    ((this.pageDots = new r(this)),
                    this.on("activate", this.activatePageDots),
                    this.on("select", this.updateSelectedPageDots),
                    this.on("cellChange", this.updatePageDots),
                    this.on("resize", this.updatePageDots),
                    this.on("deactivate", this.deactivatePageDots));
            }),
            (o.activatePageDots = function () {
                this.pageDots.activate();
            }),
            (o.updateSelectedPageDots = function () {
                this.pageDots.updateSelected();
            }),
            (o.updatePageDots = function () {
                this.pageDots.setDots();
            }),
            (o.deactivatePageDots = function () {
                this.pageDots.deactivate();
            }),
            (t.PageDots = r),
            t
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function (e, n, i) {
                  return t(e, n, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")))
            : t(e.EvEmitter, e.fizzyUIUtils, e.Flickity);
    })(window, function (e, t, n) {
        function i(e) {
            (this.parent = e), (this.state = "stopped"), (this.onVisibilityChange = this.visibilityChange.bind(this)), (this.onVisibilityPlay = this.visibilityPlay.bind(this));
        }
        (i.prototype = Object.create(e.prototype)),
            (i.prototype.play = function () {
                if ("playing" != this.state) {
                    var e = document.hidden;
                    if (e) return void document.addEventListener("visibilitychange", this.onVisibilityPlay);
                    (this.state = "playing"), document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick();
                }
            }),
            (i.prototype.tick = function () {
                if ("playing" == this.state) {
                    var e = this.parent.options.autoPlay;
                    e = "number" == typeof e ? e : 3e3;
                    var t = this;
                    this.clear(),
                        (this.timeout = setTimeout(function () {
                            t.parent.next(!0), t.tick();
                        }, e));
                }
            }),
            (i.prototype.stop = function () {
                (this.state = "stopped"), this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange);
            }),
            (i.prototype.clear = function () {
                clearTimeout(this.timeout);
            }),
            (i.prototype.pause = function () {
                "playing" == this.state && ((this.state = "paused"), this.clear());
            }),
            (i.prototype.unpause = function () {
                "paused" == this.state && this.play();
            }),
            (i.prototype.visibilityChange = function () {
                var e = document.hidden;
                this[e ? "pause" : "unpause"]();
            }),
            (i.prototype.visibilityPlay = function () {
                this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay);
            }),
            t.extend(n.defaults, { pauseAutoPlayOnHover: !0 }),
            n.createMethods.push("_createPlayer");
        var r = n.prototype;
        return (
            (r._createPlayer = function () {
                (this.player = new i(this)), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer);
            }),
            (r.activatePlayer = function () {
                this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this));
            }),
            (r.playPlayer = function () {
                this.player.play();
            }),
            (r.stopPlayer = function () {
                this.player.stop();
            }),
            (r.pausePlayer = function () {
                this.player.pause();
            }),
            (r.unpausePlayer = function () {
                this.player.unpause();
            }),
            (r.deactivatePlayer = function () {
                this.player.stop(), this.element.removeEventListener("mouseenter", this);
            }),
            (r.onmouseenter = function () {
                this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this));
            }),
            (r.onmouseleave = function () {
                this.player.unpause(), this.element.removeEventListener("mouseleave", this);
            }),
            (n.Player = i),
            n
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function (n, i) {
                  return t(e, n, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("./flickity"), require("fizzy-ui-utils")))
            : t(e, e.Flickity, e.fizzyUIUtils);
    })(window, function (e, t, n) {
        function i(e) {
            var t = document.createDocumentFragment();
            return (
                e.forEach(function (e) {
                    t.appendChild(e.element);
                }),
                t
            );
        }
        var r = t.prototype;
        return (
            (r.insert = function (e, t) {
                var n = this._makeCells(e);
                if (n && n.length) {
                    var r = this.cells.length;
                    t = void 0 === t ? r : t;
                    var o = i(n),
                        s = t == r;
                    if (s) this.slider.appendChild(o);
                    else {
                        var a = this.cells[t].element;
                        this.slider.insertBefore(o, a);
                    }
                    if (0 === t) this.cells = n.concat(this.cells);
                    else if (s) this.cells = this.cells.concat(n);
                    else {
                        var l = this.cells.splice(t, r - t);
                        this.cells = this.cells.concat(n).concat(l);
                    }
                    this._sizeCells(n), this.cellChange(t, !0);
                }
            }),
            (r.append = function (e) {
                this.insert(e, this.cells.length);
            }),
            (r.prepend = function (e) {
                this.insert(e, 0);
            }),
            (r.remove = function (e) {
                var t = this.getCells(e);
                if (t && t.length) {
                    var i = this.cells.length - 1;
                    t.forEach(function (e) {
                        e.remove();
                        var t = this.cells.indexOf(e);
                        (i = Math.min(t, i)), n.removeFrom(this.cells, e);
                    }, this),
                        this.cellChange(i, !0);
                }
            }),
            (r.cellSizeChange = function (e) {
                var t = this.getCell(e);
                if (t) {
                    t.getSize();
                    var n = this.cells.indexOf(t);
                    this.cellChange(n);
                }
            }),
            (r.cellChange = function (e, t) {
                var n = this.selectedElement;
                this._positionCells(e), this._getWrapShiftCells(), this.setGallerySize();
                var i = this.getCell(n);
                i && (this.selectedIndex = this.getCellSlideIndex(i)),
                    (this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex)),
                    this.emitEvent("cellChange", [e]),
                    this.select(this.selectedIndex),
                    t && this.positionSliderAtSelected();
            }),
            t
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function (n, i) {
                  return t(e, n, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("./flickity"), require("fizzy-ui-utils")))
            : t(e, e.Flickity, e.fizzyUIUtils);
    })(window, function (e, t, n) {
        "use strict";
        function i(e) {
            if ("IMG" == e.nodeName) {
                var t = e.getAttribute("data-flickity-lazyload"),
                    i = e.getAttribute("data-flickity-lazyload-src"),
                    r = e.getAttribute("data-flickity-lazyload-srcset");
                if (t || i || r) return [e];
            }
            var o = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
                s = e.querySelectorAll(o);
            return n.makeArray(s);
        }
        function r(e, t) {
            (this.img = e), (this.flickity = t), this.load();
        }
        t.createMethods.push("_createLazyload");
        var o = t.prototype;
        return (
            (o._createLazyload = function () {
                this.on("select", this.lazyLoad);
            }),
            (o.lazyLoad = function () {
                var e = this.options.lazyLoad;
                if (e) {
                    var t = "number" == typeof e ? e : 0,
                        n = this.getAdjacentCellElements(t),
                        o = [];
                    n.forEach(function (e) {
                        var t = i(e);
                        o = o.concat(t);
                    }),
                        o.forEach(function (e) {
                            new r(e, this);
                        }, this);
                }
            }),
            (r.prototype.handleEvent = n.handleEvent),
            (r.prototype.load = function () {
                this.img.addEventListener("load", this), this.img.addEventListener("error", this);
                var e = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
                    t = this.img.getAttribute("data-flickity-lazyload-srcset");
                (this.img.src = e),
                    t && this.img.setAttribute("srcset", t),
                    this.img.removeAttribute("data-flickity-lazyload"),
                    this.img.removeAttribute("data-flickity-lazyload-src"),
                    this.img.removeAttribute("data-flickity-lazyload-srcset");
            }),
            (r.prototype.onload = function (e) {
                this.complete(e, "flickity-lazyloaded");
            }),
            (r.prototype.onerror = function (e) {
                this.complete(e, "flickity-lazyerror");
            }),
            (r.prototype.complete = function (e, t) {
                this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                var n = this.flickity.getParentCell(this.img),
                    i = n && n.element;
                this.flickity.cellSizeChange(i), this.img.classList.add(t), this.flickity.dispatchEvent("lazyLoad", e, i);
            }),
            (t.LazyLoader = r),
            t
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], t)
            : "object" == typeof module &&
              module.exports &&
              (module.exports = t(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")));
    })(window, function (e) {
        return e;
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], t)
            : "object" == typeof module && module.exports
            ? (module.exports = t(require("flickity"), require("fizzy-ui-utils")))
            : (e.Flickity = t(e.Flickity, e.fizzyUIUtils));
    })(window, function (e, t) {
        function n(e, t, n) {
            return (t - e) * n + e;
        }
        e.createMethods.push("_createAsNavFor");
        var i = e.prototype;
        return (
            (i._createAsNavFor = function () {
                this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
                var e = this.options.asNavFor;
                if (e) {
                    var t = this;
                    setTimeout(function () {
                        t.setNavCompanion(e);
                    });
                }
            }),
            (i.setNavCompanion = function (n) {
                n = t.getQueryElement(n);
                var i = e.data(n);
                if (i && i != this) {
                    this.navCompanion = i;
                    var r = this;
                    (this.onNavCompanionSelect = function () {
                        r.navCompanionSelect();
                    }),
                        i.on("select", this.onNavCompanionSelect),
                        this.on("staticClick", this.onNavStaticClick),
                        this.navCompanionSelect(!0);
                }
            }),
            (i.navCompanionSelect = function (e) {
                if (this.navCompanion) {
                    var t = this.navCompanion.selectedCells[0],
                        i = this.navCompanion.cells.indexOf(t),
                        r = i + this.navCompanion.selectedCells.length - 1,
                        o = Math.floor(n(i, r, this.navCompanion.cellAlign));
                    if ((this.selectCell(o, !1, e), this.removeNavSelectedElements(), !(o >= this.cells.length))) {
                        var s = this.cells.slice(i, r + 1);
                        (this.navSelectedElements = s.map(function (e) {
                            return e.element;
                        })),
                            this.changeNavSelectedClass("add");
                    }
                }
            }),
            (i.changeNavSelectedClass = function (e) {
                this.navSelectedElements.forEach(function (t) {
                    t.classList[e]("is-nav-selected");
                });
            }),
            (i.activateAsNavFor = function () {
                this.navCompanionSelect(!0);
            }),
            (i.removeNavSelectedElements = function () {
                this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements);
            }),
            (i.onNavStaticClick = function (e, t, n, i) {
                "number" == typeof i && this.navCompanion.selectCell(i);
            }),
            (i.deactivateAsNavFor = function () {
                this.removeNavSelectedElements();
            }),
            (i.destroyAsNavFor = function () {
                this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion);
            }),
            e
        );
    }),
    (function (e, t) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function (n) {
                  return t(e, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("ev-emitter")))
            : (e.imagesLoaded = t(e, e.EvEmitter));
    })("undefined" != typeof window ? window : this, function (e, t) {
        function n(e, t) {
            for (var n in t) e[n] = t[n];
            return e;
        }
        function i(e) {
            if (Array.isArray(e)) return e;
            var t = "object" == typeof e && "number" == typeof e.length;
            return t ? u.call(e) : [e];
        }
        function r(e, t, o) {
            if (!(this instanceof r)) return new r(e, t, o);
            var s = e;
            return (
                "string" == typeof e && (s = document.querySelectorAll(e)),
                s
                    ? ((this.elements = i(s)),
                      (this.options = n({}, this.options)),
                      "function" == typeof t ? (o = t) : n(this.options, t),
                      o && this.on("always", o),
                      this.getImages(),
                      a && (this.jqDeferred = new a.Deferred()),
                      void setTimeout(this.check.bind(this)))
                    : void l.error("Bad element for imagesLoaded " + (s || e))
            );
        }
        function o(e) {
            this.img = e;
        }
        function s(e, t) {
            (this.url = e), (this.element = t), (this.img = new Image());
        }
        var a = e.jQuery,
            l = e.console,
            u = Array.prototype.slice;
        (r.prototype = Object.create(t.prototype)),
            (r.prototype.options = {}),
            (r.prototype.getImages = function () {
                (this.images = []), this.elements.forEach(this.addElementImages, this);
            }),
            (r.prototype.addElementImages = function (e) {
                "IMG" == e.nodeName && this.addImage(e), this.options.background === !0 && this.addElementBackgroundImages(e);
                var t = e.nodeType;
                if (t && c[t]) {
                    for (var n = e.querySelectorAll("img"), i = 0; i < n.length; i++) {
                        var r = n[i];
                        this.addImage(r);
                    }
                    if ("string" == typeof this.options.background) {
                        var o = e.querySelectorAll(this.options.background);
                        for (i = 0; i < o.length; i++) {
                            var s = o[i];
                            this.addElementBackgroundImages(s);
                        }
                    }
                }
            });
        var c = { 1: !0, 9: !0, 11: !0 };
        return (
            (r.prototype.addElementBackgroundImages = function (e) {
                var t = getComputedStyle(e);
                if (t)
                    for (var n = /url\((['"])?(.*?)\1\)/gi, i = n.exec(t.backgroundImage); null !== i; ) {
                        var r = i && i[2];
                        r && this.addBackground(r, e), (i = n.exec(t.backgroundImage));
                    }
            }),
            (r.prototype.addImage = function (e) {
                var t = new o(e);
                this.images.push(t);
            }),
            (r.prototype.addBackground = function (e, t) {
                var n = new s(e, t);
                this.images.push(n);
            }),
            (r.prototype.check = function () {
                function e(e, n, i) {
                    setTimeout(function () {
                        t.progress(e, n, i);
                    });
                }
                var t = this;
                return (
                    (this.progressedCount = 0),
                    (this.hasAnyBroken = !1),
                    this.images.length
                        ? void this.images.forEach(function (t) {
                              t.once("progress", e), t.check();
                          })
                        : void this.complete()
                );
            }),
            (r.prototype.progress = function (e, t, n) {
                this.progressedCount++,
                    (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
                    this.emitEvent("progress", [this, e, t]),
                    this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e),
                    this.progressedCount == this.images.length && this.complete(),
                    this.options.debug && l && l.log("progress: " + n, e, t);
            }),
            (r.prototype.complete = function () {
                var e = this.hasAnyBroken ? "fail" : "done";
                if (((this.isComplete = !0), this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred)) {
                    var t = this.hasAnyBroken ? "reject" : "resolve";
                    this.jqDeferred[t](this);
                }
            }),
            (o.prototype = Object.create(t.prototype)),
            (o.prototype.check = function () {
                var e = this.getIsImageComplete();
                return e
                    ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                    : ((this.proxyImage = new Image()),
                      this.proxyImage.addEventListener("load", this),
                      this.proxyImage.addEventListener("error", this),
                      this.img.addEventListener("load", this),
                      this.img.addEventListener("error", this),
                      void (this.proxyImage.src = this.img.src));
            }),
            (o.prototype.getIsImageComplete = function () {
                return this.img.complete && this.img.naturalWidth;
            }),
            (o.prototype.confirm = function (e, t) {
                (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
            }),
            (o.prototype.handleEvent = function (e) {
                var t = "on" + e.type;
                this[t] && this[t](e);
            }),
            (o.prototype.onload = function () {
                this.confirm(!0, "onload"), this.unbindEvents();
            }),
            (o.prototype.onerror = function () {
                this.confirm(!1, "onerror"), this.unbindEvents();
            }),
            (o.prototype.unbindEvents = function () {
                this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            (s.prototype = Object.create(o.prototype)),
            (s.prototype.check = function () {
                this.img.addEventListener("load", this), this.img.addEventListener("error", this), (this.img.src = this.url);
                var e = this.getIsImageComplete();
                e && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
            }),
            (s.prototype.unbindEvents = function () {
                this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            (s.prototype.confirm = function (e, t) {
                (this.isLoaded = e), this.emitEvent("progress", [this, this.element, t]);
            }),
            (r.makeJQueryPlugin = function (t) {
                (t = t || e.jQuery),
                    t &&
                        ((a = t),
                        (a.fn.imagesLoaded = function (e, t) {
                            var n = new r(this, e, t);
                            return n.jqDeferred.promise(a(this));
                        }));
            }),
            r.makeJQueryPlugin(),
            r
        );
    }),
    (function (e, t) {
        "function" == typeof define && define.amd
            ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function (n, i) {
                  return t(e, n, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("flickity"), require("imagesloaded")))
            : (e.Flickity = t(e, e.Flickity, e.imagesLoaded));
    })(window, function (e, t, n) {
        "use strict";
        t.createMethods.push("_createImagesLoaded");
        var i = t.prototype;
        return (
            (i._createImagesLoaded = function () {
                this.on("activate", this.imagesLoaded);
            }),
            (i.imagesLoaded = function () {
                function e(e, n) {
                    var i = t.getParentCell(n.img);
                    t.cellSizeChange(i && i.element), t.options.freeScroll || t.positionSliderAtSelected();
                }
                if (this.options.imagesLoaded) {
                    var t = this;
                    n(this.slider).on("progress", e);
                }
            }),
            t
        );
    }) /* @license
Papa Parse
v4.6.1
https://github.com/mholt/PapaParse
License: MIT
*/,
    Array.isArray ||
        (Array.isArray = function (e) {
            return "[object Array]" === Object.prototype.toString.call(e);
        }),
    (function (e, t) {
        "function" == typeof define && define.amd ? define([], t) : "object" == typeof module && "undefined" != typeof exports ? (module.exports = t()) : (e.Papa = t());
    })(this, function () {
        "use strict";
        function e(e) {
            (this._handle = null),
                (this._finished = !1),
                (this._completed = !1),
                (this._input = null),
                (this._baseIndex = 0),
                (this._partialLine = ""),
                (this._rowCount = 0),
                (this._start = 0),
                (this._nextChunk = null),
                (this.isFirstChunk = !0),
                (this._completeResults = { data: [], errors: [], meta: {} }),
                function (e) {
                    var t = d(e);
                    (t.chunkSize = parseInt(t.chunkSize)), e.step || e.chunk || (t.chunkSize = null), (this._handle = new s(t)), ((this._handle.streamer = this)._config = t);
                }.call(this, e),
                (this.parseChunk = function (e, t) {
                    if (this.isFirstChunk && h(this._config.beforeFirstChunk)) {
                        var n = this._config.beforeFirstChunk(e);
                        void 0 !== n && (e = n);
                    }
                    this.isFirstChunk = !1;
                    var i = this._partialLine + e;
                    this._partialLine = "";
                    var r = this._handle.parse(i, this._baseIndex, !this._finished);
                    if (!this._handle.paused() && !this._handle.aborted()) {
                        var o = r.meta.cursor;
                        this._finished || ((this._partialLine = i.substring(o - this._baseIndex)), (this._baseIndex = o)), r && r.data && (this._rowCount += r.data.length);
                        var s = this._finished || (this._config.preview && this._rowCount >= this._config.preview);
                        if (b) y.postMessage({ results: r, workerId: k.WORKER_ID, finished: s });
                        else if (h(this._config.chunk) && !t) {
                            if ((this._config.chunk(r, this._handle), this._handle.paused() || this._handle.aborted())) return;
                            (r = void 0), (this._completeResults = void 0);
                        }
                        return (
                            this._config.step ||
                                this._config.chunk ||
                                ((this._completeResults.data = this._completeResults.data.concat(r.data)), (this._completeResults.errors = this._completeResults.errors.concat(r.errors)), (this._completeResults.meta = r.meta)),
                            this._completed || !s || !h(this._config.complete) || (r && r.meta.aborted) || (this._config.complete(this._completeResults, this._input), (this._completed = !0)),
                            s || (r && r.meta.paused) || this._nextChunk(),
                            r
                        );
                    }
                }),
                (this._sendError = function (e) {
                    h(this._config.error) ? this._config.error(e) : b && this._config.error && y.postMessage({ workerId: k.WORKER_ID, error: e, finished: !1 });
                });
        }
        function t(t) {
            var n;
            (t = t || {}).chunkSize || (t.chunkSize = k.RemoteChunkSize),
                e.call(this, t),
                (this._nextChunk = m
                    ? function () {
                          this._readChunk(), this._chunkLoaded();
                      }
                    : function () {
                          this._readChunk();
                      }),
                (this.stream = function (e) {
                    (this._input = e), this._nextChunk();
                }),
                (this._readChunk = function () {
                    if (this._finished) this._chunkLoaded();
                    else {
                        if (
                            ((n = new XMLHttpRequest()),
                            this._config.withCredentials && (n.withCredentials = this._config.withCredentials),
                            m || ((n.onload = p(this._chunkLoaded, this)), (n.onerror = p(this._chunkError, this))),
                            n.open("GET", this._input, !m),
                            this._config.downloadRequestHeaders)
                        ) {
                            var e = this._config.downloadRequestHeaders;
                            for (var t in e) n.setRequestHeader(t, e[t]);
                        }
                        if (this._config.chunkSize) {
                            var i = this._start + this._config.chunkSize - 1;
                            n.setRequestHeader("Range", "bytes=" + this._start + "-" + i), n.setRequestHeader("If-None-Match", "webkit-no-cache");
                        }
                        try {
                            n.send();
                        } catch (e) {
                            this._chunkError(e.message);
                        }
                        m && 0 === n.status ? this._chunkError() : (this._start += this._config.chunkSize);
                    }
                }),
                (this._chunkLoaded = function () {
                    4 === n.readyState &&
                        (n.status < 200 || 400 <= n.status
                            ? this._chunkError()
                            : ((this._finished =
                                  !this._config.chunkSize ||
                                  this._start >
                                      (function (e) {
                                          var t = e.getResponseHeader("Content-Range");
                                          return null === t ? -1 : parseInt(t.substr(t.lastIndexOf("/") + 1));
                                      })(n)),
                              this.parseChunk(n.responseText)));
                }),
                (this._chunkError = function (e) {
                    var t = n.statusText || e;
                    this._sendError(new Error(t));
                });
        }
        function n(t) {
            var n, i;
            (t = t || {}).chunkSize || (t.chunkSize = k.LocalChunkSize), e.call(this, t);
            var r = "undefined" != typeof FileReader;
            (this.stream = function (e) {
                (this._input = e), (i = e.slice || e.webkitSlice || e.mozSlice), r ? (((n = new FileReader()).onload = p(this._chunkLoaded, this)), (n.onerror = p(this._chunkError, this))) : (n = new FileReaderSync()), this._nextChunk();
            }),
                (this._nextChunk = function () {
                    this._finished || (this._config.preview && !(this._rowCount < this._config.preview)) || this._readChunk();
                }),
                (this._readChunk = function () {
                    var e = this._input;
                    if (this._config.chunkSize) {
                        var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                        e = i.call(e, this._start, t);
                    }
                    var o = n.readAsText(e, this._config.encoding);
                    r || this._chunkLoaded({ target: { result: o } });
                }),
                (this._chunkLoaded = function (e) {
                    (this._start += this._config.chunkSize), (this._finished = !this._config.chunkSize || this._start >= this._input.size), this.parseChunk(e.target.result);
                }),
                (this._chunkError = function () {
                    this._sendError(n.error);
                });
        }
        function i(t) {
            var n;
            e.call(this, (t = t || {})),
                (this.stream = function (e) {
                    return (n = e), this._nextChunk();
                }),
                (this._nextChunk = function () {
                    if (!this._finished) {
                        var e = this._config.chunkSize,
                            t = e ? n.substr(0, e) : n;
                        return (n = e ? n.substr(e) : ""), (this._finished = !n), this.parseChunk(t);
                    }
                });
        }
        function r(t) {
            e.call(this, (t = t || {}));
            var n = [],
                i = !0,
                r = !1;
            (this.pause = function () {
                e.prototype.pause.apply(this, arguments), this._input.pause();
            }),
                (this.resume = function () {
                    e.prototype.resume.apply(this, arguments), this._input.resume();
                }),
                (this.stream = function (e) {
                    (this._input = e), this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
                }),
                (this._checkIsFinished = function () {
                    r && 1 === n.length && (this._finished = !0);
                }),
                (this._nextChunk = function () {
                    this._checkIsFinished(), n.length ? this.parseChunk(n.shift()) : (i = !0);
                }),
                (this._streamData = p(function (e) {
                    try {
                        n.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && ((i = !1), this._checkIsFinished(), this.parseChunk(n.shift()));
                    } catch (e) {
                        this._streamError(e);
                    }
                }, this)),
                (this._streamError = p(function (e) {
                    this._streamCleanUp(), this._sendError(e);
                }, this)),
                (this._streamEnd = p(function () {
                    this._streamCleanUp(), (r = !0), this._streamData("");
                }, this)),
                (this._streamCleanUp = p(function () {
                    this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
                }, this));
        }
        function o(t) {
            var n = require("stream").Duplex,
                i = d(t),
                r = !0,
                o = !1,
                s = [],
                a = null;
            (this._onCsvData = function (e) {
                for (var t = e.data, n = 0; n < t.length; n++) a.push(t[n]) || this._handle.paused() || this._handle.pause();
            }),
                (this._onCsvComplete = function () {
                    a.push(null);
                }),
                (i.step = p(this._onCsvData, this)),
                (i.complete = p(this._onCsvComplete, this)),
                e.call(this, i),
                (this._nextChunk = function () {
                    o && 1 === s.length && (this._finished = !0), s.length ? s.shift()() : (r = !0);
                }),
                (this._addToParseQueue = function (e, t) {
                    s.push(
                        p(function () {
                            if ((this.parseChunk("string" == typeof e ? e : e.toString(i.encoding)), h(t))) return t();
                        }, this)
                    ),
                        r && ((r = !1), this._nextChunk());
                }),
                (this._onRead = function () {
                    this._handle.paused() && this._handle.resume();
                }),
                (this._onWrite = function (e, t, n) {
                    this._addToParseQueue(e, n);
                }),
                (this._onWriteComplete = function () {
                    (o = !0), this._addToParseQueue("");
                }),
                (this.getStream = function () {
                    return a;
                }),
                (a = new n({ readableObjectMode: !0, decodeStrings: !1, read: p(this._onRead, this), write: p(this._onWrite, this) })).once("finish", p(this._onWriteComplete, this));
        }
        function s(e) {
            function t(t) {
                return "greedy" === e.skipEmptyLines ? "" === t.join("").trim() : 1 === t.length && 0 === t[0].length;
            }
            function n() {
                if ((x && c && (o("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + k.DefaultDelimiter + "'"), (c = !1)), e.skipEmptyLines))
                    for (var n = 0; n < x.data.length; n++) t(x.data[n]) && x.data.splice(n--, 1);
                return (
                    i() &&
                        (function () {
                            if (x) {
                                for (var t = 0; i() && t < x.data.length; t++)
                                    for (var n = 0; n < x.data[t].length; n++) {
                                        var r = x.data[t][n];
                                        e.trimHeaders && (r = r.trim()), w.push(r);
                                    }
                                x.data.splice(0, 1);
                            }
                        })(),
                    (function () {
                        if (!x || (!e.header && !e.dynamicTyping && !e.transform)) return x;
                        for (var t = 0; t < x.data.length; t++) {
                            var n,
                                i = e.header ? {} : [];
                            for (n = 0; n < x.data[t].length; n++) {
                                var s = n,
                                    a = x.data[t][n];
                                e.header && (s = n >= w.length ? "__parsed_extra" : w[n]), e.transform && (a = e.transform(a, s)), (a = r(s, a)), "__parsed_extra" === s ? ((i[s] = i[s] || []), i[s].push(a)) : (i[s] = a);
                            }
                            (x.data[t] = i),
                                e.header &&
                                    (n > w.length
                                        ? o("FieldMismatch", "TooManyFields", "Too many fields: expected " + w.length + " fields but parsed " + n, y + t)
                                        : n < w.length && o("FieldMismatch", "TooFewFields", "Too few fields: expected " + w.length + " fields but parsed " + n, y + t));
                        }
                        return e.header && x.meta && (x.meta.fields = w), (y += x.data.length), x;
                    })()
                );
            }
            function i() {
                return e.header && 0 === w.length;
            }
            function r(t, n) {
                return (
                    (i = t),
                    e.dynamicTypingFunction && void 0 === e.dynamicTyping[i] && (e.dynamicTyping[i] = e.dynamicTypingFunction(i)),
                    !0 === (e.dynamicTyping[i] || e.dynamicTyping) ? "true" === n || "TRUE" === n || ("false" !== n && "FALSE" !== n && (f.test(n) ? parseFloat(n) : p.test(n) ? new Date(n) : "" === n ? null : n)) : n
                );
                var i;
            }
            function o(e, t, n, i) {
                x.errors.push({ type: e, code: t, message: n, row: i });
            }
            var s,
                u,
                c,
                f = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i,
                p = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,
                g = this,
                v = 0,
                y = 0,
                m = !1,
                b = !1,
                w = [],
                x = { data: [], errors: [], meta: {} };
            if (h(e.step)) {
                var _ = e.step;
                e.step = function (t) {
                    if (((x = t), i())) n();
                    else {
                        if ((n(), 0 === x.data.length)) return;
                        (v += t.data.length), e.preview && v > e.preview ? u.abort() : _(x, g);
                    }
                };
            }
            (this.parse = function (i, r, o) {
                var f = e.quoteChar || '"';
                if (
                    (e.newline ||
                        (e.newline = (function (e, t) {
                            e = e.substr(0, 1048576);
                            var n = new RegExp(a(t) + "([^]*?)" + a(t), "gm"),
                                i = (e = e.replace(n, "")).split("\r"),
                                r = e.split("\n"),
                                o = 1 < r.length && r[0].length < i[0].length;
                            if (1 === i.length || o) return "\n";
                            for (var s = 0, l = 0; l < i.length; l++) "\n" === i[l][0] && s++;
                            return s >= i.length / 2 ? "\r\n" : "\r";
                        })(i, f)),
                    (c = !1),
                    e.delimiter)
                )
                    h(e.delimiter) && ((e.delimiter = e.delimiter(i)), (x.meta.delimiter = e.delimiter));
                else {
                    var p = (function (n, i, r, o) {
                        for (var s, a, u, c = [",", "\t", "|", ";", k.RECORD_SEP, k.UNIT_SEP], f = 0; f < c.length; f++) {
                            var d = c[f],
                                p = 0,
                                h = 0,
                                g = 0;
                            u = void 0;
                            for (var v = new l({ comments: o, delimiter: d, newline: i, preview: 10 }).parse(n), y = 0; y < v.data.length; y++)
                                if (r && t(v.data[y])) g++;
                                else {
                                    var m = v.data[y].length;
                                    (h += m), void 0 !== u ? 1 < m && ((p += Math.abs(m - u)), (u = m)) : (u = m);
                                }
                            0 < v.data.length && (h /= v.data.length - g), (void 0 === a || p < a) && 1.99 < h && ((a = p), (s = d));
                        }
                        return { successful: !!(e.delimiter = s), bestDelimiter: s };
                    })(i, e.newline, e.skipEmptyLines, e.comments);
                    p.successful ? (e.delimiter = p.bestDelimiter) : ((c = !0), (e.delimiter = k.DefaultDelimiter)), (x.meta.delimiter = e.delimiter);
                }
                var g = d(e);
                return e.preview && e.header && g.preview++, (s = i), (u = new l(g)), (x = u.parse(s, r, o)), n(), m ? { meta: { paused: !0 } } : x || { meta: { paused: !1 } };
            }),
                (this.paused = function () {
                    return m;
                }),
                (this.pause = function () {
                    (m = !0), u.abort(), (s = s.substr(u.getCharIndex()));
                }),
                (this.resume = function () {
                    (m = !1), g.streamer.parseChunk(s, !0);
                }),
                (this.aborted = function () {
                    return b;
                }),
                (this.abort = function () {
                    (b = !0), u.abort(), (x.meta.aborted = !0), h(e.complete) && e.complete(x), (s = "");
                });
        }
        function a(e) {
            return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
        function l(e) {
            var t,
                n = (e = e || {}).delimiter,
                i = e.newline,
                r = e.comments,
                o = e.step,
                s = e.preview,
                a = e.fastMode,
                l = (t = void 0 === e.quoteChar ? '"' : e.quoteChar);
            if ((void 0 !== e.escapeChar && (l = e.escapeChar), ("string" != typeof n || -1 < k.BAD_DELIMITERS.indexOf(n)) && (n = ","), r === n)) throw "Comment character same as delimiter";
            !0 === r ? (r = "#") : ("string" != typeof r || -1 < k.BAD_DELIMITERS.indexOf(r)) && (r = !1), "\n" !== i && "\r" !== i && "\r\n" !== i && (i = "\n");
            var u = 0,
                c = !1;
            (this.parse = function (e, f, d) {
                function p(e) {
                    C.push(e), (A = u);
                }
                function g(t) {
                    var n = 0;
                    if (-1 !== t) {
                        var i = e.substring(L + 1, t);
                        i && "" === i.trim() && (n = i.length);
                    }
                    return n;
                }
                function v(t) {
                    return d || (void 0 === t && (t = e.substr(u)), E.push(t), (u = w), p(E), S && b()), m();
                }
                function y(t) {
                    (u = t), p(E), (E = []), ($ = e.indexOf(i, u));
                }
                function m(e) {
                    return { data: C, errors: T, meta: { delimiter: n, linebreak: i, aborted: c, truncated: !!e, cursor: A + (f || 0) } };
                }
                function b() {
                    o(m()), (C = []), (T = []);
                }
                if ("string" != typeof e) throw "Input must be a string";
                var w = e.length,
                    x = n.length,
                    _ = i.length,
                    k = r.length,
                    S = h(o),
                    C = [],
                    T = [],
                    E = [],
                    A = (u = 0);
                if (!e) return m();
                if (a || (!1 !== a && -1 === e.indexOf(t))) {
                    for (var j = e.split(i), D = 0; D < j.length; D++) {
                        if (((E = j[D]), (u += E.length), D !== j.length - 1)) u += i.length;
                        else if (d) return m();
                        if (!r || E.substr(0, k) !== r) {
                            if (S) {
                                if (((C = []), p(E.split(n)), b(), c)) return m();
                            } else p(E.split(n));
                            if (s && s <= D) return (C = C.slice(0, s)), m(!0);
                        }
                    }
                    return m();
                }
                for (var L, P = e.indexOf(n, u), $ = e.indexOf(i, u), z = new RegExp(l.replace(/[-[\]\/{}()*+?.\\^$|]/g, "\\$&") + t, "g"); ; )
                    if (e[u] !== t)
                        if (r && 0 === E.length && e.substr(u, k) === r) {
                            if (-1 === $) return m();
                            (u = $ + _), ($ = e.indexOf(i, u)), (P = e.indexOf(n, u));
                        } else if (-1 !== P && (P < $ || -1 === $)) E.push(e.substring(u, P)), (u = P + x), (P = e.indexOf(n, u));
                        else {
                            if (-1 === $) break;
                            if ((E.push(e.substring(u, $)), y($ + _), S && (b(), c))) return m();
                            if (s && C.length >= s) return m(!0);
                        }
                    else
                        for (L = u, u++; ; ) {
                            if (-1 === (L = e.indexOf(t, L + 1))) return d || T.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: C.length, index: u }), v();
                            if (L === w - 1) return v(e.substring(u, L).replace(z, t));
                            if (t !== l || e[L + 1] !== l) {
                                if (t === l || 0 === L || e[L - 1] !== l) {
                                    var O = g(-1 === $ ? P : Math.min(P, $));
                                    if (e[L + 1 + O] === n) {
                                        E.push(e.substring(u, L).replace(z, t)), (u = L + 1 + O + x), (P = e.indexOf(n, u)), ($ = e.indexOf(i, u));
                                        break;
                                    }
                                    var I = g($);
                                    if (e.substr(L + 1 + I, _) === i) {
                                        if ((E.push(e.substring(u, L).replace(z, t)), y(L + 1 + I + _), (P = e.indexOf(n, u)), S && (b(), c))) return m();
                                        if (s && C.length >= s) return m(!0);
                                        break;
                                    }
                                    T.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: C.length, index: u }), L++;
                                }
                            } else L++;
                        }
                return v();
            }),
                (this.abort = function () {
                    c = !0;
                }),
                (this.getCharIndex = function () {
                    return u;
                });
        }
        function u(e) {
            var t = e.data,
                n = x[t.workerId],
                i = !1;
            if (t.error) n.userError(t.error, t.file);
            else if (t.results && t.results.data) {
                var r = {
                    abort: function () {
                        (i = !0), c(t.workerId, { data: [], errors: [], meta: { aborted: !0 } });
                    },
                    pause: f,
                    resume: f,
                };
                if (h(n.userStep)) {
                    for (var o = 0; o < t.results.data.length && (n.userStep({ data: [t.results.data[o]], errors: t.results.errors, meta: t.results.meta }, r), !i); o++);
                    delete t.results;
                } else h(n.userChunk) && (n.userChunk(t.results, r, t.file), delete t.results);
            }
            t.finished && !i && c(t.workerId, t.results);
        }
        function c(e, t) {
            var n = x[e];
            h(n.userComplete) && n.userComplete(t), n.terminate(), delete x[e];
        }
        function f() {
            throw "Not implemented.";
        }
        function d(e) {
            if ("object" != typeof e || null === e) return e;
            var t = Array.isArray(e) ? [] : {};
            for (var n in e) t[n] = d(e[n]);
            return t;
        }
        function p(e, t) {
            return function () {
                e.apply(t, arguments);
            };
        }
        function h(e) {
            return "function" == typeof e;
        }
        var g,
            v,
            y = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== y ? y : {},
            m = !y.document && !!y.postMessage,
            b = m && /(\?|&)papaworker(=|&|$)/.test(y.location.search),
            w = !1,
            x = {},
            _ = 0,
            k = {
                parse: function (e, s) {
                    var a = (s = s || {}).dynamicTyping || !1;
                    if ((h(a) && ((s.dynamicTypingFunction = a), (a = {})), (s.dynamicTyping = a), (s.transform = !!h(s.transform) && s.transform), s.worker && k.WORKERS_SUPPORTED)) {
                        var l = (function () {
                            if (!k.WORKERS_SUPPORTED) return !1;
                            if (!w && null === k.SCRIPT_PATH) throw new Error("Script path cannot be determined automatically when Papa Parse is loaded asynchronously. You need to set Papa.SCRIPT_PATH manually.");
                            var e = k.SCRIPT_PATH || g;
                            e += (-1 !== e.indexOf("?") ? "&" : "?") + "papaworker";
                            var t = new y.Worker(e);
                            return (t.onmessage = u), (t.id = _++), (x[t.id] = t);
                        })();
                        return (
                            (l.userStep = s.step),
                            (l.userChunk = s.chunk),
                            (l.userComplete = s.complete),
                            (l.userError = s.error),
                            (s.step = h(s.step)),
                            (s.chunk = h(s.chunk)),
                            (s.complete = h(s.complete)),
                            (s.error = h(s.error)),
                            delete s.worker,
                            void l.postMessage({ input: e, config: s, workerId: l.id })
                        );
                    }
                    var c = null;
                    return e === k.NODE_STREAM_INPUT
                        ? (c = new o(s)).getStream()
                        : ("string" == typeof e ? (c = s.download ? new t(s) : new i(s)) : !0 === e.readable && h(e.read) && h(e.on) ? (c = new r(s)) : ((y.File && e instanceof File) || e instanceof Object) && (c = new n(s)), c.stream(e));
                },
                unparse: function (e, t) {
                    function n(e) {
                        if ("object" != typeof e) return [];
                        var t = [];
                        for (var n in e) t.push(n);
                        return t;
                    }
                    function i(e, t, n) {
                        var i = "";
                        "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                        var o = Array.isArray(e) && 0 < e.length,
                            u = !Array.isArray(t[0]);
                        if (o && s) {
                            for (var c = 0; c < e.length; c++) 0 < c && (i += a), (i += r(e[c], c));
                            0 < t.length && (i += l);
                        }
                        for (var f = 0; f < t.length; f++) {
                            var d = o ? e.length : t[f].length,
                                p = o ? e : t[f];
                            if ("greedy" !== n || "" !== p.join("").trim()) {
                                for (var h = 0; h < d; h++) {
                                    0 < h && (i += a);
                                    var g = o && u ? e[h] : h;
                                    i += r(t[f][g], h);
                                }
                                f < t.length - 1 && (!n || 0 < d) && (i += l);
                            }
                        }
                        return i;
                    }
                    function r(e, t) {
                        if (null == e) return "";
                        if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                        e = e.toString().replace(f, u + u);
                        var n =
                            ("boolean" == typeof o && o) ||
                            (Array.isArray(o) && o[t]) ||
                            (function (e, t) {
                                for (var n = 0; n < t.length; n++) if (-1 < e.indexOf(t[n])) return !0;
                                return !1;
                            })(e, k.BAD_DELIMITERS) ||
                            -1 < e.indexOf(a) ||
                            " " === e.charAt(0) ||
                            " " === e.charAt(e.length - 1);
                        return n ? u + e + u : e;
                    }
                    var o = !1,
                        s = !0,
                        a = ",",
                        l = "\r\n",
                        u = '"',
                        c = !1;
                    !(function () {
                        "object" == typeof t &&
                            ("string" != typeof t.delimiter ||
                                k.BAD_DELIMITERS.filter(function (e) {
                                    return -1 !== t.delimiter.indexOf(e);
                                }).length ||
                                (a = t.delimiter),
                            ("boolean" == typeof t.quotes || Array.isArray(t.quotes)) && (o = t.quotes),
                            ("boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines) || (c = t.skipEmptyLines),
                            "string" == typeof t.newline && (l = t.newline),
                            "string" == typeof t.quoteChar && (u = t.quoteChar),
                            "boolean" == typeof t.header && (s = t.header));
                    })();
                    var f = new RegExp(u, "g");
                    if (("string" == typeof e && (e = JSON.parse(e)), Array.isArray(e))) {
                        if (!e.length || Array.isArray(e[0])) return i(null, e, c);
                        if ("object" == typeof e[0]) return i(n(e[0]), e, c);
                    } else if ("object" == typeof e)
                        return (
                            "string" == typeof e.data && (e.data = JSON.parse(e.data)),
                            Array.isArray(e.data) &&
                                (e.fields || (e.fields = e.meta && e.meta.fields),
                                e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : n(e.data[0])),
                                Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [e.data])),
                            i(e.fields || [], e.data || [], c)
                        );
                    throw "exception: Unable to serialize unrecognized input";
                },
            };
        if (
            ((k.RECORD_SEP = String.fromCharCode(30)),
            (k.UNIT_SEP = String.fromCharCode(31)),
            (k.BYTE_ORDER_MARK = "\ufeff"),
            (k.BAD_DELIMITERS = ["\r", "\n", '"', k.BYTE_ORDER_MARK]),
            (k.WORKERS_SUPPORTED = !m && !!y.Worker),
            (k.SCRIPT_PATH = null),
            (k.NODE_STREAM_INPUT = 1),
            (k.LocalChunkSize = 10485760),
            (k.RemoteChunkSize = 5242880),
            (k.DefaultDelimiter = ","),
            (k.Parser = l),
            (k.ParserHandle = s),
            (k.NetworkStreamer = t),
            (k.FileStreamer = n),
            (k.StringStreamer = i),
            (k.ReadableStreamStreamer = r),
            (k.DuplexStreamStreamer = o),
            y.jQuery)
        ) {
            var S = y.jQuery;
            S.fn.parse = function (e) {
                function t() {
                    if (0 !== r.length) {
                        var t,
                            i,
                            o,
                            s,
                            a = r[0];
                        if (h(e.before)) {
                            var l = e.before(a.file, a.inputElem);
                            if ("object" == typeof l) {
                                if ("abort" === l.action) return (t = "AbortError"), (i = a.file), (o = a.inputElem), (s = l.reason), void (h(e.error) && e.error({ name: t }, i, o, s));
                                if ("skip" === l.action) return void n();
                                "object" == typeof l.config && (a.instanceConfig = S.extend(a.instanceConfig, l.config));
                            } else if ("skip" === l) return void n();
                        }
                        var u = a.instanceConfig.complete;
                        (a.instanceConfig.complete = function (e) {
                            h(u) && u(e, a.file, a.inputElem), n();
                        }),
                            k.parse(a.file, a.instanceConfig);
                    } else h(e.complete) && e.complete();
                }
                function n() {
                    r.splice(0, 1), t();
                }
                var i = e.config || {},
                    r = [];
                return (
                    this.each(function (e) {
                        if ("INPUT" !== S(this).prop("tagName").toUpperCase() || "file" !== S(this).attr("type").toLowerCase() || !y.FileReader || !this.files || 0 === this.files.length) return !0;
                        for (var t = 0; t < this.files.length; t++) r.push({ file: this.files[t], inputElem: this, instanceConfig: S.extend({}, i) });
                    }),
                    t(),
                    this
                );
            };
        }
        return (
            b
                ? (y.onmessage = function (e) {
                      var t = e.data;
                      if ((void 0 === k.WORKER_ID && t && (k.WORKER_ID = t.workerId), "string" == typeof t.input)) y.postMessage({ workerId: k.WORKER_ID, results: k.parse(t.input, t.config), finished: !0 });
                      else if ((y.File && t.input instanceof File) || t.input instanceof Object) {
                          var n = k.parse(t.input, t.config);
                          n && y.postMessage({ workerId: k.WORKER_ID, results: n, finished: !0 });
                      }
                  })
                : k.WORKERS_SUPPORTED &&
                  ((v = document.getElementsByTagName("script")),
                  (g = v.length ? v[v.length - 1].src : ""),
                  document.body
                      ? document.addEventListener(
                            "DOMContentLoaded",
                            function () {
                                w = !0;
                            },
                            !0
                        )
                      : (w = !0)),
            ((t.prototype = Object.create(e.prototype)).constructor = t),
            ((n.prototype = Object.create(e.prototype)).constructor = n),
            ((i.prototype = Object.create(i.prototype)).constructor = i),
            ((r.prototype = Object.create(e.prototype)).constructor = r),
            ((o.prototype = Object.create(e.prototype)).constructor = o),
            k
        );
    }),
    (function (e, t) {
        "object" == typeof exports && exports && "string" != typeof exports.nodeName ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : ((e.Mustache = {}), t(e.Mustache));
    })(this, function (e) {
        function t(e) {
            return "function" == typeof e;
        }
        function n(e) {
            return v(e) ? "array" : typeof e;
        }
        function i(e) {
            return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
        }
        function r(e, t) {
            return null != e && "object" == typeof e && t in e;
        }
        function o(e, t) {
            return null != e && "object" != typeof e && e.hasOwnProperty && e.hasOwnProperty(t);
        }
        function s(e, t) {
            return y.call(e, t);
        }
        function a(e) {
            return !s(m, e);
        }
        function l(e) {
            return String(e).replace(/[&<>"'`=\/]/g, function (e) {
                return b[e];
            });
        }
        function u(t, n) {
            function r() {
                if (y && !m) for (; g.length; ) delete h[g.pop()];
                else g = [];
                (y = !1), (m = !1);
            }
            function o(e) {
                if (("string" == typeof e && (e = e.split(x, 2)), !v(e) || 2 !== e.length)) throw new Error("Invalid tags: " + e);
                (s = new RegExp(i(e[0]) + "\\s*")), (l = new RegExp("\\s*" + i(e[1]))), (u = new RegExp("\\s*" + i("}" + e[1])));
            }
            if (!t) return [];
            var s,
                l,
                u,
                p = [],
                h = [],
                g = [],
                y = !1,
                m = !1;
            o(n || e.tags);
            for (var b, C, T, E, A, j, D = new d(t); !D.eos(); ) {
                if (((b = D.pos), (T = D.scanUntil(s)))) for (var L = 0, P = T.length; L < P; ++L) (E = T.charAt(L)), a(E) ? g.push(h.length) : (m = !0), h.push(["text", E, b, b + 1]), (b += 1), "\n" === E && r();
                if (!D.scan(s)) break;
                if (
                    ((y = !0),
                    (C = D.scan(S) || "name"),
                    D.scan(w),
                    "=" === C ? ((T = D.scanUntil(_)), D.scan(_), D.scanUntil(l)) : "{" === C ? ((T = D.scanUntil(u)), D.scan(k), D.scanUntil(l), (C = "&")) : (T = D.scanUntil(l)),
                    !D.scan(l))
                )
                    throw new Error("Unclosed tag at " + D.pos);
                if (((A = [C, T, b, D.pos]), h.push(A), "#" === C || "^" === C)) p.push(A);
                else if ("/" === C) {
                    if (((j = p.pop()), !j)) throw new Error('Unopened section "' + T + '" at ' + b);
                    if (j[1] !== T) throw new Error('Unclosed section "' + j[1] + '" at ' + b);
                } else "name" === C || "{" === C || "&" === C ? (m = !0) : "=" === C && o(T);
            }
            if ((j = p.pop())) throw new Error('Unclosed section "' + j[1] + '" at ' + D.pos);
            return f(c(h));
        }
        function c(e) {
            for (var t, n, i = [], r = 0, o = e.length; r < o; ++r) (t = e[r]), t && ("text" === t[0] && n && "text" === n[0] ? ((n[1] += t[1]), (n[3] = t[3])) : (i.push(t), (n = t)));
            return i;
        }
        function f(e) {
            for (var t, n, i = [], r = i, o = [], s = 0, a = e.length; s < a; ++s)
                switch (((t = e[s]), t[0])) {
                    case "#":
                    case "^":
                        r.push(t), o.push(t), (r = t[4] = []);
                        break;
                    case "/":
                        (n = o.pop()), (n[5] = t[2]), (r = o.length > 0 ? o[o.length - 1][4] : i);
                        break;
                    default:
                        r.push(t);
                }
            return i;
        }
        function d(e) {
            (this.string = e), (this.tail = e), (this.pos = 0);
        }
        function p(e, t) {
            (this.view = e), (this.cache = { ".": this.view }), (this.parent = t);
        }
        function h() {
            this.cache = {};
        }
        var g = Object.prototype.toString,
            v =
                Array.isArray ||
                function (e) {
                    return "[object Array]" === g.call(e);
                },
            y = RegExp.prototype.test,
            m = /\S/,
            b = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#x2F;", "`": "&#x60;", "=": "&#x3D;" },
            w = /\s*/,
            x = /\s+/,
            _ = /\s*=/,
            k = /\s*\}/,
            S = /#|\^|\/|>|\{|&|=|!/;
        (d.prototype.eos = function () {
            return "" === this.tail;
        }),
            (d.prototype.scan = function (e) {
                var t = this.tail.match(e);
                if (!t || 0 !== t.index) return "";
                var n = t[0];
                return (this.tail = this.tail.substring(n.length)), (this.pos += n.length), n;
            }),
            (d.prototype.scanUntil = function (e) {
                var t,
                    n = this.tail.search(e);
                switch (n) {
                    case -1:
                        (t = this.tail), (this.tail = "");
                        break;
                    case 0:
                        t = "";
                        break;
                    default:
                        (t = this.tail.substring(0, n)), (this.tail = this.tail.substring(n));
                }
                return (this.pos += t.length), t;
            }),
            (p.prototype.push = function (e) {
                return new p(e, this);
            }),
            (p.prototype.lookup = function (e) {
                var n,
                    i = this.cache;
                if (i.hasOwnProperty(e)) n = i[e];
                else {
                    for (var s, a, l, u = this, c = !1; u; ) {
                        if (e.indexOf(".") > 0) for (s = u.view, a = e.split("."), l = 0; null != s && l < a.length; ) l === a.length - 1 && (c = r(s, a[l]) || o(s, a[l])), (s = s[a[l++]]);
                        else (s = u.view[e]), (c = r(u.view, e));
                        if (c) {
                            n = s;
                            break;
                        }
                        u = u.parent;
                    }
                    i[e] = n;
                }
                return t(n) && (n = n.call(this.view)), n;
            }),
            (h.prototype.clearCache = function () {
                this.cache = {};
            }),
            (h.prototype.parse = function (t, n) {
                var i = this.cache,
                    r = t + ":" + (n || e.tags).join(":"),
                    o = i[r];
                return null == o && (o = i[r] = u(t, n)), o;
            }),
            (h.prototype.render = function (e, t, n, i) {
                var r = this.parse(e, i),
                    o = t instanceof p ? t : new p(t);
                return this.renderTokens(r, o, n, e);
            }),
            (h.prototype.renderTokens = function (e, t, n, i) {
                for (var r, o, s, a = "", l = 0, u = e.length; l < u; ++l)
                    (s = void 0),
                        (r = e[l]),
                        (o = r[0]),
                        "#" === o
                            ? (s = this.renderSection(r, t, n, i))
                            : "^" === o
                            ? (s = this.renderInverted(r, t, n, i))
                            : ">" === o
                            ? (s = this.renderPartial(r, t, n, i))
                            : "&" === o
                            ? (s = this.unescapedValue(r, t))
                            : "name" === o
                            ? (s = this.escapedValue(r, t))
                            : "text" === o && (s = this.rawValue(r)),
                        void 0 !== s && (a += s);
                return a;
            }),
            (h.prototype.renderSection = function (e, n, i, r) {
                function o(e) {
                    return s.render(e, n, i);
                }
                var s = this,
                    a = "",
                    l = n.lookup(e[1]);
                if (l) {
                    if (v(l)) for (var u = 0, c = l.length; u < c; ++u) a += this.renderTokens(e[4], n.push(l[u]), i, r);
                    else if ("object" == typeof l || "string" == typeof l || "number" == typeof l) a += this.renderTokens(e[4], n.push(l), i, r);
                    else if (t(l)) {
                        if ("string" != typeof r) throw new Error("Cannot use higher-order sections without the original template");
                        (l = l.call(n.view, r.slice(e[3], e[5]), o)), null != l && (a += l);
                    } else a += this.renderTokens(e[4], n, i, r);
                    return a;
                }
            }),
            (h.prototype.renderInverted = function (e, t, n, i) {
                var r = t.lookup(e[1]);
                if (!r || (v(r) && 0 === r.length)) return this.renderTokens(e[4], t, n, i);
            }),
            (h.prototype.renderPartial = function (e, n, i) {
                if (i) {
                    var r = t(i) ? i(e[1]) : i[e[1]];
                    return null != r ? this.renderTokens(this.parse(r), n, i, r) : void 0;
                }
            }),
            (h.prototype.unescapedValue = function (e, t) {
                var n = t.lookup(e[1]);
                if (null != n) return n;
            }),
            (h.prototype.escapedValue = function (t, n) {
                var i = n.lookup(t[1]);
                if (null != i) return e.escape(i);
            }),
            (h.prototype.rawValue = function (e) {
                return e[1];
            }),
            (e.name = "mustache.js"),
            (e.version = "3.0.0"),
            (e.tags = ["{{", "}}"]);
        var C = new h();
        return (
            (e.clearCache = function () {
                return C.clearCache();
            }),
            (e.parse = function (e, t) {
                return C.parse(e, t);
            }),
            (e.render = function (e, t, i, r) {
                if ("string" != typeof e) throw new TypeError('Invalid template! Template should be a "string" but "' + n(e) + '" was given as the first argument for mustache#render(template, view, partials)');
                return C.render(e, t, i, r);
            }),
            (e.to_html = function (n, i, r, o) {
                var s = e.render(n, i, r);
                return t(o) ? void o(s) : s;
            }),
            (e.escape = l),
            (e.Scanner = d),
            (e.Context = p),
            (e.Writer = h),
            e
        );
    }) /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */,
    !(function (e) {
        e.fn.prepareTransition = function () {
            return this.each(function () {
                var t = e(this);
                t.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
                    t.removeClass("is-transitioning");
                });
                var n = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"],
                    i = 0;
                e.each(n, function (e, n) {
                    i || (i = parseFloat(t.css(n)));
                }),
                    0 != i && (t.addClass("is-transitioning"), t[0].offsetWidth);
            });
        };
    })(jQuery)
    /*!
     * jQuery Cookie Plugin v1.4.1
     * https://github.com/carhartl/jquery-cookie
     *
     * Copyright 2006, 2014 Klaus Hartl
     * Released under the MIT license
     */,
    (function (e) {
        "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof exports ? (module.exports = e(require("jquery"))) : e(jQuery);
    })(function (e) {
        function t(e) {
            return a.raw ? e : encodeURIComponent(e);
        }
        function n(e) {
            return a.raw ? e : decodeURIComponent(e);
        }
        function i(e) {
            return t(a.json ? JSON.stringify(e) : String(e));
        }
        function r(e) {
            0 === e.indexOf('"') && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
            try {
                return (e = decodeURIComponent(e.replace(s, " "))), a.json ? JSON.parse(e) : e;
            } catch (e) {}
        }
        function o(t, n) {
            var i = a.raw ? t : r(t);
            return e.isFunction(n) ? n(i) : i;
        }
        var s = /\+/g,
            a = (e.cookie = function (r, s, l) {
                if (arguments.length > 1 && !e.isFunction(s)) {
                    if (((l = e.extend({}, a.defaults, l)), "number" == typeof l.expires)) {
                        var u = l.expires,
                            c = (l.expires = new Date());
                        c.setMilliseconds(c.getMilliseconds() + 864e5 * u);
                    }
                    return (document.cookie = [t(r), "=", i(s), l.expires ? "; expires=" + l.expires.toUTCString() : "", l.path ? "; path=" + l.path : "", l.domain ? "; domain=" + l.domain : "", l.secure ? "; secure" : ""].join(""));
                }
                for (var f = r ? void 0 : {}, d = document.cookie ? document.cookie.split("; ") : [], p = 0, h = d.length; p < h; p++) {
                    var g = d[p].split("="),
                        v = n(g.shift()),
                        y = g.join("=");
                    if (r === v) {
                        f = o(y, s);
                        break;
                    }
                    r || void 0 === (y = o(y)) || (f[v] = y);
                }
                return f;
            });
        (a.defaults = {}),
            (e.removeCookie = function (t, n) {
                return e.cookie(t, "", e.extend({}, n, { expires: -1 })), !e.cookie(t);
            });
    }),
    !(function (e) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? (module.exports = e(require("jquery"))) : e(jQuery);
    })(function (e) {
        "use strict";
        var t = window.Slick || {};
        ((t = (function () {
            var t = 0;
            return function (n, i) {
                var r,
                    o = this;
                (o.defaults = {
                    accessibility: !0,
                    adaptiveHeight: !1,
                    appendArrows: e(n),
                    appendDots: e(n),
                    arrows: !0,
                    asNavFor: null,
                    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                    nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                    autoplay: !1,
                    autoplaySpeed: 3e3,
                    centerMode: !1,
                    centerPadding: "50px",
                    cssEase: "ease",
                    customPaging: function (t, n) {
                        return e('<button type="button" />').text(n + 1);
                    },
                    dots: !1,
                    dotsClass: "slick-dots",
                    draggable: !0,
                    easing: "linear",
                    edgeFriction: 0.35,
                    fade: !1,
                    focusOnSelect: !1,
                    focusOnChange: !1,
                    infinite: !0,
                    initialSlide: 0,
                    lazyLoad: "ondemand",
                    mobileFirst: !1,
                    pauseOnHover: !0,
                    pauseOnFocus: !0,
                    pauseOnDotsHover: !1,
                    respondTo: "window",
                    responsive: null,
                    rows: 1,
                    rtl: !1,
                    slide: "",
                    slidesPerRow: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    swipe: !0,
                    swipeToSlide: !1,
                    touchMove: !0,
                    touchThreshold: 5,
                    useCSS: !0,
                    useTransform: !0,
                    variableWidth: !1,
                    vertical: !1,
                    verticalSwiping: !1,
                    waitForAnimate: !0,
                    zIndex: 1e3,
                }),
                    (o.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        scrolling: !1,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        swiping: !1,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1,
                    }),
                    e.extend(o, o.initials),
                    (o.activeBreakpoint = null),
                    (o.animType = null),
                    (o.animProp = null),
                    (o.breakpoints = []),
                    (o.breakpointSettings = []),
                    (o.cssTransitions = !1),
                    (o.focussed = !1),
                    (o.interrupted = !1),
                    (o.hidden = "hidden"),
                    (o.paused = !0),
                    (o.positionProp = null),
                    (o.respondTo = null),
                    (o.rowCount = 1),
                    (o.shouldClick = !0),
                    (o.$slider = e(n)),
                    (o.$slidesCache = null),
                    (o.transformType = null),
                    (o.transitionType = null),
                    (o.visibilityChange = "visibilitychange"),
                    (o.windowWidth = 0),
                    (o.windowTimer = null),
                    (r = e(n).data("slick") || {}),
                    (o.options = e.extend({}, o.defaults, i, r)),
                    (o.currentSlide = o.options.initialSlide),
                    (o.originalSettings = o.options),
                    void 0 !== document.mozHidden
                        ? ((o.hidden = "mozHidden"), (o.visibilityChange = "mozvisibilitychange"))
                        : void 0 !== document.webkitHidden && ((o.hidden = "webkitHidden"), (o.visibilityChange = "webkitvisibilitychange")),
                    (o.autoPlay = e.proxy(o.autoPlay, o)),
                    (o.autoPlayClear = e.proxy(o.autoPlayClear, o)),
                    (o.autoPlayIterator = e.proxy(o.autoPlayIterator, o)),
                    (o.changeSlide = e.proxy(o.changeSlide, o)),
                    (o.clickHandler = e.proxy(o.clickHandler, o)),
                    (o.selectHandler = e.proxy(o.selectHandler, o)),
                    (o.setPosition = e.proxy(o.setPosition, o)),
                    (o.swipeHandler = e.proxy(o.swipeHandler, o)),
                    (o.dragHandler = e.proxy(o.dragHandler, o)),
                    (o.keyHandler = e.proxy(o.keyHandler, o)),
                    (o.instanceUid = t++),
                    (o.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                    o.registerBreakpoints(),
                    o.init(!0);
            };
        })()).prototype.activateADA = function () {
            this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
        }),
            (t.prototype.addSlide = t.prototype.slickAdd = function (t, n, i) {
                var r = this;
                if ("boolean" == typeof n) (i = n), (n = null);
                else if (n < 0 || n >= r.slideCount) return !1;
                r.unload(),
                    "number" == typeof n
                        ? 0 === n && 0 === r.$slides.length
                            ? e(t).appendTo(r.$slideTrack)
                            : i
                            ? e(t).insertBefore(r.$slides.eq(n))
                            : e(t).insertAfter(r.$slides.eq(n))
                        : !0 === i
                        ? e(t).prependTo(r.$slideTrack)
                        : e(t).appendTo(r.$slideTrack),
                    (r.$slides = r.$slideTrack.children(this.options.slide)),
                    r.$slideTrack.children(this.options.slide).detach(),
                    r.$slideTrack.append(r.$slides),
                    r.$slides.each(function (t, n) {
                        e(n).attr("data-slick-index", t);
                    }),
                    (r.$slidesCache = r.$slides),
                    r.reinit();
            }),
            (t.prototype.animateHeight = function () {
                var e = this;
                if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                    var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                    e.$list.animate({ height: t }, e.options.speed);
                }
            }),
            (t.prototype.animateSlide = function (t, n) {
                var i = {},
                    r = this;
                r.animateHeight(),
                    !0 === r.options.rtl && !1 === r.options.vertical && (t = -t),
                    !1 === r.transformsEnabled
                        ? !1 === r.options.vertical
                            ? r.$slideTrack.animate({ left: t }, r.options.speed, r.options.easing, n)
                            : r.$slideTrack.animate({ top: t }, r.options.speed, r.options.easing, n)
                        : !1 === r.cssTransitions
                        ? (!0 === r.options.rtl && (r.currentLeft = -r.currentLeft),
                          e({ animStart: r.currentLeft }).animate(
                              { animStart: t },
                              {
                                  duration: r.options.speed,
                                  easing: r.options.easing,
                                  step: function (e) {
                                      (e = Math.ceil(e)), !1 === r.options.vertical ? ((i[r.animType] = "translate(" + e + "px, 0px)"), r.$slideTrack.css(i)) : ((i[r.animType] = "translate(0px," + e + "px)"), r.$slideTrack.css(i));
                                  },
                                  complete: function () {
                                      n && n.call();
                                  },
                              }
                          ))
                        : (r.applyTransition(),
                          (t = Math.ceil(t)),
                          !1 === r.options.vertical ? (i[r.animType] = "translate3d(" + t + "px, 0px, 0px)") : (i[r.animType] = "translate3d(0px," + t + "px, 0px)"),
                          r.$slideTrack.css(i),
                          n &&
                              setTimeout(function () {
                                  r.disableTransition(), n.call();
                              }, r.options.speed));
            }),
            (t.prototype.getNavTarget = function () {
                var t = this,
                    n = t.options.asNavFor;
                return n && null !== n && (n = e(n).not(t.$slider)), n;
            }),
            (t.prototype.asNavFor = function (t) {
                var n = this.getNavTarget();
                null !== n &&
                    "object" == typeof n &&
                    n.each(function () {
                        var n = e(this).slick("getSlick");
                        n.unslicked || n.slideHandler(t, !0);
                    });
            }),
            (t.prototype.applyTransition = function (e) {
                var t = this,
                    n = {};
                !1 === t.options.fade ? (n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase) : (n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase),
                    !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
            }),
            (t.prototype.autoPlay = function () {
                var e = this;
                e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed));
            }),
            (t.prototype.autoPlayClear = function () {
                var e = this;
                e.autoPlayTimer && clearInterval(e.autoPlayTimer);
            }),
            (t.prototype.autoPlayIterator = function () {
                var e = this,
                    t = e.currentSlide + e.options.slidesToScroll;
                e.paused ||
                    e.interrupted ||
                    e.focussed ||
                    (!1 === e.options.infinite &&
                        (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? (e.direction = 0) : 0 === e.direction && ((t = e.currentSlide - e.options.slidesToScroll), e.currentSlide - 1 == 0 && (e.direction = 1))),
                    e.slideHandler(t));
            }),
            (t.prototype.buildArrows = function () {
                var t = this;
                !0 === t.options.arrows &&
                    ((t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow")),
                    (t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow")),
                    t.slideCount > t.options.slidesToShow
                        ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows),
                          t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows),
                          !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                        : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
            }),
            (t.prototype.buildDots = function () {
                var t,
                    n,
                    i = this;
                if (!0 === i.options.dots) {
                    for (i.$slider.addClass("slick-dotted"), n = e("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1) n.append(e("<li />").append(i.options.customPaging.call(this, i, t)));
                    (i.$dots = n.appendTo(i.options.appendDots)), i.$dots.find("li").first().addClass("slick-active");
                }
            }),
            (t.prototype.buildOut = function () {
                var t = this;
                (t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                    (t.slideCount = t.$slides.length),
                    t.$slides.each(function (t, n) {
                        e(n)
                            .attr("data-slick-index", t)
                            .data("originalStyling", e(n).attr("style") || "");
                    }),
                    t.$slider.addClass("slick-slider"),
                    (t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
                    (t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent()),
                    t.$slideTrack.css("opacity", 0),
                    (!0 !== t.options.centerMode && !0 !== t.options.swipeToSlide) || (t.options.slidesToScroll = 1),
                    e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
                    t.setupInfinite(),
                    t.buildArrows(),
                    t.buildDots(),
                    t.updateDots(),
                    t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
                    !0 === t.options.draggable && t.$list.addClass("draggable");
            }),
            (t.prototype.buildRows = function () {
                var e,
                    t,
                    n,
                    i,
                    r,
                    o,
                    s,
                    a = this;
                if (((i = document.createDocumentFragment()), (o = a.$slider.children()), a.options.rows > 1)) {
                    for (s = a.options.slidesPerRow * a.options.rows, r = Math.ceil(o.length / s), e = 0; e < r; e++) {
                        var l = document.createElement("div");
                        for (t = 0; t < a.options.rows; t++) {
                            var u = document.createElement("div");
                            for (n = 0; n < a.options.slidesPerRow; n++) {
                                var c = e * s + (t * a.options.slidesPerRow + n);
                                o.get(c) && u.appendChild(o.get(c));
                            }
                            l.appendChild(u);
                        }
                        i.appendChild(l);
                    }
                    a.$slider.empty().append(i),
                        a.$slider
                            .children()
                            .children()
                            .children()
                            .css({ width: 100 / a.options.slidesPerRow + "%", display: "inline-block" });
                }
            }),
            (t.prototype.checkResponsive = function (t, n) {
                var i,
                    r,
                    o,
                    s = this,
                    a = !1,
                    l = s.$slider.width(),
                    u = window.innerWidth || e(window).width();
                if (("window" === s.respondTo ? (o = u) : "slider" === s.respondTo ? (o = l) : "min" === s.respondTo && (o = Math.min(u, l)), s.options.responsive && s.options.responsive.length && null !== s.options.responsive)) {
                    r = null;
                    for (i in s.breakpoints) s.breakpoints.hasOwnProperty(i) && (!1 === s.originalSettings.mobileFirst ? o < s.breakpoints[i] && (r = s.breakpoints[i]) : o > s.breakpoints[i] && (r = s.breakpoints[i]));
                    null !== r
                        ? null !== s.activeBreakpoint
                            ? (r !== s.activeBreakpoint || n) &&
                              ((s.activeBreakpoint = r),
                              "unslick" === s.breakpointSettings[r] ? s.unslick(r) : ((s.options = e.extend({}, s.originalSettings, s.breakpointSettings[r])), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)),
                              (a = r))
                            : ((s.activeBreakpoint = r),
                              "unslick" === s.breakpointSettings[r] ? s.unslick(r) : ((s.options = e.extend({}, s.originalSettings, s.breakpointSettings[r])), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)),
                              (a = r))
                        : null !== s.activeBreakpoint && ((s.activeBreakpoint = null), (s.options = s.originalSettings), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t), (a = r)),
                        t || !1 === a || s.$slider.trigger("breakpoint", [s, a]);
                }
            }),
            (t.prototype.changeSlide = function (t, n) {
                var i,
                    r,
                    o,
                    s = this,
                    a = e(t.currentTarget);
                switch ((a.is("a") && t.preventDefault(), a.is("li") || (a = a.closest("li")), (o = s.slideCount % s.options.slidesToScroll != 0), (i = o ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll), t.data.message)) {
                    case "previous":
                        (r = 0 === i ? s.options.slidesToScroll : s.options.slidesToShow - i), s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - r, !1, n);
                        break;
                    case "next":
                        (r = 0 === i ? s.options.slidesToScroll : i), s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + r, !1, n);
                        break;
                    case "index":
                        var l = 0 === t.data.index ? 0 : t.data.index || a.index() * s.options.slidesToScroll;
                        s.slideHandler(s.checkNavigable(l), !1, n), a.children().trigger("focus");
                        break;
                    default:
                        return;
                }
            }),
            (t.prototype.checkNavigable = function (e) {
                var t, n;
                if (((t = this.getNavigableIndexes()), (n = 0), e > t[t.length - 1])) e = t[t.length - 1];
                else
                    for (var i in t) {
                        if (e < t[i]) {
                            e = n;
                            break;
                        }
                        n = t[i];
                    }
                return e;
            }),
            (t.prototype.cleanUpEvents = function () {
                var t = this;
                t.options.dots &&
                    null !== t.$dots &&
                    (e("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", e.proxy(t.interrupt, t, !0)).off("mouseleave.slick", e.proxy(t.interrupt, t, !1)),
                    !0 === t.options.accessibility && t.$dots.off("keydown.slick", t.keyHandler)),
                    t.$slider.off("focus.slick blur.slick"),
                    !0 === t.options.arrows &&
                        t.slideCount > t.options.slidesToShow &&
                        (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide),
                        t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide),
                        !0 === t.options.accessibility && (t.$prevArrow && t.$prevArrow.off("keydown.slick", t.keyHandler), t.$nextArrow && t.$nextArrow.off("keydown.slick", t.keyHandler))),
                    t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
                    t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
                    t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
                    t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
                    t.$list.off("click.slick", t.clickHandler),
                    e(document).off(t.visibilityChange, t.visibility),
                    t.cleanUpSlideEvents(),
                    !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler),
                    !0 === t.options.focusOnSelect && e(t.$slideTrack).children().off("click.slick", t.selectHandler),
                    e(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange),
                    e(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
                    e("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault),
                    e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition);
            }),
            (t.prototype.cleanUpSlideEvents = function () {
                var t = this;
                t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1));
            }),
            (t.prototype.cleanUpRows = function () {
                var e,
                    t = this;
                t.options.rows > 1 && ((e = t.$slides.children().children()).removeAttr("style"), t.$slider.empty().append(e));
            }),
            (t.prototype.clickHandler = function (e) {
                !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault());
            }),
            (t.prototype.destroy = function (t) {
                var n = this;
                n.autoPlayClear(),
                    (n.touchObject = {}),
                    n.cleanUpEvents(),
                    e(".slick-cloned", n.$slider).detach(),
                    n.$dots && n.$dots.remove(),
                    n.$prevArrow &&
                        n.$prevArrow.length &&
                        (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()),
                    n.$nextArrow &&
                        n.$nextArrow.length &&
                        (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()),
                    n.$slides &&
                        (n.$slides
                            .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                            .removeAttr("aria-hidden")
                            .removeAttr("data-slick-index")
                            .each(function () {
                                e(this).attr("style", e(this).data("originalStyling"));
                            }),
                        n.$slideTrack.children(this.options.slide).detach(),
                        n.$slideTrack.detach(),
                        n.$list.detach(),
                        n.$slider.append(n.$slides)),
                    n.cleanUpRows(),
                    n.$slider.removeClass("slick-slider"),
                    n.$slider.removeClass("slick-initialized"),
                    n.$slider.removeClass("slick-dotted"),
                    (n.unslicked = !0),
                    t || n.$slider.trigger("destroy", [n]);
            }),
            (t.prototype.disableTransition = function (e) {
                var t = this,
                    n = {};
                (n[t.transitionType] = ""), !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
            }),
            (t.prototype.fadeSlide = function (e, t) {
                var n = this;
                !1 === n.cssTransitions
                    ? (n.$slides.eq(e).css({ zIndex: n.options.zIndex }), n.$slides.eq(e).animate({ opacity: 1 }, n.options.speed, n.options.easing, t))
                    : (n.applyTransition(e),
                      n.$slides.eq(e).css({ opacity: 1, zIndex: n.options.zIndex }),
                      t &&
                          setTimeout(function () {
                              n.disableTransition(e), t.call();
                          }, n.options.speed));
            }),
            (t.prototype.fadeSlideOut = function (e) {
                var t = this;
                !1 === t.cssTransitions ? t.$slides.eq(e).animate({ opacity: 0, zIndex: t.options.zIndex - 2 }, t.options.speed, t.options.easing) : (t.applyTransition(e), t.$slides.eq(e).css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
            }),
            (t.prototype.filterSlides = t.prototype.slickFilter = function (e) {
                var t = this;
                null !== e && ((t.$slidesCache = t.$slides), t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit());
            }),
            (t.prototype.focusHandler = function () {
                var t = this;
                t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (n) {
                    n.stopImmediatePropagation();
                    var i = e(this);
                    setTimeout(function () {
                        t.options.pauseOnFocus && ((t.focussed = i.is(":focus")), t.autoPlay());
                    }, 0);
                });
            }),
            (t.prototype.getCurrent = t.prototype.slickCurrentSlide = function () {
                return this.currentSlide;
            }),
            (t.prototype.getDotCount = function () {
                var e = this,
                    t = 0,
                    n = 0,
                    i = 0;
                if (!0 === e.options.infinite)
                    if (e.slideCount <= e.options.slidesToShow) ++i;
                    else for (; t < e.slideCount; ) ++i, (t = n + e.options.slidesToScroll), (n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                else if (!0 === e.options.centerMode) i = e.slideCount;
                else if (e.options.asNavFor) for (; t < e.slideCount; ) ++i, (t = n + e.options.slidesToScroll), (n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
                return i - 1;
            }),
            (t.prototype.getLeft = function (e) {
                var t,
                    n,
                    i,
                    r,
                    o = this,
                    s = 0;
                return (
                    (o.slideOffset = 0),
                    (n = o.$slides.first().outerHeight(!0)),
                    !0 === o.options.infinite
                        ? (o.slideCount > o.options.slidesToShow &&
                              ((o.slideOffset = o.slideWidth * o.options.slidesToShow * -1),
                              (r = -1),
                              !0 === o.options.vertical && !0 === o.options.centerMode && (2 === o.options.slidesToShow ? (r = -1.5) : 1 === o.options.slidesToShow && (r = -2)),
                              (s = n * o.options.slidesToShow * r)),
                          o.slideCount % o.options.slidesToScroll != 0 &&
                              e + o.options.slidesToScroll > o.slideCount &&
                              o.slideCount > o.options.slidesToShow &&
                              (e > o.slideCount
                                  ? ((o.slideOffset = (o.options.slidesToShow - (e - o.slideCount)) * o.slideWidth * -1), (s = (o.options.slidesToShow - (e - o.slideCount)) * n * -1))
                                  : ((o.slideOffset = (o.slideCount % o.options.slidesToScroll) * o.slideWidth * -1), (s = (o.slideCount % o.options.slidesToScroll) * n * -1))))
                        : e + o.options.slidesToShow > o.slideCount && ((o.slideOffset = (e + o.options.slidesToShow - o.slideCount) * o.slideWidth), (s = (e + o.options.slidesToShow - o.slideCount) * n)),
                    o.slideCount <= o.options.slidesToShow && ((o.slideOffset = 0), (s = 0)),
                    !0 === o.options.centerMode && o.slideCount <= o.options.slidesToShow
                        ? (o.slideOffset = (o.slideWidth * Math.floor(o.options.slidesToShow)) / 2 - (o.slideWidth * o.slideCount) / 2)
                        : !0 === o.options.centerMode && !0 === o.options.infinite
                        ? (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth)
                        : !0 === o.options.centerMode && ((o.slideOffset = 0), (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2))),
                    (t = !1 === o.options.vertical ? e * o.slideWidth * -1 + o.slideOffset : e * n * -1 + s),
                    !0 === o.options.variableWidth &&
                        ((i = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow)),
                        (t = !0 === o.options.rtl ? (i[0] ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0) : i[0] ? -1 * i[0].offsetLeft : 0),
                        !0 === o.options.centerMode &&
                            ((i = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow + 1)),
                            (t = !0 === o.options.rtl ? (i[0] ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0) : i[0] ? -1 * i[0].offsetLeft : 0),
                            (t += (o.$list.width() - i.outerWidth()) / 2))),
                    t
                );
            }),
            (t.prototype.getOption = t.prototype.slickGetOption = function (e) {
                return this.options[e];
            }),
            (t.prototype.getNavigableIndexes = function () {
                var e,
                    t = this,
                    n = 0,
                    i = 0,
                    r = [];
                for (!1 === t.options.infinite ? (e = t.slideCount) : ((n = -1 * t.options.slidesToScroll), (i = -1 * t.options.slidesToScroll), (e = 2 * t.slideCount)); n < e; )
                    r.push(n), (n = i + t.options.slidesToScroll), (i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow);
                return r;
            }),
            (t.prototype.getSlick = function () {
                return this;
            }),
            (t.prototype.getSlideCount = function () {
                var t,
                    n,
                    i = this;
                return (
                    (n = !0 === i.options.centerMode ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0),
                    !0 === i.options.swipeToSlide
                        ? (i.$slideTrack.find(".slick-slide").each(function (r, o) {
                              if (o.offsetLeft - n + e(o).outerWidth() / 2 > -1 * i.swipeLeft) return (t = o), !1;
                          }),
                          Math.abs(e(t).attr("data-slick-index") - i.currentSlide) || 1)
                        : i.options.slidesToScroll
                );
            }),
            (t.prototype.goTo = t.prototype.slickGoTo = function (e, t) {
                this.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
            }),
            (t.prototype.init = function (t) {
                var n = this;
                e(n.$slider).hasClass("slick-initialized") ||
                    (e(n.$slider).addClass("slick-initialized"), n.buildRows(), n.buildOut(), n.setProps(), n.startLoad(), n.loadSlider(), n.initializeEvents(), n.updateArrows(), n.updateDots(), n.checkResponsive(!0), n.focusHandler()),
                    t && n.$slider.trigger("init", [n]),
                    !0 === n.options.accessibility && n.initADA(),
                    n.options.autoplay && ((n.paused = !1), n.autoPlay());
            }),
            (t.prototype.initADA = function () {
                var t = this,
                    n = Math.ceil(t.slideCount / t.options.slidesToShow),
                    i = t.getNavigableIndexes().filter(function (e) {
                        return e >= 0 && e < t.slideCount;
                    });
                t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }),
                    null !== t.$dots &&
                        (t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function (n) {
                            var r = i.indexOf(n);
                            e(this).attr({ role: "tabpanel", id: "slick-slide" + t.instanceUid + n, tabindex: -1 }), -1 !== r && e(this).attr({ "aria-describedby": "slick-slide-control" + t.instanceUid + r });
                        }),
                        t.$dots
                            .attr("role", "tablist")
                            .find("li")
                            .each(function (r) {
                                var o = i[r];
                                e(this).attr({ role: "presentation" }),
                                    e(this)
                                        .find("button")
                                        .first()
                                        .attr({ role: "tab", id: "slick-slide-control" + t.instanceUid + r, "aria-controls": "slick-slide" + t.instanceUid + o, "aria-label": r + 1 + " of " + n, "aria-selected": null, tabindex: "-1" });
                            })
                            .eq(t.currentSlide)
                            .find("button")
                            .attr({ "aria-selected": "true", tabindex: "0" })
                            .end());
                for (var r = t.currentSlide, o = r + t.options.slidesToShow; r < o; r++) t.$slides.eq(r).attr("tabindex", 0);
                t.activateADA();
            }),
            (t.prototype.initArrowEvents = function () {
                var e = this;
                !0 === e.options.arrows &&
                    e.slideCount > e.options.slidesToShow &&
                    (e.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, e.changeSlide),
                    e.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, e.changeSlide),
                    !0 === e.options.accessibility && (e.$prevArrow.on("keydown.slick", e.keyHandler), e.$nextArrow.on("keydown.slick", e.keyHandler)));
            }),
            (t.prototype.initDotEvents = function () {
                var t = this;
                !0 === t.options.dots && (e("li", t.$dots).on("click.slick", { message: "index" }, t.changeSlide), !0 === t.options.accessibility && t.$dots.on("keydown.slick", t.keyHandler)),
                    !0 === t.options.dots && !0 === t.options.pauseOnDotsHover && e("li", t.$dots).on("mouseenter.slick", e.proxy(t.interrupt, t, !0)).on("mouseleave.slick", e.proxy(t.interrupt, t, !1));
            }),
            (t.prototype.initSlideEvents = function () {
                var t = this;
                t.options.pauseOnHover && (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)));
            }),
            (t.prototype.initializeEvents = function () {
                var t = this;
                t.initArrowEvents(),
                    t.initDotEvents(),
                    t.initSlideEvents(),
                    t.$list.on("touchstart.slick mousedown.slick", { action: "start" }, t.swipeHandler),
                    t.$list.on("touchmove.slick mousemove.slick", { action: "move" }, t.swipeHandler),
                    t.$list.on("touchend.slick mouseup.slick", { action: "end" }, t.swipeHandler),
                    t.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, t.swipeHandler),
                    t.$list.on("click.slick", t.clickHandler),
                    e(document).on(t.visibilityChange, e.proxy(t.visibility, t)),
                    !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler),
                    !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
                    e(window).on("orientationchange.slick.slick-" + t.instanceUid, e.proxy(t.orientationChange, t)),
                    e(window).on("resize.slick.slick-" + t.instanceUid, e.proxy(t.resize, t)),
                    e("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault),
                    e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
                    e(t.setPosition);
            }),
            (t.prototype.initUI = function () {
                var e = this;
                !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show();
            }),
            (t.prototype.keyHandler = function (e) {
                var t = this;
                e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                    (37 === e.keyCode && !0 === t.options.accessibility
                        ? t.changeSlide({ data: { message: !0 === t.options.rtl ? "next" : "previous" } })
                        : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({ data: { message: !0 === t.options.rtl ? "previous" : "next" } }));
            }),
            (t.prototype.lazyLoad = function () {
                function t(t) {
                    e("img[data-lazy]", t).each(function () {
                        var t = e(this),
                            n = e(this).attr("data-lazy"),
                            i = e(this).attr("data-srcset"),
                            r = e(this).attr("data-sizes") || o.$slider.attr("data-sizes"),
                            s = document.createElement("img");
                        (s.onload = function () {
                            t.animate({ opacity: 0 }, 100, function () {
                                i && (t.attr("srcset", i), r && t.attr("sizes", r)),
                                    t.attr("src", n).animate({ opacity: 1 }, 200, function () {
                                        t.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                                    }),
                                    o.$slider.trigger("lazyLoaded", [o, t, n]);
                            });
                        }),
                            (s.onerror = function () {
                                t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), o.$slider.trigger("lazyLoadError", [o, t, n]);
                            }),
                            (s.src = n);
                    });
                }
                var n,
                    i,
                    r,
                    o = this;
                if (
                    (!0 === o.options.centerMode
                        ? !0 === o.options.infinite
                            ? (r = (i = o.currentSlide + (o.options.slidesToShow / 2 + 1)) + o.options.slidesToShow + 2)
                            : ((i = Math.max(0, o.currentSlide - (o.options.slidesToShow / 2 + 1))), (r = o.options.slidesToShow / 2 + 1 + 2 + o.currentSlide))
                        : ((i = o.options.infinite ? o.options.slidesToShow + o.currentSlide : o.currentSlide), (r = Math.ceil(i + o.options.slidesToShow)), !0 === o.options.fade && (i > 0 && i--, r <= o.slideCount && r++)),
                    (n = o.$slider.find(".slick-slide").slice(i, r)),
                    "anticipated" === o.options.lazyLoad)
                )
                    for (var s = i - 1, a = r, l = o.$slider.find(".slick-slide"), u = 0; u < o.options.slidesToScroll; u++) s < 0 && (s = o.slideCount - 1), (n = (n = n.add(l.eq(s))).add(l.eq(a))), s--, a++;
                t(n),
                    o.slideCount <= o.options.slidesToShow
                        ? t(o.$slider.find(".slick-slide"))
                        : o.currentSlide >= o.slideCount - o.options.slidesToShow
                        ? t(o.$slider.find(".slick-cloned").slice(0, o.options.slidesToShow))
                        : 0 === o.currentSlide && t(o.$slider.find(".slick-cloned").slice(-1 * o.options.slidesToShow));
            }),
            (t.prototype.loadSlider = function () {
                var e = this;
                e.setPosition(), e.$slideTrack.css({ opacity: 1 }), e.$slider.removeClass("slick-loading"), e.initUI(), "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
            }),
            (t.prototype.next = t.prototype.slickNext = function () {
                this.changeSlide({ data: { message: "next" } });
            }),
            (t.prototype.orientationChange = function () {
                var e = this;
                e.checkResponsive(), e.setPosition();
            }),
            (t.prototype.pause = t.prototype.slickPause = function () {
                var e = this;
                e.autoPlayClear(), (e.paused = !0);
            }),
            (t.prototype.play = t.prototype.slickPlay = function () {
                var e = this;
                e.autoPlay(), (e.options.autoplay = !0), (e.paused = !1), (e.focussed = !1), (e.interrupted = !1);
            }),
            (t.prototype.postSlide = function (t) {
                var n = this;
                n.unslicked ||
                    (n.$slider.trigger("afterChange", [n, t]),
                    (n.animating = !1),
                    n.slideCount > n.options.slidesToShow && n.setPosition(),
                    (n.swipeLeft = null),
                    n.options.autoplay && n.autoPlay(),
                    !0 === n.options.accessibility && (n.initADA(), n.options.focusOnChange && e(n.$slides.get(n.currentSlide)).attr("tabindex", 0).focus()));
            }),
            (t.prototype.prev = t.prototype.slickPrev = function () {
                this.changeSlide({ data: { message: "previous" } });
            }),
            (t.prototype.preventDefault = function (e) {
                e.preventDefault();
            }),
            (t.prototype.progressiveLazyLoad = function (t) {
                t = t || 1;
                var n,
                    i,
                    r,
                    o,
                    s,
                    a = this,
                    l = e("img[data-lazy]", a.$slider);
                l.length
                    ? ((n = l.first()),
                      (i = n.attr("data-lazy")),
                      (r = n.attr("data-srcset")),
                      (o = n.attr("data-sizes") || a.$slider.attr("data-sizes")),
                      ((s = document.createElement("img")).onload = function () {
                          r && (n.attr("srcset", r), o && n.attr("sizes", o)),
                              n.attr("src", i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),
                              !0 === a.options.adaptiveHeight && a.setPosition(),
                              a.$slider.trigger("lazyLoaded", [a, n, i]),
                              a.progressiveLazyLoad();
                      }),
                      (s.onerror = function () {
                          t < 3
                              ? setTimeout(function () {
                                    a.progressiveLazyLoad(t + 1);
                                }, 500)
                              : (n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), a.$slider.trigger("lazyLoadError", [a, n, i]), a.progressiveLazyLoad());
                      }),
                      (s.src = i))
                    : a.$slider.trigger("allImagesLoaded", [a]);
            }),
            (t.prototype.refresh = function (t) {
                var n,
                    i,
                    r = this;
                (i = r.slideCount - r.options.slidesToShow),
                    !r.options.infinite && r.currentSlide > i && (r.currentSlide = i),
                    r.slideCount <= r.options.slidesToShow && (r.currentSlide = 0),
                    (n = r.currentSlide),
                    r.destroy(!0),
                    e.extend(r, r.initials, { currentSlide: n }),
                    r.init(),
                    t || r.changeSlide({ data: { message: "index", index: n } }, !1);
            }),
            (t.prototype.registerBreakpoints = function () {
                var t,
                    n,
                    i,
                    r = this,
                    o = r.options.responsive || null;
                if ("array" === e.type(o) && o.length) {
                    r.respondTo = r.options.respondTo || "window";
                    for (t in o)
                        if (((i = r.breakpoints.length - 1), o.hasOwnProperty(t))) {
                            for (n = o[t].breakpoint; i >= 0; ) r.breakpoints[i] && r.breakpoints[i] === n && r.breakpoints.splice(i, 1), i--;
                            r.breakpoints.push(n), (r.breakpointSettings[n] = o[t].settings);
                        }
                    r.breakpoints.sort(function (e, t) {
                        return r.options.mobileFirst ? e - t : t - e;
                    });
                }
            }),
            (t.prototype.reinit = function () {
                var t = this;
                (t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide")),
                    (t.slideCount = t.$slides.length),
                    t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
                    t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
                    t.registerBreakpoints(),
                    t.setProps(),
                    t.setupInfinite(),
                    t.buildArrows(),
                    t.updateArrows(),
                    t.initArrowEvents(),
                    t.buildDots(),
                    t.updateDots(),
                    t.initDotEvents(),
                    t.cleanUpSlideEvents(),
                    t.initSlideEvents(),
                    t.checkResponsive(!1, !0),
                    !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
                    t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
                    t.setPosition(),
                    t.focusHandler(),
                    (t.paused = !t.options.autoplay),
                    t.autoPlay(),
                    t.$slider.trigger("reInit", [t]);
            }),
            (t.prototype.resize = function () {
                var t = this;
                e(window).width() !== t.windowWidth &&
                    (clearTimeout(t.windowDelay),
                    (t.windowDelay = window.setTimeout(function () {
                        (t.windowWidth = e(window).width()), t.checkResponsive(), t.unslicked || t.setPosition();
                    }, 50)));
            }),
            (t.prototype.removeSlide = t.prototype.slickRemove = function (e, t, n) {
                var i = this;
                return (
                    (e = "boolean" == typeof e ? (!0 === (t = e) ? 0 : i.slideCount - 1) : !0 === t ? --e : e),
                    !(i.slideCount < 1 || e < 0 || e > i.slideCount - 1) &&
                        (i.unload(),
                        !0 === n ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(),
                        (i.$slides = i.$slideTrack.children(this.options.slide)),
                        i.$slideTrack.children(this.options.slide).detach(),
                        i.$slideTrack.append(i.$slides),
                        (i.$slidesCache = i.$slides),
                        i.reinit(),
                        void 0)
                );
            }),
            (t.prototype.setCSS = function (e) {
                var t,
                    n,
                    i = this,
                    r = {};
                !0 === i.options.rtl && (e = -e),
                    (t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
                    (n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
                    (r[i.positionProp] = e),
                    !1 === i.transformsEnabled
                        ? i.$slideTrack.css(r)
                        : ((r = {}), !1 === i.cssTransitions ? ((r[i.animType] = "translate(" + t + ", " + n + ")"), i.$slideTrack.css(r)) : ((r[i.animType] = "translate3d(" + t + ", " + n + ", 0px)"), i.$slideTrack.css(r)));
            }),
            (t.prototype.setDimensions = function () {
                var e = this;
                !1 === e.options.vertical
                    ? !0 === e.options.centerMode && e.$list.css({ padding: "0px " + e.options.centerPadding })
                    : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({ padding: e.options.centerPadding + " 0px" })),
                    (e.listWidth = e.$list.width()),
                    (e.listHeight = e.$list.height()),
                    !1 === e.options.vertical && !1 === e.options.variableWidth
                        ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length)))
                        : !0 === e.options.variableWidth
                        ? e.$slideTrack.width(5e3 * e.slideCount)
                        : ((e.slideWidth = Math.ceil(e.listWidth)), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
                var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
                !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
            }),
            (t.prototype.setFade = function () {
                var t,
                    n = this;
                n.$slides.each(function (i, r) {
                    (t = n.slideWidth * i * -1),
                        !0 === n.options.rtl ? e(r).css({ position: "relative", right: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 }) : e(r).css({ position: "relative", left: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 });
                }),
                    n.$slides.eq(n.currentSlide).css({ zIndex: n.options.zIndex - 1, opacity: 1 });
            }),
            (t.prototype.setHeight = function () {
                var e = this;
                if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                    var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                    e.$list.css("height", t);
                }
            }),
            (t.prototype.setOption = t.prototype.slickSetOption = function () {
                var t,
                    n,
                    i,
                    r,
                    o,
                    s = this,
                    a = !1;
                if (
                    ("object" === e.type(arguments[0])
                        ? ((i = arguments[0]), (a = arguments[1]), (o = "multiple"))
                        : "string" === e.type(arguments[0]) &&
                          ((i = arguments[0]), (r = arguments[1]), (a = arguments[2]), "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? (o = "responsive") : void 0 !== arguments[1] && (o = "single")),
                    "single" === o)
                )
                    s.options[i] = r;
                else if ("multiple" === o)
                    e.each(i, function (e, t) {
                        s.options[e] = t;
                    });
                else if ("responsive" === o)
                    for (n in r)
                        if ("array" !== e.type(s.options.responsive)) s.options.responsive = [r[n]];
                        else {
                            for (t = s.options.responsive.length - 1; t >= 0; ) s.options.responsive[t].breakpoint === r[n].breakpoint && s.options.responsive.splice(t, 1), t--;
                            s.options.responsive.push(r[n]);
                        }
                a && (s.unload(), s.reinit());
            }),
            (t.prototype.setPosition = function () {
                var e = this;
                e.setDimensions(), e.setHeight(), !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e]);
            }),
            (t.prototype.setProps = function () {
                var e = this,
                    t = document.body.style;
                (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
                    "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
                    (void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition) || (!0 === e.options.useCSS && (e.cssTransitions = !0)),
                    e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : (e.options.zIndex = e.defaults.zIndex)),
                    void 0 !== t.OTransform && ((e.animType = "OTransform"), (e.transformType = "-o-transform"), (e.transitionType = "OTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                    void 0 !== t.MozTransform &&
                        ((e.animType = "MozTransform"), (e.transformType = "-moz-transform"), (e.transitionType = "MozTransition"), void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)),
                    void 0 !== t.webkitTransform &&
                        ((e.animType = "webkitTransform"), (e.transformType = "-webkit-transform"), (e.transitionType = "webkitTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                    void 0 !== t.msTransform && ((e.animType = "msTransform"), (e.transformType = "-ms-transform"), (e.transitionType = "msTransition"), void 0 === t.msTransform && (e.animType = !1)),
                    void 0 !== t.transform && !1 !== e.animType && ((e.animType = "transform"), (e.transformType = "transform"), (e.transitionType = "transition")),
                    (e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType);
            }),
            (t.prototype.setSlideClasses = function (e) {
                var t,
                    n,
                    i,
                    r,
                    o = this;
                if (((n = o.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true")), o.$slides.eq(e).addClass("slick-current"), !0 === o.options.centerMode)) {
                    var s = o.options.slidesToShow % 2 == 0 ? 1 : 0;
                    (t = Math.floor(o.options.slidesToShow / 2)),
                        !0 === o.options.infinite &&
                            (e >= t && e <= o.slideCount - 1 - t
                                ? o.$slides
                                      .slice(e - t + s, e + t + 1)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")
                                : ((i = o.options.slidesToShow + e),
                                  n
                                      .slice(i - t + 1 + s, i + t + 2)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")),
                            0 === e ? n.eq(n.length - 1 - o.options.slidesToShow).addClass("slick-center") : e === o.slideCount - 1 && n.eq(o.options.slidesToShow).addClass("slick-center")),
                        o.$slides.eq(e).addClass("slick-center");
                } else
                    e >= 0 && e <= o.slideCount - o.options.slidesToShow
                        ? o.$slides
                              .slice(e, e + o.options.slidesToShow)
                              .addClass("slick-active")
                              .attr("aria-hidden", "false")
                        : n.length <= o.options.slidesToShow
                        ? n.addClass("slick-active").attr("aria-hidden", "false")
                        : ((r = o.slideCount % o.options.slidesToShow),
                          (i = !0 === o.options.infinite ? o.options.slidesToShow + e : e),
                          o.options.slidesToShow == o.options.slidesToScroll && o.slideCount - e < o.options.slidesToShow
                              ? n
                                    .slice(i - (o.options.slidesToShow - r), i + r)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false")
                              : n
                                    .slice(i, i + o.options.slidesToShow)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false"));
                ("ondemand" !== o.options.lazyLoad && "anticipated" !== o.options.lazyLoad) || o.lazyLoad();
            }),
            (t.prototype.setupInfinite = function () {
                var t,
                    n,
                    i,
                    r = this;
                if ((!0 === r.options.fade && (r.options.centerMode = !1), !0 === r.options.infinite && !1 === r.options.fade && ((n = null), r.slideCount > r.options.slidesToShow))) {
                    for (i = !0 === r.options.centerMode ? r.options.slidesToShow + 1 : r.options.slidesToShow, t = r.slideCount; t > r.slideCount - i; t -= 1)
                        (n = t - 1),
                            e(r.$slides[n])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", n - r.slideCount)
                                .prependTo(r.$slideTrack)
                                .addClass("slick-cloned");
                    for (t = 0; t < i + r.slideCount; t += 1)
                        (n = t),
                            e(r.$slides[n])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", n + r.slideCount)
                                .appendTo(r.$slideTrack)
                                .addClass("slick-cloned");
                    r.$slideTrack
                        .find(".slick-cloned")
                        .find("[id]")
                        .each(function () {
                            e(this).attr("id", "");
                        });
                }
            }),
            (t.prototype.interrupt = function (e) {
                var t = this;
                e || t.autoPlay(), (t.interrupted = e);
            }),
            (t.prototype.selectHandler = function (t) {
                var n = this,
                    i = e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide"),
                    r = parseInt(i.attr("data-slick-index"));
                r || (r = 0), n.slideCount <= n.options.slidesToShow ? n.slideHandler(r, !1, !0) : n.slideHandler(r);
            }),
            (t.prototype.slideHandler = function (e, t, n) {
                var i,
                    r,
                    o,
                    s,
                    a,
                    l = null,
                    u = this;
                if (((t = t || !1), !((!0 === u.animating && !0 === u.options.waitForAnimate) || (!0 === u.options.fade && u.currentSlide === e))))
                    if (
                        (!1 === t && u.asNavFor(e),
                        (i = e),
                        (l = u.getLeft(i)),
                        (s = u.getLeft(u.currentSlide)),
                        (u.currentLeft = null === u.swipeLeft ? s : u.swipeLeft),
                        !1 === u.options.infinite && !1 === u.options.centerMode && (e < 0 || e > u.getDotCount() * u.options.slidesToScroll))
                    )
                        !1 === u.options.fade &&
                            ((i = u.currentSlide),
                            !0 !== n
                                ? u.animateSlide(s, function () {
                                      u.postSlide(i);
                                  })
                                : u.postSlide(i));
                    else if (!1 === u.options.infinite && !0 === u.options.centerMode && (e < 0 || e > u.slideCount - u.options.slidesToScroll))
                        !1 === u.options.fade &&
                            ((i = u.currentSlide),
                            !0 !== n
                                ? u.animateSlide(s, function () {
                                      u.postSlide(i);
                                  })
                                : u.postSlide(i));
                    else {
                        if (
                            (u.options.autoplay && clearInterval(u.autoPlayTimer),
                            (r =
                                i < 0
                                    ? u.slideCount % u.options.slidesToScroll != 0
                                        ? u.slideCount - (u.slideCount % u.options.slidesToScroll)
                                        : u.slideCount + i
                                    : i >= u.slideCount
                                    ? u.slideCount % u.options.slidesToScroll != 0
                                        ? 0
                                        : i - u.slideCount
                                    : i),
                            (u.animating = !0),
                            u.$slider.trigger("beforeChange", [u, u.currentSlide, r]),
                            (o = u.currentSlide),
                            (u.currentSlide = r),
                            u.setSlideClasses(u.currentSlide),
                            u.options.asNavFor && (a = (a = u.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(u.currentSlide),
                            u.updateDots(),
                            u.updateArrows(),
                            !0 === u.options.fade)
                        )
                            return (
                                !0 !== n
                                    ? (u.fadeSlideOut(o),
                                      u.fadeSlide(r, function () {
                                          u.postSlide(r);
                                      }))
                                    : u.postSlide(r),
                                void u.animateHeight()
                            );
                        !0 !== n
                            ? u.animateSlide(l, function () {
                                  u.postSlide(r);
                              })
                            : u.postSlide(r);
                    }
            }),
            (t.prototype.startLoad = function () {
                var e = this;
                !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()),
                    !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
                    e.$slider.addClass("slick-loading");
            }),
            (t.prototype.swipeDirection = function () {
                var e,
                    t,
                    n,
                    i,
                    r = this;
                return (
                    (e = r.touchObject.startX - r.touchObject.curX),
                    (t = r.touchObject.startY - r.touchObject.curY),
                    (n = Math.atan2(t, e)),
                    (i = Math.round((180 * n) / Math.PI)) < 0 && (i = 360 - Math.abs(i)),
                    i <= 45 && i >= 0
                        ? !1 === r.options.rtl
                            ? "left"
                            : "right"
                        : i <= 360 && i >= 315
                        ? !1 === r.options.rtl
                            ? "left"
                            : "right"
                        : i >= 135 && i <= 225
                        ? !1 === r.options.rtl
                            ? "right"
                            : "left"
                        : !0 === r.options.verticalSwiping
                        ? i >= 35 && i <= 135
                            ? "down"
                            : "up"
                        : "vertical"
                );
            }),
            (t.prototype.swipeEnd = function (e) {
                var t,
                    n,
                    i = this;
                if (((i.dragging = !1), (i.swiping = !1), i.scrolling)) return (i.scrolling = !1), !1;
                if (((i.interrupted = !1), (i.shouldClick = !(i.touchObject.swipeLength > 10)), void 0 === i.touchObject.curX)) return !1;
                if ((!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe)) {
                    switch ((n = i.swipeDirection())) {
                        case "left":
                        case "down":
                            (t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount()), (i.currentDirection = 0);
                            break;
                        case "right":
                        case "up":
                            (t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount()), (i.currentDirection = 1);
                    }
                    "vertical" != n && (i.slideHandler(t), (i.touchObject = {}), i.$slider.trigger("swipe", [i, n]));
                } else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), (i.touchObject = {}));
            }),
            (t.prototype.swipeHandler = function (e) {
                var t = this;
                if (!(!1 === t.options.swipe || ("ontouchend" in document && !1 === t.options.swipe) || (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))))
                    switch (
                        ((t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1),
                        (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
                        !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold),
                        e.data.action)
                    ) {
                        case "start":
                            t.swipeStart(e);
                            break;
                        case "move":
                            t.swipeMove(e);
                            break;
                        case "end":
                            t.swipeEnd(e);
                    }
            }),
            (t.prototype.swipeMove = function (e) {
                var t,
                    n,
                    i,
                    r,
                    o,
                    s,
                    a = this;
                return (
                    (o = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
                    !(!a.dragging || a.scrolling || (o && 1 !== o.length)) &&
                        ((t = a.getLeft(a.currentSlide)),
                        (a.touchObject.curX = void 0 !== o ? o[0].pageX : e.clientX),
                        (a.touchObject.curY = void 0 !== o ? o[0].pageY : e.clientY),
                        (a.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2)))),
                        (s = Math.round(Math.sqrt(Math.pow(a.touchObject.curY - a.touchObject.startY, 2)))),
                        !a.options.verticalSwiping && !a.swiping && s > 4
                            ? ((a.scrolling = !0), !1)
                            : (!0 === a.options.verticalSwiping && (a.touchObject.swipeLength = s),
                              (n = a.swipeDirection()),
                              void 0 !== e.originalEvent && a.touchObject.swipeLength > 4 && ((a.swiping = !0), e.preventDefault()),
                              (r = (!1 === a.options.rtl ? 1 : -1) * (a.touchObject.curX > a.touchObject.startX ? 1 : -1)),
                              !0 === a.options.verticalSwiping && (r = a.touchObject.curY > a.touchObject.startY ? 1 : -1),
                              (i = a.touchObject.swipeLength),
                              (a.touchObject.edgeHit = !1),
                              !1 === a.options.infinite &&
                                  ((0 === a.currentSlide && "right" === n) || (a.currentSlide >= a.getDotCount() && "left" === n)) &&
                                  ((i = a.touchObject.swipeLength * a.options.edgeFriction), (a.touchObject.edgeHit = !0)),
                              !1 === a.options.vertical ? (a.swipeLeft = t + i * r) : (a.swipeLeft = t + i * (a.$list.height() / a.listWidth) * r),
                              !0 === a.options.verticalSwiping && (a.swipeLeft = t + i * r),
                              !0 !== a.options.fade && !1 !== a.options.touchMove && (!0 === a.animating ? ((a.swipeLeft = null), !1) : void a.setCSS(a.swipeLeft))))
                );
            }),
            (t.prototype.swipeStart = function (e) {
                var t,
                    n = this;
                return (
                    (n.interrupted = !0),
                    1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow
                        ? ((n.touchObject = {}), !1)
                        : (void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]),
                          (n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX),
                          (n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY),
                          (n.dragging = !0),
                          void 0)
                );
            }),
            (t.prototype.unfilterSlides = t.prototype.slickUnfilter = function () {
                var e = this;
                null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit());
            }),
            (t.prototype.unload = function () {
                var t = this;
                e(".slick-cloned", t.$slider).remove(),
                    t.$dots && t.$dots.remove(),
                    t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(),
                    t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(),
                    t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
            }),
            (t.prototype.unslick = function (e) {
                var t = this;
                t.$slider.trigger("unslick", [t, e]), t.destroy();
            }),
            (t.prototype.updateArrows = function () {
                var e = this;
                Math.floor(e.options.slidesToShow / 2),
                    !0 === e.options.arrows &&
                        e.slideCount > e.options.slidesToShow &&
                        !e.options.infinite &&
                        (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        0 === e.currentSlide
                            ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                            : e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode
                            ? (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                            : e.currentSlide >= e.slideCount - 1 &&
                              !0 === e.options.centerMode &&
                              (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
            }),
            (t.prototype.updateDots = function () {
                var e = this;
                null !== e.$dots &&
                    (e.$dots.find("li").removeClass("slick-active").end(),
                    e.$dots
                        .find("li")
                        .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
                        .addClass("slick-active"));
            }),
            (t.prototype.visibility = function () {
                var e = this;
                e.options.autoplay && (document[e.hidden] ? (e.interrupted = !0) : (e.interrupted = !1));
            }),
            (e.fn.slick = function () {
                var e,
                    n,
                    i = this,
                    r = arguments[0],
                    o = Array.prototype.slice.call(arguments, 1),
                    s = i.length;
                for (e = 0; e < s; e++) if (("object" == typeof r || void 0 === r ? (i[e].slick = new t(i[e], r)) : (n = i[e].slick[r].apply(i[e].slick, o)), void 0 !== n)) return n;
                return i;
            });
    });
